webpackJsonp([2,34],{

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactCompatibility = __webpack_require__(40);

var _reactCompatibility2 = _interopRequireDefault(_reactCompatibility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadOverlayManager = {};

DownloadOverlayManager.show = function () {
  // OnboardingTour is not running or it will not be triggered
  if (typeof window.checkForExportCookieIntervalCleared === 'undefined' || window.checkForExportCookieIntervalCleared) {
    _reactCompatibility2.default.showDownloadOverlay();
  } else {
    // OnboardingTour is running. Need to wait for checkForExportCookieIntervalId to be cleared
    var checkForExportCookieIntervalId = setInterval(function () {
      if (window.checkForExportCookieIntervalCleared) {
        clearInterval(checkForExportCookieIntervalId);

        if ($('.saveButton').length > 0) {
          $('.saveButton').button('reset');
          document.querySelector('.saveButton').classList.remove('active');
        }

        if ($('.onboardingModal').hasClass('in')) {
          $('.onboardingModal').on('hidden', function () {
            _reactCompatibility2.default.showDownloadOverlay();
          });
        } else {
          _reactCompatibility2.default.showDownloadOverlay();
        }
      }
    }, 500);
  }
};

exports.default = DownloadOverlayManager;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Banner = function (_React$Component) {
  _inherits(Banner, _React$Component);

  function Banner(props) {
    _classCallCheck(this, Banner);

    var _this = _possibleConstructorReturn(this, (Banner.__proto__ || Object.getPrototypeOf(Banner)).call(this, props));

    _this.state = {
      isVisible: _this.props.isVisible
    };

    _this.closeBtn = null;
    if (_this.props.isCloseable) {
      _this.closeBtn = _react2.default.createElement(
        'button',
        {
          onClick: _this.props.buttonClick,
          style: {
            border: 'none',
            display: 'inline-block',
            verticalAlign: 'middle',
            textAlign: 'center',
            padding: 0,
            fontSize: _this.props.fontSize,
            color: _this.props.buttonColor
          }
        },
        'x'
      );
    }
    return _this;
  }

  _createClass(Banner, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.isVisible !== nextProps.isVisible) {
        this.setState({ isVisible: nextProps.isVisible });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.isVisible) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        {
          className: this.props.className,
          style: Object.assign({}, this.props.style, { width: '100%' })
        },
        this.props.children,
        this.closeBtn
      );
    }
  }]);

  return Banner;
}(_react2.default.Component);

exports.default = Banner;


Banner.propTypes = {
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  isVisible: _propTypes2.default.bool,
  isCloseable: _propTypes2.default.bool,
  buttonClick: _propTypes2.default.func,
  fontSize: _propTypes2.default.number,
  buttonColor: _propTypes2.default.string,
  style: _propTypes2.default.shape()
};

Banner.defaultProps = {
  className: '',
  isVisible: true,
  isCloseable: true,
  buttonClick: null,
  fontSize: 14,
  buttonColor: '#000',
  style: null
};

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignaturePreview = __webpack_require__(141);

var _SignaturePreview2 = _interopRequireDefault(_SignaturePreview);

var _SignatureCreator = __webpack_require__(139);

var _SignatureCreator2 = _interopRequireDefault(_SignatureCreator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var uuidV4 = __webpack_require__(37);

var SignatureManager = function (_React$Component) {
  _inherits(SignatureManager, _React$Component);

  _createClass(SignatureManager, null, [{
    key: 'clearInput',
    value: function clearInput() {
      if (document.getElementById('sig-text')) {
        document.getElementById('sig-text').textContent = '';
      }
    }
  }, {
    key: 'getTypeInputValue',
    value: function getTypeInputValue() {
      var sigTextEl = document.getElementById('sig-text');
      // Skip if no input
      if (!sigTextEl || !sigTextEl.value) {
        return null;
      }
      return sigTextEl.value;
    }
  }]);

  function SignatureManager(props) {
    _classCallCheck(this, SignatureManager);

    var _this = _possibleConstructorReturn(this, (SignatureManager.__proto__ || Object.getPrototypeOf(SignatureManager)).call(this, props));

    _this.closeCreator = _this.closeCreator.bind(_this);
    _this.openCreator = _this.openCreator.bind(_this);
    _this.openUpload = _this.openUpload.bind(_this);
    _this.getPreviewData = _this.getPreviewData.bind(_this);
    _this.saveTypeSignature = _this.saveTypeSignature.bind(_this);
    _this.saveImageSignature = _this.saveImageSignature.bind(_this);
    _this.saveUploadImage = _this.saveUploadImage.bind(_this);
    _this.useSignature = _this.useSignature.bind(_this);
    _this.renderButtons = _this.renderButtons.bind(_this);
    _this.removeSignature = _this.removeSignature.bind(_this);
    _this.handleSignatureEnterPress = _this.handleSignatureEnterPress.bind(_this);

    _this.state = {
      displayCreator: false,
      creatorType: null
    };

    _this.isTouchDevice = !!('ontouchstart' in window) || !!(navigator.maxTouchPoints > 0);
    return _this;
  }

  _createClass(SignatureManager, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (!this.props.loadFromSave) {
        this.props.getSignatures(this.props.isSingleSignatureMode);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('keypress', this.handleSignatureEnterPress);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var displayCreatorDiffers = nextProps.displayCreator !== this.props.displayCreator;
      var creatorTypeDiffers = nextProps.creatorType !== this.props.creatorType;
      if (displayCreatorDiffers || creatorTypeDiffers) {
        this.setState({
          displayCreator: nextProps.displayCreator,
          creatorType: nextProps.creatorType
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('keypress', this.handleSignatureEnterPress);
    }
  }, {
    key: 'getPreviewData',
    value: function getPreviewData(previewType) {
      var _this2 = this;

      var imgSrc = this.props.imageUrls[previewType];
      var submitCreatorFunc = previewType === 'upload' ? this.openUpload : function () {
        _this2.openCreator(previewType);
      };

      return {
        imageUrl: imgSrc,
        type: previewType,
        visible: this.props.alwaysShowPreviewData || !this.state.displayCreator,
        buttonText: this.props.buttonText[previewType],
        buttonChildren: this.props.buttonChildren[previewType],
        forSigning: this.props.forSigning,
        submitCreator: submitCreatorFunc,
        submitPopup: function submitPopup(type, e) {
          _this2.props.imageClick(imgSrc, previewType, e);
        },
        submitClear: function submitClear(type, e) {
          _this2.removeSignature(e, previewType);
        },
        title: this.props.previewTitles[previewType]
      };
    }
  }, {
    key: 'handleSignatureEnterPress',
    value: function handleSignatureEnterPress(e) {
      if (this.props.isSelfServe && e.key === 'Enter') {
        this.useSignature(e);
      }
    }
  }, {
    key: 'removeSignature',
    value: function removeSignature(e, previewType) {
      if (this.props.preventFormSubmit) {
        // Prevent default form submit for self-serve
        e.preventDefault();
      }
      if (this.props.isSelfServe) {
        window._track('Remove Signature | Recipient Builder', 'Recipient Builder');
      }
      this.props.removeSignature(previewType);
      if (this.props.afterRemoveSignatureAction) {
        this.props.afterRemoveSignatureAction();
      }
    }
  }, {
    key: 'closeCreator',
    value: function closeCreator() {
      this.setState({ displayCreator: false, creatorType: null });
      if (this.props.closeCreatorAction) {
        this.props.closeCreatorAction();
      }
      setTimeout(window.setMainContainerHeight, 0);
    }
  }, {
    key: 'openCreator',
    value: function openCreator(type) {
      if (this.props.trackSelectFunction) {
        this.props.trackSelectFunction(type);
      }
      this.setState({ displayCreator: true, creatorType: type });
      if (this.props.openCreatorAction) {
        this.props.openCreatorAction();
      }
      setTimeout(window.setMainContainerHeight, 0);
    }
  }, {
    key: 'openUpload',
    value: function openUpload() {
      if (this.props.trackSelectFunction) {
        this.props.trackSelectFunction('upload');
      }
      this.uploadInput.click();
    }
  }, {
    key: 'attachImageToMouse',
    value: function attachImageToMouse(type) {
      var _this3 = this;

      var img = new Image();
      var imgSrc = this.props.imageUrls[type];
      img.src = imgSrc;
      img.onload = function () {
        _this3.props.createSigPopup(imgSrc, uuidV4(), window.getPageIndex(), img.width, 0, 0);
        window.attachImgToMouse();
      };
    }
  }, {
    key: 'saveTypeSignature',
    value: function saveTypeSignature(textVal) {
      var _this4 = this;

      this.props.saveTypeSignature(textVal, 'sig-text', this.props.isSingleSignatureMode).then(function () {
        SignatureManager.clearInput();
        _this4.setState({ displayCreator: false, creatorType: null });
        if (_this4.props.closeCreatorAction) {
          _this4.props.closeCreatorAction();
        }
        if (_this4.props.attachToMouse) {
          _this4.attachImageToMouse('type');
        }
        if (_this4.props.afterSaveSignatureAction) {
          _this4.props.afterSaveSignatureAction('type');
        }
      }).catch(function () {
        _this4.setState({ displayCreator: false, creatorType: null });
      });
    }
  }, {
    key: 'saveImageSignature',
    value: function saveImageSignature(imageSrc, type) {
      var _this5 = this;

      var signaturePayload = { sig_image: imageSrc };

      this.props.saveSignature(signaturePayload, type, this.props.isSingleSignatureMode).then(function () {
        _this5.setState({ displayCreator: false, creatorType: null });
        if (_this5.props.closeCreatorAction) {
          _this5.props.closeCreatorAction();
        }
        if (_this5.props.attachToMouse) {
          _this5.attachImageToMouse(type);
        }
        if (_this5.props.afterSaveSignatureAction) {
          _this5.props.afterSaveSignatureAction(type);
        }
      }).catch(function () {
        _this5.setState({ displayCreator: false, creatorType: null });
      });
    }
  }, {
    key: 'saveUploadImage',
    value: function saveUploadImage(e) {
      var _this6 = this;

      e.preventDefault();

      var reader = new FileReader();

      reader.readAsDataURL(e.target.files[0]);

      reader.onloadend = function () {
        _this6.saveImageSignature(reader.result, 'upload');
      };
      if (this.props.trackUsageFunction) {
        this.props.trackUsageFunction('upload');
      }
    }
  }, {
    key: 'useSignature',
    value: function useSignature(e) {
      if (this.props.preventFormSubmit) {
        // Prevent default form submit for self-serve
        e.preventDefault();
      }
      if (this.props.trackUsageFunction) {
        this.props.trackUsageFunction(this.state.creatorType);
      }
      switch (this.state.creatorType) {
        case 'type':
          {
            var typeValue = SignatureManager.getTypeInputValue();
            if (!typeValue) {
              return false;
            }
            this.saveTypeSignature(typeValue);
            break;
          }
        case 'draw':
          {
            var src = this.sigCreator.saveCanvas();
            this.saveImageSignature(src, 'draw');
            break;
          }
        default:
          return false;
      }

      return true;
    }
  }, {
    key: 'renderButtons',
    value: function renderButtons() {
      return this.state.displayCreator ? _react2.default.createElement(this.props.creatorButtons, _extends({
        closeCreator: this.closeCreator,
        useSignature: this.useSignature
      }, this.props.creatorButtonProps)) : _react2.default.createElement(this.props.previewButtons, _extends({
        imageUrls: this.props.imageUrls
      }, this.props.previewButtonProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var sigClass = '' + this.props.signatureManagerClass + (this.state.displayCreator ? ' ' + this.state.creatorType + '-creator' : '');

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: sigClass },
          this.props.types.type && _react2.default.createElement(_SignaturePreview2.default, this.getPreviewData('type')),
          this.props.types.draw && _react2.default.createElement(_SignaturePreview2.default, this.getPreviewData('draw')),
          this.props.types.upload && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(_SignaturePreview2.default, this.getPreviewData('upload')),
            _react2.default.createElement(
              'a',
              { style: { display: 'none' } },
              _react2.default.createElement('input', {
                type: 'file',
                name: 'file',
                accept: 'image/*',
                ref: function ref(input) {
                  _this7.uploadInput = input;
                },
                onChange: function onChange(e) {
                  _this7.saveUploadImage(e);
                }
              })
            )
          ),
          _react2.default.createElement(_SignatureCreator2.default, {
            type: this.state.creatorType,
            visible: this.state.displayCreator,
            isTouchDevice: this.isTouchDevice,
            typeLabel: this.props.typeCreatorLabel,
            drawLabel: this.props.drawCreatorLabel,
            clearBtnText: this.props.clearBtnText,
            sigPadHeight: this.props.sigPadHeight,
            sigPadWidth: this.props.sigPadWidth,
            ref: function ref(c) {
              _this7.sigCreator = c;
            }
          })
        ),
        _react2.default.createElement(
          'div',
          { className: this.props.buttonClass },
          this.renderButtons()
        )
      );
    }
  }]);

  return SignatureManager;
}(_react2.default.Component);

exports.default = SignatureManager;


SignatureManager.propTypes = {
  alwaysShowPreviewData: _propTypes2.default.bool,
  afterRemoveSignatureAction: _propTypes2.default.func,
  afterSaveSignatureAction: _propTypes2.default.func,
  attachToMouse: _propTypes2.default.bool,
  buttonChildren: _propTypes2.default.shape({
    type: _propTypes2.default.node,
    draw: _propTypes2.default.node,
    upload: _propTypes2.default.node
  }),
  buttonClass: _propTypes2.default.string,
  buttonText: _propTypes2.default.shape({
    type: _propTypes2.default.string,
    draw: _propTypes2.default.string,
    upload: _propTypes2.default.string
  }),
  clearBtnText: _propTypes2.default.string,
  closeCreatorAction: _propTypes2.default.func,
  createSigPopup: _propTypes2.default.func,
  creatorButtonProps: _propTypes2.default.shape(),
  creatorType: _propTypes2.default.string,
  displayCreator: _propTypes2.default.bool,
  drawCreatorLabel: _propTypes2.default.string,
  forSigning: _propTypes2.default.bool,
  getSignatures: _propTypes2.default.func.isRequired,
  imageClick: _propTypes2.default.func,
  imageUrls: _propTypes2.default.shape({
    draw: _propTypes2.default.string,
    type: _propTypes2.default.string,
    upload: _propTypes2.default.string
  }).isRequired,
  isSelfServe: _propTypes2.default.bool,
  isSingleSignatureMode: _propTypes2.default.bool,
  loadFromSave: _propTypes2.default.bool,
  openCreatorAction: _propTypes2.default.func,
  preventFormSubmit: _propTypes2.default.bool,
  previewButtonProps: _propTypes2.default.shape(),
  previewTitles: _propTypes2.default.shape({
    type: _propTypes2.default.string,
    draw: _propTypes2.default.string,
    upload: _propTypes2.default.string
  }),
  removeSignature: _propTypes2.default.func.isRequired,
  saveSignature: _propTypes2.default.func.isRequired,
  saveTypeSignature: _propTypes2.default.func.isRequired,
  signatureManagerClass: _propTypes2.default.string,
  sigPadHeight: _propTypes2.default.number,
  sigPadWidth: _propTypes2.default.number,
  trackSelectFunction: _propTypes2.default.func,
  trackUsageFunction: _propTypes2.default.func,
  typeCreatorLabel: _propTypes2.default.string,
  types: _propTypes2.default.shape({
    draw: _propTypes2.default.bool,
    type: _propTypes2.default.bool,
    upload: _propTypes2.default.bool
  })
};

SignatureManager.defaultProps = {
  alwaysShowPreviewData: false,
  afterRemoveSignatureAction: null,
  afterSaveSignatureAction: null,
  attachToMouse: false,
  buttonChildren: {
    type: null,
    draw: null,
    upload: null
  },
  buttonClass: 'buttons',
  buttonText: {
    type: null,
    draw: null,
    upload: null
  },
  clearBtnText: 'Clear',
  closeCreatorAction: null,
  createSigPopup: null,
  creatorButtons: null,
  creatorButtonProps: null,
  creatorType: null,
  displayCreator: false,
  drawCreatorLabel: null,
  forSigning: false,
  imageClick: function imageClick() {},
  isSelfServe: false,
  isSingleSignatureMode: false,
  loadFromSave: false,
  openCreatorAction: null,
  preventFormSubmit: false,
  previewButtons: null,
  previewButtonProps: null,
  previewTitles: {
    type: null,
    draw: null,
    upload: null
  },
  signatureManagerClass: '',
  sigPadHeight: null,
  sigPadWidth: null,
  trackSelectFunction: null,
  trackUsageFunction: null,
  typeCreatorLabel: null,
  types: {
    draw: false,
    type: false,
    upload: false
  }
};

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Typography = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnswerQuestionTooltipContent = function AnswerQuestionTooltipContent() {
  return _react2.default.createElement(
    'div',
    {
      className: 'recipient-preview-tour-tooltip-content recipient-preview-answer-question-tooltip'
    },
    _react2.default.createElement(
      _Typography.HeadingD,
      { className: 'recipient-preview-answer-question-tooltip-heading' },
      'The fillable field you\u2019ve created is now in a questionnaire format for recipients!'
    ),
    _react2.default.createElement(
      _Typography.ProductContent,
      {
        className: 'recipient-preview-answer-question-tooltip-text',
        variation: 'small'
      },
      'Try answering as a recipient.'
    )
  );
};

exports.default = AnswerQuestionTooltipContent;

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _Buttons = __webpack_require__(12);

var _Typography = __webpack_require__(48);

var _SelfServeBuilderActions = __webpack_require__(41);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RecipientPreviewEmptyStateTooltip = function (_React$Component) {
  _inherits(RecipientPreviewEmptyStateTooltip, _React$Component);

  function RecipientPreviewEmptyStateTooltip(props) {
    _classCallCheck(this, RecipientPreviewEmptyStateTooltip);

    var _this = _possibleConstructorReturn(this, (RecipientPreviewEmptyStateTooltip.__proto__ || Object.getPrototypeOf(RecipientPreviewEmptyStateTooltip)).call(this, props));

    _this.closeRecipientPreview = _this.closeRecipientPreview.bind(_this);
    return _this;
  }

  _createClass(RecipientPreviewEmptyStateTooltip, [{
    key: 'closeRecipientPreview',
    value: function closeRecipientPreview() {
      this.props.setIsRecipientPreviewModalVisible(false);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'recipient-preview-empty-state-tooltip' },
        _react2.default.createElement('img', {
          alt: 'what-is-your-name-illustration',
          className: 'what-is-your-name-illustration',
          src: '/images/self-serve-builder/what-is-your-name-illustration.png'
        }),
        _react2.default.createElement(
          _Typography.ProductContent,
          {
            className: 'self-serve-empty-state-tooltip-text',
            variation: 'smallest'
          },
          'Your recipient will see your fillable field label in this questionnaire format.'
        ),
        _react2.default.createElement(
          _Typography.ProductContent,
          {
            className: 'self-serve-empty-state-tooltip-text bold',
            variation: 'smallest'
          },
          'To test the recipient preview:'
        ),
        _react2.default.createElement(
          _Buttons.PrimaryButton,
          {
            className: 'back-to-fillable-fields-btn',
            onClick: this.closeRecipientPreview
          },
          'Go Back and Add Fillable Fields'
        )
      );
    }
  }]);

  return RecipientPreviewEmptyStateTooltip;
}(_react2.default.Component);

RecipientPreviewEmptyStateTooltip.propTypes = {
  setIsRecipientPreviewModalVisible: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setIsRecipientPreviewModalVisible: _SelfServeBuilderActions.setIsRecipientPreviewModalVisible
  }, dispatch);
};

var RecipientPreviewEmptyStateTooltipWithRedux = ReactRedux.connect(null, mapDispatchToProps)(RecipientPreviewEmptyStateTooltip);

exports.default = RecipientPreviewEmptyStateTooltipWithRedux;

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StaticBuilderField = __webpack_require__(31);

var _StaticBuilderField2 = _interopRequireDefault(_StaticBuilderField);

var _CalendarFieldInput = __webpack_require__(251);

var _CalendarFieldInput2 = _interopRequireDefault(_CalendarFieldInput);

var _CalendarFieldDatePicker = __webpack_require__(250);

var _CalendarFieldDatePicker2 = _interopRequireDefault(_CalendarFieldDatePicker);

var _Utils = __webpack_require__(18);

var _Icons = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CalendarField = function (_React$Component) {
  _inherits(CalendarField, _React$Component);

  function CalendarField(props) {
    _classCallCheck(this, CalendarField);

    var _this = _possibleConstructorReturn(this, (CalendarField.__proto__ || Object.getPrototypeOf(CalendarField)).call(this, props));

    var initialDate = new Date(_this.props.value);
    if (isNaN(initialDate.getTime())) {
      initialDate = new Date();
    }

    _this.state = {
      date: initialDate,
      showCalendar: false
    };

    _this.onClickDay = _this.onClickTile.bind(_this);
    _this.onClickMonth = _this.onClickTile.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onMouseDown = _this.onMouseDown.bind(_this);
    _this.getDayAbbreviation = _this.getDayAbbreviation.bind(_this);
    _this.getNextLabel = _this.getNavigationLabel.bind(_this, true);
    _this.getPrevLabel = _this.getNavigationLabel.bind(_this, false);
    return _this;
  }

  _createClass(CalendarField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.onMouseDown);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.onMouseDown);
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.setState({
        showCalendar: true
      });
    }
  }, {
    key: 'onMouseDown',
    value: function onMouseDown(e) {
      if (!this.datepickerContainer.contains(e.target)) {
        this.setState({
          showCalendar: false
        });
      }
    }
  }, {
    key: 'onClickTile',
    value: function onClickTile(date) {
      var dateChosen = void 0;
      if (this.props.isMobileOptimization) {
        dateChosen = (0, _Utils.formatDate)(date, false);
      } else {
        dateChosen = (0, _Utils.formatDate)(date);
      }

      this.props.onChange({
        target: {
          value: dateChosen
        }
      });
      this.setState({
        date: date,
        showCalendar: false
      });
    }
  }, {
    key: 'getDayAbbreviation',
    value: function getDayAbbreviation(value) {
      if (this.props.isMobileOptimization) {
        var dayLetters = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
        return dayLetters[value.getDay()];
      }
      return value.toString().substring(0, 2);
    }
  }, {
    key: 'getNavigationLabel',
    value: function getNavigationLabel(isNext) {
      if (this.props.isMobileOptimization) {
        if (isNext) {
          return _react2.default.createElement(_Icons.ArrowRightIcon, { className: 'ds-icon-inherit-color calendar-next-arrow' });
        }
        return _react2.default.createElement(_Icons.ArrowLeftIcon, { className: 'ds-icon-inherit-color calendar-previous-arrow' });
      }
      return undefined;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var placeholder = '';

      if (!this.props.value) {
        var today = new Date();

        if (this.props.isMobileOptimization) {
          placeholder = (0, _Utils.formatDate)(today, false);
        } else {
          placeholder = (0, _Utils.formatDate)(today);
        }
      }

      var datepickerTypes = ['calendar', 'month'];
      var datepickerType = this.props.datepickerType;
      if (datepickerTypes.indexOf(this.props.datepickerType) < 0) {
        datepickerType = 'calendar';
      }

      var datepickerTypeToMaxDetailType = {
        calendar: 'month',
        month: 'year'
      };

      return _react2.default.createElement(
        'div',
        {
          className: 'calendar-field-container',
          ref: function ref(node) {
            _this2.datepickerContainer = node;
          }
        },
        _react2.default.createElement(_CalendarFieldInput2.default, {
          datepickerType: datepickerType,
          id: this.props.id,
          isMobileOptimization: this.props.isMobileOptimization,
          onChange: this.props.onChange,
          onFocus: this.onFocus,
          placeholder: placeholder,
          value: this.props.value
        }),
        _react2.default.createElement(_CalendarFieldDatePicker2.default, {
          date: this.state.date,
          getDayAbbreviation: this.getDayAbbreviation,
          getNextLabel: this.getNextLabel,
          getPrevLabel: this.getPrevLabel,
          isMobileOptimization: this.props.isMobileOptimization,
          maxDetail: datepickerTypeToMaxDetailType[this.props.datepickerType],
          onClickDay: this.onClickDay,
          onClickMonth: this.onClickMonth,
          showCalendar: this.state.showCalendar
        })
      );
    }
  }]);

  return CalendarField;
}(_react2.default.Component);

CalendarField.defaultProps = {
  isMobileOptimization: false,
  value: '',
  datepickerType: 'calendar'
};

CalendarField.propTypes = {
  id: _propTypes2.default.string.isRequired,
  isMobileOptimization: _propTypes2.default.bool,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  datepickerType: _propTypes2.default.string
};

exports.default = (0, _StaticBuilderField2.default)(CalendarField);

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LineBreak = function LineBreak(props) {
  return _react2.default.createElement(
    'div',
    { className: 'controls' },
    _react2.default.createElement('hr', { id: props.id })
  );
};

LineBreak.propTypes = {
  id: _propTypes2.default.string.isRequired
};

exports.default = (0, _WithInit2.default)(LineBreak);

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavSideBarListItem = function (_React$PureComponent) {
  _inherits(NavSideBarListItem, _React$PureComponent);

  function NavSideBarListItem(props) {
    _classCallCheck(this, NavSideBarListItem);

    var _this = _possibleConstructorReturn(this, (NavSideBarListItem.__proto__ || Object.getPrototypeOf(NavSideBarListItem)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  _createClass(NavSideBarListItem, [{
    key: 'onClick',
    value: function onClick(e) {
      e.preventDefault();
      this.props.loadStaticBuilderSection(this.props.screenIdx);
      window._track(this.props.documentType + ' | Builder', this.props.section + ' | Menu');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'li',
        { className: this.props.className },
        !this.props.offsiteBuilder && _react2.default.createElement(
          'span',
          { className: 'builder-navbar-number' },
          this.props.title
        ),
        _react2.default.createElement(
          'a',
          {
            className: 'navbar-item-link',
            href: '',
            onClick: this.onClick,
            style: {
              overflow: 'hidden'
            }
          },
          this.props.section
        ),
        !this.props.offsiteBuilder && _react2.default.createElement('img', {
          alt: 'check',
          className: 'builder-navbar-img',
          src: window.cdnUrl + '/images/icons/icon-nav-confirm.png'
        })
      );
    }
  }]);

  return NavSideBarListItem;
}(_react2.default.PureComponent);

NavSideBarListItem.defaultProps = {
  className: '',
  offsiteBuilder: false
};

NavSideBarListItem.propTypes = {
  className: _propTypes2.default.string,
  documentType: _propTypes2.default.string.isRequired,
  loadStaticBuilderSection: _propTypes2.default.func.isRequired,
  offsiteBuilder: _propTypes2.default.bool,
  screenIdx: _propTypes2.default.number.isRequired,
  section: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired
};

exports.default = NavSideBarListItem;

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var categoryButtonStyle = {
  color: '#37455b',
  fontSize: '14px',
  fontWeight: 'bold',
  width: '100%',
  textAlign: 'left',
  overflow: 'visible'
};

var NavSideBarListSectionHeader = function (_React$PureComponent) {
  _inherits(NavSideBarListSectionHeader, _React$PureComponent);

  function NavSideBarListSectionHeader() {
    _classCallCheck(this, NavSideBarListSectionHeader);

    return _possibleConstructorReturn(this, (NavSideBarListSectionHeader.__proto__ || Object.getPrototypeOf(NavSideBarListSectionHeader)).apply(this, arguments));
  }

  _createClass(NavSideBarListSectionHeader, [{
    key: 'render',
    value: function render() {
      var content = this.props.children;

      if (this.props.onClick) {
        content = _react2.default.createElement(
          'button',
          {
            className: 'nav-header-button ' + this.props.className,
            style: categoryButtonStyle,
            onClick: this.props.onClick
          },
          this.props.children
        );
      }

      return _react2.default.createElement(
        'li',
        { className: 'nav-header ' + this.props.className },
        content
      );
    }
  }]);

  return NavSideBarListSectionHeader;
}(_react2.default.PureComponent);

exports.default = NavSideBarListSectionHeader;


NavSideBarListSectionHeader.defaultProps = {
  onClick: null,
  className: ''
};

NavSideBarListSectionHeader.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.node.isRequired
};

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavSideBarListWithSectionsWithRedux = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _store = __webpack_require__(25);

var _store2 = _interopRequireDefault(_store);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _AnimationActions = __webpack_require__(213);

var AnimationActions = _interopRequireWildcard(_AnimationActions);

var _CustomPropTypes = __webpack_require__(19);

var _CustomPropTypes2 = _interopRequireDefault(_CustomPropTypes);

var _StaticBuilderActions = __webpack_require__(24);

var StaticBuilderActions = _interopRequireWildcard(_StaticBuilderActions);

var _actions = __webpack_require__(218);

var StaticBuilderModalActions = _interopRequireWildcard(_actions);

var _NavSideBarListWithSections = __webpack_require__(172);

var _NavSideBarListWithSections2 = _interopRequireDefault(_NavSideBarListWithSections);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavSideBarList = function (_React$PureComponent) {
  _inherits(NavSideBarList, _React$PureComponent);

  function NavSideBarList(props) {
    _classCallCheck(this, NavSideBarList);

    var _this = _possibleConstructorReturn(this, (NavSideBarList.__proto__ || Object.getPrototypeOf(NavSideBarList)).call(this, props));

    _this.onLoadStaticBuilderSection = _this.onLoadStaticBuilderSection.bind(_this);
    return _this;
  }

  _createClass(NavSideBarList, [{
    key: 'onLoadStaticBuilderSection',
    value: function onLoadStaticBuilderSection(step) {
      var self = this;
      var successAction = function successAction() {
        window.scrollTo(0, 0);
        self.props.loadStaticBuilderSection(step);
      };

      window.SessionManager.save(successAction);
    }
  }, {
    key: 'render',
    value: function render() {
      var categories = {};
      var self = this;
      Object.keys(this.props.fieldOutline || {}).forEach(function (categoryKey) {
        categories[categoryKey] = Object.keys(self.props.fieldOutline[categoryKey]);
      });

      return _react2.default.createElement(_NavSideBarListWithSections2.default, _extends({}, this.props, {
        categories: categories,
        onStep: this.props.onStep,
        loadStaticBuilderSection: this.onLoadStaticBuilderSection
      }));
    }
  }]);

  return NavSideBarList;
}(_react2.default.PureComponent);

NavSideBarList.defaultProps = {
  fieldData: {},
  fieldOutline: null,
  onStep: 0,
  releaseType: ''
};

NavSideBarList.propTypes = {
  fieldOutline: _CustomPropTypes2.default.hashmapOf(_CustomPropTypes2.default.hashmapOf(_propTypes2.default.shape({
    header: _propTypes2.default.string,
    fields: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.string,
      label: _propTypes2.default.string,
      options: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.shape({
        text: _propTypes2.default.string,
        value: _propTypes2.default.string
      })), _propTypes2.default.string]),
      type: _propTypes2.default.string
    }))
  }))),
  onStep: _propTypes2.default.number,
  releaseType: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(_ref) {
  var StaticBuilderReducer = _ref.StaticBuilderReducer;
  return {
    releaseType: StaticBuilderReducer.fieldData.release_type,
    fieldOutline: StaticBuilderReducer.fieldOutline,
    onStep: StaticBuilderReducer.step
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadStaticBuilderSection: StaticBuilderActions.loadStaticBuilderSection
  }, dispatch);
};

var NavSideBarListWithSectionsWithRedux = exports.NavSideBarListWithSectionsWithRedux = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(NavSideBarList);

if (window.FormSwift && window.FormSwift.React) {
  var addedActions = Object.assign({}, _extends({}, AnimationActions, StaticBuilderActions, StaticBuilderModalActions), window.FormSwift.React.actions);
  window.FormSwift.React.actions = addedActions;
} else {
  window.FormSwift = {
    React: {
      store: _store2.default,
      actions: _extends({}, AnimationActions, StaticBuilderActions, StaticBuilderModalActions)
    }
  };
}

exports.default = (0, _WithInit2.default)(NavSideBarListWithSectionsWithRedux, true);

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StaticBuilderField = __webpack_require__(31);

var _StaticBuilderField2 = _interopRequireDefault(_StaticBuilderField);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioButton = function (_React$PureComponent) {
  _inherits(RadioButton, _React$PureComponent);

  function RadioButton(props) {
    _classCallCheck(this, RadioButton);

    var _this = _possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call(this, props));

    _this.isChecked = _this.isChecked.bind(_this);
    return _this;
  }

  _createClass(RadioButton, [{
    key: 'isChecked',
    value: function isChecked(_ref) {
      var id = _ref.id,
          value = _ref.value;

      if (id) {
        return this.props.value === id;
      }

      return this.props.value === value;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        this.props.options.map(function (option, idx) {
          return _react2.default.createElement(
            _react2.default.Fragment,
            { key: option.value },
            _react2.default.createElement(
              'label',
              {
                className: 'radio inline',
                htmlFor: '' + _this2.props.id + idx
              },
              option.text
            ),
            _react2.default.createElement('input', {
              onChange: _this2.props.onChange,
              type: 'radio',
              className: 'input-large radio inline',
              id: '' + _this2.props.id + idx,
              name: _this2.props.id,
              value: option.value,
              checked: _this2.isChecked(option)
            })
          );
        })
      );
    }
  }]);

  return RadioButton;
}(_react2.default.PureComponent);

RadioButton.defaultProps = {
  value: ''
};

RadioButton.propTypes = {
  id: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string,
    value: _propTypes2.default.string
  })).isRequired
};

exports.default = (0, _StaticBuilderField2.default)(RadioButton);

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticBuilderDocumentPreviewTitle = function StaticBuilderDocumentPreviewTitle(props) {
  var titleClass = (0, _classnames2.default)('document-preview-title', 'static-builder', props.titleClass);
  return _react2.default.createElement(
    'h2',
    { className: titleClass },
    props.titleText
  );
};

StaticBuilderDocumentPreviewTitle.defaultProps = {
  titleClass: '',
  titleText: 'DOCUMENT PREVIEW'
};

StaticBuilderDocumentPreviewTitle.propTypes = {
  titleClass: _propTypes2.default.string,
  titleText: _propTypes2.default.string
};

exports.default = (0, _WithInit2.default)(StaticBuilderDocumentPreviewTitle);

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticBuilderForm = exports.support = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _TooltipTourActions = __webpack_require__(171);

var _StaticBuilderActions = __webpack_require__(24);

var _StaticBuilderSaveButton = __webpack_require__(264);

var _StaticBuilderSaveButton2 = _interopRequireDefault(_StaticBuilderSaveButton);

var _StaticBuilderBackButton = __webpack_require__(259);

var _StaticBuilderBackButton2 = _interopRequireDefault(_StaticBuilderBackButton);

var _Utils = __webpack_require__(42);

var _components = __webpack_require__(58);

var _StaticBuilderFormattedFields = __webpack_require__(51);

var _StaticBuilderFormattedFields2 = _interopRequireDefault(_StaticBuilderFormattedFields);

var _StaticBuilderFormField = __webpack_require__(261);

var _StaticBuilderFormField2 = _interopRequireDefault(_StaticBuilderFormField);

var _StaticBuilderAddAnotherButton = __webpack_require__(258);

var _StaticBuilderAddAnotherButton2 = _interopRequireDefault(_StaticBuilderAddAnotherButton);

var _StaticBuilderSignatureManager = __webpack_require__(268);

var _StaticBuilderSignatureManager2 = _interopRequireDefault(_StaticBuilderSignatureManager);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Event listener manipulation cannot be effectively stubbed for testing, but these wrappers can.
var support = exports.support = {
  addEventListener: function addEventListener() {
    var _window;

    return (_window = window).addEventListener.apply(_window, arguments);
  },
  removeEventListener: function removeEventListener() {
    var _window2;

    return (_window2 = window).removeEventListener.apply(_window2, arguments);
  }
};

var StaticBuilderForm = exports.StaticBuilderForm = function (_React$Component) {
  _inherits(StaticBuilderForm, _React$Component);

  _createClass(StaticBuilderForm, null, [{
    key: 'getMemberTracking',
    value: function getMemberTracking() {
      if (window.COOKIE.get('member') === '1') {
        return '-Member';
      }
      return '';
    }
  }, {
    key: 'onAddAdditonalGroup',
    value: function onAddAdditonalGroup() {
      window.FormManager.addAnotherItem('groupMultiple');
    }
  }, {
    key: 'getBuilderStepFromUrlHash',
    value: function getBuilderStepFromUrlHash() {
      return window.location.hash.split('#')[1] ? parseInt(window.location.hash.split('#')[1], 10) : null;
    }
  }]);

  function StaticBuilderForm(props) {
    _classCallCheck(this, StaticBuilderForm);

    var _this = _possibleConstructorReturn(this, (StaticBuilderForm.__proto__ || Object.getPrototypeOf(StaticBuilderForm)).call(this, props));

    _this.state = {
      isSaveButtonHidden: false,
      isSignatureAdded: false,
      shouldClosePreview: false
    };
    _this.onBack = _this.onBack.bind(_this);
    _this.clickNextButton = _this.clickNextButton.bind(_this);
    _this.onContinue = _this.onContinue.bind(_this);
    _this.onSign = _this.onSign.bind(_this);
    _this.isLastStep = _this.isLastStep.bind(_this);
    _this.getSaveButtonContent = _this.getSaveButtonContent.bind(_this);
    _this.getFormattedField = _this.getFormattedField.bind(_this);
    _this.isSignatureType = _this.isSignatureType.bind(_this);
    _this.hideSaveButton = _this.hideSaveButton.bind(_this);
    _this.showSaveButton = _this.showSaveButton.bind(_this);
    _this.setIsSignatureAdded = _this.setIsSignatureAdded.bind(_this);
    _this.handleEnterPress = _this.handleEnterPress.bind(_this);
    _this.isSignatureRequired = _this.isSignatureRequired.bind(_this);
    _this.handlePreviewModalState = _this.handlePreviewModalState.bind(_this);
    _this.onHashChange = _this.onHashChange.bind(_this);
    _this.setCurrentFieldValue = _this.setCurrentFieldValue.bind(_this);
    _this.trackWaiverSelection = _this.trackWaiverSelection.bind(_this);

    window.location.hash = _this.props.onStep;

    _this.currentFieldValue = null;
    return _this;
  }

  _createClass(StaticBuilderForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.FormManager.hideUnnecessarySubSections('groupMultiple');
      if (this.props.inlineConditionals) {
        this.props.inlineConditionals();
      }
      support.addEventListener('keypress', this.handleEnterPress);
      support.addEventListener('hashchange', this.onHashChange);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.isBackClicked) {
        this.onBack();
        this.props.setStaticBuilderBackButton(false);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      support.removeEventListener('keypress', this.handleEnterPress);
      support.removeEventListener('hashchange', this.onHashChange);
    }
  }, {
    key: 'onHashChange',
    value: function onHashChange() {
      var nextStep = StaticBuilderForm.getBuilderStepFromUrlHash();
      if (nextStep >= 0 && nextStep < this.props.onStep) {
        this.props.loadPreviousStaticBuilderSection();
        window._track('Section ' + (this.props.onStep + 1) + ' | Browser Back Button', this.props.documentType + ' | Builder' + StaticBuilderForm.getMemberTracking());
      }
    }
  }, {
    key: 'onBack',
    value: function onBack() {
      this.showSaveButton();
      this.props.loadPreviousStaticBuilderSection();
      window._track('Section ' + (this.props.onStep + 1) + ' | Back Button', this.props.documentType + ' | Builder' + StaticBuilderForm.getMemberTracking());
    }
  }, {
    key: 'onContinue',
    value: function onContinue() {
      this.handlePreviewModalState();
      this.props.saveAndContinue();

      var trackingSaveCategory = 'Save And Continue';
      if (this.isLastStep()) {
        if (this.props.isSelfServe && !this.props.isPreviewMode) {
          this.props.finishSelfServe();
          return;
        }
        trackingSaveCategory = 'Save And Export';
      }

      if (this.props.isSelfServe && this.props.isPreviewMode) {
        window._track('Save and Continue | Preview Modal', 'Template Builder');
      } else {
        window._track('Section ' + (this.props.onStep + 1) + ' | ' + trackingSaveCategory, this.props.documentType + ' | Builder' + StaticBuilderForm.getMemberTracking());
      }
    }
  }, {
    key: 'onSign',
    value: function onSign() {
      if (this.state.isSignatureAdded) {
        // save signature field
        this.handlePreviewModalState();
        this.props.saveAndSign(this.getFormattedField().field.id);
      }
      if (this.props.isSelfServe && this.props.isPreviewMode) {
        this.props.showNextTip();
      }
    }
  }, {
    key: 'setCurrentFieldValue',
    value: function setCurrentFieldValue(value) {
      this.currentFieldValue = value;
    }
  }, {
    key: 'getSaveButtonContent',
    value: function getSaveButtonContent() {
      var _props = this.props,
          isSelfServe = _props.isSelfServe,
          isPreviewMode = _props.isPreviewMode;

      var buttonContent = 'Save & Continue';
      if (this.isLastStep()) {
        if (isSelfServe && isPreviewMode && this.state.shouldClosePreview) {
          buttonContent = 'Close Recipient View';
        } else if (!isPreviewMode && (this.isSignatureType() || isSelfServe)) {
          buttonContent = 'Finish & Send';
        } else if (!isSelfServe) {
          buttonContent = 'Save & Export';
        }
      }

      return buttonContent;
    }
  }, {
    key: 'getFormattedField',
    value: function getFormattedField() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      return this.props.formattedFields.getAllFormattedFields()[index];
    }
  }, {
    key: 'setIsSignatureAdded',
    value: function setIsSignatureAdded(state) {
      this.setState({
        isSignatureAdded: state
      });
    }
  }, {
    key: 'handlePreviewModalState',
    value: function handlePreviewModalState() {
      var _props2 = this.props,
          isSelfServe = _props2.isSelfServe,
          isPreviewMode = _props2.isPreviewMode;

      if (isSelfServe && isPreviewMode && this.isLastStep()) {
        this.setState({
          shouldClosePreview: true
        });
      }
    }
  }, {
    key: 'trackWaiverSelection',
    value: function trackWaiverSelection() {
      var _props3 = this.props,
          documentType = _props3.documentType,
          onStep = _props3.onStep;

      var formattedField = this.getFormattedField();
      var fieldValue = this.currentFieldValue || formattedField && formattedField.field && formattedField.field.initialValue;
      var isGeneralForm = fieldValue === 'general_form';
      var isSpecificForm = fieldValue === 'specific_participant';
      if ((0, _Utils.isGetLinkType)(documentType) && onStep === 3) {
        if (isGeneralForm) {
          window._track('Reuseable General Waiver', documentType + ' | Static-builder-member');
        } else if (isSpecificForm) {
          window._track('Specific Waiver', documentType + ' | Static-builder-member');
        }
      }
    }
  }, {
    key: 'clickNextButton',
    value: function clickNextButton() {
      this.trackWaiverSelection();
      if (this.isLastStep() && this.props.showRequestSignature === false) {
        var documentType = this.props.documentType;

        window.exportStaticWithURL('No One | Request Signature Section', documentType, 'export/pdf.php' + window.location.search);
        var clearProgressBarInterval = setInterval(function () {
          if (document.getElementById('saveBarObj').style.visibility !== 'hidden') {
            $('#saveBarObj').fadeOut();
            clearInterval(clearProgressBarInterval);
          }
        }, 500);
        setTimeout(function () {
          return $('.saveButton').button('reset');
        }, 1000);
        return;
      }
      if (this.props.isSelfServe && this.props.isPreviewMode) {
        this.props.showNextTip();
      }
      var _props4 = this.props,
          isSelfServe = _props4.isSelfServe,
          finishSelfServe = _props4.finishSelfServe,
          isPreviewMode = _props4.isPreviewMode;

      var isFinishAvailable = !isPreviewMode || isPreviewMode && this.state.shouldClosePreview;
      if (this.isLastStep() && isSelfServe && isFinishAvailable) {
        finishSelfServe();
      } else {
        this.onContinue();
      }
    }

    // Capture the Enter button and treat it as clicking CTA

  }, {
    key: 'handleEnterPress',
    value: function handleEnterPress(e) {
      var _props5 = this.props,
          isSelfServe = _props5.isSelfServe,
          finishSelfServe = _props5.finishSelfServe,
          isPreviewMode = _props5.isPreviewMode;

      // Either it is a signature section and has been prepopulated or it's not a signature section

      var shouldContinue = this.state.isSignatureAdded || !this.isSignatureType();

      // Either it is not in preview mode or it is and Save & Continue has been pressed
      var isFinishAvailable = !isPreviewMode || isPreviewMode && this.state.shouldClosePreview;

      if (isSelfServe && e.key === 'Enter' && shouldContinue) {
        e.preventDefault();

        if (isSelfServe && isPreviewMode) {
          this.props.showNextTip();
        }

        if (this.isSignatureRequired()) {
          this.onSign();
        } else if (this.isLastStep() && isFinishAvailable) {
          finishSelfServe();
        } else {
          this.onContinue();
        }
      }
    }
  }, {
    key: 'isSignatureRequired',
    value: function isSignatureRequired() {
      var formattedField = this.getFormattedField();

      // Show the sign button instead of save and continue buttons
      return this.isSignatureType() && formattedField && formattedField.field && formattedField.field.initialValue && !(formattedField.field.initialValue.type || formattedField.field.initialValue.draw);
    }
  }, {
    key: 'isLastStep',
    value: function isLastStep() {
      if (this.props.showRequestSignature === false) {
        return this.props.sectionKeys.length - 1 === this.props.onStep;
      }
      return (window.secondPresence || !window.User.isLoggedIn || this.props.isSelfServe) && !window.showRequestSignature && this.props.sectionKeys.length - 1 === this.props.onStep;
    }
  }, {
    key: 'isSignatureType',
    value: function isSignatureType() {
      var formattedField = this.getFormattedField();

      return formattedField && formattedField.field && formattedField.field.type === 'signature';
    }
  }, {
    key: 'hideSaveButton',
    value: function hideSaveButton() {
      this.setState({
        isSaveButtonHidden: true
      });
    }
  }, {
    key: 'showSaveButton',
    value: function showSaveButton() {
      this.setState({
        isSaveButtonHidden: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'form',
        { id: 'staticBuilderForm', className: 'form-vertical static-builder-form' },
        _react2.default.createElement(
          'fieldset',
          null,
          this.props.formattedFields.getAllFormattedFields().map(function (formattedField, i) {
            if (formattedField.isMultiple) {
              return _react2.default.createElement(
                _react2.default.Fragment,
                { key: formattedField.fields[0].id },
                _react2.default.createElement(
                  'div',
                  { className: 'groupMultiple' },
                  formattedField.fields.map(function (field) {
                    return _react2.default.createElement(_StaticBuilderFormField2.default, {
                      key: 'groupMultiple-' + field.id,
                      field: field
                    });
                  })
                ),
                formattedField.isEndOfMultiple && _react2.default.createElement(_StaticBuilderAddAnotherButton2.default, {
                  onAddAdditonalGroup: StaticBuilderForm.onAddAdditonalGroup
                })
              );
            }

            if (formattedField.field && formattedField.field.type === 'signature') {
              return _react2.default.createElement(
                _components.ElementWithAnswerQuestionTooltip,
                {
                  targetElementType: formattedField.field.type
                },
                _react2.default.createElement(_StaticBuilderSignatureManager2.default, {
                  isSelfServe: _this2.props.isSelfServe,
                  key: formattedField.field.id,
                  onSign: _this2.onSign,
                  signatureActions: {
                    openCreatorAction: _this2.hideSaveButton,
                    closeCreatorAction: _this2.showSaveButton,
                    isSaveButtonHidden: _this2.state.isSaveButtonHidden
                  },
                  savedSignature: formattedField.field.initialValue || {},
                  setIsSignatureAdded: _this2.setIsSignatureAdded,
                  isSignatureAdded: _this2.state.isSignatureAdded
                })
              );
            }
            return _react2.default.createElement(_StaticBuilderFormField2.default, {
              key: formattedField.field.id,
              field: formattedField.field,
              fieldNumber: i,
              setCurrentFieldValue: _this2.setCurrentFieldValue
            });
          }),
          _react2.default.createElement(
            'div',
            { className: 'form-actions' },
            this.props.onStep > 0 && _react2.default.createElement(_StaticBuilderBackButton2.default, {
              onBack: this.onBack
            }),
            _react2.default.createElement(_StaticBuilderSaveButton2.default, {
              buttonContent: this.getSaveButtonContent(),
              clickNextButton: this.clickNextButton,
              documentType: this.props.documentType,
              isHidden: this.state.isSaveButtonHidden,
              isLastStep: this.isLastStep(),
              isPreviewMode: this.props.isPreviewMode,
              isSelfServe: this.props.isSelfServe,
              isSignatureAdded: this.state.isSignatureAdded,
              onSign: this.onSign,
              shareKey: this.props.shareKey,
              showSignButton: this.isSignatureRequired()
            })
          )
        )
      );
    }
  }]);

  return StaticBuilderForm;
}(_react2.default.Component);

StaticBuilderForm.defaultProps = {
  finishSelfServe: function finishSelfServe() {},
  inlineConditionals: null,
  isBackClicked: false,
  isPreviewMode: false,
  isSelfServe: false,
  onStep: 0,
  sectionKeys: [],
  showNextTip: function showNextTip() {},
  shareKey: '',
  showRequestSignature: true
};

StaticBuilderForm.propTypes = {
  documentType: _propTypes2.default.string.isRequired,
  finishSelfServe: _propTypes2.default.func,
  formattedFields: _propTypes2.default.instanceOf(_StaticBuilderFormattedFields2.default).isRequired,
  inlineConditionals: _propTypes2.default.func,
  isBackClicked: _propTypes2.default.bool,
  isPreviewMode: _propTypes2.default.bool,
  isSelfServe: _propTypes2.default.bool,
  loadPreviousStaticBuilderSection: _propTypes2.default.func.isRequired,
  onStep: _propTypes2.default.number,
  setStaticBuilderBackButton: _propTypes2.default.func.isRequired,
  saveAndContinue: _propTypes2.default.func.isRequired,
  saveAndSign: _propTypes2.default.func.isRequired,
  sectionKeys: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showNextTip: _propTypes2.default.func,
  showRequestSignature: _propTypes2.default.bool,
  shareKey: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(_ref) {
  var SelfServeBuilderReducer = _ref.SelfServeBuilderReducer,
      StaticBuilderReducer = _ref.StaticBuilderReducer;
  return {
    isBackClicked: StaticBuilderReducer.isBackClicked,
    isSampleState: SelfServeBuilderReducer.isSampleState
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    setStaticBuilderBackButton: _StaticBuilderActions.setStaticBuilderBackButton,
    showNextTip: _TooltipTourActions.showNextTip,
    startTourPreviewOpen: _TooltipTourActions.startTourPreviewOpen
  }, dispatch);
};

var StaticBuilderFormWithRedux = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(StaticBuilderForm);

exports.default = StaticBuilderFormWithRedux;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticBuilderProgressBarWithRedux = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Utils = __webpack_require__(42);

var _FinishLaterButton = __webpack_require__(252);

var _FinishLaterButton2 = _interopRequireDefault(_FinishLaterButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaticBuilderProgressBar = function (_React$PureComponent) {
  _inherits(StaticBuilderProgressBar, _React$PureComponent);

  function StaticBuilderProgressBar(props) {
    _classCallCheck(this, StaticBuilderProgressBar);

    var _this = _possibleConstructorReturn(this, (StaticBuilderProgressBar.__proto__ || Object.getPrototypeOf(StaticBuilderProgressBar)).call(this, props));

    _this.getPercentDone = _this.getPercentDone.bind(_this);
    _this.getTimeLeft = _this.getTimeLeft.bind(_this);
    return _this;
  }

  _createClass(StaticBuilderProgressBar, [{
    key: 'getPercentDone',
    value: function getPercentDone() {
      var numSteps = this.props.showRequestSignature ? this.props.numSteps : this.props.numSteps - 2;
      return (100 * (this.props.onStep / numSteps)).toFixed(0);
    }
  }, {
    key: 'getTimeLeft',
    value: function getTimeLeft() {
      var numSteps = this.props.showRequestSignature ? this.props.numSteps : this.props.numSteps - 2;
      var numberStepsLeft = numSteps - this.props.onStep;
      return (0, _Utils.stepsToTime)(numberStepsLeft);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'status-box' },
        this.props.showFinishLaterButton && this.props.isMenuOpen && _react2.default.createElement(_FinishLaterButton2.default, null),
        _react2.default.createElement(
          'div',
          { className: 'status-info' },
          this.getPercentDone(),
          ' %\xA0',
          _react2.default.createElement(
            'span',
            { className: 'percent-complete-text' },
            'Complete ',
            _react2.default.createElement(
              'i',
              null,
              'apx. ',
              this.getTimeLeft()
            )
          )
        ),
        _react2.default.createElement(
          'strong',
          null,
          'Section ',
          this.props.onStep + 1
        ),
        _react2.default.createElement(
          'div',
          { className: 'statusbar' },
          _react2.default.createElement(
            'div',
            { style: { width: this.getPercentDone() + '%' } },
            '\xA0'
          )
        )
      );
    }
  }]);

  return StaticBuilderProgressBar;
}(_react2.default.PureComponent);

StaticBuilderProgressBar.defaultProps = {
  onStep: 0,
  numSteps: 1,
  showFinishLaterButton: false,
  isMenuOpen: false,
  showRequestSignature: true
};

StaticBuilderProgressBar.propTypes = {
  onStep: _propTypes2.default.number,
  numSteps: _propTypes2.default.number,
  showFinishLaterButton: _propTypes2.default.bool,
  isMenuOpen: _propTypes2.default.bool,
  showRequestSignature: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(_ref) {
  var StaticBuilderReducer = _ref.StaticBuilderReducer;
  return {
    StaticBuilderReducer: StaticBuilderReducer,
    onStep: StaticBuilderReducer.step,
    numSteps: StaticBuilderReducer.sectionKeys.length + 1,
    isMenuOpen: StaticBuilderReducer.isMenuOpen
  };
};

exports.default = StaticBuilderProgressBar;
var StaticBuilderProgressBarWithRedux = exports.StaticBuilderProgressBarWithRedux = ReactRedux.connect(mapStateToProps)(StaticBuilderProgressBar);

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dompurify = __webpack_require__(53);

var _dompurify2 = _interopRequireDefault(_dompurify);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subheading = function Subheading(props) {
  return _react2.default.createElement(
    'div',
    { className: 'controls subheading' },
    _react2.default.createElement('h4', {
      dangerouslySetInnerHTML: { __html: '' + _dompurify2.default.sanitize(props.label) }
    })
  );
};

Subheading.propTypes = {
  label: _propTypes2.default.string.isRequired
};

exports.default = (0, _WithInit2.default)(Subheading);

/***/ }),

/***/ 1193:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FillStaticPdf = function () {
  function FillStaticPdf() {
    _classCallCheck(this, FillStaticPdf);
  }

  _createClass(FillStaticPdf, null, [{
    key: 'init',
    value: function init() {
      // Hide the preview (it's a PDF file)
      document.querySelector('.document-preview-wrapper').style.display = 'none';
      // Hide the Print button (Download only)
      document.getElementById('printButton').style.display = 'none';

      // Custom Save and Export to fill in a PDF
      var saveAndExportPDF = function saveAndExportPDF() {
        document.querySelector('#instructionPane h1').textContent = 'Compiling Your PDF Document...';
        document.querySelector('#instructionPane .modal-footer').style.display = 'none';

        var pane = document.querySelector('#instructionPane');
        var paneClasses = pane.classList;

        pane.style.display = 'block';
        paneClasses.remove('hide');
        paneClasses.add('in');

        setTimeout(function () {
          pane.style.display = 'none';
          paneClasses.remove('in');
        }, 2500);

        // Save before triggering the export
        var successAction = function successAction() {
          document.location = '/_api/fillAndExportPDFFromSession.php' + document.location.search;
        };

        window.SessionManager.save(successAction);
      };

      // Fill and export PDF and trigger auto-download
      var button = document.querySelector('.export-button-preview');
      button.href = '#';
      button.removeAttribute('onclick');
      button.addEventListener('click', saveAndExportPDF);

      // Override the save button in the last section to trigger the export
      var exportOnLastSection = function exportOnLastSection() {
        var numberOfSections = window.ReactCompatibility.getStaticBuilderSectionKeys();
        // Check if we're on the last section
        if (window.Wizard.interface.getCurrentStep() + 1 >= numberOfSections) {
          var saveButton = document.getElementsByClassName('saveButton')[0];
          saveButton.removeAttribute('onclick');
          saveButton.addEventListener('click', saveAndExportPDF);
        }
      };

      // Execute on every section load
      window.ReactCompatibility.addStaticBuilderOnSectionLoadAction(exportOnLastSection);

      // Reload our current step to execute our load action
      window.ReactCompatibility.loadStaticBuilderSection(window.ReactCompatibility.getStaticBuilderCurrentStep());

      // Show the drawer with the sections
      document.querySelector('.builder-toolbar-arrow-wrapper').classList.remove('active-arrow');
      document.getElementById('sectionProgress').className = 'section-progress-wrapper navbar-opened';
      var nav = document.querySelector('.builder-nav');
      nav.classList.remove('collapsed');
      nav.style.display = 'block';
      nav.style.right = '0px';
    }
  }]);

  return FillStaticPdf;
}();

module.exports = FillStaticPdf;

/***/ }),

/***/ 1194:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_accountnumber', 'payee1_2ndtinnotice', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_direct_sales', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_section409a_deferrals', 'payee1_section409a_income', 'payee1_statetax_with1', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state_income1', 'payee1_statetax_with2', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income2'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      VisualStatic.initExportPDF();
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 1195:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_accountnumber', 'payee1_2ndtinnotice', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_direct_sales', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_section409a_deferrals', 'payee1_section409a_income', 'payee1_statetax_with1', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state_income1', 'payee1_statetax_with2', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income2'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      VisualStatic.initExportPDF();
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 1196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber', 'payee1_2ndtinnotice', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_direct_sales', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_section409a_deferrals', 'payee1_section409a_income', 'payee1_statetax_with1', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state_income1', 'payee1_statetax_with2', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income2'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      VisualStatic.initExportPDF();
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 1197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payer_country', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber', 'payee1_fatca_filing', 'payee1_2ndtinnotice', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_direct_sales', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_gross_paid_attorney', 'payee1_fish_resale', 'payee1_section409a_deferrals', 'payee1_excess_golden_parachut', 'payee1_section409a_income', 'payee1_statetax_with1', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state_income1', 'payee1_statetax_with2', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income2'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_fish_resale', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();
      VisualStatic.setUpIowaBENInput();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      var eFileButton = document.getElementById('efileDocument');
      // Hide the eFiling option for unpaid users
      if (!window.SessionManager.isPaidUser && eFileButton) {
        eFileButton.style.display = 'none';
      }

      // Attach button events
      VisualStatic.initExportPDF();

      // [E-file] Context on the E-file flow at this stage:
      // When the e-filing button is clicked, we validate that required fields are added and
      // that certain fields have passed regex validation. Once all specified fields pass validation,
      // we should save the document session and redirect to the taxFiling page.
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_company_name1', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var tinRegex = { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' };
          var accountNumberRegex = { regex: new RegExp('^.{1,20}$'), message: '20 or less characters' };
          var regexValidations = {
            payer_tin: tinRegex,
            payee1_tin: tinRegex,
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state1_name: stateRegex,
            payee1_state2_name: stateRegex,
            payee1_accountnumber: accountNumberRegex,
            payee1_rents: currencyRegex,
            payee1_royalties: currencyRegex,
            payee1_other_income: currencyRegex,
            payee1_fedtaxwith: currencyRegex,
            payee1_fishingboat_proceeds: currencyRegex,
            payee1_fish_resale: currencyRegex,
            payee1_medical_healthcare_payments: currencyRegex,
            payee1_sub_payments_div_intr: currencyRegex,
            payee1_crop_ins: currencyRegex,
            payee1_excess_golden_parachut: currencyRegex,
            payee1_gross_paid_attorney: currencyRegex,
            payee1_statetax_with1: currencyRegex,
            payee1_statetax_with2: currencyRegex,
            payee1_state_income1: currencyRegex,
            payee1_state_income2: currencyRegex,
            payee1_section409a_deferrals: currencyRegex,
            payee1_section409a_income: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 1198:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payer_country', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber', 'payee1_2ndtinnotice', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_direct_sales', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_gross_paid_attorney', 'payee1_fish_resale', 'payee1_section409a_deferrals', 'payee1_fatca_filing', 'payee1_excess_golden_parachut', 'payee1_section409a_income', 'payee1_statetax_with1', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state_income1', 'payee1_statetax_with2', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income2'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_fish_resale', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      var eFileButton = document.getElementById('efileDocument');
      // Hide the eFiling option for unpaid users
      if (!window.SessionManager.isPaidUser && eFileButton) {
        eFileButton.style.display = 'none';
      }

      // Attach button events
      VisualStatic.initExportPDF();

      // [E-file] Context on the E-file flow at this stage:
      // When the e-filing button is clicked, we validate that required fields are added and
      // that certain fields have passed regex validation. Once all specified fields pass validation,
      // we should save the document session and redirect to the taxFiling page.
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_company_name1', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var tinRegex = { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' };
          var accountNumberRegex = { regex: new RegExp('^.{1,20}$'), message: '20 or less characters' };
          var regexValidations = {
            payer_tin: tinRegex,
            payee1_tin: tinRegex,
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state1_name: stateRegex,
            payee1_state2_name: stateRegex,
            payee1_accountnumber: accountNumberRegex,
            payee1_rents: currencyRegex,
            payee1_royalties: currencyRegex,
            payee1_other_income: currencyRegex,
            payee1_fedtaxwith: currencyRegex,
            payee1_fishingboat_proceeds: currencyRegex,
            payee1_fish_resale: currencyRegex,
            payee1_medical_healthcare_payments: currencyRegex,
            payee1_sub_payments_div_intr: currencyRegex,
            payee1_crop_ins: currencyRegex,
            payee1_excess_golden_parachut: currencyRegex,
            payee1_gross_paid_attorney: currencyRegex,
            payee1_statetax_with1: currencyRegex,
            payee1_statetax_with2: currencyRegex,
            payee1_state_income1: currencyRegex,
            payee1_state_income2: currencyRegex,
            payee1_section409a_deferrals: currencyRegex,
            payee1_section409a_income: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 1199:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_country', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_fatca_filing', 'payee1_accountnumber', 'payee1_2ndtinnotice', 'payee1_non_employee_comp', 'payee1_fedtaxwith', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income1', 'payee1_state_income2'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_accountnumber', 'payee1_non_employee_comp', 'payee1_fedtaxwith', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();
      VisualStatic.setUpIowaBENInput();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      var eFileButton = document.getElementById('efileDocument');
      // Hide the eFiling option if user is unpaid and only if efile button even exists on page
      if (!window.SessionManager.isPaidUser && eFileButton) {
        eFileButton.style.display = 'none';
      }

      // Attach button events
      VisualStatic.initExportPDF();

      // [E-file] Context on the E-file flow at this stage:
      // When the e-filing button is clicked, we validate that required fields are added and
      // that certain fields have passed regex validation. Once all specified fields pass validation,
      // we should save the document session and redirect to the taxFiling page.
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_company_name1', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var regexValidations = {
            payer_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state1_name: stateRegex,
            payee1_state2_name: stateRegex,
            payee1_accountnumber: { regex: new RegExp('^.{1,20}$'), message: '20 or less characters' },
            payee1_fedtaxwith: currencyRegex,
            payee1_non_employee_comp: currencyRegex,
            payee1_statetax_with1: currencyRegex,
            payee1_statetax_with2: currencyRegex,
            payee1_state_income1: currencyRegex,
            payee1_state_income2: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dompurify = __webpack_require__(53);

var _dompurify2 = _interopRequireDefault(_dompurify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticCreateAccountErrorBox = function StaticCreateAccountErrorBox(props) {
  return _react2.default.createElement(
    'div',
    { className: 'alert alert-danger' },
    _react2.default.createElement(
      'b',
      null,
      'Error! '
    ),
    _react2.default.createElement('span', {
      dangerouslySetInnerHTML: { __html: _dompurify2.default.sanitize(props.errorMessage) }
    })
  );
};

StaticCreateAccountErrorBox.propTypes = {
  errorMessage: _propTypes2.default.string.isRequired
};

exports.default = StaticCreateAccountErrorBox;

/***/ }),

/***/ 1200:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_country', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_accountnumber', 'payee1_2ndtinnotice', 'payee1_non_employee_comp', 'payee1_direct_sales_checked', 'payee1_fedtaxwith', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income1', 'payee1_state_income2'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_accountnumber', 'payee1_non_employee_comp', 'payee1_fedtaxwith', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();
      VisualStatic.setUpIowaBENInput();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      var eFileButton = document.getElementById('efileDocument');
      // Hide the eFiling option if user is unpaid and only if efile button even exists on page
      if (!window.SessionManager.isPaidUser && eFileButton) {
        eFileButton.style.display = 'none';
      }

      // Attach button events
      VisualStatic.initExportPDF();

      // [E-file] Context on the E-file flow at this stage:
      // When the e-filing button is clicked, we validate that required fields are added and
      // that certain fields have passed regex validation. Once all specified fields pass validation,
      // we should save the document session and redirect to the taxFiling page.
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_company_name1', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var tinRegex = { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' };
          var accountNumberRegex = { regex: new RegExp('^.{1,20}$'), message: '20 or less characters' };
          var regexValidations = {
            payer_tin: tinRegex,
            payee1_tin: tinRegex,
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state1_name: stateRegex,
            payee1_state2_name: stateRegex,
            payee1_accountnumber: accountNumberRegex,
            payee1_fedtaxwith: currencyRegex,
            payee1_non_employee_comp: currencyRegex,
            payee1_statetax_with1: currencyRegex,
            payee1_statetax_with2: currencyRegex,
            payee1_state_income1: currencyRegex,
            payee1_state_income2: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 1201:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_country', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_accountnumber', 'payee1_2ndtinnotice', 'payee1_non_employee_comp', 'payee1_direct_sales_checked', 'payee1_fedtaxwith', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income1', 'payee1_state_income2'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_accountnumber', 'payee1_non_employee_comp', 'payee1_fedtaxwith', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      var eFileButton = document.getElementById('efileDocument');
      // Hide the eFiling option if user is unpaid and only if efile button even exists on page
      if (!window.SessionManager.isPaidUser && eFileButton) {
        eFileButton.style.display = 'none';
      }

      // Attach button events
      VisualStatic.initExportPDF();

      // [E-file] Context on the E-file flow at this stage:
      // When the e-filing button is clicked, we validate that required fields are added and
      // that certain fields have passed regex validation. Once all specified fields pass validation,
      // we should save the document session and redirect to the taxFiling page.
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_company_name1', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var tinRegex = { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' };
          var accountNumberRegex = { regex: new RegExp('^.{1,20}$'), message: '20 or less characters' };
          var regexValidations = {
            payer_tin: tinRegex,
            payee1_tin: tinRegex,
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state1_name: stateRegex,
            payee1_state2_name: stateRegex,
            payee1_accountnumber: accountNumberRegex,
            payee1_fedtaxwith: currencyRegex,
            payee1_non_employee_comp: currencyRegex,
            payee1_statetax_with1: currencyRegex,
            payee1_statetax_with2: currencyRegex,
            payee1_state_income1: currencyRegex,
            payee1_state_income2: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 1202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['employer_name', 'employer_address_one', 'employer_address_two', 'employer_city', 'employer_state', 'employer_zip', 'employer_phone', 'employee_name', 'employee_address_one', 'employee_address_two', 'employee_city', 'employee_state', 'employee_zip', 'employee_id', 'check_number', 'employee_ssn', 'start_date', 'end_date', 'pay_date', 'regular_r', 'regular_hr', 'regular_current', 'regular_ytd', 'overtime_r', 'overtime_hr', 'overtime_current', 'overtime_ytd', 'other_r', 'other_hr', 'other_current', 'other_ytd', 'medicare_current', 'medicare_ytd', 'ss_current', 'ss_ytd', 'federal_current', 'federal_ytd', 'state_current', 'state_ytd', 'other_deduct_current', 'other_deduct_ytd', 'current_gross_total', 'ytd_gross_total', 'current_deductions_total', 'ytd_deductions_total', 'current_net_pay', 'ytd_net_pay'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      // For older browsers use our POLYFILL to add the appropriate placeholders
      $('input').placeholder();

      VisualStatic.initExportPDF();

      $('form #group_other_current').eq(1).addClass('copy');
      $('form #group_other_ytd').eq(1).addClass('copy');
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 1203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Enter key is disabled from triggering a PDF export
var VisualStatic = __webpack_require__(35);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payee1_tin', 'payee1_tin', 'payer_tin', 'payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payee1_w2_control_number', 'payee1_first_name', 'payee1_middle_initial', 'payee1_last_name', 'payee1_name_suffix', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_phone', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_wages', 'payee1_soc_sec_withh', 'payee1_med_wages_and_tips', 'payee1_medicare_withh', 'payee1_soc_sec_tips', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_non_qual457', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_state_name_one', 'payee1_state_id_one', 'payee1_state_wages_tips_etc_one', 'payee1_state_tax_withh_one', 'payee1_local_wages_tips_etc_one', 'payee1_local_tax_withh_one', 'payee1_local_name_one', 'payee1_state_name_two', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_two', 'payee1_local_name_two', 'payee1_local_name_two', 'payee1_local_name_two'];

      this.removeLabelsFromFields = ['payee1_tin', 'payer_tin', 'payee1_w2_control_number', 'payee1_state_name_one', 'payee1_state_name_two', 'payee1_state_id_one', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_one', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_one', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_one', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_one', 'payee1_local_tax_withh_two', 'payee1_local_name_one', 'payee1_local_name_two', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_non_qual457', 'payee1_soc_sec_tips', 'payee1_med_wages_and_tips', 'payee1_soc_sec_wages', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_withh', 'payee1_medicare_withh', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      // Hide the eFiling option for the 2014 tax returns
      if (!window.SessionManager.isPaidUser) {
        document.getElementById('group_efiling_subheading').style.display = 'none';
        document.getElementById('group_payee1_employment_type').style.visibility = 'hidden';
        document.getElementById('group_payer_kind_of_employer').style.visibility = 'hidden';
        document.getElementById('group_payee1_non_qual_non457').style.visibility = 'hidden';
      }

      // Disables default dropdown option for W2 additional fields:
      // payee1_employment_type and payer_kind_of_employer
      VisualStatic.disableW2SelectDefaultOption();

      VisualStatic.initExportPDF();
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 1204:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Enter key is disabled from triggering a PDF export
var VisualStatic = __webpack_require__(35);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payee1_tin', 'payee1_tin', 'payer_tin', 'payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payee1_w2_control_number', 'payee1_first_name', 'payee1_middle_initial', 'payee1_last_name', 'payee1_name_suffix', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_phone', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_wages', 'payee1_soc_sec_withh', 'payee1_med_wages_and_tips', 'payee1_medicare_withh', 'payee1_soc_sec_tips', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_non_qual457', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_state_name_one', 'payee1_state_id_one', 'payee1_state_wages_tips_etc_one', 'payee1_state_tax_withh_one', 'payee1_local_wages_tips_etc_one', 'payee1_local_tax_withh_one', 'payee1_local_name_one', 'payee1_state_name_two', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_two', 'payee1_local_name_two', 'payee1_local_name_two', 'payee1_local_name_two'];

      this.removeLabelsFromFields = ['payee1_tin', 'payer_tin', 'payee1_w2_control_number', 'payee1_state_name_one', 'payee1_state_name_two', 'payee1_state_id_one', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_one', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_one', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_one', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_one', 'payee1_local_tax_withh_two', 'payee1_local_name_one', 'payee1_local_name_two', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_non_qual457', 'payee1_soc_sec_tips', 'payee1_med_wages_and_tips', 'payee1_soc_sec_wages', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_withh', 'payee1_medicare_withh', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      // Hide the eFiling option for the 2014 tax returns
      if (!window.SessionManager.isPaidUser) {
        document.getElementById('group_efiling_subheading').style.display = 'none';
        document.getElementById('group_payee1_employment_type').style.visibility = 'hidden';
        document.getElementById('group_payer_kind_of_employer').style.visibility = 'hidden';
        document.getElementById('group_payee1_non_qual_non457').style.visibility = 'hidden';
      }

      // Disables default dropdown option for W2 additional fields:
      // payee1_employment_type and payer_kind_of_employer
      VisualStatic.disableW2SelectDefaultOption();

      VisualStatic.initExportPDF();
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 1205:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Enter key is disabled from triggering a PDF export
var VisualStatic = __webpack_require__(35);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payee1_tin', 'payee1_tin', 'payer_tin', 'payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_w2_control_number', 'payee1_first_name', 'payee1_middle_initial', 'payee1_last_name', 'payee1_name_suffix', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_phone', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_wages', 'payee1_soc_sec_withh', 'payee1_med_wages_and_tips', 'payee1_medicare_withh', 'payee1_soc_sec_tips', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_non_qual457', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_state_name_one', 'payee1_state_id_one', 'payee1_state_wages_tips_etc_one', 'payee1_state_tax_withh_one', 'payee1_local_wages_tips_etc_one', 'payee1_local_tax_withh_one', 'payee1_local_name_one', 'payee1_state_name_two', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_two', 'payee1_local_name_two', 'payee1_local_name_two', 'payee1_local_name_two'];

      this.removeLabelsFromFields = ['payee1_tin', 'payer_tin', 'payee1_w2_control_number', 'payee1_state_name_one', 'payee1_state_name_two', 'payee1_state_id_one', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_one', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_one', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_one', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_one', 'payee1_local_tax_withh_two', 'payee1_local_name_one', 'payee1_local_name_two', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_non_qual457', 'payee1_soc_sec_tips', 'payee1_med_wages_and_tips', 'payee1_soc_sec_wages', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_withh', 'payee1_medicare_withh', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      // Hide the eFiling option for the 2014 tax returns
      if (!window.SessionManager.isPaidUser) {
        document.getElementById('group_efiling_subheading').style.display = 'none';
        document.getElementById('group_payee1_employment_type').style.visibility = 'hidden';
        document.getElementById('group_payer_kind_of_employer').style.visibility = 'hidden';
        document.getElementById('group_payee1_non_qual_non457').style.visibility = 'hidden';

        // group_efiling_subheading is not displayed, which affects positioning of country fields
        document.getElementById('group_payee1_country').style.top = '-3042px';
        document.getElementById('group_payer_country').style.top = '-3355px';
      }

      // Disables default dropdown option for W2 additional fields:
      // payee1_employment_type and payer_kind_of_employer
      VisualStatic.disableW2SelectDefaultOption();

      VisualStatic.initExportPDF();
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 1206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Enter key is disabled from triggering a PDF export
var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payee1_tin', 'payer_tin', 'payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payer_country', 'payee1_w2_control_number', 'payee1_first_name', 'payee1_middle_initial', 'payee1_last_name', 'payee1_name_suffix', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_phone', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_wages', 'payee1_soc_sec_withh', 'payee1_med_wages_and_tips', 'payee1_medicare_withh', 'payee1_soc_sec_tips', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_non_qual457', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d', 'payee1_statutory_ind', 'payee1_retirement_plan_ind', 'payee1_third_party_sick_pay_ind', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_state_name_one', 'payee1_state_id_one', 'payee1_state_wages_tips_etc_one', 'payee1_state_tax_withh_one', 'payee1_local_wages_tips_etc_one', 'payee1_local_tax_withh_one', 'payee1_local_name_one', 'payee1_state_name_two', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_two', 'payee1_local_name_two', 'payee1_local_name_two', 'payee1_local_name_two'];

      this.removeLabelsFromFields = ['payee1_tin', 'payer_tin', 'payee1_w2_control_number', 'payee1_state_name_one', 'payee1_state_name_two', 'payee1_state_id_one', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_one', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_one', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_one', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_one', 'payee1_local_tax_withh_two', 'payee1_local_name_one', 'payee1_local_name_two', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_non_qual457', 'payee1_soc_sec_tips', 'payee1_med_wages_and_tips', 'payee1_soc_sec_wages', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_withh', 'payee1_medicare_withh', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();
      VisualStatic.setUpIowaBENInput();

      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      // Hide the eFiling option for upaid users
      if (!window.SessionManager.isPaidUser) {
        var eFileElm = document.getElementById('efileDocument');
        if (eFileElm) {
          eFileElm.style.display = 'none';
        }
        document.getElementById('group_efiling_subheading').style.display = 'none';
        document.getElementById('group_payee1_employment_type').style.visibility = 'hidden';
        document.getElementById('group_payer_kind_of_employer').style.visibility = 'hidden';
        document.getElementById('group_payee1_non_qual_non457').style.visibility = 'hidden';

        // group_efiling_subheading is not displayed, which affects positioning of country fields
        document.getElementById('group_payee1_country').style.top = '-3042px';
        document.getElementById('group_payer_country').style.top = '-3355px';
      }

      // Disables default dropdown option for W2 additional fields:
      // payee1_employment_type and payer_kind_of_employer
      VisualStatic.disableW2SelectDefaultOption();

      // Attach button events
      VisualStatic.initExportPDF();

      // [E-file] Context on the E-file flow at this stage:
      // When the e-filing button is clicked, we validate that required fields are added and
      // that certain fields have passed regex validation. Once all specified fields pass validation,
      // we should save the document session and redirect to the taxFiling page.
      var eFileButton = document.getElementById('efileDocument');
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payee1_address1', 'payee1_city', 'payee1_country', 'payee1_employment_type', 'payee1_first_name', 'payee1_last_name', 'payee1_state', 'payee1_tin', 'payee1_zipcode', 'payer_address1', 'payer_city', 'payer_company_name1', 'payer_country', 'payer_kind_of_employer', 'payer_phone', 'payer_state', 'payer_tin', 'payer_zipcode'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var tinRegex = { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' };
          var payeeCodeRegex = { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' };
          var localNameRegex = { regex: new RegExp('^.{1,11}$'), message: '11 or less characters' };
          var regexValidations = {
            payer_tin: tinRegex,
            payee1_tin: tinRegex,
            payee1_code_a: payeeCodeRegex,
            payee1_code_b: payeeCodeRegex,
            payee1_code_c: payeeCodeRegex,
            payee1_code_d: payeeCodeRegex,
            payee1_amt_a: currencyRegex,
            payee1_amt_b: currencyRegex,
            payee1_amt_c: currencyRegex,
            payee1_amt_d: currencyRegex,
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state_name_one: stateRegex,
            payee1_state_name_two: stateRegex,
            payee1_local_name_one: localNameRegex,
            payee1_local_name_two: localNameRegex,
            payee1_allocated_tips: currencyRegex,
            payee1_dependent_care_benefits: currencyRegex,
            payee1_fit_withh: currencyRegex,
            payee1_local_tax_withh_one: currencyRegex,
            payee1_local_tax_withh_two: currencyRegex,
            payee1_local_wages_tips_etc_one: currencyRegex,
            payee1_local_wages_tips_etc_two: currencyRegex,
            payee1_medicare_withh: currencyRegex,
            payee1_med_wages_and_tips: currencyRegex,
            payee1_non_qual457: currencyRegex,
            payee1_non_qual_non457: currencyRegex,
            payee1_soc_sec_tips: currencyRegex,
            payee1_soc_sec_wages: currencyRegex,
            payee1_soc_sec_withh: currencyRegex,
            payee1_state_tax_withh_one: currencyRegex,
            payee1_state_tax_withh_two: currencyRegex,
            payee1_state_wages_tips_etc_one: currencyRegex,
            payee1_state_wages_tips_etc_two: currencyRegex,
            payee1_wages_tips_other_comp: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 1207:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Enter key is disabled from triggering a PDF export
var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payee1_tin', 'payer_tin', 'payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payer_country', 'payee1_w2_control_number', 'payee1_first_name', 'payee1_middle_initial', 'payee1_last_name', 'payee1_name_suffix', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_phone', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_wages', 'payee1_soc_sec_withh', 'payee1_med_wages_and_tips', 'payee1_medicare_withh', 'payee1_soc_sec_tips', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_non_qual457', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d', 'payee1_statutory_ind', 'payee1_retirement_plan_ind', 'payee1_third_party_sick_pay_ind', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_state_name_one', 'payee1_state_id_one', 'payee1_state_wages_tips_etc_one', 'payee1_state_tax_withh_one', 'payee1_local_wages_tips_etc_one', 'payee1_local_tax_withh_one', 'payee1_local_name_one', 'payee1_state_name_two', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_two', 'payee1_local_name_two', 'payee1_local_name_two', 'payee1_local_name_two'];

      this.removeLabelsFromFields = ['payee1_tin', 'payer_tin', 'payee1_w2_control_number', 'payee1_state_name_one', 'payee1_state_name_two', 'payee1_state_id_one', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_one', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_one', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_one', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_one', 'payee1_local_tax_withh_two', 'payee1_local_name_one', 'payee1_local_name_two', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_non_qual457', 'payee1_soc_sec_tips', 'payee1_med_wages_and_tips', 'payee1_soc_sec_wages', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_withh', 'payee1_medicare_withh', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();

      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      // Hide the eFiling option for upaid users
      if (!window.SessionManager.isPaidUser) {
        var eFileElm = document.getElementById('efileDocument');
        if (eFileElm) {
          eFileElm.style.display = 'none';
        }
        document.getElementById('group_efiling_subheading').style.display = 'none';
        document.getElementById('group_payee1_employment_type').style.visibility = 'hidden';
        document.getElementById('group_payer_kind_of_employer').style.visibility = 'hidden';
        document.getElementById('group_payee1_non_qual_non457').style.visibility = 'hidden';

        // group_efiling_subheading is not displayed, which affects positioning of country fields
        document.getElementById('group_payee1_country').style.top = '-3042px';
        document.getElementById('group_payer_country').style.top = '-3355px';
      }

      // Disables default dropdown option for W2 additional fields:
      // payee1_employment_type and payer_kind_of_employer
      VisualStatic.disableW2SelectDefaultOption();

      // Attach button events
      VisualStatic.initExportPDF();

      // [E-file] Context on the E-file flow at this stage:
      // When the e-filing button is clicked, we validate that required fields are added and
      // that certain fields have passed regex validation. Once all specified fields pass validation,
      // we should save the document session and redirect to the taxFiling page.
      var eFileButton = document.getElementById('efileDocument');
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payee1_address1', 'payee1_city', 'payee1_country', 'payee1_employment_type', 'payee1_first_name', 'payee1_last_name', 'payee1_state', 'payee1_tin', 'payee1_zipcode', 'payer_address1', 'payer_city', 'payer_company_name1', 'payer_country', 'payer_kind_of_employer', 'payer_phone', 'payer_state', 'payer_tin', 'payer_zipcode'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var tinRegex = { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' };
          var payeeCodeRegex = { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' };
          var localNameRegex = { regex: new RegExp('^.{1,11}$'), message: '11 or less characters' };
          var regexValidations = {
            payer_tin: tinRegex,
            payee1_tin: tinRegex,
            payee1_code_a: payeeCodeRegex,
            payee1_code_b: payeeCodeRegex,
            payee1_code_c: payeeCodeRegex,
            payee1_code_d: payeeCodeRegex,
            payee1_amt_a: currencyRegex,
            payee1_amt_b: currencyRegex,
            payee1_amt_c: currencyRegex,
            payee1_amt_d: currencyRegex,
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state_name_one: stateRegex,
            payee1_state_name_two: stateRegex,
            payee1_local_name_one: localNameRegex,
            payee1_local_name_two: localNameRegex,
            payee1_allocated_tips: currencyRegex,
            payee1_dependent_care_benefits: currencyRegex,
            payee1_fit_withh: currencyRegex,
            payee1_local_tax_withh_one: currencyRegex,
            payee1_local_tax_withh_two: currencyRegex,
            payee1_local_wages_tips_etc_one: currencyRegex,
            payee1_local_wages_tips_etc_two: currencyRegex,
            payee1_medicare_withh: currencyRegex,
            payee1_med_wages_and_tips: currencyRegex,
            payee1_non_qual457: currencyRegex,
            payee1_non_qual_non457: currencyRegex,
            payee1_soc_sec_tips: currencyRegex,
            payee1_soc_sec_wages: currencyRegex,
            payee1_soc_sec_withh: currencyRegex,
            payee1_state_tax_withh_one: currencyRegex,
            payee1_state_tax_withh_two: currencyRegex,
            payee1_state_wages_tips_etc_one: currencyRegex,
            payee1_state_wages_tips_etc_two: currencyRegex,
            payee1_wages_tips_other_comp: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 1208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['name', 'business_name', 'sole_proprietor', 'c_corporation', 's_corporation', 'partnership', 'trust_estate', 'llc', 'tax', 'other', 'other_details', 'payee', 'fatca', 'address', 'city', 'state', 'zip', 'account_numbers', 'requester_name', 'requester_address', 'r_city', 'r_state', 'r_zip', 'ss1', 'ss2', 'ss3', 'ein1', 'ein2', 'sign_date'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      // For older browsers use our POLYFILL to add the appropriate placeholders
      $('input').placeholder();

      VisualStatic.initExportPDF();
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DownloadOverlayConstants = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadArrow = function DownloadArrow(props) {
  var color = '#5cb85c';
  if (props.active) {
    color = '#7cf26a';
  }

  var display = 'inline-block';
  var rotation = 0;
  switch (props.downloadArrowDirection) {
    case _DownloadOverlayConstants.DownloadArrowDirectionEnum.UP:
      display = 'block';
      rotation = -45;
      break;
    case _DownloadOverlayConstants.DownloadArrowDirectionEnum.RIGHT:
      rotation = 45;
      break;
    case _DownloadOverlayConstants.DownloadArrowDirectionEnum.DOWN:
      display = 'block';
      rotation = 135;
      break;
    case _DownloadOverlayConstants.DownloadArrowDirectionEnum.LEFT:
      rotation = -135;
      break;
    default:
      rotation = 0;
  }

  var styles = {
    backgroundColor: 'transparent',
    borderColor: color,
    borderStyle: 'solid',
    borderWidth: '8px 8px 0 0',
    display: display,
    height: 14,
    position: 'relative',
    transform: 'rotate(' + rotation + 'deg)',
    WebKitTransform: 'rotate(' + rotation + 'deg)',
    MozTransform: 'rotate(' + rotation + 'deg) perspective(1px)', // adding perspective to remove border seams
    msTransform: 'rotate(' + rotation + 'deg)',
    verticalAlign: top,
    width: 14
  };

  return _react2.default.createElement('div', { className: 'download-arrow', style: styles });
};

DownloadArrow.propTypes = {
  active: _propTypes2.default.bool.isRequired,
  downloadArrowDirection: _propTypes2.default.oneOf([_DownloadOverlayConstants.DownloadArrowDirectionEnum.UP, _DownloadOverlayConstants.DownloadArrowDirectionEnum.RIGHT, _DownloadOverlayConstants.DownloadArrowDirectionEnum.DOWN, _DownloadOverlayConstants.DownloadArrowDirectionEnum.LEFT]).isRequired
};

exports.default = DownloadArrow;

/***/ }),

/***/ 1214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Modals = __webpack_require__(169);

var ProgressCircle = {};

ProgressCircle.init = function (callback) {
  // This is the default new account page url pulled from the preview modal.
  var href = document.querySelector('.proceed-to-export-upgrade').getAttribute('href');
  var userId = window.COOKIE.get('userid');

  var defaultCallback = function defaultCallback() {
    window.location.assign(href);
  };
  var callbackToUse = callback || defaultCallback;

  // Don't show export modal if the user is logged in
  // or if the download should be free for SEO purposes
  if (userId || window.location.pathname === '/builder-download.php') {
    callbackToUse();
    return;
  }

  // https://app.optimizely.com/v2/projects/48120048/experiments/11074953455/variations/11053235131
  // Currently we have a split test that overrides this init method. The primary reason for this, is that
  // the split test affects different parts of the page (uses different id's to mount components), which
  // means we cannot use our OptimizelyTestContainer as usual
  _Modals.ExportProgressBarModal.init('exportProgressBarModalContainer', {
    href: href,
    callback: callbackToUse
  });
};

module.exports = ProgressCircle;

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(316)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)(o|0)s/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser'
        , whale: t
        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser'
        , mzbrowser: t
        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus'
        , focus: t
        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});


/***/ }),

/***/ 1222:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Animation = __webpack_require__(323);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _PreviewAnimationOverlay = __webpack_require__(1448);

var _PreviewAnimationOverlay2 = _interopRequireDefault(_PreviewAnimationOverlay);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExportDocumentPreviewAnimation = function ExportDocumentPreviewAnimation(props) {
  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(_PreviewAnimationOverlay2.default, {
      progressBarAnimation: props.progressBarAnimation,
      src: props.src
    }),
    _react2.default.createElement('iframe', {
      id: 'documentPreview',
      className: 'document-preview',
      src: props.src,
      scrolling: 'no'
    })
  );
};

ExportDocumentPreviewAnimation.propTypes = {
  progressBarAnimation: _propTypes2.default.shape({
    started: _propTypes2.default.bool,
    finished: _propTypes2.default.bool,
    step: _propTypes2.default.number,
    stepInterval: _propTypes2.default.number
  }).isRequired,
  src: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(_ref) {
  var AnimationReducer = _ref.AnimationReducer;
  return {
    progressBarAnimation: AnimationReducer[_Animation.AnimationConstants.PROGRESS_BAR_ANIMATION]
  };
};

var ExportDocumentPreviewAnimationWithRedux = ReactRedux.connect(mapStateToProps)(ExportDocumentPreviewAnimation);

exports.default = (0, _WithInit2.default)(ExportDocumentPreviewAnimationWithRedux, true);

/***/ }),

/***/ 1233:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _ConnectModal = __webpack_require__(34);

var _ConnectModal2 = _interopRequireDefault(_ConnectModal);

var _ModalConstants = __webpack_require__(20);

var _ModalConstants2 = _interopRequireDefault(_ModalConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FinishLaterModalWithRedux = (0, _ConnectModal2.default)(_BaseModal2.default);

var FinishLaterModal = function (_React$Component) {
  _inherits(FinishLaterModal, _React$Component);

  function FinishLaterModal() {
    _classCallCheck(this, FinishLaterModal);

    return _possibleConstructorReturn(this, (FinishLaterModal.__proto__ || Object.getPrototypeOf(FinishLaterModal)).apply(this, arguments));
  }

  _createClass(FinishLaterModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(FinishLaterModalWithRedux, {
        modalType: _ModalConstants2.default.STATIC_FINISH_LATER,
        activeModal: 'static-finish-later',
        includeHeaderCloseButton: true,
        shouldCloseOnOverlayClick: false,
        shouldCloseOnEsc: false,
        bodyContent: _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement('img', {
            alt: 'document-illustration',
            src: '/images/finish-later-modal-document-icon.png',
            className: 'finish-later-modal-icon'
          }),
          _react2.default.createElement(
            'p',
            { className: 'finish-later-modal-question' },
            'Do you want to save this document and finish later?'
          ),
          _react2.default.createElement(
            'p',
            { className: 'finish-later-modal-text' },
            'You will be redirected to create an account'
          ),
          _react2.default.createElement(
            'button',
            {
              className: 'finish-later-modal-cta btn btn-primary',
              onClick: FinishLaterModal.saveDocumentProgress
            },
            'Yes, Save & Finish Later'
          )
        ),
        footerContent: null
      });
    }
  }], [{
    key: 'saveDocumentProgress',
    value: function saveDocumentProgress() {
      window.localStorage.setItem('staticSection-' + window.SessionManager.id, JSON.stringify(window.ReactCompatibility.getStaticBuilderCurrentStep()));
      window.location.assign('/newAccountForDoc.php' + window.location.search + '&redirectAction=builder');
    }
  }]);

  return FinishLaterModal;
}(_react2.default.Component);

exports.default = (0, _WithInit2.default)(FinishLaterModal, true);

/***/ }),

/***/ 1234:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticBuilderCreateAccountWithRedux = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(92);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RegisterForm = __webpack_require__(342);

var _RegisterForm2 = _interopRequireDefault(_RegisterForm);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _RegisterFormConstants = __webpack_require__(216);

var _RegisterFormConstants2 = _interopRequireDefault(_RegisterFormConstants);

var _StaticBuilderActions = __webpack_require__(24);

var _main = __webpack_require__(85);

var _main2 = _interopRequireDefault(_main);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultModalStyle = {
  overlay: {
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: _main2.default.modalZIndex
  },
  content: {
    border: 'none',
    borderRadius: '4px',
    background: 'transparent',
    height: '447px',
    margin: '0 auto',
    overflow: 'visible',
    padding: '0',
    width: '677px',
    backgroundColor: '#fff'
  }
};

var StaticBuilderCreateAccount = function (_React$PureComponent) {
  _inherits(StaticBuilderCreateAccount, _React$PureComponent);

  function StaticBuilderCreateAccount(props) {
    _classCallCheck(this, StaticBuilderCreateAccount);

    var _this = _possibleConstructorReturn(this, (StaticBuilderCreateAccount.__proto__ || Object.getPrototypeOf(StaticBuilderCreateAccount)).call(this, props));

    _this.closeCreateAccountModal = _this.closeCreateAccountModal.bind(_this);
    return _this;
  }

  _createClass(StaticBuilderCreateAccount, [{
    key: 'closeCreateAccountModal',
    value: function closeCreateAccountModal() {
      this.props.closeCreateAccountModal();
      if (this.props.hasFormSwiftLogoBeenClicked) {
        window.location.assign('/');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactModal2.default,
        {
          ariaHideApp: false,
          isOpen: this.props.isCreateAccountModalOpen,
          style: defaultModalStyle
        },
        _react2.default.createElement(
          'div',
          { className: 'static-builder-create-account-modal-wrapper' },
          _react2.default.createElement('button', {
            className: 'modal-close-btn',
            onClick: this.closeCreateAccountModal
          }),
          _react2.default.createElement(
            'div',
            { className: 'static-builder-create-account-modal-form-wrapper' },
            _react2.default.createElement(_RegisterForm2.default, {
              displayTOS: _RegisterFormConstants2.default.NONE,
              documentType: this.props.documentType,
              heading: 'Create a Free Account to Save Your Document',
              hideConfirmPassword: false,
              redirectToPage: window.location.href,
              sessionHash: this.props.sessionHash,
              sessionKey: this.props.sessionId
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'static-builder-create-account-modal-sidebar-wrapper' },
            _react2.default.createElement('img', {
              alt: 'free flag icon',
              className: 'static-builder-create-account-modal-free-flag-icon',
              src: '/images/free-flag.png'
            }),
            _react2.default.createElement(
              'p',
              { className: 'static-builder-create-account-modal-info-text' },
              'Create a free account to save your progress on this form. You can come back to it at any time.'
            ),
            _react2.default.createElement(
              'p',
              { className: 'static-builder-create-account-modal-sign-in-text' },
              'Already have an account?',
              _react2.default.createElement(
                'a',
                { href: '/sign-in' },
                'Sign in here'
              ),
              '.'
            )
          )
        )
      );
    }
  }]);

  return StaticBuilderCreateAccount;
}(_react2.default.PureComponent);

StaticBuilderCreateAccount.defaultProps = {
  sessionHash: '',
  sessionId: ''
};

StaticBuilderCreateAccount.propTypes = {
  closeCreateAccountModal: _propTypes2.default.func.isRequired,
  documentType: _propTypes2.default.string.isRequired,
  hasFormSwiftLogoBeenClicked: _propTypes2.default.bool.isRequired,
  isCreateAccountModalOpen: _propTypes2.default.bool.isRequired,
  sessionHash: _propTypes2.default.string,
  sessionId: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(_ref) {
  var StaticBuilderReducer = _ref.StaticBuilderReducer;
  return {
    documentType: StaticBuilderReducer.documentType,
    hasFormSwiftLogoBeenClicked: StaticBuilderReducer.hasFormSwiftLogoBeenClicked,
    isCreateAccountModalOpen: StaticBuilderReducer.isCreateAccountModalOpen,
    sessionHash: StaticBuilderReducer.sessionHash,
    sessionId: StaticBuilderReducer.sessionId
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    closeCreateAccountModal: _StaticBuilderActions.closeCreateAccountModal
  }, dispatch);
};

var StaticBuilderCreateAccountWithRedux = exports.StaticBuilderCreateAccountWithRedux = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(StaticBuilderCreateAccount);

exports.default = (0, _WithInit2.default)(StaticBuilderCreateAccountWithRedux, true);

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var mergeClassNames = function mergeClassNames() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (classList, arg) {
    return typeof arg === 'string' || arg instanceof Array ? classList.concat(arg) : classList;
  }, []).filter(function (className) {
    return className;
  }).join(' ');
};

exports.default = mergeClassNames;

/***/ }),

/***/ 1261:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticEmailButtonWithRedux = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _Icons = __webpack_require__(17);

var _SessionEmailActions = __webpack_require__(888);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticEmailButton = function StaticEmailButton(_ref) {
  var openModal = _ref.openEmailModal;
  return _react2.default.createElement(
    'button',
    { className: 'btn static-email-button', onClick: openModal },
    _react2.default.createElement(_Icons.ShareIcon, null)
  );
};

StaticEmailButton.propTypes = {
  openEmailModal: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    openEmailModal: _SessionEmailActions.openEmailModal
  }, dispatch);
};

var StaticEmailButtonWithRedux = exports.StaticEmailButtonWithRedux = ReactRedux.connect(null, mapDispatchToProps)(StaticEmailButton);

exports.default = (0, _WithInit2.default)(StaticEmailButtonWithRedux, true);

/***/ }),

/***/ 1262:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticEmailModalWithRedux = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _validator = __webpack_require__(202);

var _validator2 = _interopRequireDefault(_validator);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _DesignSystem = __webpack_require__(97);

var _ModalActions = __webpack_require__(398);

var _ModalActions2 = _interopRequireDefault(_ModalActions);

var _ModalBody = __webpack_require__(346);

var _ModalBody2 = _interopRequireDefault(_ModalBody);

var _ModalError = __webpack_require__(1373);

var _ModalError2 = _interopRequireDefault(_ModalError);

var _ModalHeader = __webpack_require__(347);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _EmailInput = __webpack_require__(819);

var _EmailInput2 = _interopRequireDefault(_EmailInput);

var _SessionEmailActions = __webpack_require__(888);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var StaticEmailModal = function StaticEmailModal(_ref) {
  var closeModal = _ref.closeEmailModal,
      documentType = _ref.documentType,
      emailSendError = _ref.emailSendError,
      isEmailModalOpen = _ref.isEmailModalOpen,
      sendEmail = _ref.sendSessionLinkEmail,
      sessionHash = _ref.sessionHash,
      sessionId = _ref.sessionId;

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      email = _useState2[0],
      setEmail = _useState2[1];

  var sendEmailOnClick = (0, _react.useCallback)(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!_validator2.default.isEmail(email.trim())) {
              _context.next = 3;
              break;
            }

            _context.next = 3;
            return sendEmail(sessionId, sessionHash, documentType, email, closeModal);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  })));

  var emailOnChange = (0, _react.useCallback)(function (e) {
    setEmail(e.target.value);
  });

  return _react2.default.createElement(
    _DesignSystem.FormSwiftModal,
    {
      className: 'send-session-link-email-modal',
      handleCloseModal: closeModal,
      isCloseButtonVisible: true,
      isOpen: isEmailModalOpen
    },
    _react2.default.createElement(_ModalError2.default, { errorCopy: emailSendError }),
    _react2.default.createElement(_ModalHeader2.default, { headerCopy: 'Access This Document Later' }),
    _react2.default.createElement(
      _ModalBody2.default,
      null,
      _react2.default.createElement(
        'p',
        { className: 'send-session-link-email-subheader' },
        'Send yourself a link to this document to complete and export at another time.'
      ),
      _react2.default.createElement(_EmailInput2.default, {
        id: 'sessionLinkEmailInput',
        label: 'Your Email Address:',
        onChange: emailOnChange,
        placeholder: 'Email',
        value: email
      })
    ),
    _react2.default.createElement(_ModalActions2.default, {
      primaryCta: {
        btnCopy: 'Send Link',
        className: 'send-session-link-email-button',
        onClick: sendEmailOnClick
      }
    })
  );
};

StaticEmailModal.defaultProps = {
  documentType: '',
  emailSendError: '',
  isEmailModalOpen: false,
  sessionHash: '',
  sessionId: ''
};

StaticEmailModal.propTypes = {
  closeEmailModal: _propTypes2.default.func.isRequired,
  documentType: _propTypes2.default.string,
  emailSendError: _propTypes2.default.string,
  isEmailModalOpen: _propTypes2.default.bool,
  sendSessionLinkEmail: _propTypes2.default.func.isRequired,
  sessionHash: _propTypes2.default.string,
  sessionId: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(_ref3) {
  var SessionEmailReducer = _ref3.SessionEmailReducer;
  return {
    emailSendError: SessionEmailReducer.emailSendError,
    isEmailModalOpen: SessionEmailReducer.isEmailModalOpen
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    closeEmailModal: _SessionEmailActions.closeEmailModal,
    sendSessionLinkEmail: _SessionEmailActions.sendSessionLinkEmail
  }, dispatch);
};

var StaticEmailModalWithRedux = exports.StaticEmailModalWithRedux = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(StaticEmailModal);

exports.default = (0, _WithInit2.default)(StaticEmailModalWithRedux, true);

/***/ }),

/***/ 1263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondActionModalWithRedux = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var _redux = __webpack_require__(4);

var _actions = __webpack_require__(218);

var _SecondActionModalV = __webpack_require__(1738);

var _SecondActionModalV2 = _interopRequireDefault(_SecondActionModalV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SecondActionModal = function SecondActionModal(props) {
  return _react2.default.createElement(_SecondActionModalV2.default, props);
};

SecondActionModal.propTypes = {
  closeStaticSecondActionModal: _propTypes2.default.func.isRequired,
  isSecondActionModalOpen: _propTypes2.default.bool.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({ closeStaticSecondActionModal: _actions.closeStaticSecondActionModal }, dispatch);
};

var mapStateToProps = function mapStateToProps(_ref) {
  var StaticBuilderModalHandler = _ref.StaticBuilderModalHandler,
      StaticBuilderReducer = _ref.StaticBuilderReducer;
  return {
    isSecondActionModalOpen: StaticBuilderModalHandler.isSecondActionModalOpen,
    fieldOutline: StaticBuilderReducer.fieldOutline
  };
};

var SecondActionModalWithRedux = exports.SecondActionModalWithRedux = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SecondActionModal);

exports.default = (0, _WithInit2.default)(SecondActionModalWithRedux, true);

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Decades = __webpack_require__(302);

var _Decades2 = _interopRequireDefault(_Decades);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CenturyView = function (_PureComponent) {
  _inherits(CenturyView, _PureComponent);

  function CenturyView() {
    _classCallCheck(this, CenturyView);

    return _possibleConstructorReturn(this, (CenturyView.__proto__ || Object.getPrototypeOf(CenturyView)).apply(this, arguments));
  }

  _createClass(CenturyView, [{
    key: 'renderDecades',
    value: function renderDecades() {
      return _react2.default.createElement(_Decades2.default, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'react-calendar__century-view' },
        this.renderDecades()
      );
    }
  }]);

  return CenturyView;
}(_react.PureComponent);

exports.default = CenturyView;


CenturyView.propTypes = {
  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
  maxDate: _propTypes3.isMaxDate,
  minDate: _propTypes3.isMinDate,
  onChange: _propTypes2.default.func,
  setActiveRange: _propTypes2.default.func,
  value: _propTypes3.isValue,
  valueType: _propTypes2.default.string
};

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Years = __webpack_require__(304);

var _Years2 = _interopRequireDefault(_Years);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DecadeView = function (_PureComponent) {
  _inherits(DecadeView, _PureComponent);

  function DecadeView() {
    _classCallCheck(this, DecadeView);

    return _possibleConstructorReturn(this, (DecadeView.__proto__ || Object.getPrototypeOf(DecadeView)).apply(this, arguments));
  }

  _createClass(DecadeView, [{
    key: 'renderYears',
    value: function renderYears() {
      return _react2.default.createElement(_Years2.default, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'react-calendar__decade-view' },
        this.renderYears()
      );
    }
  }]);

  return DecadeView;
}(_react.PureComponent);

exports.default = DecadeView;


DecadeView.propTypes = {
  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
  maxDate: _propTypes3.isMaxDate,
  minDate: _propTypes3.isMinDate,
  onChange: _propTypes2.default.func,
  setActiveRange: _propTypes2.default.func,
  value: _propTypes3.isValue,
  valueType: _propTypes2.default.string
};

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Days = __webpack_require__(306);

var _Days2 = _interopRequireDefault(_Days);

var _Weekdays = __webpack_require__(309);

var _Weekdays2 = _interopRequireDefault(_Weekdays);

var _WeekNumbers = __webpack_require__(308);

var _WeekNumbers2 = _interopRequireDefault(_WeekNumbers);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MonthView = function (_PureComponent) {
  _inherits(MonthView, _PureComponent);

  function MonthView() {
    _classCallCheck(this, MonthView);

    return _possibleConstructorReturn(this, (MonthView.__proto__ || Object.getPrototypeOf(MonthView)).apply(this, arguments));
  }

  _createClass(MonthView, [{
    key: 'renderWeekdays',
    value: function renderWeekdays() {
      var _props = this.props,
          activeStartDate = _props.activeStartDate,
          formatShortWeekday = _props.formatShortWeekday,
          locale = _props.locale;


      return _react2.default.createElement(_Weekdays2.default, {
        calendarType: this.calendarType,
        locale: locale,
        month: activeStartDate,
        formatShortWeekday: formatShortWeekday
      });
    }
  }, {
    key: 'renderWeekNumbers',
    value: function renderWeekNumbers() {
      var showWeekNumbers = this.props.showWeekNumbers;


      if (!showWeekNumbers) {
        return null;
      }

      var _props2 = this.props,
          activeStartDate = _props2.activeStartDate,
          onClickWeekNumber = _props2.onClickWeekNumber,
          showFixedNumberOfWeeks = _props2.showFixedNumberOfWeeks;


      return _react2.default.createElement(_WeekNumbers2.default, {
        activeStartDate: activeStartDate,
        calendarType: this.calendarType,
        onClickWeekNumber: onClickWeekNumber,
        showFixedNumberOfWeeks: showFixedNumberOfWeeks
      });
    }
  }, {
    key: 'renderDays',
    value: function renderDays() {
      var _props3 = this.props,
          calendarType = _props3.calendarType,
          showWeekNumbers = _props3.showWeekNumbers,
          childProps = _objectWithoutProperties(_props3, ['calendarType', 'showWeekNumbers']);

      return _react2.default.createElement(_Days2.default, _extends({
        calendarType: this.calendarType
      }, childProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var showWeekNumbers = this.props.showWeekNumbers;


      var className = 'react-calendar__month-view';

      return _react2.default.createElement(
        'div',
        {
          className: [className, showWeekNumbers ? className + '--weekNumbers' : ''].join(' ')
        },
        _react2.default.createElement(
          'div',
          {
            style: {
              display: 'flex',
              alignItems: 'flex-end'
            }
          },
          this.renderWeekNumbers(),
          _react2.default.createElement(
            'div',
            {
              style: {
                flexGrow: 1,
                width: '100%'
              }
            },
            this.renderWeekdays(),
            this.renderDays()
          )
        )
      );
    }
  }, {
    key: 'calendarType',
    get: function get() {
      var _props4 = this.props,
          calendarType = _props4.calendarType,
          locale = _props4.locale;


      if (calendarType) {
        return calendarType;
      }

      switch (locale) {
        case 'en-CA':
        case 'en-US':
        case 'es-AR':
        case 'es-BO':
        case 'es-CL':
        case 'es-CO':
        case 'es-CR':
        case 'es-DO':
        case 'es-EC':
        case 'es-GT':
        case 'es-HN':
        case 'es-MX':
        case 'es-NI':
        case 'es-PA':
        case 'es-PE':
        case 'es-PR':
        case 'es-SV':
        case 'es-VE':
        case 'pt-BR':
          return 'US';
        // ar-LB, ar-MA intentionally missing
        case 'ar':
        case 'ar-AE':
        case 'ar-BH':
        case 'ar-DZ':
        case 'ar-EG':
        case 'ar-IQ':
        case 'ar-JO':
        case 'ar-KW':
        case 'ar-LY':
        case 'ar-OM':
        case 'ar-QA':
        case 'ar-SA':
        case 'ar-SD':
        case 'ar-SY':
        case 'ar-YE':
        case 'dv':
        case 'dv-MV':
        case 'ps':
        case 'ps-AR':
          return 'Arabic';
        case 'he':
        case 'he-IL':
          return 'Hebrew';
        default:
          return 'ISO 8601';
      }
    }
  }]);

  return MonthView;
}(_react.PureComponent);

exports.default = MonthView;


MonthView.propTypes = {
  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
  calendarType: _propTypes3.isCalendarType,
  formatShortWeekday: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  maxDate: _propTypes3.isMaxDate,
  minDate: _propTypes3.isMinDate,
  onChange: _propTypes2.default.func,
  onClickWeekNumber: _propTypes2.default.func,
  setActiveRange: _propTypes2.default.func,
  showFixedNumberOfWeeks: _propTypes2.default.bool,
  showNeighboringMonth: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,
  value: _propTypes3.isValue,
  valueType: _propTypes2.default.string
};

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Months = __webpack_require__(311);

var _Months2 = _interopRequireDefault(_Months);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var YearView = function (_PureComponent) {
  _inherits(YearView, _PureComponent);

  function YearView() {
    _classCallCheck(this, YearView);

    return _possibleConstructorReturn(this, (YearView.__proto__ || Object.getPrototypeOf(YearView)).apply(this, arguments));
  }

  _createClass(YearView, [{
    key: 'renderMonths',
    value: function renderMonths() {
      return _react2.default.createElement(_Months2.default, this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'react-calendar__year-view' },
        this.renderMonths()
      );
    }
  }]);

  return YearView;
}(_react.PureComponent);

exports.default = YearView;


YearView.propTypes = {
  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
  formatMonth: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  maxDate: _propTypes3.isMaxDate,
  minDate: _propTypes3.isMinDate,
  onChange: _propTypes2.default.func,
  setActiveRange: _propTypes2.default.func,
  value: _propTypes3.isValue,
  valueType: _propTypes2.default.string
};

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTileClasses = exports.between = exports.doRangesOverlap = exports.isRangeWithinRange = exports.isValueWithinRange = exports.callIfDefined = exports.mergeFunctions = undefined;

var _dates = __webpack_require__(15);

/**
 * Returns a function that, when called, calls all the functions
 * passed to it, applying its arguments to them.
 *
 * @param {Function[]} functions
 */
var mergeFunctions = exports.mergeFunctions = function mergeFunctions() {
  for (var _len = arguments.length, functions = Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return functions.filter(Boolean).forEach(function (f) {
      return f.apply(undefined, args);
    });
  };
};

/**
 * Calls a function, if it's defined, with specified arguments
 * @param {Function} fn
 * @param {Object} args
 */
var callIfDefined = exports.callIfDefined = function callIfDefined(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  if (fn && typeof fn === 'function') {
    fn.apply(undefined, args);
  }
};

var isValueWithinRange = exports.isValueWithinRange = function isValueWithinRange(value, range) {
  return range[0] <= value && range[1] >= value;
};

var isRangeWithinRange = exports.isRangeWithinRange = function isRangeWithinRange(greaterRange, smallerRange) {
  return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
};

var doRangesOverlap = exports.doRangesOverlap = function doRangesOverlap(range1, range2) {
  return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
};

/**
 * Returns a value no smaller than min and no larger than max.
 *
 * @param {*} value Value to return.
 * @param {*} min Minimum return value.
 * @param {*} max Maximum return value.
 */
var between = exports.between = function between(value, min, max) {
  if (min && min > value) {
    return min;
  }
  if (max && max < value) {
    return max;
  }
  return value;
};

var isEqual = function isEqual(date1, date2) {
  return new Date(date1).getTime() === new Date(date2).getTime();
};

var getTileClasses = exports.getTileClasses = function getTileClasses() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      value = _ref.value,
      valueType = _ref.valueType,
      date = _ref.date,
      dateType = _ref.dateType,
      hover = _ref.hover;

  var className = 'react-calendar__tile';
  var classes = [className];

  if (!date) {
    return classes;
  }

  if (!(date instanceof Array) && !dateType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }

  var now = new Date();
  var dateRange = date instanceof Array ? date : (0, _dates.getRange)(dateType, date);

  if (isValueWithinRange(now, dateRange)) {
    classes.push(className + '--now');
  }

  if (!value) {
    return classes;
  }

  if (!(value instanceof Array) && !valueType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }

  var valueRange = value instanceof Array ? value : (0, _dates.getRange)(valueType, value);

  if (isRangeWithinRange(valueRange, dateRange)) {
    classes.push(className + '--active');
  } else if (doRangesOverlap(valueRange, dateRange)) {
    classes.push(className + '--hasActive');
  } else if (hover && (
  // Date before value
  dateRange[1] < valueRange[0] && isRangeWithinRange([hover, valueRange[0]], dateRange) ||
  // Date after value
  dateRange[0] > valueRange[1] && isRangeWithinRange([valueRange[1], hover], dateRange))) {
    classes.push(className + '--hover');
  }

  var isRangeStart = isEqual(dateRange[0], valueRange[0]);
  var isRangeEnd = isEqual(dateRange[1], valueRange[1]);

  if (isRangeStart) {
    classes.push(className + '--rangeStart');
  }

  if (isRangeEnd) {
    classes.push(className + '--rangeEnd');
  }

  if (isRangeStart && isRangeEnd) {
    classes.push(className + '--rangeBothEnds');
  }

  return classes;
};

/***/ }),

/***/ 1311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _StaticBuilder = __webpack_require__(167);

var _StaticBuilder2 = _interopRequireDefault(_StaticBuilder);

var _StaticBuilderProgressBarWrapper = __webpack_require__(206);

var _StaticBuilderProgressBarWrapper2 = _interopRequireDefault(_StaticBuilderProgressBarWrapper);

var _StaticEmailButton = __webpack_require__(1261);

var _StaticEmailButton2 = _interopRequireDefault(_StaticEmailButton);

var _StaticEmailModal = __webpack_require__(1262);

var _StaticEmailModal2 = _interopRequireDefault(_StaticEmailModal);

var _ExportProgressBar = __webpack_require__(318);

var _ExportProgressBar2 = _interopRequireDefault(_ExportProgressBar);

var _ReactivationBanner = __webpack_require__(135);

var _Modals = __webpack_require__(169);

var _ExportDocumentPreviewAnimation = __webpack_require__(1222);

var _ExportDocumentPreviewAnimation2 = _interopRequireDefault(_ExportDocumentPreviewAnimation);

var _messageHandler = __webpack_require__(71);

var _messageHandler2 = _interopRequireDefault(_messageHandler);

var _CreateAccount = __webpack_require__(496);

var _CreateAccount2 = _interopRequireDefault(_CreateAccount);

var _FinishLater = __webpack_require__(1233);

var _FinishLater2 = _interopRequireDefault(_FinishLater);

var _StaticBuilderCreateAccount = __webpack_require__(1234);

var _StaticBuilderCreateAccount2 = _interopRequireDefault(_StaticBuilderCreateAccount);

var _SecondActionModal = __webpack_require__(1263);

var _SecondActionModal2 = _interopRequireDefault(_SecondActionModal);

var _downloadOverlay = __webpack_require__(153);

var _downloadOverlay2 = _interopRequireDefault(_downloadOverlay);

var _downloadOverlayManager = __webpack_require__(102);

var _downloadOverlayManager2 = _interopRequireDefault(_downloadOverlayManager);

var _reactCompatibility = __webpack_require__(40);

var _reactCompatibility2 = _interopRequireDefault(_reactCompatibility);

var _StaticRequestSignatureContentSection = __webpack_require__(151);

var _StaticRequestSignatureContentSection2 = _interopRequireDefault(_StaticRequestSignatureContentSection);

var _StaticCreateAccountSection = __webpack_require__(207);

var _StaticCreateAccountSection2 = _interopRequireDefault(_StaticCreateAccountSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(67);
__webpack_require__(168);
window.SessionManager = __webpack_require__(154);
window.OfferManager = __webpack_require__(72);
window.Form1099MiscEFile2014 = __webpack_require__(1194);
window.Form1099MiscEFile2015 = __webpack_require__(1195);
window.Form1099MiscEFile2016 = __webpack_require__(1196);
window.Form1099MiscEFile2017 = __webpack_require__(488);
window.Form1099MiscEFile2018 = __webpack_require__(489);
window.Form1099MiscEFile2019 = __webpack_require__(490);
window.Form1099MiscEFile2020 = __webpack_require__(491);
window.Form1099MiscEFile2021 = __webpack_require__(1197);
window.Form1099MiscEFile2022 = __webpack_require__(1198);
window.Form1099NECEFile2020 = __webpack_require__(1199);
window.Form1099NECEFile2021 = __webpack_require__(1200);
window.Form1099NECEFile2022 = __webpack_require__(1201);
window.FormW92014 = __webpack_require__(1208);
window.FormW2EFile2014 = __webpack_require__(1203);
window.FormW2EFile2015 = __webpack_require__(1204);
window.FormW2EFile2016 = __webpack_require__(1205);
window.FormW2EFile2017 = __webpack_require__(492);
window.FormW2EFile2018 = __webpack_require__(493);
window.FormW2EFile2019 = __webpack_require__(494);
window.FormW2EFile2020 = __webpack_require__(495);
window.FormW2EFile2021 = __webpack_require__(1206);
window.FormW2EFile2022 = __webpack_require__(1207);
window.FormEmployeePaystub = __webpack_require__(1202);
window.FillStaticPdf = __webpack_require__(1193);
window.ProgressCircle = __webpack_require__(1214);

window.StaticBuilderNavSideBarWrapper = _StaticBuilder.StaticBuilderNavSideBarWrapper;
window.BuilderReactivationBanner = _ReactivationBanner.BuilderReactivationBanner;
window.DownloadOverlayManager = _downloadOverlayManager2.default;
window.DownloadOverlayContainer = _downloadOverlay2.default;
window.NavSideBarList = _StaticBuilder.NavSideBarList;
window.NavSideBarMenuButton = _StaticBuilder.NavSideBarMenuButton;
window.ReactCompatibility = _reactCompatibility2.default;
window.ReactivationOfferModal = _Modals.ReactivationOfferModal;
window.StaticBuilder = _StaticBuilder2.default;
window.StaticRequestSignatureContentSection = _StaticRequestSignatureContentSection2.default;
window.StaticCreateAccountSection = _StaticCreateAccountSection2.default;
window.StaticBuilderDocumentPreview = _StaticBuilder.StaticBuilderDocumentPreview;
window.StaticBuilderDocumentPreviewTitle = _StaticBuilder.StaticBuilderDocumentPreviewTitle;
window.StaticBuilderSection = _StaticBuilder.StaticBuilderSection;
window.ExportProgressBar = _ExportProgressBar2.default;
window.ExportDocumentPreviewAnimation = _ExportDocumentPreviewAnimation2.default;
window.ExportProgressBarModal = _Modals.ExportProgressBarModal;
window.CreateAccountModal = _CreateAccount2.default;
window.FinishLaterModal = _FinishLater2.default;
window.SecondActionModal = _SecondActionModal2.default;
window.MessageHandler = _messageHandler2.default;
window.StaticBuilderProgressBarWrapper = _StaticBuilderProgressBarWrapper2.default;
window.StaticBuilderCreateAccountModal = _StaticBuilderCreateAccount2.default;
window.StaticEmailButton = _StaticEmailButton2.default;
window.StaticEmailModal = _StaticEmailModal2.default;
// duplicating logic in onboardingTour.js to show the react second action modal on first export
var showModalOnFirstExport = function showModalOnFirstExport() {
  var docCount = Number(window.COOKIE.get('num_of_docs'));
  var firstDocumentExported = window.COOKIE.get('firstDocumentExported');
  if (!firstDocumentExported && docCount === 1) {
    window.COOKIE.set('firstDocumentExported', 1);
    _reactCompatibility2.default.openStaticSecondActionModal();
  }
};

// wrapper to test exportStaticWithURL
window.redirect = function (path) {
  if (path) {
    window.location = path;
  }
};

window.exportStaticWithURL = function (trackCategory, trackAction, url, autoPrint) {
  window._track(trackCategory, trackAction);
  window.SessionManager.save();

  // Put this url in global scope so we can pull out the url to go to if the export request
  // succeeds. Not sure why this doesn't work as a closure
  window.exportURL = url;

  var offerManager = new window.OfferManager();
  var exportCallback = function exportCallback() {
    offerManager.requestExport(function () {
      if (typeof FreemiumBox !== 'undefined') {
        window.FreemiumBox.deductCredit();
      }

      // Only show the Download Overlay for downloads
      // and if we're not in autoPrint mode
      if (!autoPrint) {
        window.DownloadOverlayManager.show();
      }

      window.redirect(window.exportURL);
    }, '/new-account-for-doc?' + window.location.search.substr(1), true);
    showModalOnFirstExport();
    window.onbeforeunload = function () {
      return null;
    };
  };
  window.ProgressCircle.init(exportCallback);
  return false;
};

window.exportStatic = function (e, trackCategory, trackAction, button, autoPrint) {
  e.preventDefault();
  return window.exportStaticWithURL(trackCategory, trackAction, $(button).attr('href'), autoPrint);
};

window.fixStaticBuilderNavPlacement = function () {
  // Adjust for the precense of the message bar on the static and visual static builders
  if ($('.message-bar').length) {
    $('#exportButtons').css('top', '+=' + $('.message-bar').outerHeight());
  }
};

window.activateBootstrapTooltips = function () {
  $('button[rel=tooltip]').tooltip({ placement: 'right' });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BuilderReactivationBanner = __webpack_require__(240);

Object.defineProperty(exports, 'BuilderReactivationBanner', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BuilderReactivationBanner).default;
  }
});

var _MembersAreaReactivationBanner = __webpack_require__(241);

Object.defineProperty(exports, 'MembersAreaReactivationBanner', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MembersAreaReactivationBanner).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreatorButtons = function CreatorButtons(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'button',
      {
        id: props.addBtnData.id,
        className: props.addBtnData.className,
        onClick: props.addBtnData.click
      },
      props.addBtnData.text
    ),
    _react2.default.createElement(
      'button',
      {
        id: props.cancelBtnData.id,
        className: props.cancelBtnData.className,
        onClick: props.cancelBtnData.click
      },
      props.cancelBtnData.text
    )
  );
};

CreatorButtons.propTypes = {
  addBtnData: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    className: _propTypes2.default.string,
    click: _propTypes2.default.func,
    text: _propTypes2.default.string
  }).isRequired,
  cancelBtnData: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    className: _propTypes2.default.string,
    click: _propTypes2.default.func,
    text: _propTypes2.default.string
  }).isRequired
};

CreatorButtons.defaultProps = {
  addBtnData: {
    id: '',
    className: 'btn btn-large btn-success save-use-btn',
    click: function click() {},
    text: 'Add Signature'
  },
  cancelBtnData: {
    id: '',
    className: 'btn btn-large save-use-btn',
    click: function click() {},
    text: 'Cancel'
  }
};

exports.default = CreatorButtons;

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _SignatureManagerActions = __webpack_require__(140);

var SignatureManagerActions = _interopRequireWildcard(_SignatureManagerActions);

var _actions = __webpack_require__(52);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var withSignatures = function withSignatures(WrappedComponent) {
  var mapStateToProps = function mapStateToProps(_ref) {
    var SignatureHandler = _ref.SignatureHandler;
    return {
      imageUrls: SignatureHandler.imageUrls,
      lastUsedImageType: SignatureHandler.lastUsedImageType,
      lastUsedImageUrl: SignatureHandler.lastUsedImageUrl
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)(_extends({}, SignatureManagerActions, {
      createSigPopup: _actions.createSigPopup,
      createSignatureEvent: _actions.createSignatureEvent
    }), dispatch);
  };

  var ConnectedSignatureComponent = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);

  var SignatureContainerWithInit = (0, _WithInit2.default)(ConnectedSignatureComponent, true);

  return SignatureContainerWithInit;
};

exports.default = withSignatures;

/***/ }),

/***/ 1373:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Alert = __webpack_require__(324);

var _Alert2 = _interopRequireDefault(_Alert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalError = function ModalError(_ref) {
  var errorCopy = _ref.errorCopy;

  if (!errorCopy) {
    return null;
  }
  return _react2.default.createElement(_Alert2.default, {
    className: 'ds-modal-error-banner',
    text: errorCopy,
    type: _Alert.AlertTypes.Error
  });
};

ModalError.defaultProps = {
  errorCopy: ''
};

ModalError.propTypes = {
  errorCopy: _propTypes2.default.string
};

exports.default = ModalError;

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviewButton = function PreviewButton(props) {
  return props.isVisible ? _react2.default.createElement(
    'button',
    {
      id: props.id,
      className: props.className,
      onClick: props.click
    },
    props.text
  ) : null;
};

PreviewButton.propTypes = {
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  click: _propTypes2.default.func,
  text: _propTypes2.default.string,
  isVisible: _propTypes2.default.bool
};

PreviewButton.defaultProps = {
  id: '',
  className: '',
  click: function click() {},
  text: '',
  isVisible: true
};

exports.default = PreviewButton;

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSignatureCanvas = __webpack_require__(149);

var _reactSignatureCanvas2 = _interopRequireDefault(_reactSignatureCanvas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SignatureCreator = function (_React$Component) {
  _inherits(SignatureCreator, _React$Component);

  _createClass(SignatureCreator, null, [{
    key: 'clearInput',
    value: function clearInput() {
      var sigText = document.getElementById('sig-text');
      if (sigText) {
        sigText.value = '';
      }
    }
  }, {
    key: 'enableAddSignature',
    value: function enableAddSignature() {
      var addSigBtn = document.querySelector('.signature-manager-container button.btn-large.save-use-btn');
      if (addSigBtn) {
        addSigBtn.classList.remove('disabled');
      }
    }
  }]);

  function SignatureCreator(props) {
    _classCallCheck(this, SignatureCreator);

    var _this = _possibleConstructorReturn(this, (SignatureCreator.__proto__ || Object.getPrototypeOf(SignatureCreator)).call(this, props));

    _this.displayToolbox = _this.displayToolbox.bind(_this);
    _this.clearCanvas = _this.clearCanvas.bind(_this);
    return _this;
  }

  _createClass(SignatureCreator, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!nextProps.visible) {
        SignatureCreator.clearInput();
        this.clearCanvas();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.visible && this.props.type === 'type') {
        this.typeCreator.focus();
      }
    }
  }, {
    key: 'displayToolbox',
    value: function displayToolbox(type) {
      if (this.props.type === type && this.props.visible) {
        return { display: 'block' };
      }
      return { display: 'none' };
    }
  }, {
    key: 'clearCanvas',
    value: function clearCanvas() {
      this.sigCanvas.clear();
    }
  }, {
    key: 'saveCanvas',
    value: function saveCanvas() {
      return this.sigCanvas.getTrimmedCanvas().toDataURL();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var sigPadClass = this.props.isTouchDevice ? 'signature-pad touch-device' : 'signature-pad';
      var canvasProperties = {
        className: 'pad sig-draw-pad',
        height: this.props.sigPadHeight,
        id: 'sig-draw-pad',
        width: this.props.sigPadWidth,

        style: {
          boxShadow: 'none'
        }
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { id: 'sig-type-toolbox', className: 'sig-type-toolbox', style: this.displayToolbox('type') },
          _react2.default.createElement(
            'label',
            { htmlFor: 'sig-text' },
            this.props.typeLabel
          ),
          _react2.default.createElement('input', {
            type: 'text',
            name: 'sig-text',
            id: 'sig-text',
            className: 'sig-text',
            maxLength: '35',
            ref: function ref(input) {
              _this2.typeCreator = input;
            },
            onKeyPress: SignatureCreator.enableAddSignature
          }),
          _react2.default.createElement(
            'div',
            { className: 'sig-marker' },
            'X'
          ),
          _react2.default.createElement('div', { className: 'teaxarea-triangle' })
        ),
        _react2.default.createElement(
          'div',
          { id: 'sig-draw-toolbox', className: 'sig-draw-toolbox', style: this.displayToolbox('draw') },
          _react2.default.createElement(
            'p',
            { className: 'signature-label' },
            this.props.drawLabel
          ),
          _react2.default.createElement(
            'div',
            {
              className: sigPadClass,
              onMouseUp: SignatureCreator.enableAddSignature
            },
            _react2.default.createElement(_reactSignatureCanvas2.default, {
              velocityFilterWeight: 0.7,
              minWidth: 0.5,
              maxWidth: 2,
              dotSize: 1.25,
              ref: function ref(canvas) {
                _this2.sigCanvas = canvas;
              },
              canvasProps: canvasProperties
            })
          ),
          _react2.default.createElement(
            'a',
            {
              href: '#clear',
              className: 'clear-button btn btn-mini',
              role: 'button',
              onClick: this.clearCanvas
            },
            this.props.clearBtnText
          ),
          _react2.default.createElement('div', { className: 'teaxarea-triangle' })
        )
      );
    }
  }]);

  return SignatureCreator;
}(_react2.default.Component);

exports.default = SignatureCreator;


SignatureCreator.propTypes = {
  visible: _propTypes2.default.bool.isRequired,
  isTouchDevice: _propTypes2.default.bool,
  type: _propTypes2.default.string,
  typeLabel: _propTypes2.default.string,
  drawLabel: _propTypes2.default.string,
  clearBtnText: _propTypes2.default.string,
  sigPadHeight: _propTypes2.default.number,
  sigPadWidth: _propTypes2.default.number
};

SignatureCreator.defaultProps = {
  isTouchDevice: false,
  type: null,
  typeLabel: null,
  drawLabel: null,
  clearBtnText: 'Clear',
  sigPadHeight: 0,
  sigPadWidth: 0
};

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignaturePreviewButtons = __webpack_require__(143);

var _SignaturePreviewButtons2 = _interopRequireDefault(_SignaturePreviewButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var emptyBtnStyle = {
  height: '100%',
  border: 'none',
  background: 'transparent'
};

var SignaturePreview = function (_React$Component) {
  _inherits(SignaturePreview, _React$Component);

  function SignaturePreview(props) {
    _classCallCheck(this, SignaturePreview);

    var _this = _possibleConstructorReturn(this, (SignaturePreview.__proto__ || Object.getPrototypeOf(SignaturePreview)).call(this, props));

    _this.renderTitle = _this.renderTitle.bind(_this);
    _this.renderContent = _this.renderContent.bind(_this);
    return _this;
  }

  _createClass(SignaturePreview, [{
    key: 'renderTitle',
    value: function renderTitle() {
      return this.props.title ? _react2.default.createElement(
        'div',
        { className: 'title' },
        this.props.title
      ) : null;
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _this2 = this;

      if (this.props.imageUrl) {
        return _react2.default.createElement(
          'div',
          { className: 'img-wrap-container' },
          _react2.default.createElement(
            'button',
            {
              className: 'img-wrap',
              onClick: function onClick(e) {
                _this2.props.submitPopup(_this2.props.type, e);
              }
            },
            _react2.default.createElement('img', { src: this.props.imageUrl, alt: '' })
          ),
          _react2.default.createElement(_SignaturePreviewButtons2.default, {
            deleteSignatureOnClick: this.props.submitClear,
            hasUseButton: this.props.forSigning,
            type: this.props.type,
            useSignatureOnClick: this.props.submitPopup
          })
        );
      }

      switch (this.props.type) {
        case 'type':
          return _react2.default.createElement(
            'button',
            {
              className: 'empty',
              style: emptyBtnStyle,
              onClick: function onClick() {
                _this2.props.submitCreator('type');
              }
            },
            this.props.buttonText,
            this.props.buttonChildren
          );
        case 'draw':
          return _react2.default.createElement(
            'button',
            {
              className: 'empty',
              style: emptyBtnStyle,
              onClick: function onClick() {
                _this2.props.submitCreator('draw');
              }
            },
            this.props.buttonText,
            this.props.buttonChildren
          );
        case 'upload':
          return _react2.default.createElement(
            'button',
            {
              className: 'empty',
              style: emptyBtnStyle,
              onClick: function onClick() {
                _this2.props.submitCreator('upload');
              }
            },
            this.props.buttonText,
            this.props.buttonChildren
          );
        default:
          return '';
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var boxClass = this.props.type + '-box box';
      var contentClass = this.props.imageUrl ? 'content my-docs-redesign' : 'content my-docs-redesign content-empty';

      return !this.props.visible ? null : _react2.default.createElement(
        'div',
        { className: boxClass },
        this.renderTitle(),
        _react2.default.createElement(
          'div',
          {
            className: contentClass
          },
          this.renderContent()
        )
      );
    }
  }]);

  return SignaturePreview;
}(_react2.default.Component);

exports.default = SignaturePreview;


SignaturePreview.propTypes = {
  buttonChildren: _propTypes2.default.node,
  buttonText: _propTypes2.default.string,
  forSigning: _propTypes2.default.bool,
  imageUrl: _propTypes2.default.string,
  submitClear: _propTypes2.default.func.isRequired,
  submitCreator: _propTypes2.default.func.isRequired,
  submitPopup: _propTypes2.default.func,
  title: _propTypes2.default.string,
  type: _propTypes2.default.string.isRequired,
  visible: _propTypes2.default.bool.isRequired
};

SignaturePreview.defaultProps = {
  buttonChildren: null,
  buttonText: 'Add Your Signature',
  forSigning: false,
  imageUrl: null,
  submitPopup: null,
  title: null
};

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Buttons = __webpack_require__(12);

var _Icons = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeleteSignatureButton = function DeleteSignatureButton(_ref) {
  var deleteSignatureOnClick = _ref.deleteSignatureOnClick,
      hasLabel = _ref.hasLabel,
      type = _ref.type;
  return _react2.default.createElement(
    _Buttons.PrimaryButton,
    {
      className: 'signature-preview-button btn btn-mini btn-danger remove-btn',
      onClick: function onClick(e) {
        deleteSignatureOnClick(type, e);
      },
      size: 'xs',
      variation: 'destructive'
    },
    _react2.default.createElement(
      'span',
      { className: 'my-documents-button delete-signature-trash-icon' },
      _react2.default.createElement(_Icons.TrashIcon, null),
      hasLabel ? ' Delete' : ''
    )
  );
};

DeleteSignatureButton.defaultProps = {
  hasLabel: true
};

DeleteSignatureButton.propTypes = {
  deleteSignatureOnClick: _propTypes2.default.func.isRequired,
  hasLabel: _propTypes2.default.bool,
  type: _propTypes2.default.string.isRequired
};

exports.default = DeleteSignatureButton;

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DeleteSignatureButton = __webpack_require__(142);

var _DeleteSignatureButton2 = _interopRequireDefault(_DeleteSignatureButton);

var _UseSignatureButton = __webpack_require__(144);

var _UseSignatureButton2 = _interopRequireDefault(_UseSignatureButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignaturePreviewButtons = function SignaturePreviewButtons(_ref) {
  var deleteSignatureOnClick = _ref.deleteSignatureOnClick,
      hasUseButton = _ref.hasUseButton,
      type = _ref.type,
      useSignatureOnClick = _ref.useSignatureOnClick;
  return _react2.default.createElement(
    'div',
    { className: 'buttons signature-preview-buttons' },
    _react2.default.createElement(_DeleteSignatureButton2.default, {
      deleteSignatureOnClick: deleteSignatureOnClick,
      hasLabel: !hasUseButton,
      type: type
    }),
    hasUseButton && _react2.default.createElement(_UseSignatureButton2.default, { useSignatureOnClick: useSignatureOnClick, type: type })
  );
};

SignaturePreviewButtons.defaultProps = {
  hasUseButton: false
};

SignaturePreviewButtons.propTypes = {
  deleteSignatureOnClick: _propTypes2.default.func.isRequired,
  hasUseButton: _propTypes2.default.bool,
  type: _propTypes2.default.string.isRequired,
  useSignatureOnClick: _propTypes2.default.func.isRequired
};

exports.default = SignaturePreviewButtons;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Buttons = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UseSignatureButton = function UseSignatureButton(_ref) {
  var type = _ref.type,
      useSignatureOnClick = _ref.useSignatureOnClick;
  return _react2.default.createElement(
    _Buttons.PrimaryButton,
    {
      className: 'signature-preview-button use-btn',
      onClick: function onClick(e) {
        useSignatureOnClick(type, e);
      },
      size: 'xs',
      variation: 'normal'
    },
    'Use Signature'
  );
};

UseSignatureButton.propTypes = {
  type: _propTypes2.default.string.isRequired,
  useSignatureOnClick: _propTypes2.default.func.isRequired
};

exports.default = UseSignatureButton;

/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactAnimateHeight = __webpack_require__(2403);

var _reactAnimateHeight2 = _interopRequireDefault(_reactAnimateHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviewAnimationOverlay = function PreviewAnimationOverlay(props) {
  return _react2.default.createElement(
    _reactAnimateHeight2.default,
    {
      duration: props.progressBarAnimation.stepInterval,
      height: props.progressBarAnimation.started ? 500.0 * (1.0 - props.progressBarAnimation.step / (props.progressBarAnimation.totalSteps - 1)) : '500',
      easing: 'linear',
      style: {
        position: 'absolute',
        width: '100%',
        bottom: 0
      }
    },
    _react2.default.createElement('iframe', {
      className: 'document-preview',
      scrolling: 'no',
      style: {
        WebkitFilter: 'blur(8px)',
        height: 500,
        width: '100%',
        position: 'absolute',
        bottom: 0
      },
      src: props.src
    })
  );
};

PreviewAnimationOverlay.propTypes = {
  progressBarAnimation: _propTypes2.default.shape({
    started: _propTypes2.default.bool,
    step: _propTypes2.default.number,
    totalSteps: _propTypes2.default.number,
    stepInterval: _propTypes2.default.number // in milliseconds
  }).isRequired,
  src: _propTypes2.default.string.isRequired
};

exports.default = PreviewAnimationOverlay;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(1),__webpack_require__(0),__webpack_require__(150)):"function"==typeof define&&define.amd?define(["prop-types","react","trim-canvas"],e):"object"==typeof exports?exports.SignatureCanvas=e(require("prop-types"),require("react"),require("trim-canvas")):t.SignatureCanvas=e(t["prop-types"],t.react,t["trim-canvas"])}(this,function(t,e,n){return function(t){function e(o){if(n[o])return n[o].exports;var r=n[o]={exports:{},id:o,loaded:!1};return t[o].call(r.exports,r,r.exports,e),r.loaded=!0,r.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function o(t){return t&&t.__esModule?t:{default:t}}function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function i(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}function a(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var s=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},u=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),c=n(3),l=o(c),d=n(4),f=o(d),h=n(5),p=o(h),v=n(1),_=o(v),y=n(2),m=o(y),x=function(t){function e(){var t,n,o,a;r(this,e);for(var s=arguments.length,u=Array(s),c=0;c<s;c++)u[c]=arguments[c];return n=o=i(this,(t=e.__proto__||Object.getPrototypeOf(e)).call.apply(t,[this].concat(u))),o.clear=function(){var t=o._ctx,e=o._canvas;t.fillStyle=o.props.backgroundColor,t.clearRect(0,0,e.width,e.height),t.fillRect(0,0,e.width,e.height),o._reset(),o._isEmpty=!0},o.fromDataURL=function(t){var e=new Image,n=window.devicePixelRatio||1,r=o._canvas.width/n,i=o._canvas.height/n;o._reset(),e.onload=function(){return o._ctx.drawImage(e,0,0,r,i)},e.src=t,o._isEmpty=!1},o.getCanvas=function(){return o._canvas},o.getTrimmedCanvas=function(){var t=document.createElement("canvas");return t.width=o._canvas.width,t.height=o._canvas.height,t.getContext("2d").drawImage(o._canvas,0,0),(0,p.default)(t)},o.isEmpty=function(){return o._isEmpty},o._resizeCanvas=function(){var t=o.props.canvasProps||{},e=t.width,n=t.height,r=o._ctx,i=o._canvas,a=Math.max(window.devicePixelRatio||1,1);e||(i.width=i.offsetWidth*a),n||(i.height=i.offsetHeight*a),e&&n||r.scale(a,a)},o._reset=function(){o.points=[],o._lastVelocity=0,o._lastWidth=(o.props.minWidth+o.props.maxWidth)/2,o._ctx.fillStyle=o.props.penColor},o._handleMouseEvents=function(){o._mouseButtonDown=!1,o._canvas.addEventListener("mousedown",o._handleMouseDown),o._canvas.addEventListener("mousemove",o._handleMouseMove),document.addEventListener("mouseup",o._handleMouseUp),window.addEventListener("resize",o._resizeCanvas)},o._handleTouchEvents=function(){o._canvas.style.msTouchAction="none",o._canvas.addEventListener("touchstart",o._handleTouchStart),o._canvas.addEventListener("touchmove",o._handleTouchMove),document.addEventListener("touchend",o._handleTouchEnd)},o.off=function(){o._canvas.removeEventListener("mousedown",o._handleMouseDown),o._canvas.removeEventListener("mousemove",o._handleMouseMove),document.removeEventListener("mouseup",o._handleMouseUp),o._canvas.removeEventListener("touchstart",o._handleTouchStart),o._canvas.removeEventListener("touchmove",o._handleTouchMove),document.removeEventListener("touchend",o._handleTouchEnd),window.removeEventListener("resize",o._resizeCanvas)},o._handleMouseDown=function(t){1===t.which&&(o._mouseButtonDown=!0,o._strokeBegin(t))},o._handleMouseMove=function(t){o._mouseButtonDown&&o._strokeUpdate(t)},o._handleMouseUp=function(t){1===t.which&&o._mouseButtonDown&&(o._mouseButtonDown=!1,o._strokeEnd(t))},o._handleTouchStart=function(t){var e=t.changedTouches[0];o._strokeBegin(e)},o._handleTouchMove=function(t){t.preventDefault();var e=t.changedTouches[0];o._strokeUpdate(e)},o._handleTouchEnd=function(t){var e=t.target===o._canvas;e&&o._strokeEnd(t)},o._strokeUpdate=function(t){var e=o._createPoint(t);o._addPoint(e)},o._strokeBegin=function(t){o._reset(),o._strokeUpdate(t),o.props.onBegin(t)},o._strokeDraw=function(t){var e=o._ctx,n="function"==typeof o.props.dotSize?o.props.dotSize(o.props.minWidth,o.props.maxWidth):o.props.dotSize;e.beginPath(),o._drawPoint(t.x,t.y,n),e.closePath(),e.fill()},o._strokeEnd=function(t){var e=o.points.length>2,n=o.points[0];!e&&n&&o._strokeDraw(n),o.props.onEnd(t)},o._createPoint=function(t){var e=o._canvas.getBoundingClientRect();return new m.default(t.clientX-e.left,t.clientY-e.top)},o._addPoint=function(t){var e,n,r,i,a=o.points;a.push(t),a.length>2&&(3===a.length&&a.unshift(a[0]),i=o._calculateCurveControlPoints(a[0],a[1],a[2]),e=i.c2,i=o._calculateCurveControlPoints(a[1],a[2],a[3]),n=i.c1,r=new _.default(a[1],e,n,a[2]),o._addCurve(r),a.shift())},o._addCurve=function(t){var e,n,r=t.startPoint,i=t.endPoint;e=i.velocityFrom(r),e=o.props.velocityFilterWeight*e+(1-o.props.velocityFilterWeight)*o._lastVelocity,n=o._strokeWidth(e),o._drawCurve(t,o._lastWidth,n),o._lastVelocity=e,o._lastWidth=n},o._drawPoint=function(t,e,n){var r=o._ctx;r.moveTo(t,e),r.arc(t,e,n,0,2*Math.PI,!1),o._isEmpty=!1},o._drawCurve=function(t,e,n){var r,i,a,s,u,c,l,d,f,h,p,v=o._ctx,_=n-e;for(r=Math.floor(t.length()),v.beginPath(),a=0;a<r;a++)s=a/r,u=s*s,c=u*s,l=1-s,d=l*l,f=d*l,h=f*t.startPoint.x,h+=3*d*s*t.control1.x,h+=3*l*u*t.control2.x,h+=c*t.endPoint.x,p=f*t.startPoint.y,p+=3*d*s*t.control1.y,p+=3*l*u*t.control2.y,p+=c*t.endPoint.y,i=e+c*_,o._drawPoint(h,p,i);v.closePath(),v.fill()},o._strokeWidth=function(t){return Math.max(o.props.maxWidth/(t+1),o.props.minWidth)},a=n,i(o,a)}return a(e,t),u(e,[{key:"componentDidMount",value:function(){this._ctx=this._canvas.getContext("2d"),this._handleMouseEvents(),this._handleTouchEvents(),this._resizeCanvas(),this.clear()}},{key:"componentWillUnmount",value:function(){this.off()}},{key:"_calculateCurveControlPoints",value:function(t,e,n){var o=t.x-e.x,r=t.y-e.y,i=e.x-n.x,a=e.y-n.y,s={x:(t.x+e.x)/2,y:(t.y+e.y)/2},u={x:(e.x+n.x)/2,y:(e.y+n.y)/2},c=Math.sqrt(o*o+r*r),l=Math.sqrt(i*i+a*a),d=s.x-u.x,f=s.y-u.y,h=l/(c+l),p={x:u.x+d*h,y:u.y+f*h},v=e.x-p.x,_=e.y-p.y;return{c1:new m.default(s.x+v,s.y+_),c2:new m.default(u.x+v,u.y+_)}}},{key:"render",value:function(){var t=this,e=this.props.canvasProps;return f.default.createElement("canvas",s({ref:function(e){t._canvas=e}},e))}}]),e}(d.Component);x.propTypes={velocityFilterWeight:l.default.number,minWidth:l.default.number,maxWidth:l.default.number,dotSize:l.default.oneOfType([l.default.number,l.default.func]),penColor:l.default.string,onEnd:l.default.func,onBegin:l.default.func,canvasProps:l.default.object},x.defaultProps={velocityFilterWeight:.7,minWidth:.5,maxWidth:2.5,dotSize:function(t,e){return(t+e)/2},penColor:"black",backgroundColor:"rgba(0,0,0,0)",onEnd:function(){},onBegin:function(){}},e.default=x},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),r=function(){function t(e,o,r,i){n(this,t),this.startPoint=e,this.control1=o,this.control2=r,this.endPoint=i}return o(t,[{key:"length",value:function t(){var e,n,o,r,i,a,s,u,c=10,t=0;for(e=0;e<=c;e++)n=e/c,o=this._point(n,this.startPoint.x,this.control1.x,this.control2.x,this.endPoint.x),r=this._point(n,this.startPoint.y,this.control1.y,this.control2.y,this.endPoint.y),e>0&&(s=o-i,u=r-a,t+=Math.sqrt(s*s+u*u)),i=o,a=r;return t}},{key:"_point",value:function(t,e,n,o,r){return e*(1-t)*(1-t)*(1-t)+3*n*(1-t)*(1-t)*t+3*o*(1-t)*t*t+r*t*t*t}}]),t}();e.default=r},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}return function(e,n,o){return n&&t(e.prototype,n),o&&t(e,o),e}}(),r=function(){function t(e,o,r){n(this,t),this.x=e,this.y=o,this.time=r||(new Date).getTime()}return o(t,[{key:"velocityFrom",value:function(t){return this.time!==t.time?this.distanceTo(t)/(this.time-t.time):1}},{key:"distanceTo",value:function(t){return Math.sqrt(Math.pow(this.x-t.x,2)+Math.pow(this.y-t.y,2))}}]),t}();e.default=r},function(e,n){e.exports=t},function(t,n){t.exports=e},function(t,e){t.exports=n}])});

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _map = [].concat(_toConsumableArray(Array(7))).map(function (el, index) {
  return index;
}),
    _map2 = _slicedToArray(_map, 7),

// eslint-disable-next-line no-unused-vars
SUNDAY = _map2[0],
    MONDAY = _map2[1],
    TUESDAY = _map2[2],
    WEDNESDAY = _map2[3],
    THURSDAY = _map2[4],
    FRIDAY = _map2[5],
    SATURDAY = _map2[6];

/* Simple getters - getting a property of a given point in time */

var getYear = exports.getYear = function getYear(date) {
  if (date instanceof Date) {
    return date.getFullYear();
  }

  if (typeof date === 'number') {
    return date;
  }

  var year = parseInt(date, 10);

  if (typeof date === 'string' && !isNaN(year)) {
    return year;
  }

  throw new Error('Failed to get year from date: ' + date + '.');
};

var getMonth = exports.getMonth = function getMonth(date) {
  return date.getMonth() + 1;
};

var getMonthIndex = exports.getMonthIndex = function getMonthIndex(date) {
  return date.getMonth();
};

var getDay = exports.getDay = function getDay(date) {
  return date.getDate();
};

var getDayOfWeek = exports.getDayOfWeek = function getDayOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';

  var weekday = date.getDay();

  switch (calendarType) {
    case 'ISO 8601':
      // Shifts days of the week so that Monday is 0, Sunday is 6
      return (weekday + 6) % 7;
    case 'Arabic':
      return (weekday + 1) % 7;
    case 'Hebrew':
    case 'US':
      return weekday;
    default:
      throw new Error('Unsupported calendar type.');
  }
};

/* Complex getters - getting a property somehow related to a given point in time */

var getBeginOfCenturyYear = exports.getBeginOfCenturyYear = function getBeginOfCenturyYear(date) {
  var year = getYear(date) - 1;
  return year + -year % 100 + 1;
};

var getBeginOfCentury = exports.getBeginOfCentury = function getBeginOfCentury(date) {
  var beginOfCenturyYear = getBeginOfCenturyYear(date);
  return new Date(beginOfCenturyYear, 0, 1);
};

var getEndOfCentury = exports.getEndOfCentury = function getEndOfCentury(date) {
  var beginOfCenturyYear = getBeginOfCenturyYear(date);
  return new Date(beginOfCenturyYear + 100, 0, 1, 0, 0, 0, -1);
};

var getCenturyRange = exports.getCenturyRange = function getCenturyRange(date) {
  return [getBeginOfCentury(date), getEndOfCentury(date)];
};

var getBeginOfPreviousCentury = exports.getBeginOfPreviousCentury = function getBeginOfPreviousCentury(date) {
  var previousCenturyYear = getYear(date) - 100;
  return getBeginOfCentury(previousCenturyYear);
};

var getEndOfPreviousCentury = exports.getEndOfPreviousCentury = function getEndOfPreviousCentury(date) {
  var previousCenturyYear = getYear(date) - 100;
  return getEndOfCentury(previousCenturyYear);
};

var getBeginOfNextCentury = exports.getBeginOfNextCentury = function getBeginOfNextCentury(date) {
  var nextCenturyYear = getYear(date) + 100;
  return getBeginOfCentury(nextCenturyYear);
};

var getBeginOfDecadeYear = exports.getBeginOfDecadeYear = function getBeginOfDecadeYear(date) {
  var year = getYear(date) - 1;
  return year + -year % 10 + 1;
};

var getBeginOfDecade = exports.getBeginOfDecade = function getBeginOfDecade(date) {
  var beginOfDecadeYear = getBeginOfDecadeYear(date);
  return new Date(beginOfDecadeYear, 0, 1);
};

var getEndOfDecade = exports.getEndOfDecade = function getEndOfDecade(date) {
  var beginOfDecadeYear = getBeginOfDecadeYear(date);
  return new Date(beginOfDecadeYear + 10, 0, 1, 0, 0, 0, -1);
};

var getDecadeRange = exports.getDecadeRange = function getDecadeRange(date) {
  return [getBeginOfDecade(date), getEndOfDecade(date)];
};

var getBeginOfPreviousDecade = exports.getBeginOfPreviousDecade = function getBeginOfPreviousDecade(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
  return getBeginOfDecade(previousDecadeYear);
};

var getEndOfPreviousDecade = exports.getEndOfPreviousDecade = function getEndOfPreviousDecade(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
  return getEndOfDecade(previousDecadeYear);
};

var getBeginOfNextDecade = exports.getBeginOfNextDecade = function getBeginOfNextDecade(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

  var nextDecadeYear = getBeginOfDecadeYear(date) + offset;
  return getBeginOfDecade(nextDecadeYear);
};

/**
 * Returns the beginning of a given year.
 *
 * @param {Date} date Date.
 */
var getBeginOfYear = exports.getBeginOfYear = function getBeginOfYear(date) {
  var year = getYear(date);
  return new Date(year, 0, 1);
};

/**
 * Returns the end of a given year.
 *
 * @param {Date} date Date.
 */
var getEndOfYear = exports.getEndOfYear = function getEndOfYear(date) {
  var year = getYear(date);
  return new Date(year + 1, 0, 1, 0, 0, 0, -1);
};

/**
 * Returns an array with the beginning and the end of a given year.
 *
 * @param {Date} date Date.
 */
var getYearRange = exports.getYearRange = function getYearRange(date) {
  return [getBeginOfYear(date), getEndOfYear(date)];
};

var getBeginOfPreviousYear = exports.getBeginOfPreviousYear = function getBeginOfPreviousYear(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var previousYear = getYear(date) - offset;
  return getBeginOfYear(previousYear);
};

var getEndOfPreviousYear = exports.getEndOfPreviousYear = function getEndOfPreviousYear(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var previousYear = getYear(date) - offset;
  return getEndOfYear(previousYear);
};

var getBeginOfNextYear = exports.getBeginOfNextYear = function getBeginOfNextYear(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var nextYear = getYear(date) + offset;
  return getBeginOfYear(nextYear);
};

/**
 * Returns the beginning of a given month.
 *
 * @param {Date} date Date.
 */
var getBeginOfMonth = exports.getBeginOfMonth = function getBeginOfMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return new Date(year, monthIndex, 1);
};

/**
 * Returns the end of a given month.
 *
 * @param {Date} date Date.
 */
var getEndOfMonth = exports.getEndOfMonth = function getEndOfMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return new Date(year, monthIndex + 1, 1, 0, 0, 0, -1);
};

/**
 * Returns the beginning of a given week.
 *
 * @param {Date} date Date.
 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
 */
var getBeginOfWeek = exports.getBeginOfWeek = function getBeginOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';

  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = date.getDate() - getDayOfWeek(date, calendarType);
  return new Date(year, monthIndex, day);
};

/**
 * Returns an array with the beginning and the end of a given month.
 *
 * @param {Date} date Date.
 */
var getMonthRange = exports.getMonthRange = function getMonthRange(date) {
  return [getBeginOfMonth(date), getEndOfMonth(date)];
};

var getDifferentMonth = function getDifferentMonth(date, offset) {
  var year = getYear(date);
  var previousMonthIndex = getMonthIndex(date) + offset;
  return new Date(year, previousMonthIndex, 1);
};

var getBeginOfPreviousMonth = exports.getBeginOfPreviousMonth = function getBeginOfPreviousMonth(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var previousMonth = getDifferentMonth(date, -offset);
  return getBeginOfMonth(previousMonth);
};

var getEndOfPreviousMonth = exports.getEndOfPreviousMonth = function getEndOfPreviousMonth(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var previousMonth = getDifferentMonth(date, -offset);
  return getEndOfMonth(previousMonth);
};

var getBeginOfNextMonth = exports.getBeginOfNextMonth = function getBeginOfNextMonth(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

  var nextMonth = getDifferentMonth(date, offset);
  return getBeginOfMonth(nextMonth);
};

var getBeginOfDay = exports.getBeginOfDay = function getBeginOfDay(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = getDay(date);
  return new Date(year, monthIndex, day);
};

var getEndOfDay = exports.getEndOfDay = function getEndOfDay(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = getDay(date);
  return new Date(year, monthIndex, day + 1, 0, 0, 0, -1);
};

/**
 * Returns an array with the beginning and the end of a given day.
 *
 * @param {Date} date Date.
 */
var getDayRange = exports.getDayRange = function getDayRange(date) {
  return [getBeginOfDay(date), getEndOfDay(date)];
};

/**
 * Gets week number according to ISO 8601 or US standard.
 * In ISO 8601, Arabic and Hebrew week 1 is the one with January 4.
 * In US calendar week 1 is the one with January 1.
 *
 * @param {Date} date Date.
 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
 */
var getWeekNumber = exports.getWeekNumber = function getWeekNumber(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';

  var calendarTypeForWeekNumber = calendarType === 'US' ? 'US' : 'ISO 8601';
  var beginOfWeek = getBeginOfWeek(date, calendarTypeForWeekNumber);
  var year = getYear(date) + 1;
  var dayInWeekOne = void 0;
  var beginOfFirstWeek = void 0;

  // Look for the first week one that does not come after a given date
  do {
    dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === 'ISO 8601' ? 4 : 1);
    beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarTypeForWeekNumber);
    year -= 1;
  } while (date - beginOfFirstWeek < 0);

  return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
};

/**
 * Returns the beginning of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */
var getBegin = exports.getBegin = function getBegin(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfCentury(date);
    case 'decade':
      return getBeginOfDecade(date);
    case 'year':
      return getBeginOfYear(date);
    case 'month':
      return getBeginOfMonth(date);
    case 'day':
      return getBeginOfDay(date);
    default:
      throw new Error('Invalid rangeType: ' + rangeType);
  }
};

var getBeginPrevious = exports.getBeginPrevious = function getBeginPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfPreviousCentury(date);
    case 'decade':
      return getBeginOfPreviousDecade(date);
    case 'year':
      return getBeginOfPreviousYear(date);
    case 'month':
      return getBeginOfPreviousMonth(date);
    default:
      throw new Error('Invalid rangeType: ' + rangeType);
  }
};

var getBeginNext = exports.getBeginNext = function getBeginNext(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfNextCentury(date);
    case 'decade':
      return getBeginOfNextDecade(date);
    case 'year':
      return getBeginOfNextYear(date);
    case 'month':
      return getBeginOfNextMonth(date);
    default:
      throw new Error('Invalid rangeType: ' + rangeType);
  }
};

var getBeginPrevious2 = exports.getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getBeginOfPreviousDecade(date, 100);
    case 'year':
      return getBeginOfPreviousYear(date, 10);
    case 'month':
      return getBeginOfPreviousMonth(date, 12);
    default:
      throw new Error('Invalid rangeType: ' + rangeType);
  }
};

var getBeginNext2 = exports.getBeginNext2 = function getBeginNext2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getBeginOfNextDecade(date, 100);
    case 'year':
      return getBeginOfNextYear(date, 10);
    case 'month':
      return getBeginOfNextMonth(date, 12);
    default:
      throw new Error('Invalid rangeType: ' + rangeType);
  }
};

/**
 * Returns the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */
var getEnd = exports.getEnd = function getEnd(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getEndOfCentury(date);
    case 'decade':
      return getEndOfDecade(date);
    case 'year':
      return getEndOfYear(date);
    case 'month':
      return getEndOfMonth(date);
    case 'day':
      return getEndOfDay(date);
    default:
      throw new Error('Invalid rangeType: ' + rangeType);
  }
};

var getEndPrevious = exports.getEndPrevious = function getEndPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getEndOfPreviousCentury(date);
    case 'decade':
      return getEndOfPreviousDecade(date);
    case 'year':
      return getEndOfPreviousYear(date);
    case 'month':
      return getEndOfPreviousMonth(date);
    default:
      throw new Error('Invalid rangeType: ' + rangeType);
  }
};

var getEndPrevious2 = exports.getEndPrevious2 = function getEndPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getEndOfPreviousDecade(date, 100);
    case 'year':
      return getEndOfPreviousYear(date, 10);
    case 'month':
      return getEndOfPreviousMonth(date, 12);
    default:
      throw new Error('Invalid rangeType: ' + rangeType);
  }
};

/**
 * Returns an array with the beginning and the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */
var getRange = exports.getRange = function getRange(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyRange(date);
    case 'decade':
      return getDecadeRange(date);
    case 'year':
      return getYearRange(date);
    case 'month':
      return getMonthRange(date);
    case 'day':
      return getDayRange(date);
    default:
      throw new Error('Invalid rangeType: ' + rangeType);
  }
};

/**
 * Creates a range out of two values, ensuring they are in order and covering entire period ranges.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date1 First date.
 * @param {Date} date2 Second date.
 */
var getValueRange = exports.getValueRange = function getValueRange(rangeType, date1, date2) {
  var rawNextValue = [date1, date2].sort(function (a, b) {
    return a.getTime() > b.getTime();
  });
  return [getBegin(rangeType, rawNextValue[0]), getEnd(rangeType, rawNextValue[1])];
};

/**
 * Returns a number of days in a month of a given date.
 *
 * @param {Date} date Date.
 */
var getDaysInMonth = exports.getDaysInMonth = function getDaysInMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return new Date(year, monthIndex + 1, 0).getDate();
};

var toYearLabel = function toYearLabel(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      start = _ref2[0],
      end = _ref2[1];

  return getYear(start) + ' \u2013 ' + getYear(end);
};

/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2001-2100.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */
var getCenturyLabel = exports.getCenturyLabel = function getCenturyLabel(date) {
  return toYearLabel(getCenturyRange(date));
};

/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2011-2020.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */
var getDecadeLabel = exports.getDecadeLabel = function getDecadeLabel(date) {
  return toYearLabel(getDecadeRange(date));
};

/**
 * Returns a boolean determining whether a given date is on Saturday or Sunday.
 *
 * @param {Date} date Date.
 */
var isWeekend = exports.isWeekend = function isWeekend(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';

  var weekday = date.getDay();
  switch (calendarType) {
    case 'Arabic':
    case 'Hebrew':
      return weekday === FRIDAY || weekday === SATURDAY;
    case 'ISO 8601':
    case 'US':
      return weekday === SATURDAY || weekday === SUNDAY;
    default:
      throw new Error('Unsupported calendar type.');
  }
};

/**
 * Returns local month in ISO-like format (YYYY-MM).
 */
var getISOLocalMonth = exports.getISOLocalMonth = function getISOLocalMonth(value) {
  if (!value) {
    return value;
  }

  var date = new Date(value);

  if (isNaN(date.getTime())) {
    throw new Error('Invalid date: ' + value);
  }

  var year = getYear(date);
  var month = ('0' + getMonth(date)).slice(-2);

  return year + '-' + month;
};

/**
 * Returns local date in ISO-like format (YYYY-MM-DD).
 */
var getISOLocalDate = exports.getISOLocalDate = function getISOLocalDate(value) {
  if (!value) {
    return value;
  }

  var date = new Date(value);

  if (isNaN(date.getTime())) {
    throw new Error('Invalid date: ' + value);
  }

  var year = getYear(date);
  var month = ('0' + getMonth(date)).slice(-2);
  var day = ('0' + getDay(date)).slice(-2);

  return year + '-' + month + '-' + day;
};

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.trimCanvas=t():e.trimCanvas=t()}(this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t){"use strict";function r(e){var t=e.getContext("2d"),r=e.width,n=e.height,o=t.getImageData(0,0,r,n).data,f=a(!0,r,n,o),i=a(!1,r,n,o),c=u(!0,r,n,o),d=u(!1,r,n,o),p=d-c+1,l=i-f+1,s=t.getImageData(c,f,p,l);return e.width=p,e.height=l,t.clearRect(0,0,p,l),t.putImageData(s,0,0),e}function n(e,t,r,n){return{red:n[4*(r*t+e)],green:n[4*(r*t+e)+1],blue:n[4*(r*t+e)+2],alpha:n[4*(r*t+e)+3]}}function o(e,t,r,o){return n(e,t,r,o).alpha}function a(e,t,r,n){for(var a=e?1:-1,u=e?0:r-1,f=u;e?f<r:f>-1;f+=a)for(var i=0;i<t;i++)if(o(i,f,t,n))return f;return null}function u(e,t,r,n){for(var a=e?1:-1,u=e?0:t-1,f=u;e?f<t:f>-1;f+=a)for(var i=0;i<r;i++)if(o(f,i,t,n))return f;return null}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r}])});

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticRequestSignatureContentSection = exports.SaveActionsEnum = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StaticBuilderActions = __webpack_require__(24);

var _Popups = __webpack_require__(49);

var _StaticGetLinkSection = __webpack_require__(274);

var _StaticGetLinkSection2 = _interopRequireDefault(_StaticGetLinkSection);

var _Utils = __webpack_require__(42);

var _DropDownSection = __webpack_require__(275);

var _DropDownSection2 = _interopRequireDefault(_DropDownSection);

var _StaticCreateAccountErrorBox = __webpack_require__(120);

var _StaticCreateAccountErrorBox2 = _interopRequireDefault(_StaticCreateAccountErrorBox);

var _NoSignatureToTemplateBuilderModal = __webpack_require__(276);

var _NoSignatureToTemplateBuilderModal2 = _interopRequireDefault(_NoSignatureToTemplateBuilderModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SaveActionsEnum = exports.SaveActionsEnum = {
  SAVE_AND_CONTINUE: 1,
  SAVE_AND_SHARE: 2,
  SAVE_AND_SIGN: 3,
  SAVE_SHARE_AND_SIGN: 4
};

var StaticRequestSignatureContentSection = exports.StaticRequestSignatureContentSection = function (_React$Component) {
  _inherits(StaticRequestSignatureContentSection, _React$Component);

  function StaticRequestSignatureContentSection(props) {
    _classCallCheck(this, StaticRequestSignatureContentSection);

    var _this = _possibleConstructorReturn(this, (StaticRequestSignatureContentSection.__proto__ || Object.getPrototypeOf(StaticRequestSignatureContentSection)).call(this, props));

    _this.state = {
      action: SaveActionsEnum.SAVE_AND_CONTINUE,
      isNoSignatureToTemplateModalOpen: false
    };

    _this.onBackClick = _this.onBackClick.bind(_this);

    if (_this.props.onClickSaveAction) {
      _this.onSaveClick = _this.props.onClickSaveAction.bind(_this);
    } else {
      _this.onSaveClick = _this.onSaveClick.bind(_this);
    }

    if (_this.props.handleChange) {
      _this.handleChange = _this.props.handleChange.bind(_this);
    } else {
      _this.handleChange = _this.handleChange.bind(_this);
    }

    _this.toggleNoSignatureToTemplateBuilderModal = _this.toggleNoSignatureToTemplateBuilderModal.bind(_this);
    _this.getOptions = _this.getOptions.bind(_this);
    return _this;
  }

  _createClass(StaticRequestSignatureContentSection, [{
    key: 'onBackClick',
    value: function onBackClick() {
      this.props.loadPreviousStaticBuilderSection();
    }
  }, {
    key: 'onSaveClick',
    value: function onSaveClick(event) {
      var documentType = this.props.documentType;

      localStorage.removeItem('staticSection-' + window.SessionManager.id);
      localStorage.removeItem('staticViewedScreens-' + window.SessionManager.id);

      var redirectURL = void 0;

      switch (this.state.action) {
        case SaveActionsEnum.SAVE_SHARE_AND_SIGN:
          event.preventDefault();
          window._track('Me and Someone Else | Request Signature Section', documentType);
          redirectURL = './_api/convert-static-to-freewrite.php?action=request-signature&member=1&documentType=' + window.CurrentDocumentInfo.type + '&ses=' + window.SessionManager.hash + '&key=' + window.SessionManager.id + '&ignoreFreeWriteToCustom=1';
          break;
        case SaveActionsEnum.SAVE_AND_SHARE:
          event.preventDefault();
          if (this.props.redirectToTemplateBuilder) {
            window._track('Someone Else | Redirect to Template Builder', documentType);
            redirectURL = './convert-static-to-custom-template?documentType=' + window.CurrentDocumentInfo.type + '&ses=' + window.SessionManager.hash + '&key=' + window.SessionManager.id + '&toolType=' + _Popups.SelfServeBuilderPopupTypes.SIGNATURE;
          } else {
            window._track('Someone Else | Request Signature Section', documentType);
            redirectURL = './_api/convert-static-to-freewrite.php?action=request-signature&member=1&documentType=' + window.CurrentDocumentInfo.type + '&ses=' + window.SessionManager.hash + '&key=' + window.SessionManager.id + '&ignoreFreeWriteToCustom=1';
          }
          break;
        case SaveActionsEnum.SAVE_AND_SIGN:
          event.preventDefault();
          window._track('Me | Request Signature Section', documentType);
          redirectURL = './_api/convert-static-to-freewrite.php?action=sign&member=1&documentType=' + window.CurrentDocumentInfo.type + '&ses=' + window.SessionManager.hash + '&key=' + window.SessionManager.id + '&ignoreFreeWriteToCustom=1';
          break;
        case SaveActionsEnum.SAVE_AND_CONTINUE:
        default:
          {
            window.exportStaticWithURL('No One | Request Signature Section', documentType, 'export/pdf.php' + window.location.search);
            var isFirstExport = !window.COOKIE.get('firstDocumentExported');
            var isPaid = window.User.isPaid;
            // Skip unpaid users
            if (this.props.useNoSignatureToTemplateBuilderModal && isPaid && !isFirstExport) {
              this.toggleNoSignatureToTemplateBuilderModal();
            }
            break;
          }
      }

      if (redirectURL) {
        window.location.assign(redirectURL);
      }
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var dropDownOptions = this.props.dropDownOptions;

      var options = [{
        label: 'No one',
        value: '' + SaveActionsEnum.SAVE_AND_CONTINUE
      }, {
        label: 'Me',
        value: '' + SaveActionsEnum.SAVE_AND_SIGN
      }, {
        label: 'Someone Else',
        value: '' + SaveActionsEnum.SAVE_AND_SHARE
      }, {
        label: 'Me and Someone Else',
        value: '' + SaveActionsEnum.SAVE_SHARE_AND_SIGN
      }];

      if (dropDownOptions) {
        options = dropDownOptions;
      }
      return options;
    }
  }, {
    key: 'toggleNoSignatureToTemplateBuilderModal',
    value: function toggleNoSignatureToTemplateBuilderModal() {
      this.setState(function (prevState) {
        return { isNoSignatureToTemplateModalOpen: !prevState.isNoSignatureToTemplateModalOpen };
      });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      var action = parseInt(event.target.value, 10);
      if (isNaN(action)) {
        action = SaveActionsEnum.SAVE_AND_CONTINUE;
      }
      this.setState({
        action: action
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          documentType = _props.documentType,
          isLoading = _props.isLoading,
          loadPrevious = _props.loadPreviousStaticBuilderSection,
          releaseType = _props.releaseType;

      if ((0, _Utils.isLastSectionGetLink)(documentType, releaseType) && !isLoading) {
        return _react2.default.createElement(_StaticGetLinkSection2.default, {
          documentType: documentType,
          loadPreviousStaticBuilderSection: loadPrevious
        });
      }

      var postLabel = '';
      var buttonLabel = 'Save and Export';
      switch (this.state.action) {
        case SaveActionsEnum.SAVE_AND_SIGN:
          postLabel = 'Great! After you save your document, we\'ll take you straight to our signature editor.';
          buttonLabel = 'Save and Sign';
          break;
        case SaveActionsEnum.SAVE_SHARE_AND_SIGN:
          postLabel = 'Great! After you save your document, we\'ll take you straight to our signature editor. You can sign your document after your recipient(s) signs.';
          buttonLabel = 'Save and Sign';
          break;
        case SaveActionsEnum.SAVE_AND_SHARE:
          postLabel = 'Great! After you save your document, we\'ll take you straight to our signature editor. You can sign your document after your recipient(s) signs.';
          buttonLabel = 'Save and Sign';
          if (this.props.redirectToTemplateBuilder) {
            postLabel = 'Great! After you save your document, we\'ll take you to add fillable fields for your recipient to fill and sign.';
            buttonLabel = 'Save';
          }
          break;
        case SaveActionsEnum.SAVE_AND_CONTINUE:
        default:
          postLabel = 'No problem. If you change your mind, you can always add a signature later!';
      }

      if (this.props.postLabel) {
        postLabel = this.props.postLabel;
      }

      var options = this.getOptions();

      var sectionHeader = 'Do you need to sign your ' + this.props.documentLabel + '?';
      if (this.props.sectionHeader) {
        sectionHeader = this.props.sectionHeader;
      }

      var highlightDropDownSection = this.props.redirectToTemplateBuilder;

      return _react2.default.createElement(
        'div',
        { id: 'screen', className: 'static-request-signature-content-section page' },
        isLoading && _react2.default.createElement(
          'h3',
          { className: 'static-builder-form-header-loading' },
          'Loading...'
        ),
        !isLoading && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'h2',
            null,
            sectionHeader
          ),
          this.props.showErrorBox && _react2.default.createElement(_StaticCreateAccountErrorBox2.default, { errorMessage: this.props.errorMessage }),
          this.props.useNoSignatureToTemplateBuilderModal && _react2.default.createElement(_NoSignatureToTemplateBuilderModal2.default, {
            isOpen: this.state.isNoSignatureToTemplateModalOpen,
            closeModal: this.toggleNoSignatureToTemplateBuilderModal
          }),
          _react2.default.createElement(
            'div',
            { className: 'innerContent' },
            _react2.default.createElement(_DropDownSection2.default, {
              label: this.props.requestSignatureDropdownLabel,
              onChange: this.handleChange,
              options: options,
              postLabel: postLabel,
              showDropDown: this.props.showDropDown,
              highlightDropDownSection: highlightDropDownSection
            }),
            this.props.showFormAction && _react2.default.createElement(
              'div',
              { className: 'form-actions' },
              _react2.default.createElement(
                'button',
                {
                  className: 'backButton pull-left btn btn-large',
                  onClick: this.onBackClick
                },
                'Back'
              ),
              _react2.default.createElement(
                'button',
                {
                  className: 'pull-right btn btn-large btn-success saveButton',
                  onClick: this.onSaveClick
                },
                buttonLabel
              )
            ),
            this.props.children
          )
        )
      );
    }
  }]);

  return StaticRequestSignatureContentSection;
}(_react2.default.Component);

StaticRequestSignatureContentSection.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  documentLabel: _propTypes2.default.string,
  documentType: _propTypes2.default.string,
  dropDownOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
  })),
  errorMessage: _propTypes2.default.string,
  handleChange: _propTypes2.default.func,
  isLoading: _propTypes2.default.bool,
  loadPreviousStaticBuilderSection: _propTypes2.default.func.isRequired,
  onClickSaveAction: _propTypes2.default.func,
  postLabel: _propTypes2.default.string,
  redirectToTemplateBuilder: _propTypes2.default.bool,
  releaseType: _propTypes2.default.string,
  requestSignatureDropdownLabel: _propTypes2.default.string,
  sectionHeader: _propTypes2.default.string,
  showDropDown: _propTypes2.default.bool,
  showErrorBox: _propTypes2.default.bool,
  showFormAction: _propTypes2.default.bool,
  useNoSignatureToTemplateBuilderModal: _propTypes2.default.bool
};

StaticRequestSignatureContentSection.defaultProps = {
  children: null,
  documentLabel: '',
  documentType: '',
  dropDownOptions: null,
  errorMessage: null,
  handleChange: null,
  isLoading: false,
  onClickSaveAction: null,
  postLabel: null,
  redirectToTemplateBuilder: false,
  releaseType: '',
  requestSignatureDropdownLabel: 'Who will sign?',
  sectionHeader: null,
  showDropDown: true,
  showErrorBox: false,
  showFormAction: true,
  useNoSignatureToTemplateBuilderModal: false
};

var mapStateToProps = function mapStateToProps(_ref) {
  var StaticBuilderReducer = _ref.StaticBuilderReducer;
  return {
    releaseType: StaticBuilderReducer.fieldData.release_type,
    isLoading: StaticBuilderReducer.isLoading
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadPreviousStaticBuilderSection: _StaticBuilderActions.loadPreviousStaticBuilderSection
  }, dispatch);
};

exports.default = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(StaticRequestSignatureContentSection);

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(13);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _DownloadOverlayActions = __webpack_require__(402);

var DownloadOverlayActions = _interopRequireWildcard(_DownloadOverlayActions);

var _DownloadOverlay2 = __webpack_require__(290);

var _DownloadOverlay3 = _interopRequireDefault(_DownloadOverlay2);

var _store = __webpack_require__(25);

var _store2 = _interopRequireDefault(_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    show: state.DownloadOverlayHandler.show
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_extends({}, DownloadOverlayActions), dispatch);
};

var ConnectedDownloadOverlayContainer = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(_DownloadOverlay3.default);

var DownloadOverlayContainer = function (_DownloadOverlay) {
  _inherits(DownloadOverlayContainer, _DownloadOverlay);

  function DownloadOverlayContainer() {
    _classCallCheck(this, DownloadOverlayContainer);

    return _possibleConstructorReturn(this, (DownloadOverlayContainer.__proto__ || Object.getPrototypeOf(DownloadOverlayContainer)).apply(this, arguments));
  }

  _createClass(DownloadOverlayContainer, null, [{
    key: 'init',
    value: function init(id, props) {
      _reactDom2.default.render(_react2.default.createElement(
        ReactRedux.Provider,
        { store: _store2.default },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(ConnectedDownloadOverlayContainer, props)
        )
      ), document.getElementById(id));
    }
  }]);

  return DownloadOverlayContainer;
}(_DownloadOverlay3.default);

exports.default = DownloadOverlayContainer;


if (window.FormSwift && window.FormSwift.React) {
  var addedActions = Object.assign({}, DownloadOverlayActions, window.FormSwift.React.actions);
  window.FormSwift.React.actions = addedActions;
} else {
  window.FormSwift = {
    React: {
      store: _store2.default,
      actions: DownloadOverlayActions
    }
  };
}

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticBuilderWithRedux = exports.StaticBuilder = exports.StaticBuilderProgressBar = exports.StaticBuilderProgressBarWrapper = exports.StaticBuilderDocumentPreviewTitle = exports.StaticBuilderDocumentPreview = exports.StaticBuilderSection = exports.StaticBuilderNavSideBarWrapper = exports.StaticBuilderForm = exports.NavSideBarMenuButton = exports.NavSideBarList = exports.Subheading = exports.RadioButton = exports.Note = exports.LineBreak = exports.CalendarField = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CalendarField = __webpack_require__(110);

Object.defineProperty(exports, 'CalendarField', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CalendarField).default;
  }
});

var _LineBreak = __webpack_require__(111);

Object.defineProperty(exports, 'LineBreak', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LineBreak).default;
  }
});

var _Note = __webpack_require__(77);

Object.defineProperty(exports, 'Note', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Note).default;
  }
});

var _RadioButton = __webpack_require__(115);

Object.defineProperty(exports, 'RadioButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RadioButton).default;
  }
});

var _Subheading = __webpack_require__(119);

Object.defineProperty(exports, 'Subheading', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Subheading).default;
  }
});

var _NavSideBarList = __webpack_require__(114);

Object.defineProperty(exports, 'NavSideBarList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NavSideBarList).default;
  }
});

var _NavSideBarMenuButton = __webpack_require__(173);

Object.defineProperty(exports, 'NavSideBarMenuButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NavSideBarMenuButton).default;
  }
});

var _StaticBuilderForm = __webpack_require__(117);

Object.defineProperty(exports, 'StaticBuilderForm', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StaticBuilderForm).default;
  }
});

var _StaticBuilderNavSideBarWrapper = __webpack_require__(263);

Object.defineProperty(exports, 'StaticBuilderNavSideBarWrapper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StaticBuilderNavSideBarWrapper).default;
  }
});

var _StaticBuilderSection = __webpack_require__(174);

Object.defineProperty(exports, 'StaticBuilderSection', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StaticBuilderSection).default;
  }
});

var _StaticBuilderDocumentPreview = __webpack_require__(260);

Object.defineProperty(exports, 'StaticBuilderDocumentPreview', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StaticBuilderDocumentPreview).default;
  }
});

var _StaticBuilderDocumentPreviewTitle = __webpack_require__(116);

Object.defineProperty(exports, 'StaticBuilderDocumentPreviewTitle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StaticBuilderDocumentPreviewTitle).default;
  }
});

var _StaticBuilderProgressBarWrapper = __webpack_require__(206);

Object.defineProperty(exports, 'StaticBuilderProgressBarWrapper', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StaticBuilderProgressBarWrapper).default;
  }
});

var _StaticBuilderProgressBar = __webpack_require__(118);

Object.defineProperty(exports, 'StaticBuilderProgressBar', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StaticBuilderProgressBar).default;
  }
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CustomPropTypes = __webpack_require__(19);

var _CustomPropTypes2 = _interopRequireDefault(_CustomPropTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _StaticCreateAccountSection = __webpack_require__(207);

var _StaticCreateAccountSection2 = _interopRequireDefault(_StaticCreateAccountSection);

var _StaticRequestSignatureContentSection = __webpack_require__(151);

var _StaticRequestSignatureContentSection2 = _interopRequireDefault(_StaticRequestSignatureContentSection);

var _ConnectedHelpSideBar = __webpack_require__(176);

var _ConnectedHelpSideBar2 = _interopRequireDefault(_ConnectedHelpSideBar);

var _HelpSideBarButton = __webpack_require__(177);

var _HelpSideBarButton2 = _interopRequireDefault(_HelpSideBarButton);

var _StaticBuilderSection2 = _interopRequireDefault(_StaticBuilderSection);

var _StaticBuilderActions = __webpack_require__(24);

var _StaticBuilderFormattedFields = __webpack_require__(51);

var _StaticBuilderFormattedFields2 = _interopRequireDefault(_StaticBuilderFormattedFields);

var _StaticBuilderSetup = __webpack_require__(271);

var _StaticBuilderSetup2 = _interopRequireDefault(_StaticBuilderSetup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INCLUDE_CORP_FLOW_DOCUMENT_TYPES = ['ca-articles-of-incorporation-c-corp', 'ca-articles-of-incorporation-s-corp', 'ca-articles-of-incorporation-si', 'irs-2553-form'];

var INCLUDE_CUSTOM_CSS_DOCUMENT_TYPES = ['1099-misc-efile-2014', '1099-misc-efile-2015', '1099-misc-efile-2016', '1099-misc-efile-2017', '1099-misc-efile-2018', '1099-misc-efile-2019', '1099-misc-efile-2020', '1099-misc-efile-2021', '1099-misc-efile-2022', '1099-nec-efile-2020', '1099-nec-efile-2021', '1099-nec-efile-2022', 'employee-paystub', 'invoice-pages', 'sample-document', 'w2-efile-2014', 'w2-efile-2015', 'w2-efile-2016', 'w2-efile-2017', 'w2-efile-2018', 'w2-efile-2019', 'w2-efile-2020', 'w2-efile-2021', 'w2-efile-2022', 'w9-2014-static'];

var INCLUDE_CUSTOM_JS_DOCUMENT_TYPES = ['1099-misc-efile-2014', '1099-misc-efile-2015', '1099-misc-efile-2016', '1099-misc-efile-2017', '1099-misc-efile-2018', '1099-misc-efile-2019', '1099-misc-efile-2020', '1099-misc-efile-2021', '1099-misc-efile-2022', '1099-nec-efile-2020', '1099-nec-efile-2021', '1099-nec-efile-2022', 'ca-articles-of-organization', 'ca-statement-of-information', 'employee-paystub', 'i9-2012', 'w2-efile-2014', 'w2-efile-2015', 'w2-efile-2016', 'w2-efile-2017', 'w2-efile-2018', 'w2-efile-2019', 'w2-efile-2020', 'w2-efile-2021', 'w2-efile-2022', 'w9-2014-static'];

var HELP_SIDE_BAR_DOCUMENT_MAP = {
  'w2-efile-2022': 'w2',
  '1099-misc-efile-2022': 'form1099Misc',
  '1099-nec-efile-2022': 'form1099Nec'
};

var SKIP_SHOW_REQUEST_SIGNATURE = ['sample-document'];
var RENDER_HEADER_TEXT_AS_HTML = ['sample-document'];

var StaticBuilder = exports.StaticBuilder = function (_React$Component) {
  _inherits(StaticBuilder, _React$Component);

  _createClass(StaticBuilder, null, [{
    key: 'loadScript',
    value: function loadScript(src) {
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    }
  }]);

  function StaticBuilder(props) {
    _classCallCheck(this, StaticBuilder);

    var _this = _possibleConstructorReturn(this, (StaticBuilder.__proto__ || Object.getPrototypeOf(StaticBuilder)).call(this, props));

    _this.shouldInitalizeHelpSideBar = _this.shouldInitalizeHelpSideBar.bind(_this);
    _this.initializeHelpSideBar = _this.initializeHelpSideBar.bind(_this);

    _this.props.setStaticBuilderFieldOutline(_this.props.documentType, _this.props.productMap, _this.props.initialOnStep, _this.props.forceDownload);
    return _this;
  }

  _createClass(StaticBuilder, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.getSessionContent(this.props.sessionId, this.props.sessionHash, this.props.forceDownload);

      if (INCLUDE_CORP_FLOW_DOCUMENT_TYPES.indexOf(this.props.documentType) >= 0) {
        StaticBuilder.loadScript((window.FORMSWIFT_URL || '') + '/js/custom-document/common/corp-flow.js?v=1.4');
      }

      if (INCLUDE_CUSTOM_JS_DOCUMENT_TYPES.indexOf(this.props.documentType) >= 0) {
        StaticBuilder.loadScript((window.FORMSWIFT_URL || '') + '/js/custom-document/' + this.props.documentType + '.js?v=1.7');
      }

      this.showRequestSignature = SKIP_SHOW_REQUEST_SIGNATURE.indexOf(this.props.documentType) === -1;
      this.renderHeaderTextAsHtml = RENDER_HEADER_TEXT_AS_HTML.indexOf(this.props.documentType) >= 0;
    }
  }, {
    key: 'shouldInitalizeHelpSideBar',
    value: function shouldInitalizeHelpSideBar() {
      var _props = this.props,
          documentType = _props.documentType,
          isVisualStatic = _props.isVisualStatic;

      return isVisualStatic && Object.keys(HELP_SIDE_BAR_DOCUMENT_MAP).indexOf(documentType) >= 0;
    }
  }, {
    key: 'initializeHelpSideBar',
    value: function initializeHelpSideBar() {
      var builderContainer = document.getElementById('srb_content_wrapper');
      var helpButtonContainer = document.createElement('div');

      helpButtonContainer.id = 'helpButtonContainer';
      builderContainer.appendChild(helpButtonContainer);
      _HelpSideBarButton2.default.init('helpButtonContainer');
      _ConnectedHelpSideBar2.default.init('helpSideBarAnchor', {
        documentName: HELP_SIDE_BAR_DOCUMENT_MAP[this.props.documentType]
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (window.createAccountScreen === this.props.onStep) {
        return _react2.default.createElement(_StaticCreateAccountSection2.default, null);
      }

      // window.showRequestSignature is set via Optimizely editor
      // Experiment ID: 8487421299 Variation: 8488201416
      if ((window.User.isLoggedIn && !window.secondPresence || window.showRequestSignature) && this.props.onStep >= this.props.sectionKeys.length) {
        return _react2.default.createElement(_StaticRequestSignatureContentSection2.default, {
          documentLabel: window.CurrentDocumentInfo.label.toLowerCase(),
          documentType: this.props.documentType
        });
      }

      var currentSectionKey = this.props.sectionKeys[this.props.onStep];
      var sectionKeyGroup = this.props.sectionKeyToSectionGroupKey[currentSectionKey];
      var sectionOutline = {};
      if (sectionKeyGroup) {
        sectionOutline = this.props.fieldOutline[sectionKeyGroup][currentSectionKey];
      }

      var updatedOnSectionLoadActions = [].concat(_toConsumableArray(this.props.onSectionLoadActions));

      if (this.shouldInitalizeHelpSideBar()) {
        updatedOnSectionLoadActions.push(this.initializeHelpSideBar);
      }

      return _react2.default.createElement(
        'div',
        { id: 'loadedContentArea' },
        INCLUDE_CUSTOM_CSS_DOCUMENT_TYPES.indexOf(this.props.documentType) >= 0 && _react2.default.createElement('link', {
          rel: 'stylesheet',
          type: 'text/css',
          media: 'screen',
          href: (window.FORMSWIFT_URL || '') + '/styles/custom-document/' + this.props.documentType + '.css?v=1.1'
        }),
        _react2.default.createElement(_StaticBuilderSection2.default, {
          documentName: HELP_SIDE_BAR_DOCUMENT_MAP[this.props.documentType],
          documentType: this.props.documentType,
          formattedFields: this.props.formattedFields,
          header: sectionOutline.header,
          inlineConditionalScripts: this.props.sectionKeyToConditionals[currentSectionKey] || '',
          isLoading: this.props.isLoading,
          isVisualStatic: this.props.isVisualStatic,
          loadNextStaticBuilderSection: this.props.loadNextStaticBuilderSection,
          loadPreviousStaticBuilderSection: this.props.loadPreviousStaticBuilderSection,
          onSectionLoadActions: updatedOnSectionLoadActions,
          onStep: this.props.onStep,
          renderHeaderTextAsHtml: this.renderHeaderTextAsHtml,
          saveAndContinue: window.SessionManager.saveAndContinue,
          sectionKeys: this.props.sectionKeys,
          showRequestSignature: this.showRequestSignature
        })
      );
    }
  }]);

  return StaticBuilder;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var StaticBuilderReducer = _ref.StaticBuilderReducer;

  var sectionKeyGroup = null;
  var currentSectionKey = null;
  var sectionOutline = {};

  if (!StaticBuilderReducer.isLoading) {
    currentSectionKey = StaticBuilderReducer.sectionKeys[StaticBuilderReducer.step];
    sectionKeyGroup = StaticBuilderReducer.sectionKeyToSectionGroupKey[currentSectionKey];
  }

  if (sectionKeyGroup) {
    sectionOutline = StaticBuilderReducer.fieldOutline[sectionKeyGroup][currentSectionKey];
  }

  return {
    fields: sectionOutline.fields,
    onStep: StaticBuilderReducer.step,
    sectionKeys: StaticBuilderReducer.sectionKeys,
    fieldOutline: StaticBuilderReducer.fieldOutline,
    sectionContent: StaticBuilderReducer.fieldData,
    sectionKeyToSectionGroupKey: StaticBuilderReducer.sectionKeyToSectionGroupKey,
    isLoading: StaticBuilderReducer.isLoading,
    onSectionLoadActions: StaticBuilderReducer.onSectionLoadActions,
    sectionKeyToConditionals: StaticBuilderReducer.sectionKeyToConditionals
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    getSessionContent: _StaticBuilderActions.getSessionContent,
    loadNextStaticBuilderSection: _StaticBuilderActions.loadNextStaticBuilderSection,
    loadPreviousStaticBuilderSection: _StaticBuilderActions.loadPreviousStaticBuilderSection,
    setStaticBuilderFieldOutline: _StaticBuilderActions.setStaticBuilderFieldOutline
  }, dispatch);
};

var StaticBuilderWithRedux = exports.StaticBuilderWithRedux = ReactRedux.connect(mapStateToProps, mapDispatchToProps)((0, _StaticBuilderSetup2.default)(StaticBuilder));

StaticBuilder.defaultProps = {
  fieldOutline: null,
  forceDownload: false,
  initialOnStep: 0,
  isVisualStatic: false,
  onSectionLoadActions: [],
  onStep: 0,
  productMap: {},
  sectionKeys: [],
  sectionKeyToConditionals: {},
  sectionKeyToSectionGroupKey: {}
};

var productMapPropType = _CustomPropTypes2.default.hashmapOf(_CustomPropTypes2.default.hashmapOf(_propTypes2.default.shape({
  fields: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    label: _propTypes2.default.string,
    options: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.shape({
      text: _propTypes2.default.string,
      value: _propTypes2.default.string
    })), _propTypes2.default.string]),
    type: _propTypes2.default.string
  })),
  header: _propTypes2.default.string
})));

StaticBuilder.propTypes = {
  documentType: _propTypes2.default.string.isRequired,
  fieldOutline: productMapPropType,
  forceDownload: _propTypes2.default.bool,
  formattedFields: _propTypes2.default.instanceOf(_StaticBuilderFormattedFields2.default).isRequired,
  getSessionContent: _propTypes2.default.func.isRequired,
  initialOnStep: _propTypes2.default.number,
  isLoading: _propTypes2.default.bool.isRequired,
  isVisualStatic: _propTypes2.default.bool,
  loadNextStaticBuilderSection: _propTypes2.default.func.isRequired,
  loadPreviousStaticBuilderSection: _propTypes2.default.func.isRequired,
  onSectionLoadActions: _propTypes2.default.arrayOf(_propTypes2.default.func),
  onStep: _propTypes2.default.number,
  productMap: productMapPropType,
  sectionKeys: _propTypes2.default.arrayOf(_propTypes2.default.string),
  sectionKeyToConditionals: _CustomPropTypes2.default.hashmapOf(_propTypes2.default.string),
  sectionKeyToSectionGroupKey: _CustomPropTypes2.default.hashmapOf(_propTypes2.default.string),
  sessionHash: _propTypes2.default.string.isRequired,
  sessionId: _propTypes2.default.string.isRequired,
  setStaticBuilderFieldOutline: _propTypes2.default.func.isRequired
};

exports.default = (0, _WithInit2.default)(StaticBuilderWithRedux, true);

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function closestPolyfill(s) {
    var el = this;
    var ancestor = this;
    if (!document.documentElement.contains(el)) return null;
    do {
      if (ancestor.matches(s)) return ancestor;
      ancestor = ancestor.parentElement;
    } while (ancestor !== null);
    return null;
  };
}

// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: https://es5.github.io/#x15.4.4.18
if (!NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function forEachPolyfill(callback /* , thisArg */) {
    var T = void 0;
    var k = void 0;

    if (this == null) {
      throw new TypeError('this is null or not defined');
    }

    // 1. Let O be the result of calling toObject() passing the
    // |this| value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get() internal
    // method of O with the argument "length".
    // 3. Let len be toUint32(lenValue).
    var len = O.length >>> 0; // eslint-disable-line no-bitwise

    // 4. If isCallable(callback) is false, throw a TypeError exception.
    // See: https://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let
    // T be undefined.
    if (arguments.length > 1) {
      T = arguments[1]; // eslint-disable-line prefer-rest-params
    }

    // 6. Let k be 0.
    k = 0;

    // 7. Repeat while k < len.
    while (k < len) {
      var kValue = void 0;

      // a. Let Pk be ToString(k).
      //    This is implicit for LHS operands of the in operator.
      // b. Let kPresent be the result of calling the HasProperty
      //    internal method of O with argument Pk.
      //    This step can be combined with c.
      // c. If kPresent is true, then
      if (k in O) {
        // i. Let kValue be the result of calling the Get internal
        // method of O with argument Pk.
        kValue = O[k];

        // ii. Call the Call internal method of callback with T as
        // the this value and argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k += 1;
    }
    // 8. return undefined.
  };
}

if (!(typeof window.CustomEvent === 'function')) {
  var CustomEvent = function CustomEvent(event, initialParams) {
    var params = initialParams || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
}

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ExportProgressBarModal = __webpack_require__(351);

Object.defineProperty(exports, 'ExportProgressBarModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ExportProgressBarModal).default;
  }
});

var _FreeWriteSignatureCancelSurveyModal = __webpack_require__(355);

Object.defineProperty(exports, 'FreeWriteSignatureCancelSurveyModalContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FreeWriteSignatureCancelSurveyModal).default;
  }
});

var _FreeWriteSignatureReminderModal = __webpack_require__(319);

Object.defineProperty(exports, 'FreeWriteSignatureReminderModalContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FreeWriteSignatureReminderModal).default;
  }
});

var _ModalConstants = __webpack_require__(20);

Object.defineProperty(exports, 'ModalTypeEnum', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModalConstants).default;
  }
});

var _ReactivationOfferModal = __webpack_require__(352);

Object.defineProperty(exports, 'ReactivationOfferModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ReactivationOfferModal).default;
  }
});

var _UpdateSubscriptionProgressModal = __webpack_require__(353);

Object.defineProperty(exports, 'UpdateSubscriptionProgressModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UpdateSubscriptionProgressModal).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Utils = __webpack_require__(42);

var _NavSideBarListSection = __webpack_require__(254);

var _NavSideBarListSection2 = _interopRequireDefault(_NavSideBarListSection);

var _NavSideBarListSectionWithDropDown = __webpack_require__(255);

var _NavSideBarListSectionWithDropDown2 = _interopRequireDefault(_NavSideBarListSectionWithDropDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavSideBarListWithSections = function (_React$Component) {
  _inherits(NavSideBarListWithSections, _React$Component);

  function NavSideBarListWithSections(props) {
    _classCallCheck(this, NavSideBarListWithSections);

    var _this = _possibleConstructorReturn(this, (NavSideBarListWithSections.__proto__ || Object.getPrototypeOf(NavSideBarListWithSections)).call(this, props));

    _this.getCategoriesWithSections = _this.getCategoriesWithSections.bind(_this);
    return _this;
  }

  _createClass(NavSideBarListWithSections, [{
    key: 'getCategoriesWithSections',
    value: function getCategoriesWithSections() {
      var _this2 = this;

      var categories = Object.keys(this.props.categories);
      var categoriesWithSections = categories.filter(function (potentialCategory) {
        return Array.isArray(_this2.props.categories[potentialCategory]);
      });

      return categoriesWithSections;
    }
  }, {
    key: 'render',
    value: function render() {
      var isDropdown = !this.props.offsiteBuilder;
      var _props = this.props,
          documentType = _props.documentType,
          releaseType = _props.releaseType;

      var navSideBarList = [];
      var categoriesWithSections = this.getCategoriesWithSections();
      var isGetLink = (0, _Utils.isLastSectionGetLink)(documentType, releaseType);

      var numOfCategories = categoriesWithSections.length;
      var offsetIdx = 0;

      for (var i = 0; i < numOfCategories; i += 1) {
        var category = categoriesWithSections[i];
        var sections = this.props.categories[category];
        var lastCategory = i + 1 === numOfCategories;

        var listSectionProps = {
          category: category,
          documentType: this.props.documentType,
          isLastSectionGetLink: lastCategory && isGetLink,
          key: category,
          loadStaticBuilderSection: this.props.loadStaticBuilderSection,
          offsetIdx: offsetIdx,
          offsiteBuilder: this.props.offsiteBuilder,
          onStep: this.props.onStep,
          sections: sections,
          showRequestSignature: this.props.showRequestSignature && lastCategory
        };

        var navSideBarListSection = _react2.default.createElement(_NavSideBarListSection2.default, listSectionProps);

        if (isDropdown) {
          navSideBarListSection = _react2.default.createElement(_NavSideBarListSectionWithDropDown2.default, listSectionProps);
        }

        offsetIdx += sections.length;
        navSideBarList.push(navSideBarListSection);
      }

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        navSideBarList
      );
    }
  }]);

  return NavSideBarListWithSections;
}(_react2.default.Component);

exports.default = NavSideBarListWithSections;


NavSideBarListWithSections.defaultProps = {
  categories: {},
  offsiteBuilder: false,
  onStep: 0,
  releaseType: '',
  showRequestSignature: false
};

NavSideBarListWithSections.propTypes = {
  categories: _propTypes2.default.shape({}),
  documentType: _propTypes2.default.string.isRequired,
  loadStaticBuilderSection: _propTypes2.default.func.isRequired,
  offsiteBuilder: _propTypes2.default.bool,
  onStep: _propTypes2.default.number,
  releaseType: _propTypes2.default.string,
  showRequestSignature: _propTypes2.default.bool
};

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavSideBarMenuButtonWithRedux = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = __webpack_require__(18);

var _StaticBuilderActions = __webpack_require__(24);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BOOTSTRAP_SM_WIDTH = 768;

var NavSideBarMenuButton = function (_React$PureComponent) {
  _inherits(NavSideBarMenuButton, _React$PureComponent);

  _createClass(NavSideBarMenuButton, null, [{
    key: 'scrollToCurrentStep',
    value: function scrollToCurrentStep() {
      var maxOffsetTop = 725;
      var offsetTopAdjustment = 150;
      var coords = (0, _Utils.getCoords)(document.querySelector('.builder-nav li.active'));
      if (coords.top > maxOffsetTop) {
        document.querySelector('.builder-nav').scrollTop = document.querySelector('.builder-nav').scrollTop + (coords.top - offsetTopAdjustment);
      }
    }
  }]);

  function NavSideBarMenuButton(props) {
    _classCallCheck(this, NavSideBarMenuButton);

    var _this = _possibleConstructorReturn(this, (NavSideBarMenuButton.__proto__ || Object.getPrototypeOf(NavSideBarMenuButton)).call(this, props));

    _this.handleResize = _this.handleResize.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onResize = _this.onResize.bind(_this);

    _this.state = {
      isMobile: false
    };

    _this.props.addStaticBuilderOnSectionLoadAction(NavSideBarMenuButton.scrollToCurrentStep);
    return _this;
  }

  _createClass(NavSideBarMenuButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.onResize);
      this.handleResize(window.innerWidth);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      window._track('Side By Side Preview Sliding Section', this.props.documentType);

      var builderNavNode = document.getElementById('builderNav');
      var staticBuilderContentNode = document.getElementById('staticBuilderContent');
      var documentPreviewWrapperNode = document.getElementById('documentPreviewWrapper');
      var sectionProgressNode = document.getElementById('sectionProgress');

      if (this.props.isMenuOpen) {
        builderNavNode.classList.add('collapsed');
        builderNavNode.style.display = 'none';
        staticBuilderContentNode.classList.add('expanded');
        documentPreviewWrapperNode.classList.add('expanded');
        sectionProgressNode.classList.remove('navbar-opened');
      } else {
        builderNavNode.classList.remove('collapsed');
        builderNavNode.style.display = 'block';
        staticBuilderContentNode.classList.remove('expanded');
        documentPreviewWrapperNode.classList.remove('expanded');
        sectionProgressNode.classList.add('navbar-opened');
      }

      this.props.setStaticBuilderMenuButton(!this.props.isMenuOpen);
    }
  }, {
    key: 'onResize',
    value: function onResize(e) {
      this.handleResize(e.target.innerWidth);
    }
  }, {
    key: 'handleResize',
    value: function handleResize(innerWidth) {
      var builderContainerNode = document.getElementById('builderContainer');
      var builderNavNode = document.getElementById('builderNav');
      var staticBuilderContentNode = document.getElementById('staticBuilderContent');
      var documentPreviewWrapperNode = document.getElementById('documentPreviewWrapper');

      if (innerWidth < BOOTSTRAP_SM_WIDTH) {
        staticBuilderContentNode.classList.remove('expanded');
        documentPreviewWrapperNode.classList.remove('expanded');
        builderNavNode.classList.remove('collapsed');

        // Only want to hide the navigation if it's been set to hide
        // based on split test where we have V3 hiding the preview to begin with
        // and want to hide navigation when the preview is visible
        builderNavNode.style.display = this.props.isBuilderHidden ? 'none' : 'block';
        builderContainerNode.appendChild(builderNavNode);
        this.setState({ isMobile: true });
      } else {
        if (!this.props.isMenuOpen) {
          builderNavNode.style.display = 'none';
          staticBuilderContentNode.classList.add('expanded');
          documentPreviewWrapperNode.classList.add('expanded');
        }

        staticBuilderContentNode.parentNode.insertBefore(builderNavNode, staticBuilderContentNode);
        this.setState({ isMobile: false });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var imgSrc = this.props.isMenuOpen ? 'icon-nav-close.png' : 'icon-nav-menu.png';
      var buttonClassName = (0, _classnames2.default)('builder-side-bar-menu-button', {
        hidden: this.state.isMobile,
        'is-closed': !this.props.isMenuOpen
      });

      return _react2.default.createElement(
        'button',
        {
          className: buttonClassName,
          id: 'staticMenuButton',
          onClick: this.onClick
        },
        _react2.default.createElement(
          'span',
          null,
          'MENU'
        ),
        _react2.default.createElement('img', {
          alt: '',
          className: 'builder-toolbar-arrow-img',
          src: window.cdnUrl + '/images/icons/' + imgSrc
        })
      );
    }
  }]);

  return NavSideBarMenuButton;
}(_react2.default.PureComponent);

NavSideBarMenuButton.defaultProps = {
  isMenuOpen: false
};

NavSideBarMenuButton.propTypes = {
  addStaticBuilderOnSectionLoadAction: _propTypes2.default.func.isRequired,
  documentType: _propTypes2.default.string.isRequired,
  isBuilderHidden: _propTypes2.default.bool.isRequired,
  isMenuOpen: _propTypes2.default.bool,
  setStaticBuilderMenuButton: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(_ref) {
  var StaticBuilderReducer = _ref.StaticBuilderReducer;
  return {
    isMenuOpen: StaticBuilderReducer.isMenuOpen,
    isBuilderHidden: StaticBuilderReducer.isBuilderHidden
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    addStaticBuilderOnSectionLoadAction: _StaticBuilderActions.addStaticBuilderOnSectionLoadAction,
    setStaticBuilderMenuButton: _StaticBuilderActions.setStaticBuilderMenuButton
  }, dispatch);
};

var NavSideBarMenuButtonWithRedux = exports.NavSideBarMenuButtonWithRedux = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(NavSideBarMenuButton);

exports.default = (0, _WithInit2.default)(NavSideBarMenuButtonWithRedux, true);

/***/ }),

/***/ 1738:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FormSwiftModal = __webpack_require__(815);

var _FormSwiftModal2 = _interopRequireDefault(_FormSwiftModal);

var _ModalHeader = __webpack_require__(347);

var _ModalHeader2 = _interopRequireDefault(_ModalHeader);

var _ModalBody = __webpack_require__(346);

var _ModalBody2 = _interopRequireDefault(_ModalBody);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SecondActionModal = function SecondActionModal(_ref) {
  var handleCloseStaticSecondActionModal = _ref.closeStaticSecondActionModal,
      isSecondActionModalOpen = _ref.isSecondActionModalOpen,
      shareUrl = _ref.shareUrl,
      signUrl = _ref.signUrl;

  var headerCopy = 'Success! Next, do you need to send your document to someone?';

  var handleShareClick = function handleShareClick() {
    window._track('Main CTA | Second Action Modal | Static-Builder-Member', 'Share');
    window.COOKIE.set('secondaryActionClicked', 'share');
  };

  var handleCreateClick = function handleCreateClick() {
    window._track('Share Variation | Secondary CTA | Second Action Modal | Static-Builder-Member', 'Create');
    window.COOKIE.set('secondaryActionClicked', 'create');
  };

  var handleUploadClick = function handleUploadClick() {
    window._track('Share Variation | Secondary CTA | Second Action Modal | Static-Builder-Member', 'Upload');
    window.COOKIE.set('secondaryActionClicked', 'upload');
  };

  var handleSignClick = function handleSignClick() {
    window._track('Share Variation | Secondary CTA | Second Action Modal | Static-Builder-Member', 'Sign');
    window.COOKIE.set('secondaryActionClicked', 'sign');
  };

  return _react2.default.createElement(
    _FormSwiftModal2.default,
    {
      className: 'onboarding-second-action-modal',
      isOpen: isSecondActionModalOpen,
      handleCloseModal: handleCloseStaticSecondActionModal,
      onAfterOpen: function onAfterOpen() {
        return window.Upload.activateUploadButtonById('uploadSecondAction');
      }
    },
    _react2.default.createElement(_ModalHeader2.default, { headerCopy: headerCopy }),
    _react2.default.createElement(
      _ModalBody2.default,
      null,
      _react2.default.createElement(
        'a',
        {
          className: 'btn btn-success onboarding-modal-main-cta-button',
          href: shareUrl,
          onClick: handleShareClick
        },
        'Yes, Share Document'
      ),
      _react2.default.createElement(
        'div',
        { className: 'onboarding-modal-footer' },
        _react2.default.createElement(
          'div',
          { className: 'onboarding-try-block' },
          'Or try one of these:'
        ),
        _react2.default.createElement(
          'div',
          { className: 'onboarding-modal-secondary-action-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'onboarding-modal-secondary-action-block' },
            _react2.default.createElement(
              'div',
              { className: 'image-wrapper' },
              _react2.default.createElement('img', {
                alt: 'Start a new document',
                src: '/images/builder-static/new-doc.png'
              })
            ),
            _react2.default.createElement(
              'a',
              {
                className: 'onboarding-modal-secondary-action',
                'data-ctatype': 'create',
                href: '/document-library',
                onClick: handleCreateClick
              },
              'Start a New Document >'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'onboarding-modal-secondary-action-block' },
            _react2.default.createElement(
              'div',
              { className: 'image-wrapper' },
              _react2.default.createElement('img', {
                alt: 'Upload your PDF',
                src: '/images/builder-static/edit-pdf.png'
              })
            ),
            _react2.default.createElement(
              'a',
              {
                className: 'onboarding-modal-secondary-action',
                'data-ctatype': 'upload',
                id: 'uploadSecondAction',
                onClick: handleUploadClick
              },
              'Upload Your PDF >'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'onboarding-modal-secondary-action-block' },
            _react2.default.createElement(
              'div',
              { className: 'image-wrapper' },
              _react2.default.createElement('img', {
                alt: 'Sign your document',
                src: '/images/builder-static/signature.png'
              })
            ),
            _react2.default.createElement(
              'a',
              {
                className: 'onboarding-modal-secondary-action',
                'data-ctatype': 'sign',
                href: signUrl,
                onClick: handleSignClick
              },
              'Sign Your Document >'
            )
          )
        ),
        _react2.default.createElement(
          'a',
          {
            className: 'onboarding-modal-return-button',
            href: '/my-documents',
            onClick: function onClick() {
              return window._track('Share Variation | Second Action Modal | Static-Builder-Member', 'My Documents');
            }
          },
          'Return to Recent Documents >'
        )
      )
    )
  );
};

SecondActionModal.propTypes = {
  closeStaticSecondActionModal: _propTypes2.default.func.isRequired,
  isSecondActionModalOpen: _propTypes2.default.bool.isRequired,
  shareUrl: _propTypes2.default.string.isRequired,
  signUrl: _propTypes2.default.string.isRequired
};

exports.default = SecondActionModal;

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dompurify = __webpack_require__(53);

var _dompurify2 = _interopRequireDefault(_dompurify);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _StaticBuilderFormattedFields = __webpack_require__(51);

var _StaticBuilderFormattedFields2 = _interopRequireDefault(_StaticBuilderFormattedFields);

var _StaticBuilderForm = __webpack_require__(117);

var _StaticBuilderForm2 = _interopRequireDefault(_StaticBuilderForm);

var _StaticBuilderSaveProgressBar = __webpack_require__(265);

var _StaticBuilderSaveProgressBar2 = _interopRequireDefault(_StaticBuilderSaveProgressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BUTTON_SELECTOR = '.controls button';
var INPUT_SELECTOR = '.controls input';
var SELECT_SELECTOR = '.controls select';
var TEXTAREA_SELECTOR = '.controls textarea';
var FIELDSET_SELECTOR = 'fieldset .control-group';

var StaticBuilderSection = function (_React$Component) {
  _inherits(StaticBuilderSection, _React$Component);

  function StaticBuilderSection(props) {
    _classCallCheck(this, StaticBuilderSection);

    var _this = _possibleConstructorReturn(this, (StaticBuilderSection.__proto__ || Object.getPrototypeOf(StaticBuilderSection)).call(this, props));

    _this.inlineConditionals = _this.inlineConditionals.bind(_this);
    _this.onNewSectionLoaded = _this.onNewSectionLoaded.bind(_this);
    _this.onKeyPress = _this.onKeyPress.bind(_this);
    _this.setSidebarShiftAmount = _this.setSidebarShiftAmount.bind(_this);
    _this.calculateSidebarShiftAmount = _this.calculateSidebarShiftAmount.bind(_this);

    _this.state = {
      sidebarShiftAmount: 0
    };
    return _this;
  }

  _createClass(StaticBuilderSection, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.showSidebarAnimation) {
        window.addEventListener('resize', this.setSidebarShiftAmount);
        this.setSidebarShiftAmount();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // new section loaded
      if (prevProps.isLoading && !this.props.isLoading) {
        this.onNewSectionLoaded();
      }
    }

    // Capture the Enter button and treat it as Save and continue

  }, {
    key: 'onKeyPress',
    value: function onKeyPress(e) {
      // Does not call for self serve because saveOnEnter fires off static builder actions
      // Self serve enter key functionality handled in StaticBuilderForm

      if (this.props.isSelfServe) {
        return;
      }

      if (!this.props.isMobileOptimization) {
        window.SessionManager.saveOnEnter(e);
      } else if (e.key === 'Enter') {
        // Handles enter press for mobile optimization split test
        var formInputs = document.querySelectorAll(INPUT_SELECTOR + ', ' + SELECT_SELECTOR + ', ' + TEXTAREA_SELECTOR);

        var activeIndex = [].concat(_toConsumableArray(formInputs)).findIndex(function (formInput) {
          return formInput === document.activeElement;
        });

        if (activeIndex === formInputs.length - 1) {
          window.SessionManager.saveOnEnter(e);
        } else {
          formInputs[activeIndex + 1].focus();
        }
      }
    }
  }, {
    key: 'onNewSectionLoaded',
    value: function onNewSectionLoaded() {
      window.scrollTo(0, 0);

      if (this.props.onSectionLoadActions.length) {
        this.props.onSectionLoadActions.forEach(function (onSectionLoadAction) {
          onSectionLoadAction();
        });
      }

      var formInputs = document.querySelectorAll(INPUT_SELECTOR + ', ' + SELECT_SELECTOR + ', ' + TEXTAREA_SELECTOR + ', ' + BUTTON_SELECTOR);

      if (formInputs.length) {
        formInputs[0].focus();
      }
    }
  }, {
    key: 'setSidebarShiftAmount',
    value: function setSidebarShiftAmount() {
      this.setState({
        sidebarShiftAmount: this.calculateSidebarShiftAmount()
      });
    }
  }, {
    key: 'calculateSidebarShiftAmount',
    value: function calculateSidebarShiftAmount() {
      var browserWidth = this.props.hasSiteSidebar ? window.innerWidth - 48 : window.innerWidth;
      if (browserWidth >= 1260 && browserWidth <= 1500) {
        var sidebarShiftAmount = (1500 - browserWidth) / 2 + 2;
        return sidebarShiftAmount;
      }
      return 0;
    }
  }, {
    key: 'inlineConditionals',
    value: function inlineConditionals() {
      if (this.props.disableConditionals) {
        return;
      }
      // Yikes! We currently have dynamically produced jquery from our php class,
      // `Conditionals`. In order to reuse our StaticBuilder react component, we
      // need to include these inline scripts while we look for other solutions that
      // will make use of our redux store
      var inlineScriptsWithoutTag = this.props.inlineConditionalScripts.replace(/<script.+?>/g, '').replace(/<script>/g, '').replace(/<\/script>/g, '');

      eval(_dompurify2.default.sanitize(inlineScriptsWithoutTag, { SAFE_FOR_JQUERY: true }));

      var fields = document.querySelectorAll(FIELDSET_SELECTOR);
      var visibleFields = [].concat(_toConsumableArray(fields)).filter(function (field) {
        return field.offsetParent !== null;
      });

      if (visibleFields.length === 0) {
        // Check if we can go to the next step (or if it's the last section)
        var skipPage = true;
        var nextStepAvailable = this.props.loadNextStaticBuilderSection(skipPage);

        if (!nextStepAvailable) {
          this.props.saveAndContinue();
        }
      }

      if (window.secondPresence) {
        setTimeout(window.Wizard.interface.updateSectionProgressTimed, 10);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          documentName = _props.documentName,
          highlightedBox = _props.highlightedBox,
          isLoading = _props.isLoading,
          showHelpSideBar = _props.showHelpSideBar,
          showSidebarAnimation = _props.showSidebarAnimation;

      var sidebarShiftAmount = showHelpSideBar ? this.state.sidebarShiftAmount + 'px' : '0';

      var screenStyle = {
        marginLeft: sidebarShiftAmount,
        opacity: 1.0
      };

      if (isLoading) {
        screenStyle = _extends({}, screenStyle, {
          opacity: 0.5,
          height: 30
        });
      }

      var screenClass = (0, _classnames2.default)('bpage', {
        'screen-with-transition': showSidebarAnimation
      });

      var screenOverlayClass = (0, _classnames2.default)('screen-overlay', screenClass);

      var highlightedImage = 'url(/styles/custom-document/assets/' + documentName + '-highlighted-boxes/box-' + highlightedBox + '.png)';
      var backgroundImage = documentName && highlightedBox ? highlightedImage : 'none';

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          { className: 'hide' },
          _react2.default.createElement(
            'h4',
            null,
            'Loading Next Section...'
          ),
          _react2.default.createElement(
            'div',
            { className: 'progressAnimation' },
            _react2.default.createElement('span', { className: 'bar' })
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement('div', {
          className: screenOverlayClass,
          style: {
            backgroundImage: backgroundImage,
            marginLeft: sidebarShiftAmount
          }
        }),
        _react2.default.createElement(
          'div',
          {
            id: 'screen',
            className: screenClass,
            onKeyPress: this.onKeyPress,
            style: screenStyle
          },
          isLoading && _react2.default.createElement(
            'h3',
            { className: 'static-builder-form-header-loading' },
            'Loading...'
          ),
          !isLoading && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            this.props.renderHeaderTextAsHtml ? _react2.default.createElement('h2', {
              className: 'static-builder-form-header',
              dangerouslySetInnerHTML: { __html: this.props.header }
            }) : _react2.default.createElement(
              'h2',
              { className: 'static-builder-form-header' },
              this.props.header
            ),
            _react2.default.createElement(
              'div',
              { id: 'staticBuilderFormContainer', className: 'innerContent' },
              _react2.default.createElement(_StaticBuilderForm2.default, {
                loadPreviousStaticBuilderSection: this.props.loadPreviousStaticBuilderSection,
                saveAndSign: this.props.saveAndSign,
                saveAndContinue: this.props.saveAndContinue,
                renderHeaderTextAsHtml: this.props.renderHeaderTextAsHtml,
                shareKey: this.props.shareKey,
                onStep: this.props.onStep,
                sectionKeys: this.props.sectionKeys,
                documentType: this.props.documentType,
                finishSelfServe: this.props.finishSelfServe,
                formattedFields: this.props.formattedFields,
                inlineConditionals: this.inlineConditionals,
                isSelfServe: this.props.isSelfServe,
                isPreviewMode: this.props.isPreviewMode,
                showRequestSignature: this.props.showRequestSignature
              })
            ),
            _react2.default.createElement(_StaticBuilderSaveProgressBar2.default, null)
          )
        )
      );
    }
  }]);

  return StaticBuilderSection;
}(_react2.default.Component);

StaticBuilderSection.defaultProps = {
  disableConditionals: false,
  documentName: '',
  finishSelfServe: function finishSelfServe() {},
  hasSiteSidebar: false,
  header: '',
  highlightedBox: '',
  inlineConditionalScripts: '',
  isMobileOptimization: false,
  isSelfServe: false,
  isPreviewMode: false,
  onSectionLoadActions: [],
  onStep: 0,
  renderHeaderTextAsHtml: false,
  sectionKeys: [],
  shareKey: '',
  showHelpSideBar: false,
  showSidebarAnimation: false,
  showRequestSignature: true
};

StaticBuilderSection.propTypes = {
  disableConditionals: _propTypes2.default.bool,
  documentName: _propTypes2.default.string,
  documentType: _propTypes2.default.string.isRequired,
  finishSelfServe: _propTypes2.default.func,
  formattedFields: _propTypes2.default.instanceOf(_StaticBuilderFormattedFields2.default).isRequired,
  hasSiteSidebar: _propTypes2.default.bool,
  header: _propTypes2.default.string,
  highlightedBox: _propTypes2.default.string,
  inlineConditionalScripts: _propTypes2.default.string,
  isLoading: _propTypes2.default.bool.isRequired,
  isMobileOptimization: _propTypes2.default.bool,
  isSelfServe: _propTypes2.default.bool,
  isPreviewMode: _propTypes2.default.bool,
  loadNextStaticBuilderSection: _propTypes2.default.func.isRequired,
  loadPreviousStaticBuilderSection: _propTypes2.default.func.isRequired,
  renderHeaderTextAsHtml: _propTypes2.default.bool,
  saveAndSign: _propTypes2.default.func.isRequired,
  showHelpSideBar: _propTypes2.default.bool,
  showSidebarAnimation: _propTypes2.default.bool,
  showRequestSignature: _propTypes2.default.bool,
  onSectionLoadActions: _propTypes2.default.arrayOf(_propTypes2.default.func),
  onStep: _propTypes2.default.number,
  saveAndContinue: _propTypes2.default.func.isRequired,
  sectionKeys: _propTypes2.default.arrayOf(_propTypes2.default.string),
  shareKey: _propTypes2.default.string
};

exports.default = StaticBuilderSection;

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _redux = __webpack_require__(4);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _HelpSideBar = __webpack_require__(280);

var _HelpSideBar2 = _interopRequireDefault(_HelpSideBar);

var _VisualStaticActions = __webpack_require__(178);

var VisualStaticActions = _interopRequireWildcard(_VisualStaticActions);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _store = __webpack_require__(25);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var mapStateToProps = function mapStateToProps(_ref) {
  var VisualStaticStateHandler = _ref.VisualStaticStateHandler;
  return { showSideBar: VisualStaticStateHandler.showSideBar };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_extends({}, VisualStaticActions), dispatch);
};

var HelpSideBarWithRedux = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(_HelpSideBar2.default);

exports.default = (0, _WithInit2.default)(HelpSideBarWithRedux, true);


if (window.FormSwift && window.FormSwift.React) {
  var addedActions = Object.assign({}, VisualStaticActions, window.FormSwift.React.actions);
  window.FormSwift.React.actions = addedActions;
} else {
  window.FormSwift = {
    React: {
      store: _store2.default,
      actions: VisualStaticActions
    }
  };
}

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpSideBarButtonWithRedux = exports.HelpSideBarButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(4);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _VisualStaticActions = __webpack_require__(178);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HelpSideBarButton = exports.HelpSideBarButton = function (_React$PureComponent) {
  _inherits(HelpSideBarButton, _React$PureComponent);

  function HelpSideBarButton(props) {
    _classCallCheck(this, HelpSideBarButton);

    var _this = _possibleConstructorReturn(this, (HelpSideBarButton.__proto__ || Object.getPrototypeOf(HelpSideBarButton)).call(this, props));

    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }

  _createClass(HelpSideBarButton, [{
    key: 'onClick',
    value: function onClick(e) {
      window._track('Help | Helpful Sidebar', 'Visual-Static-Builder');
      e.stopPropagation();
      this.props.toggleHelpSideBar();
    }
  }, {
    key: 'render',
    value: function render() {
      var containerClass = (0, _classnames2.default)('help-side-bar-btn-container', {
        hidden: this.props.isUserSessionsPanelOpen
      });

      return _react2.default.createElement(
        'div',
        { className: containerClass },
        _react2.default.createElement(
          'button',
          {
            className: 'help-side-bar-help-btn',
            onClick: this.onClick
          },
          _react2.default.createElement('img', {
            alt: 'Click to expand',
            src: 'images/builder-static/icon-question-mark-2x.png'
          }),
          _react2.default.createElement(
            'span',
            null,
            'Help'
          )
        )
      );
    }
  }]);

  return HelpSideBarButton;
}(_react2.default.PureComponent);

var mapStateToProps = function mapStateToProps(_ref) {
  var SidebarSiteNavigationReducer = _ref.SidebarSiteNavigationReducer;
  return {
    isUserSessionsPanelOpen: SidebarSiteNavigationReducer.isUserSessionsPanelOpen
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    toggleHelpSideBar: _VisualStaticActions.toggleHelpSideBar
  }, dispatch);
};

var HelpSideBarButtonWithRedux = exports.HelpSideBarButtonWithRedux = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(HelpSideBarButton);

HelpSideBarButton.defaultProps = {
  isUserSessionsPanelOpen: false
};

HelpSideBarButton.propTypes = {
  isUserSessionsPanelOpen: _propTypes2.default.bool,
  toggleHelpSideBar: _propTypes2.default.func.isRequired
};

exports.default = (0, _WithInit2.default)(HelpSideBarButtonWithRedux, true);

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _StaticBuilderProgressBar = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaticBuilderProgressBarWrapper = function (_React$PureComponent) {
  _inherits(StaticBuilderProgressBarWrapper, _React$PureComponent);

  function StaticBuilderProgressBarWrapper() {
    _classCallCheck(this, StaticBuilderProgressBarWrapper);

    return _possibleConstructorReturn(this, (StaticBuilderProgressBarWrapper.__proto__ || Object.getPrototypeOf(StaticBuilderProgressBarWrapper)).apply(this, arguments));
  }

  _createClass(StaticBuilderProgressBarWrapper, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_StaticBuilderProgressBar.StaticBuilderProgressBarWithRedux, this.props);
    }
  }]);

  return StaticBuilderProgressBarWrapper;
}(_react2.default.PureComponent);

exports.default = (0, _WithInit2.default)(StaticBuilderProgressBarWrapper, true);

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticCreateAccountSection = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StaticCreateAccountForm = __webpack_require__(277);

var _StaticCreateAccountForm2 = _interopRequireDefault(_StaticCreateAccountForm);

var _StaticCreateAccountErrorBox = __webpack_require__(120);

var _StaticCreateAccountErrorBox2 = _interopRequireDefault(_StaticCreateAccountErrorBox);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaticCreateAccountSection = exports.StaticCreateAccountSection = function (_React$Component) {
  _inherits(StaticCreateAccountSection, _React$Component);

  function StaticCreateAccountSection(props) {
    _classCallCheck(this, StaticCreateAccountSection);

    var _this = _possibleConstructorReturn(this, (StaticCreateAccountSection.__proto__ || Object.getPrototypeOf(StaticCreateAccountSection)).call(this, props));

    _this.setErrorBoxState = _this.setErrorBoxState.bind(_this);
    _this.onBackClickOverride = _this.onBackClickOverride.bind(_this);

    _this.state = {
      showErrorBox: false,
      errorMessage: ''
    };

    // Update component copy if Create Account Section is on last step of builder
    if (window.createAccountScreen === _this.props.sectionKeys.length - 1) {
      _this.sectionHeader = 'Almost Done! Create an Account to Save Your Document';
      _this.saveButtonCta = 'Save & Create Account';
      _this.backButtonCta = 'Back';
      _this.onBackClickOverride = null;
      _this.postSubmitAction = 'redirect';
    } else {
      _this.sectionHeader = _this.props.sectionHeader;
      _this.saveButtonCta = _this.props.saveButtonCta;
      _this.backButtonCta = _this.props.backButtonCta;
      _this.postSubmitAction = 'nextBuilderStep';
    }
    return _this;
  }

  _createClass(StaticCreateAccountSection, [{
    key: 'onBackClickOverride',
    value: function onBackClickOverride(event) {
      event.preventDefault();
      if (this.props.trackingId) {
        window.localStorage.setItem('createAccountLaterStaticBuilderTrackingId', this.props.trackingId);
      }
      window.moveCreateAccountSection();
    }
  }, {
    key: 'setErrorBoxState',
    value: function setErrorBoxState(state, message) {
      this.setState({
        showErrorBox: state,
        errorMessage: message
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { id: 'screen', className: 'static-request-signature-content-section page' },
        _react2.default.createElement(
          'h2',
          null,
          this.sectionHeader
        ),
        this.state.showErrorBox && _react2.default.createElement(_StaticCreateAccountErrorBox2.default, { errorMessage: this.state.errorMessage }),
        _react2.default.createElement(
          'p',
          { className: 'lighter-text' },
          this.props.sectionSubHeader
        ),
        _react2.default.createElement(
          'div',
          { className: 'innerContent' },
          _react2.default.createElement(_StaticCreateAccountForm2.default, {
            setErrorBoxState: this.setErrorBoxState,
            saveButtonCta: this.saveButtonCta,
            backButtonCta: this.backButtonCta,
            onBackClickOverride: this.onBackClickOverride,
            trackDropdownSelection: false,
            postSubmitAction: this.postSubmitAction,
            trackingId: this.props.trackingId
          })
        )
      );
    }
  }]);

  return StaticCreateAccountSection;
}(_react2.default.Component);

StaticCreateAccountSection.propTypes = {
  sectionHeader: _propTypes2.default.string,
  sectionSubHeader: _propTypes2.default.string,
  backButtonCta: _propTypes2.default.string,
  saveButtonCta: _propTypes2.default.string,
  trackingId: _propTypes2.default.string,
  sectionKeys: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

StaticCreateAccountSection.defaultProps = {
  saveButtonCta: 'Create Account',
  backButtonCta: 'I\'ll Do This Later',
  trackingId: 'Section 4',
  sectionHeader: 'Don\'t Lose Your Hard Work! Create an Account to Save Your Document',
  sectionSubHeader: 'Create a free account to save your progress on this form. You can come back to it at any time.',
  sectionKeys: []
};

var mapStateToProps = function mapStateToProps(_ref) {
  var StaticBuilderReducer = _ref.StaticBuilderReducer;
  return {
    sectionKeys: StaticBuilderReducer.sectionKeys
  };
};

exports.default = ReactRedux.connect(mapStateToProps)(StaticCreateAccountSection);

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewAccountTermsOfService = function NewAccountTermsOfService() {
  return _react2.default.createElement(
    "p",
    { className: "terms-of-service-text" },
    "By continuing, you confirm that you have read and consent to our\xA0",
    _react2.default.createElement(
      "a",
      { href: "/terms.php", target: "_blank", rel: "noopener noreferrer" },
      "Terms of Use"
    ),
    "\xA0and\xA0",
    _react2.default.createElement(
      "a",
      { href: "/privacy", target: "_blank", rel: "noopener noreferrer" },
      "Privacy Policy"
    ),
    "."
  );
};

exports.default = NewAccountTermsOfService;

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RegisterFormTOSPositionEnum = {
  TOP: 'top',
  BOTTOM: 'bottom',
  NONE: 'none'
};

exports.default = RegisterFormTOSPositionEnum;

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _closeStaticSecondActionModal = __webpack_require__(272);

Object.defineProperty(exports, 'closeStaticSecondActionModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_closeStaticSecondActionModal).default;
  }
});

var _openStaticSecondActionModal = __webpack_require__(273);

Object.defineProperty(exports, 'openStaticSecondActionModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_openStaticSecondActionModal).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactValidation = __webpack_require__(314);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_React$Component) {
  _inherits(Input, _React$Component);

  function Input(props) {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.onFocus = _this.onFocus.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onChange = _this.onChange.bind(_this);

    _this.state = {
      showError: true
    };
    return _this;
  }

  _createClass(Input, [{
    key: 'onFocus',
    value: function onFocus(e) {
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
      if (this.props.handleOnFocus) {
        this.props.handleOnFocus(e);
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      if (this.props.isChanged && this.props.error) {
        this.props.onShowError();
        this.setState({
          showError: true
        });
      }
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
      if (this.props.handleOnBlur) {
        this.props.handleOnBlur(e);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      this.props.onHideError();
      this.setState({
        showError: false
      });
      if (this.props.onChange) {
        this.props.onChange(e);
      }
      if (this.props.handleOnChange) {
        this.props.handleOnChange(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          error = _props.error,
          isChanged = _props.isChanged,
          isUsed = _props.isUsed,
          onShowError = _props.onShowError,
          onHideError = _props.onHideError,
          handleOnBlur = _props.handleOnBlur,
          handleOnFocus = _props.handleOnFocus,
          handleOnChange = _props.handleOnChange,
          props = _objectWithoutProperties(_props, ['error', 'isChanged', 'isUsed', 'onShowError', 'onHideError', 'handleOnBlur', 'handleOnFocus', 'handleOnChange']);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('input', _extends({
          tabIndex: 0
        }, props, this.state.showError && isUsed && isChanged && error ? { className: 'is-invalid-input ' + props.className } : { className: props.className }, {
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          onChange: this.onChange
        })),
        this.state.showError && isUsed && isChanged && error
      );
    }
  }]);

  return Input;
}(_react2.default.Component);

Input.defaultProps = {
  children: null,
  error: null,
  isChanged: false,
  isUsed: false,
  onShowError: function onShowError() {},
  onHideError: function onHideError() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onChange: function onChange() {},
  handleOnBlur: function handleOnBlur() {},
  handleOnFocus: function handleOnFocus() {},
  handleOnChange: function handleOnChange() {}
};

Input.propTypes = {
  children: _propTypes2.default.node,
  error: _propTypes2.default.node,
  isChanged: _propTypes2.default.bool,
  isUsed: _propTypes2.default.bool,
  onShowError: _propTypes2.default.func,
  onHideError: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  handleOnBlur: _propTypes2.default.func,
  handleOnFocus: _propTypes2.default.func,
  handleOnChange: _propTypes2.default.func
};

var ControlInput = (0, _reactValidation.control)(Input);
exports.default = ControlInput;

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Form1099MiscHelpData = [{
  box: 'a',
  title: "Payer's name, street address, city or town, state or province, country, zip or foreign postal code, and telephone number",
  keywords: ['Payer', 'Payer\'s', 'Name', 'Street Address', 'City', 'Town', 'State', 'Province', 'Country', 'Zip', 'Foreign', 'Postal', 'Code', 'Telephone', 'Phone'],
  details: ['As the payer, enter your business address details.']
}, {
  box: 'b',
  title: "Payer's TIN, also known as federal identification number",
  keywords: ['Payer', 'Payer\'s', 'Federal', 'Identification', 'Number', 'No'],
  details: ['Enter your federal identification number. You can choose between an EIN or a SSN. If you are the sole proprietor, usually you will enter the SSN which is 9 digits, written ### - ## - ####. Your IRS-assigned EIN is nine digits, written ## - #######.']
}, {
  box: 'c',
  title: "Recipient's TIN, also known as identification number",
  keywords: ['Recipient', 'Recipient\'s', 'Identification', 'Number', 'No'],
  details: ["Enter the recipient's federal identification number. You can choose between an EIN or a SSN. The SSN is 9 digits, written ### - ## - ####. The IRS-assigned EIN is nine digits, written ## - #######."]
}, {
  box: 'd',
  title: "Recipient's name, street address, city or town, state or province, country, zip or foreign postal code, and telephone number",
  keywords: ['Recipient', 'Recipient\'s', 'Name', 'Payee', 'Street', 'Address', 'Including', 'Apt', 'No', 'Number', 'City', 'Town', 'State', 'Province', 'Country', 'Zip', 'Foreign', 'Postal', 'Code'],
  details: ["Enter the recipient's name and address as it appears on the recipient's Form W-9."]
}, {
  box: 'e',
  title: 'Account number (see instructions)',
  keywords: ['Account', 'Number', 'See', 'Instruction', 'Instructions'],
  details: ["If you have more than one account for a recipient and are filing multiple 1099-MISC's for a recipient, include an account number. If you ticked the FATCA filing requirement checkbox, include an account number also."]
}, {
  box: 'f',
  title: '2nd TIN not.',
  keywords: ['2nd', 'Tin', 'Not'],
  details: ['Check this box if the IRS has notified you twice in the last 3 calendar years that your recipient has given you an incorrect TIN. The IRS will not send further notices regarding this recipient if you checked this box.']
}, {
  box: '1',
  title: 'Rents',
  keywords: ['1', 'box 1', 'Rents', 'rent'],
  details: ["Enter amounts of $600+ for all rents such as office space rental, machine rental, and pasture rentals. In regards to machine rentals (for example, renting a bulldozer to level your parking lot), if the machine rental is part of a contract that includes both the use of the machine and the operator, prorate the rental between the rent of the machine (report that in box 1) and the operator's charge (report that on Form 1099-NEC in box 1)."]
}, {
  box: '2',
  title: 'Royalties',
  keywords: ['2', 'box 2', 'Royalties', 'Royalty', '1099-NEC', '1099-S'],
  details: ['Enter payments for gross royalty of $10+ from oil, gas, or other mineral properties. Also report intangible property such as patents, copyrights, trade names, and trademarks. Do not include surface/land royalties as they should be reported in box 1. Do not report oil or gas payments for a working interest in box 2; report payments for working interest in box 1 of the 1099-NEC. Do not report timber royalties made under a pay-as-cut contract; report these timber royalties on Form 1099-S, Proceeds From Real Estate Transactions.']
}, {
  box: '3',
  title: 'Other Income',
  keywords: ['3', 'box 3', 'Other', 'Income', '1099-NEC'],
  details: ['Enter amounts of $600+ for other income that you cannot report on any other boxes on this form. This includes prizes and awards that are not for services performed, like winning merchandise on a game show or a sweepstakes not involving a wager. If a wager is made to earn income, report the winnings on Form W-2G. Do not include in box 3 prizes and awards for services performed by nonemployees, such as an award for the top commission salesperson. Report them in box 1 of the 1099-NEC.']
}, {
  box: '4',
  title: 'Federal Income Tax Withheld',
  keywords: ['4', 'box 4', 'Federal', 'Income', 'Tax', 'Withheld'],
  details: ['Enter your backup withholding. For example, persons who have not furnished their TINs to you are subject to withholding on payments required to be reported in boxes 1, 2 (net of severance taxes), 3, 5 (to the extent paid in cash), 6, 8, 9, and 10.']
}, {
  box: '5',
  title: 'Fishing Boat Proceeds',
  keywords: ['5', 'box 5', 'Fishing', 'Boat', 'Proceeds'],
  details: ['Enter your share of all proceeds from selling catch, the fair market value of a distribution to each crew member of fishing boats with less than 10 crew members, and cash payments up to $100 for each trip that are contingent on a minimum catch and paid for performing additional roles. Do not report any wages reportable on your W-2.']
}, {
  box: '6',
  title: 'Medical and Health Care Payments',
  keywords: ['6', 'box 6', 'Medical', 'Health', 'Payments', 'Payment'],
  details: ['Enter payments of $600+ to physicians or suppliers of medical/healthcare services during your trade/business. These payments include those made by medical and healthcare insurers under health, accident, and sickness insurance programs.']
}, {
  box: '7',
  title: 'Payer Made Direct Sales of $5,000 or More',
  keywords: ['7', 'box 7', '5000', 'Consumer', 'Buy', 'Sell', 'Commission'],
  details: ['Check this box if you made direct sales of $5000+ of consumer products to a recipient on a buy-sell, deposit-commission, or other commission basis anywhere other than a permanent retail establishment.']
}, {
  box: '8',
  title: 'Substitute Payments in Lieu of Dividends or Interest',
  keywords: ['8', 'box 8', 'Substitute', 'Payment', 'Payments', 'Lieu', 'Dividends', 'Interest'],
  details: ["Enter payments of $10+ from a broker to a customer in place of dividends or tax-exempt interest, resulting from a customer's security loan."]
}, {
  box: '9',
  title: 'Crop Insurance Proceeds',
  keywords: ['9', 'box 9', '600', 'Farmer'],
  details: ['Enter payments of $600+ to a farmer if you are an insurance company.']
}, {
  box: '10',
  title: 'Gross Proceeds Paid to an Attorney',
  keywords: ['10', 'box 10', 'Gross', 'Proceed', 'Proceeds', 'Paid', 'Attorney', '600'],
  details: ['Enter payments of $600+ to an attorney for legal services.']
}, {
  box: '11',
  title: 'Fish Purchased for Resale',
  keywords: ['11', 'box 11', '600', 'Fish', 'Resale'],
  details: ['Enter payments of $600+ paid during the year to any person who is engaged in the trade or business of catching fish.']
}, {
  box: '12',
  title: 'Section 409A deferrals',
  keywords: ['12', 'box 12', '2008-115', 'Defer', 'Nonemployee', '600', 'Deferrals'],
  details: ['You do not have to complete this box. For more information see Notice 2008-115, available at IRS.gov/irb/2008-52_IRB#NOT-2008-115.', 'If you complete this box, enter deferred payments of $600+ to a nonemployee under nonqualified plans.']
}, {
  box: '13',
  title: 'FATCA filing requirement checkbox',
  keywords: ['FATCA', 'Filing', 'Requirement', '13', 'box 13'],
  details: ['According to Regulations section 1.1471-4(d)(2)(iii)(A), check this box if you are a US payer reporting a 1099-MISC to satisfy your requirement to report due to a US account for chapter 4 purposes.', 'According to Regulations section 1.1471-4(d)(5)(i)(A), check this box if you are a foreign financial institution (FFI) reporting payments to a US account for a described election, or making the election described and reporting a US account for chapter 4 purposes that you did not pay during any reportable year or any applicable 1099-MISC.']
}, {
  box: '14',
  title: 'Excess Golden Parachute Payments',
  keywords: ['14', 'box 14', 'Excess', 'Golden', 'Parachute', 'Payment', 'Payments'],
  details: ["Enter payments to employees that receive benefits of three time's their base upon a change in ownership or control of the company."]
}, {
  box: '15',
  title: 'Nonqualified Deferred Compensation',
  keywords: ['15', 'box 15', '409A', 'Section', 'Income'],
  details: ['Enter deferred payments for nonemployees under nonqualified plans that do not satisfy the requirements of section 409A that can be included as income. Do not include income that was previously reported on a W-2 or 1099-MISC for a prior year.']
}, {
  box: '16',
  title: 'State Tax Withheld',
  keywords: ['16', 'box 16', 'State', 'Tax', 'Withheld'],
  details: ['If you participate in the Combined Federal/State Filing Program and/or are required to file paper copies of the 1099-MISC with a state tax department, enter withheld state income tax for up to two states.']
}, {
  box: '17',
  title: "State/Payer's State no.",
  keywords: ['17', 'box 17', 'State', 'Payer', 'Payer\'s', 'State', 'No', 'Number'],
  details: ['If you participate in the Combined Federal/State Filing Program and/or are required to file paper copies of the 1099-MISC with a state tax department, enter the abbreviated name of the state and your state identification number assigned by the state.']
}, {
  box: '18',
  title: 'State Income',
  keywords: ['18', 'box 18', 'State', 'Income'],
  details: ['If you participate in the Combined Federal/State Filing Program and/or are required to file paper copies of the 1099-MISC with a state tax department, enter the state payment.']
}];

exports.default = Form1099MiscHelpData;

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var Form1099NecHelpData = [{
  box: 'a',
  title: "Payer's name, street address, city or town, state or province, country, zip or foreign postal code, and telephone number",
  keywords: ['Payer', 'Payer\'s', 'Name', 'Street Address', 'City', 'Town', 'State', 'Province', 'Country', 'Zip', 'Foreign', 'Postal', 'Code', 'Telephone', 'Phone'],
  details: ['As the payer, enter your business address details.']
}, {
  box: 'b',
  title: "Payer's TIN, also known as federal identification number",
  keywords: ['Payer', 'Payer\'s', 'Federal', 'Identification', 'Number'],
  details: ['Enter your federal identification number. You can choose between an EIN or a SSN. If you are the sole proprietor, usually you will enter the SSN which is 9 digits, written ### - ## - ####. Your IRS-assigned EIN is nine digits, written ## - #######.']
}, {
  box: 'c',
  title: "Recipient's TIN, also known as identification number",
  keywords: ['Recipient', 'Recipient\'s', 'Identification', 'Number'],
  details: ["Enter the recipient's federal identification number. You can choose between an EIN or a SSN. The SSN is 9 digits, written ### - ## - ####. The IRS-assigned EIN is nine digits, written ## - #######."]
}, {
  box: 'd',
  title: "Recipient's name, street address, city or town, state or province, country, zip or foreign postal code, and telephone number",
  keywords: ['Recipient', 'Recipient\'s', 'Name', 'Payee', 'Street', 'Address', 'Number', 'City', 'Town', 'State', 'Province', 'Country', 'Zip', 'Foreign', 'Postal', 'Code'],
  details: ["Enter the recipient's name and address as it appears on the recipient's Form W-9."]
}, {
  box: 'e',
  title: 'Account number (see instructions)',
  keywords: ['Account', 'Number', 'See', 'Instruction', 'Instructions'],
  details: ['If you have more than one account for a recipient and are filing multiple 1099-NECs for a recipient, include an account number.']
}, {
  box: 'f',
  title: '2nd TIN not.',
  keywords: ['2nd', 'Tin', 'Not'],
  details: ['Check this box if the IRS has notified you twice in the last 3 calendar years that your recipient has given you an incorrect TIN. The IRS will not send further notices regarding this recipient if you checked this box.']
}, {
  box: '1',
  title: 'Nonemployee Compensation',
  keywords: ['1', 'box 1', '600', 'Nonemployee', 'Nonemployees'],
  details: ['Enter amounts of $600+ made to nonemployees. However, do not use the 1099-NEC to report gross proceeds to an attorney; use the 1099-MISC instead. Additionally, do not use the 1099-NEC to report payments of rent to real estate agents or property managers; use the 1099-MISC instead. Lastly, do not use the 1099-NEC to report cash payments for the purchase of fish for resale purposes; use the 1099-MISC instead.']
}, {
  box: '2',
  title: 'Payer Made Direct Sales of $5,000 or More',
  keywords: ['2', 'box 2', 'Payer', 'Made', 'Direct', 'Sales', 'Sale', '5000', 'Consumer', 'Products ', 'More', 'Recipient', 'Buyer', 'Buy', 'Sell', 'Buy-Sell', 'Deposit', 'Commission', 'Deposit-Commission'],
  details: ['Check this box if you made direct sales of $5000+ of consumer products to a recipient on a buy-sell, deposit-commission, or other commission basis anywhere other than a permanent retail establishment.']
}, {
  box: '4',
  title: 'Federal Income Tax Withheld',
  keywords: ['4', 'box 4', 'Federal', 'Income', 'Tax', 'Withheld'],
  details: ['Enter any federal income tax withheld.']
}, {
  box: '5',
  title: 'State Tax Withheld',
  keywords: ['5', 'box 5', 'State', 'Tax', 'Withheld'],
  details: ['Enter withheld state income tax for up to two states.']
}, {
  box: '6',
  title: "State/Payer's State no.",
  keywords: ['6', 'box 6', 'State', 'Payer', 'Payer\'s', 'State', 'No', 'Number'],
  details: ['Enter the abbreviated name of the state and your state identification number assigned by the state.']
}, {
  box: '7',
  title: 'State Income',
  keywords: ['7', 'box 7', 'State', 'Income'],
  details: ['Enter the amount of earned income in the state.']
}];

exports.default = Form1099NecHelpData;

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var W2HelpData = [{
  box: 'a',
  title: "Employee's Social Security Number (SSN)",
  keywords: ['Employee', 'Employee\'s', 'Social', 'Security', 'Number', 'SSN'],
  details: ["Your Employee's SSN is 9 digits, written ### - ## - ####. If your employee has applied but not received a SSN yet, enter zeros (000-00-0000). When the employee receives their social security card, file Form W-2c to correct your previous report."]
}, {
  box: 'b',
  title: 'Employer Identification Number (EIN)',
  keywords: ['Employer', 'Identification', 'Number', 'EIN'],
  details: ['Your IRS-assigned EIN is nine digits (## - #######). You used this on your federal employment tax returns. If you do not have an EIN when filing Form W-2, enter "Applied For" in box b to indicate an EIN was applied for; do not use your SSN. You can get an EIN online at www.IRS.gov/EIN']
}, {
  box: 'c',
  title: "Employer's name, address, and ZIP code",
  keywords: ['Employer\'s', 'Employer', 'Name', 'Address', 'Zip', 'Code', 'Phone', 'City', 'State'],
  details: ["This is the employer's legal address, which may not be the same as an employee's work address."]
}, {
  box: 'd',
  title: 'Control Number (optional)',
  keywords: ['Control', 'Number'],
  details: ['Some payroll departments use an internal control number to identify individual W-2 forms. You do not have to fill this box if you do not use control numbers.']
}, {
  box: 'e',
  title: "Employee's name, address, and ZIP code",
  keywords: ['Employee', 'Employee\'s', 'Name', 'Address', 'Zip', 'Code', 'Phone', 'City', 'State'],
  details: ["This is the employee's legal name and the address on file for tax purposes. The employee's name should match the name on file for their SSN (first name, middle initial, last name). If the full name does not fit in the space allowed on the form, you may show the first and middle name initials and the full last name.", "The employee's address can be a P.O. box number if needed. For a foreign address, give the information in the following order: city, province, or state, and country. Follow the country's practice for entering the postal code. Do not abbreviate the country name."]
}, {
  box: '1',
  title: 'Wages, tips, other compensation',
  keywords: ['1', 'box 1', 'Wages', 'Tips', 'Other', 'compensation'],
  details: ['Include everything the employee was paid - wages, tips, bonuses, commission - during the current tax year. Do not include contributions to retirement plans. This number can be less than the sum of boxes 2 and 3.']
}, {
  box: '2',
  title: 'Federal income tax withheld',
  keywords: ['2', 'box 2', 'Federal', 'Income', 'withheld', 'Tax'],
  details: ['The federal income tax withheld during the tax year is based on exemptions the employee chose for the W-4 form and other withholdings.']
}, {
  box: '3',
  title: 'Social security wages',
  keywords: ['3', 'box 3', 'wages', 'Security', 'Social'],
  details: ['These are the employee’s wages that are subject to the Social Security tax, excluding tips. The maximum for social security wages for 2022 is $147,000. The total of boxes 3 and 7 cannot exceed this maximum.']
}, {
  box: '4',
  title: 'Social security tax withheld',
  keywords: ['4', 'box 4', 'Social', 'Security', 'Tax', 'withheld'],
  details: ['Show the total employee social security tax (not your share) withheld. This tax is calculated on a 6.2% flat rate, including social security tips. To calculate box 4, add the values of box 3 and 7 together, and then multiply the sum by 6.2% (i.e. x0.062). For 2022, this amount cannot exceed $9,114.00 ($147,000 x 6.2%).']
}, {
  box: '5',
  title: 'Medicare wages and tips',
  keywords: ['5', 'box 5', 'Medicare', 'Wages', 'tips'],
  details: ['Enter the total Medicare wages and tips in box 5. The wages and tips subject to Medicare tax are the same as those subject to social security tax (boxes 3 and 7) except the $147,000 limit does not apply for Medicare tax. If the amount of wages paid was $147,000 or less, the amounts entered in boxes 3 and 5 will be the same. If the amount of wages paid was more than $147,000, you would enter $147,000 for box 3, and enter the full amount in box 5.']
}, {
  box: '6',
  title: 'Medicare tax withheld',
  keywords: ['6', 'box 6', 'Medicare', 'Tax', 'Withheld'],
  details: ['This tax is calculated on a 1.45% flat rate. To calculate box 6, multiply box 5 by 1.45% (i.e x0.0145) and add any additional Medicare taxes. There is an additional withholding percentage above a certain income level. The IRS explains it here: www.IRS.gov/ADMT']
}, {
  box: '7',
  title: 'Social security tips',
  keywords: ['7', 'box 7', 'Social', 'Security', 'tips'],
  details: ['This is the tips that the employee reported to the employer. Employees must report this if they earn over $20 in tips per month. In 2022 the maximum for social security wages and tips is $147,000. The total of boxes 3 and 7 cannot exceed this maximum.']
}, {
  box: '8',
  title: 'Allocated tips',
  keywords: ['8', 'box 8', 'Allocated', 'tips'],
  details: ['If you operate a large food or beverage establishment, show the tips allocated to the employee. Do not include this amount in boxes 1, 3, 5, or 7.']
}, {
  box: '10',
  title: 'Dependent care benefits',
  keywords: ['10', 'box 10', 'Dependent', 'Care', 'benefits'],
  details: ['Some employers pay for benefits such as child care for their employees. If this amount is less than $5,000, it is considered a non-taxable benefit. Report all amounts paid or incurred (regardless of any employee forfeitures), including those in excess of $5000. Include any amounts over $5,000 in boxes 1, 3, 5.']
}, {
  box: '11',
  title: 'Nonqualified Plans',
  keywords: ['11', 'box 11', 'Nonqualified', 'plans'],
  details: ['The purpose of box 11 is for the SSA (Social Security Administration) to determine if any part of the amount reported in box 1 or boxes 3 and/or 5 was earned in a prior year. Nonqualified plans include other tax-deferred, employer-sponsored plans like deferred compensation, executive bonus, group carve-out plans or split-dollar life insurance.']
}, {
  box: '12',
  title: 'Codes',
  keywords: ['12', 'box 12', 'See', 'Instructions'],
  details: ['The IRS instructions designate codes A through HH for use in box 12. For example, enter code D for elective deferrals for 401(K) and DD for employer-sponsored health coverage. Include a maximum of 4 items, and use a separate W-2 if there are more. See the full list of codes on page 30 of the IRS Instructions (https://www.irs.gov/pub/irs-pdf/iw2w3.pdf).']
}, {
  box: '13',
  title: 'Statutory employee, retirement plan, third-party sick pay',
  keywords: ['13', 'box 13', 'Statutory', 'Employee', 'Retirement', 'Plan', 'third', 'Third-party', 'Party', 'Sick', 'pay'],
  details: ['Check all boxes that apply to the employee. Statutory employees pay social security and medicare taxes, but no federal income tax.']
}, {
  box: '14',
  title: 'Other',
  keywords: ['14', 'box 14', 'other'],
  details: ["This covers additional taxes or deductions that are not reported elsewhere, like state disability insurance taxes withheld, union dues, health insurance premiums deducted and nontaxable income.  If you included 100% of a vehicle's annual lease value in the employee's income, it also must be reported here or on a separate statement to your employees."]
}, {
  box: '15',
  title: "Employer's state id number",
  keywords: ['15', 'box 15', 'Employer\'s', 'Employer', 'State', 'Id', 'number'],
  details: ['Enter the two-letter abbreviation for the name of the state or territory being reported. Also, enter your state or territory  assigned ID number. If the employee has tax withheld in multiple states, more than one box will be filled. However, if a W-3 will be submitted with this form that contains wage and income tax information from more than one state or territory, enter an "X" under "state" and do not enter any state or territory ID number.']
}, {
  box: '16',
  title: 'State wages, tips, etc',
  keywords: ['16', 'box 16', 'State', 'Wages', 'Tips', 'etc'],
  details: ['Include everything the employee was paid - wages, tips, bonuses, commission - during the current tax year subject to state taxes. This may be the same number in box 1.']
}, {
  box: '17',
  title: 'State income tax',
  keywords: ['17', 'box 17', 'State', 'Income', 'tax'],
  details: ['This shows the amount of state income taxes withheld with respect to box 16. This number can be checked if the state has a flat tax rate by multiplying the tax rate by box 16.']
}, {
  box: '18',
  title: 'Local wages, tips, etc',
  keywords: ['18', 'box 18', 'Local', 'Wages', 'Wage', 'Tips', 'Tip', 'etc'],
  details: ["This is the employee's locally taxable gross pay. This may be the same as box 1 or 16."]
}, {
  box: '19',
  title: 'Local income tax',
  keywords: ['19', 'box 19', 'Local', 'Income', 'tax'],
  details: ["If the employee has wages that are withheld in more than two states or localities, the employer will give multiple W-2's."]
}, {
  box: '20',
  title: 'Locality name',
  keywords: ['20', 'box 20', 'Locality', 'name'],
  details: ['This is the name of the local, city or other state tax being reported in box 19.']
}];

exports.default = W2HelpData;

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _Banner = __webpack_require__(103);

var _Banner2 = _interopRequireDefault(_Banner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BuilderReactivationBanner = function BuilderReactivationBanner(_ref) {
  var builderType = _ref.builderType,
      isCancelled = _ref.isCancelled;

  var trackAndRedirect = function trackAndRedirect() {
    if (isCancelled) {
      window._track('Reactivate Banner', builderType + ' Builder');
      window.location.assign('/my-account?skip_start_reactivation=1');
    } else {
      window._track('Upgrade Banner', builderType + ' Builder');
      window.location.assign('/upgrade-freemium');
    }
  };

  return _react2.default.createElement(
    _Banner2.default,
    { isCloseable: false },
    _react2.default.createElement(
      'div',
      { className: 'builder-reactivation-banner' },
      _react2.default.createElement(
        'p',
        { className: 'free-downloads-text' },
        'Looks like you are out of free downloads, but not to worry!'
      ),
      _react2.default.createElement(
        'p',
        { className: 'discount-text' },
        'To download this document,',
        ' ',
        _react2.default.createElement(
          'a',
          { className: 'upgrade', onClick: trackAndRedirect },
          isCancelled ? 'REACTIVATE' : 'UPGRADE'
        ),
        ' ',
        isCancelled ? 'your' : 'to a',
        ' ',
        'paid plan today!'
      )
    )
  );
};

BuilderReactivationBanner.defaultProps = {
  isCancelled: false
};

BuilderReactivationBanner.propTypes = {
  builderType: _propTypes2.default.string.isRequired,
  isCancelled: _propTypes2.default.bool
};

exports.default = (0, _WithInit2.default)(BuilderReactivationBanner);

/***/ }),

/***/ 2403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANIMATION_STATE_CLASSES = {
  animating: 'rah-animating',
  animatingUp: 'rah-animating--up',
  animatingDown: 'rah-animating--down',
  animatingToHeightZero: 'rah-animating--to-height-zero',
  animatingToHeightAuto: 'rah-animating--to-height-auto',
  animatingToHeightSpecific: 'rah-animating--to-height-specific',
  static: 'rah-static',
  staticHeightZero: 'rah-static--height-zero',
  staticHeightAuto: 'rah-static--height-auto',
  staticHeightSpecific: 'rah-static--height-specific'
};

var PROPS_TO_OMIT = ['animateOpacity', 'animationStateClasses', 'applyInlineTransitions', 'children', 'contentClassName', 'delay', 'duration', 'easing', 'height', 'onAnimationEnd', 'onAnimationStart'];

function omit(obj) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  if (!keys.length) {
    return obj;
  }

  var res = {};
  var objectKeys = Object.keys(obj);

  for (var i = 0; i < objectKeys.length; i++) {
    var key = objectKeys[i];

    if (keys.indexOf(key) === -1) {
      res[key] = obj[key];
    }
  }

  return res;
}

// Start animation helper using nested requestAnimationFrames
function startAnimationHelper(callback) {
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      callback();
    });
  });
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function isPercentage(height) {
  // Percentage height
  return typeof height === 'string' && height.search('%') === height.length - 1 && isNumber(height.substr(0, height.length - 1));
}

function runCallback(callback) {
  if (callback && typeof callback === 'function') {
    callback();
  }
}

var AnimateHeight = function (_React$Component) {
  _inherits(AnimateHeight, _React$Component);

  function AnimateHeight(props) {
    _classCallCheck(this, AnimateHeight);

    var _this = _possibleConstructorReturn(this, (AnimateHeight.__proto__ || Object.getPrototypeOf(AnimateHeight)).call(this, props));

    var height = 'auto';
    var overflow = 'visible';

    if (isNumber(props.height)) {
      height = props.height < 0 ? 0 : props.height;
      overflow = 'hidden';
    } else if (isPercentage(props.height)) {
      height = props.height;
      overflow = 'hidden';
    }

    _this.animationStateClasses = _extends({}, ANIMATION_STATE_CLASSES, props.animationStateClasses);

    var animationStateClasses = _this.getStaticStateClasses(height);

    _this.state = {
      animationStateClasses: animationStateClasses,
      height: height,
      overflow: overflow,
      shouldUseTransitions: false
    };
    return _this;
  }

  _createClass(AnimateHeight, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var height = this.state.height;

      // Hide content if height is 0 (to prevent tabbing into it)
      // Check for contentElement is added cause this would fail in tests (react-test-renderer)
      // Read more here: https://github.com/Stanko/react-animate-height/issues/17

      if (this.contentElement && this.contentElement.style) {
        this.hideContent(height);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props = this.props,
          delay = _props.delay,
          duration = _props.duration,
          height = _props.height,
          onAnimationEnd = _props.onAnimationEnd,
          onAnimationStart = _props.onAnimationStart;

      // Check if 'height' prop has changed

      if (this.contentElement && height !== prevProps.height) {
        var _cx;

        // Remove display: none from the content div
        // if it was hidden to prevent tabbing into it
        this.showContent(prevState.height);

        // Cache content height
        this.contentElement.style.overflow = 'hidden';
        var contentHeight = this.contentElement.offsetHeight;
        this.contentElement.style.overflow = '';

        // set total animation time
        var totalDuration = duration + delay;

        var newHeight = null;
        var timeoutState = {
          height: null, // it will be always set to either 'auto' or specific number
          overflow: 'hidden'
        };
        var isCurrentHeightAuto = prevState.height === 'auto';

        if (isNumber(height)) {
          // If new height is a number
          newHeight = height < 0 ? 0 : height;
          timeoutState.height = newHeight;
        } else if (isPercentage(height)) {
          newHeight = height;
          timeoutState.height = newHeight;
        } else {
          // If not, animate to content height
          // and then reset to auto
          newHeight = contentHeight; // TODO solve contentHeight = 0
          timeoutState.height = 'auto';
          timeoutState.overflow = null;
        }

        if (isCurrentHeightAuto) {
          // This is the height to be animated to
          timeoutState.height = newHeight;

          // If previous height was 'auto'
          // set starting height explicitly to be able to use transition
          newHeight = contentHeight;
        }

        // Animation classes
        var animationStateClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, this.animationStateClasses.animating, true), _defineProperty(_cx, this.animationStateClasses.animatingUp, prevProps.height === 'auto' || height < prevProps.height), _defineProperty(_cx, this.animationStateClasses.animatingDown, height === 'auto' || height > prevProps.height), _defineProperty(_cx, this.animationStateClasses.animatingToHeightZero, timeoutState.height === 0), _defineProperty(_cx, this.animationStateClasses.animatingToHeightAuto, timeoutState.height === 'auto'), _defineProperty(_cx, this.animationStateClasses.animatingToHeightSpecific, timeoutState.height > 0), _cx));

        // Animation classes to be put after animation is complete
        var timeoutAnimationStateClasses = this.getStaticStateClasses(timeoutState.height);

        // Set starting height and animating classes
        // We are safe to call set state as it will not trigger infinite loop
        // because of the "height !== prevProps.height" check
        this.setState({ // eslint-disable-line react/no-did-update-set-state
          animationStateClasses: animationStateClasses,
          height: newHeight,
          overflow: 'hidden',
          // When animating from 'auto' we first need to set fixed height
          // that change should be animated
          shouldUseTransitions: !isCurrentHeightAuto
        });

        // Clear timeouts
        clearTimeout(this.timeoutID);
        clearTimeout(this.animationClassesTimeoutID);

        if (isCurrentHeightAuto) {
          // When animating from 'auto' we use a short timeout to start animation
          // after setting fixed height above
          timeoutState.shouldUseTransitions = true;

          startAnimationHelper(function () {
            _this2.setState(timeoutState);

            // ANIMATION STARTS, run a callback if it exists
            runCallback(onAnimationStart);
          });

          // Set static classes and remove transitions when animation ends
          this.animationClassesTimeoutID = setTimeout(function () {
            _this2.setState({
              animationStateClasses: timeoutAnimationStateClasses,
              shouldUseTransitions: false
            });

            // ANIMATION ENDS
            // Hide content if height is 0 (to prevent tabbing into it)
            _this2.hideContent(timeoutState.height);
            // Run a callback if it exists
            runCallback(onAnimationEnd);
          }, totalDuration);
        } else {
          // ANIMATION STARTS, run a callback if it exists
          runCallback(onAnimationStart);

          // Set end height, classes and remove transitions when animation is complete
          this.timeoutID = setTimeout(function () {
            timeoutState.animationStateClasses = timeoutAnimationStateClasses;
            timeoutState.shouldUseTransitions = false;

            _this2.setState(timeoutState);

            // ANIMATION ENDS
            // If height is auto, don't hide the content
            // (case when element is empty, therefore height is 0)
            if (height !== 'auto') {
              // Hide content if height is 0 (to prevent tabbing into it)
              _this2.hideContent(newHeight); // TODO solve newHeight = 0
            }
            // Run a callback if it exists
            runCallback(onAnimationEnd);
          }, totalDuration);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutID);
      clearTimeout(this.animationClassesTimeoutID);
      this.timeoutID = null;
      this.animationClassesTimeoutID = null;
      this.animationStateClasses = null;
    }
  }, {
    key: 'showContent',
    value: function showContent(height) {
      if (height === 0) {
        this.contentElement.style.display = '';
      }
    }
  }, {
    key: 'hideContent',
    value: function hideContent(newHeight) {
      if (newHeight === 0) {
        this.contentElement.style.display = 'none';
      }
    }
  }, {
    key: 'getStaticStateClasses',
    value: function getStaticStateClasses(height) {
      var _cx2;

      return (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, this.animationStateClasses.static, true), _defineProperty(_cx2, this.animationStateClasses.staticHeightZero, height === 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightSpecific, height > 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightAuto, height === 'auto'), _cx2));
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx3,
          _this3 = this;

      var _props2 = this.props,
          animateOpacity = _props2.animateOpacity,
          applyInlineTransitions = _props2.applyInlineTransitions,
          children = _props2.children,
          className = _props2.className,
          contentClassName = _props2.contentClassName,
          duration = _props2.duration,
          easing = _props2.easing,
          delay = _props2.delay,
          style = _props2.style;
      var _state = this.state,
          height = _state.height,
          overflow = _state.overflow,
          animationStateClasses = _state.animationStateClasses,
          shouldUseTransitions = _state.shouldUseTransitions;


      var componentStyle = _extends({}, style, {
        height: height,
        overflow: overflow || style.overflow
      });

      if (shouldUseTransitions && applyInlineTransitions) {
        componentStyle.transition = 'height ' + duration + 'ms ' + easing + ' ' + delay + 'ms';

        // Include transition passed through styles
        if (style.transition) {
          componentStyle.transition = style.transition + ', ' + componentStyle.transition;
        }

        // Add webkit vendor prefix still used by opera, blackberry...
        componentStyle.WebkitTransition = componentStyle.transition;
      }

      var contentStyle = {};

      if (animateOpacity) {
        contentStyle.transition = 'opacity ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
        // Add webkit vendor prefix still used by opera, blackberry...
        contentStyle.WebkitTransition = contentStyle.transition;

        if (height === 0) {
          contentStyle.opacity = 0;
        }
      }

      var componentClasses = (0, _classnames2.default)((_cx3 = {}, _defineProperty(_cx3, animationStateClasses, true), _defineProperty(_cx3, className, className), _cx3));

      return _react2.default.createElement(
        'div',
        _extends({}, omit.apply(undefined, [this.props].concat(PROPS_TO_OMIT)), {
          'aria-hidden': height === 0,
          className: componentClasses,
          style: componentStyle
        }),
        _react2.default.createElement(
          'div',
          {
            className: contentClassName,
            style: contentStyle,
            ref: function ref(el) {
              return _this3.contentElement = el;
            }
          },
          children
        )
      );
    }
  }]);

  return AnimateHeight;
}(_react2.default.Component);

AnimateHeight.propTypes = {
  animateOpacity: _propTypes2.default.bool,
  animationStateClasses: _propTypes2.default.object,
  applyInlineTransitions: _propTypes2.default.bool,
  children: _propTypes2.default.any.isRequired,
  className: _propTypes2.default.string,
  contentClassName: _propTypes2.default.string,
  duration: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  easing: _propTypes2.default.string,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onAnimationEnd: _propTypes2.default.func,
  onAnimationStart: _propTypes2.default.func,
  style: _propTypes2.default.object
};

AnimateHeight.defaultProps = {
  animateOpacity: false,
  animationStateClasses: ANIMATION_STATE_CLASSES,
  applyInlineTransitions: true,
  duration: 250,
  delay: 0,
  easing: 'ease',
  style: {}
};

exports.default = AnimateHeight;

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _Banner = __webpack_require__(103);

var _Banner2 = _interopRequireDefault(_Banner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MembersAreaReactivationBanner = function MembersAreaReactivationBanner(_ref) {
  var page = _ref.page;

  var trackAndRedirect = function trackAndRedirect() {
    window._track('Reactivate Banner', page);
    window.location.assign('/my-account?subscription_settings_scroll=1');
  };

  return _react2.default.createElement(
    _Banner2.default,
    {
      isCloseable: false
    },
    _react2.default.createElement(
      'div',
      { className: 'members-area-reactivation-banner' },
      _react2.default.createElement(
        'button',
        { onClick: trackAndRedirect },
        'Reactivate'
      ),
      '\xA0your account today to export your documents!'
    )
  );
};

MembersAreaReactivationBanner.propTypes = {
  page: _propTypes2.default.string.isRequired
};

exports.default = (0, _WithInit2.default)(MembersAreaReactivationBanner);

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _TooltipTourConstants = __webpack_require__(50);

var _TooltipTourConstants2 = _interopRequireDefault(_TooltipTourConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisableOverlay = function DisableOverlay(_ref) {
  var activeTooltipIndex = _ref.activeTooltipIndex,
      isEmptyState = _ref.isEmptyState,
      isTourDisplayed = _ref.isTourDisplayed;

  var isAnswerQuestionTooltipDisplayed = isTourDisplayed && activeTooltipIndex === _TooltipTourConstants2.default.ANSWER_QUESTION_TOOLTIP_IDX;

  var disableOverlayClasses = (0, _classnames2.default)('recipient-builder-empty-state-background', {
    'disable-menu-and-progress-bar': isAnswerQuestionTooltipDisplayed
  });

  var isDisableOverlayDisplayed = isEmptyState || isAnswerQuestionTooltipDisplayed;

  if (isDisableOverlayDisplayed) {
    return _react2.default.createElement('div', { className: disableOverlayClasses });
  }

  return null;
};

DisableOverlay.defaultProps = {
  isEmptyState: false
};

DisableOverlay.propTypes = {
  activeTooltipIndex: _propTypes2.default.number.isRequired,
  isEmptyState: _propTypes2.default.bool,
  isTourDisplayed: _propTypes2.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var TooltipTourReducer = _ref2.TooltipTourReducer;
  return {
    activeTooltipIndex: TooltipTourReducer.activeTooltipIndex,
    isTourDisplayed: TooltipTourReducer.isTourDisplayed
  };
};

exports.default = ReactRedux.connect(mapStateToProps)(DisableOverlay);

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Tooltips = __webpack_require__(98);

var _Typography = __webpack_require__(48);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ElementWithAnswerFilledTooltip = function ElementWithAnswerFilledTooltip(_ref) {
  var targetElement = _ref.targetElement;

  var tooltipContentClasses = (0, _classnames2.default)('recipient-preview-tour-tooltip-content', 'recipient-preview-answer-filled-tooltip-text');
  return _react2.default.createElement(
    _Tooltips.ElementWithTooltip,
    {
      className: 'recipient-preview-tour-tooltip self-serve-recipient-preview-answer-filled-tooltip',
      displayEvent: 'none',
      placement: 'left',
      showByDefault: true,
      size: 'lg',
      targetClassName: 'self-serve-recipient-preview-answer-filled-tooltip-target',
      targetElement: targetElement,
      tooltipId: 'selfServeRecipientPreviewAnswerFilledTooltip'
    },
    _react2.default.createElement(
      _Typography.ProductContent,
      {
        className: tooltipContentClasses,
        variation: 'small'
      },
      'Your answer has automatically plugged into your document. Click below to exit.'
    )
  );
};

ElementWithAnswerFilledTooltip.propTypes = {
  targetElement: _propTypes2.default.node.isRequired
};

exports.default = ElementWithAnswerFilledTooltip;

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _TooltipTourConstants = __webpack_require__(50);

var _TooltipTourConstants2 = _interopRequireDefault(_TooltipTourConstants);

var _Tooltips = __webpack_require__(98);

var _AnswerQuestionTooltipContent = __webpack_require__(108);

var _AnswerQuestionTooltipContent2 = _interopRequireDefault(_AnswerQuestionTooltipContent);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ElementWithAnswerQuestionTooltip = function ElementWithAnswerQuestionTooltip(_ref) {
  var activeTooltipIndex = _ref.activeTooltipIndex,
      recipientBuilderField = _ref.children,
      isTourDisplayed = _ref.isTourDisplayed,
      targetElementType = _ref.targetElementType;

  var tooltipClasses = (0, _classnames2.default)('self-serve-recipient-preview-answer-question-tooltip', 'recipient-preview-tour-tooltip', 'recipient-preview-' + targetElementType + '-input');

  var isAnswerQuestionTooltipDisplayed = isTourDisplayed && activeTooltipIndex === _TooltipTourConstants2.default.ANSWER_QUESTION_TOOLTIP_IDX;

  if (isAnswerQuestionTooltipDisplayed) {
    return _react2.default.createElement(
      _Tooltips.ElementWithTooltip,
      {
        className: tooltipClasses,
        displayEvent: 'none',
        placement: 'right',
        size: 'lg',
        showByDefault: true,
        showCloseButton: true,
        targetClassName: 'answer-question-tooltip-target',
        targetElement: recipientBuilderField,
        tooltipId: 'selfServeRecipientPreviewAnswerQuestionTooltip'
      },
      _react2.default.createElement(_AnswerQuestionTooltipContent2.default, null)
    );
  }

  return recipientBuilderField;
};

ElementWithAnswerQuestionTooltip.propTypes = {
  activeTooltipIndex: _propTypes2.default.number.isRequired,
  children: _propTypes2.default.node.isRequired,
  isTourDisplayed: _propTypes2.default.bool.isRequired,
  targetElementType: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var TooltipTourReducer = _ref2.TooltipTourReducer;
  return {
    activeTooltipIndex: TooltipTourReducer.activeTooltipIndex,
    isTourDisplayed: TooltipTourReducer.isTourDisplayed
  };
};

exports.default = ReactRedux.connect(mapStateToProps)(ElementWithAnswerQuestionTooltip);

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _Icons = __webpack_require__(17);

var _Buttons = __webpack_require__(12);

var _TooltipTourConstants = __webpack_require__(50);

var _TooltipTourConstants2 = _interopRequireDefault(_TooltipTourConstants);

var _SelfServeBuilderSidePanelConstants = __webpack_require__(157);

var _SelfServePostBuilderSidePanelActions = __webpack_require__(242);

var _SelfServeBuilderSidePanelActions = __webpack_require__(217);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrganizeSectionsButton = function (_React$PureComponent) {
  _inherits(OrganizeSectionsButton, _React$PureComponent);

  function OrganizeSectionsButton(props) {
    _classCallCheck(this, OrganizeSectionsButton);

    var _this = _possibleConstructorReturn(this, (OrganizeSectionsButton.__proto__ || Object.getPrototypeOf(OrganizeSectionsButton)).call(this, props));

    _this.reorganizeSections = _this.reorganizeSections.bind(_this);
    return _this;
  }

  _createClass(OrganizeSectionsButton, [{
    key: 'reorganizeSections',
    value: function reorganizeSections() {
      window._track('Organize Sections | Preview Modal', 'Template Builder');
      this.props.closeRecipientPreview();
      this.props.displayOrganizer();
      this.props.openPanel(_SelfServeBuilderSidePanelConstants.SelfServeBuilderSidePanelTypes.POST_BUILDER);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          activeTooltipIndex = _props.activeTooltipIndex,
          isEmptyState = _props.isEmptyState,
          isTourDisplayed = _props.isTourDisplayed;


      var isAnswerQuestionTooltipDisplayed = isTourDisplayed && activeTooltipIndex === _TooltipTourConstants2.default.ANSWER_QUESTION_TOOLTIP_IDX;
      var isOrganizeButtonDisabled = isEmptyState || isAnswerQuestionTooltipDisplayed;

      return _react2.default.createElement(
        _Buttons.SecondaryButton,
        {
          className: 'recipient-builder-reorganize-button',
          disabled: isOrganizeButtonDisabled,
          onClick: this.reorganizeSections,
          icon: _react2.default.createElement(_Icons.OrganizeTemplateIcon, null)
        },
        'Organize Sections'
      );
    }
  }]);

  return OrganizeSectionsButton;
}(_react2.default.PureComponent);

OrganizeSectionsButton.defaultProps = {
  isEmptyState: false
};

OrganizeSectionsButton.propTypes = {
  activeTooltipIndex: _propTypes2.default.number.isRequired,
  closeRecipientPreview: _propTypes2.default.func.isRequired,
  displayOrganizer: _propTypes2.default.func.isRequired,
  isEmptyState: _propTypes2.default.bool,
  isTourDisplayed: _propTypes2.default.bool.isRequired,
  openPanel: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(_ref) {
  var TooltipTourReducer = _ref.TooltipTourReducer;
  return {
    activeTooltipIndex: TooltipTourReducer.activeTooltipIndex,
    isTourDisplayed: TooltipTourReducer.isTourDisplayed
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    displayOrganizer: _SelfServePostBuilderSidePanelActions.displayOrganizer,
    openPanel: _SelfServeBuilderSidePanelActions.openPanel
  }, dispatch);
};

exports.default = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(OrganizeSectionsButton);

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tooltips = __webpack_require__(98);

var _RecipientPreviewEmptyStateTooltip = __webpack_require__(109);

var _RecipientPreviewEmptyStateTooltip2 = _interopRequireDefault(_RecipientPreviewEmptyStateTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecipientPreviewEmptyStateTextField = function RecipientPreviewEmptyStateTextField(_ref) {
  var targetElement = _ref.targetElement;
  return _react2.default.createElement(
    _Tooltips.ElementWithTooltip,
    {
      className: 'self-serve-recipient-preview-empty-state-tooltip',
      placement: 'right',
      size: 'lg',
      showByDefault: true,
      targetElement: targetElement,
      tooltipId: 'selfServeRecipientPreviewEmptyStateTooltip'
    },
    _react2.default.createElement(_RecipientPreviewEmptyStateTooltip2.default, null)
  );
};

RecipientPreviewEmptyStateTextField.propTypes = {
  targetElement: _propTypes2.default.node.isRequired
};

exports.default = RecipientPreviewEmptyStateTextField;

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Alert = __webpack_require__(324);

var _Alert2 = _interopRequireDefault(_Alert);

var _Note = __webpack_require__(77);

var _Note2 = _interopRequireDefault(_Note);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlertNote = function AlertNote(props) {
  return _react2.default.createElement(
    _Alert2.default,
    {
      text: '',
      type: _Alert.AlertTypes.Warning
    },
    _react2.default.createElement(_Note2.default, _extends({}, props, { includeDefaultNoteStyle: false }))
  );
};

exports.default = AlertNote;

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _entry = __webpack_require__(312);

var _entry2 = _interopRequireDefault(_entry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarFieldDatePicker = function CalendarFieldDatePicker(props) {
  var datePickerClasses = (0, _classnames2.default)('datepicker', 'dropdown-menu', {
    active: props.showCalendar
  });
  return _react2.default.createElement(
    'div',
    {
      className: datePickerClasses,
      style: {
        top: '100%',
        display: props.showCalendar ? 'block' : 'none'
      }
    },
    _react2.default.createElement(_entry2.default, {
      maxDetail: props.maxDetail,
      calendarType: 'US',
      tileClassName: 'calendar-day',
      value: props.date,
      showFixedNumberOfWeeks: !props.isMobileOptimization,
      showNeighboringMonth: !props.isMobileOptimization,
      formatShortWeekday: props.getDayAbbreviation,
      formatMonth: function formatMonth(value) {
        return value.toString().substring(4, 7);
      },
      onClickDay: props.onClickDay,
      onClickMonth: props.onClickMonth,
      nextLabel: props.getNextLabel(),
      prevLabel: props.getPrevLabel()
    })
  );
};

CalendarFieldDatePicker.defaultProps = {
  isMobileOptimization: false
};

CalendarFieldDatePicker.propTypes = {
  date: _propTypes2.default.instanceOf(Date).isRequired,
  getDayAbbreviation: _propTypes2.default.func.isRequired,
  getNextLabel: _propTypes2.default.func.isRequired,
  getPrevLabel: _propTypes2.default.func.isRequired,
  isMobileOptimization: _propTypes2.default.bool,
  maxDetail: _propTypes2.default.oneOf(['month', 'year']).isRequired,
  onClickDay: _propTypes2.default.func.isRequired,
  onClickMonth: _propTypes2.default.func.isRequired,
  showCalendar: _propTypes2.default.bool.isRequired
};

exports.default = CalendarFieldDatePicker;

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarFieldInput = function CalendarFieldInput(props) {
  var inputWrapperClasses = (0, _classnames2.default)({
    'ds-text-input calendar-input': props.isMobileOptimization
  });

  return _react2.default.createElement(
    'div',
    { className: inputWrapperClasses },
    _react2.default.createElement('input', {
      className: 'input-large datepicker-' + props.datepickerType,
      type: 'text',
      id: props.id.toLowerCase(),
      name: props.id,
      onFocus: props.onFocus,
      onChange: props.onChange,
      value: props.value,
      placeholder: props.placeholder,
      'data-date-date': props.placeholder,
      'data-date-format': 'mm/dd/yyyy'
    })
  );
};

CalendarFieldInput.defaultProps = {
  isMobileOptimization: false,
  placeholder: '',
  value: ''
};

CalendarFieldInput.propTypes = {
  datepickerType: _propTypes2.default.oneOf(['calendar', 'month']).isRequired,
  id: _propTypes2.default.string.isRequired,
  isMobileOptimization: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired,
  onFocus: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.string
};

exports.default = CalendarFieldInput;

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StaticBuilderActions = __webpack_require__(24);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FinishLaterButton = function (_React$PureComponent) {
  _inherits(FinishLaterButton, _React$PureComponent);

  function FinishLaterButton(props) {
    _classCallCheck(this, FinishLaterButton);

    var _this = _possibleConstructorReturn(this, (FinishLaterButton.__proto__ || Object.getPrototypeOf(FinishLaterButton)).call(this, props));

    _this.finishLaterCtaOnClick = _this.finishLaterCtaOnClick.bind(_this);
    return _this;
  }

  _createClass(FinishLaterButton, [{
    key: 'finishLaterCtaOnClick',
    value: function finishLaterCtaOnClick() {
      window._track('Finish Later | Variation 1', window.CurrentDocumentInfo.type + ' | Static Builder');
      this.props.openCreateAccountModal();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        {
          className: 'static-builder-finish-later-cta-button',
          onClick: this.finishLaterCtaOnClick
        },
        'Finish Later'
      );
    }
  }]);

  return FinishLaterButton;
}(_react2.default.PureComponent);

FinishLaterButton.propTypes = {
  openCreateAccountModal: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    openCreateAccountModal: _StaticBuilderActions.openCreateAccountModal
  }, dispatch);
};

exports.default = ReactRedux.connect(null, mapDispatchToProps)(FinishLaterButton);

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StaticBuilderField = __webpack_require__(31);

var _StaticBuilderField2 = _interopRequireDefault(_StaticBuilderField);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CustomPropTypes = __webpack_require__(19);

var _CustomPropTypes2 = _interopRequireDefault(_CustomPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// in order to pass in data even if nothing is selected, create hidden input field
var MultiSelectCheckList = function (_React$Component) {
  _inherits(MultiSelectCheckList, _React$Component);

  function MultiSelectCheckList(props) {
    _classCallCheck(this, MultiSelectCheckList);

    var _this = _possibleConstructorReturn(this, (MultiSelectCheckList.__proto__ || Object.getPrototypeOf(MultiSelectCheckList)).call(this, props));

    _this.isChecked = _this.isChecked.bind(_this);
    _this.getOptionName = _this.getOptionName.bind(_this);
    return _this;
  }

  _createClass(MultiSelectCheckList, [{
    key: 'getOptionName',
    value: function getOptionName() {
      if (this.props.isSelfServe) {
        return this.props.id + '[]';
      }
      return this.props.id;
    }
  }, {
    key: 'isChecked',
    value: function isChecked(_ref) {
      var id = _ref.id,
          value = _ref.value;

      if (id) {
        return !!this.props.selectedValues[id];
      }
      return !!this.props.selectedValues[value];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        !this.props.isSelfServe && _react2.default.createElement('input', {
          key: '' + this.props.id,
          type: 'hidden',
          name: '' + this.props.id,
          value: '--'
        }),
        this.props.options.map(function (option) {
          return _react2.default.createElement(
            'label',
            {
              key: _this2.props.id + '_' + option.value,
              className: 'checkbox',
              htmlFor: _this2.props.id
            },
            _react2.default.createElement('input', {
              type: 'checkbox',
              name: _this2.getOptionName(),
              onChange: _this2.props.onChange,
              value: option.value,
              checked: _this2.isChecked(option)
            }),
            option.text
          );
        })
      );
    }
  }]);

  return MultiSelectCheckList;
}(_react2.default.Component);

MultiSelectCheckList.defaultProps = {
  isSelfServe: false
};

MultiSelectCheckList.propTypes = {
  id: _propTypes2.default.string.isRequired,
  selectedValues: _CustomPropTypes2.default.shapeWithBooleanValues.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    text: _propTypes2.default.string,
    value: _propTypes2.default.string
  })).isRequired,
  isSelfServe: _propTypes2.default.bool
};

exports.default = (0, _StaticBuilderField2.default)(MultiSelectCheckList);

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = __webpack_require__(18);

var _NavSideBarListItem = __webpack_require__(112);

var _NavSideBarListItem2 = _interopRequireDefault(_NavSideBarListItem);

var _NavSideBarListSectionHeader = __webpack_require__(113);

var _NavSideBarListSectionHeader2 = _interopRequireDefault(_NavSideBarListSectionHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavSideBarListSection = function (_React$PureComponent) {
  _inherits(NavSideBarListSection, _React$PureComponent);

  function NavSideBarListSection(props) {
    _classCallCheck(this, NavSideBarListSection);

    var _this = _possibleConstructorReturn(this, (NavSideBarListSection.__proto__ || Object.getPrototypeOf(NavSideBarListSection)).call(this, props));

    _this.getCategoryListItem = _this.getCategoryListItem.bind(_this);
    _this.getNavSideBarListSection = _this.getNavSideBarListSection.bind(_this);
    return _this;
  }

  _createClass(NavSideBarListSection, [{
    key: 'getCategoryListItem',
    value: function getCategoryListItem(section, screenIdx) {
      var sectionTitleCase = (0, _Utils.delimiterSeparatedToTitleCase)('_', section);
      var className = (0, _classnames2.default)(this.props.categoryListItemClassName, {
        active: this.props.onStep === screenIdx
      });

      return _react2.default.createElement(_NavSideBarListItem2.default, {
        className: className,
        documentType: this.props.documentType,
        key: 'section-' + screenIdx,
        loadStaticBuilderSection: this.props.loadStaticBuilderSection,
        offsiteBuilder: this.props.offsiteBuilder,
        screenIdx: screenIdx,
        section: sectionTitleCase,
        title: (screenIdx + 1).toString()
      });
    }
  }, {
    key: 'getNavSideBarListSection',
    value: function getNavSideBarListSection() {
      var navSideBarListSection = [];
      var numOfSections = this.props.sections.length;
      for (var i = 0; i < numOfSections; i += 1) {
        var section = this.props.sections[i];
        var screenIdx = this.props.offsetIdx + i;
        var navSideBarListItem = this.getCategoryListItem(section, screenIdx);
        navSideBarListSection.push(navSideBarListItem);
      }

      return navSideBarListSection;
    }
  }, {
    key: 'render',
    value: function render() {
      var navSideBarListSection = this.getNavSideBarListSection();
      var categoryTitleCase = (0, _Utils.delimiterSeparatedToTitleCase)('_', this.props.category).trim();
      var screenIdx = this.props.offsetIdx + this.props.sections.length;
      var requestSignatureNavSideBarListItem = this.getCategoryListItem('request_signature', screenIdx);

      var isSectionHeaderActive = this.props.offsetIdx <= this.props.onStep && this.props.onStep < this.props.offsetIdx + this.props.sections.length;

      return _react2.default.createElement(
        _react2.default.Fragment,
        {
          key: categoryTitleCase
        },
        _react2.default.createElement(
          _NavSideBarListSectionHeader2.default,
          {
            className: (0, _classnames2.default)({
              active: isSectionHeaderActive && !this.props.offsiteBuilder
            }),
            key: categoryTitleCase + '_heading'
          },
          this.props.category
        ),
        navSideBarListSection,
        this.props.showRequestSignature && requestSignatureNavSideBarListItem
      );
    }
  }]);

  return NavSideBarListSection;
}(_react2.default.PureComponent);

exports.default = NavSideBarListSection;


NavSideBarListSection.defaultProps = {
  categoryListItemClassName: '',
  offsetIdx: 0,
  offsiteBuilder: false,
  onStep: 0,
  sections: [],
  showRequestSignature: false
};

NavSideBarListSection.propTypes = {
  category: _propTypes2.default.string.isRequired,
  categoryListItemClassName: _propTypes2.default.string,
  documentType: _propTypes2.default.string.isRequired,
  loadStaticBuilderSection: _propTypes2.default.func.isRequired,
  offsetIdx: _propTypes2.default.number,
  offsiteBuilder: _propTypes2.default.bool,
  onStep: _propTypes2.default.number,
  sections: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showRequestSignature: _propTypes2.default.bool
};

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Utils = __webpack_require__(18);

var _NavSideBarListItem = __webpack_require__(112);

var _NavSideBarListItem2 = _interopRequireDefault(_NavSideBarListItem);

var _NavSideBarListSectionHeader = __webpack_require__(113);

var _NavSideBarListSectionHeader2 = _interopRequireDefault(_NavSideBarListSectionHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var spanButtonStyle = {
  display: 'inline-block',
  verticalAlign: 'middle',
  paddingLeft: '15px'
};

var DROPDOWN_ARROW_WIDTH = 10;

var NavSideBarListSectionWithDropDown = function (_React$PureComponent) {
  _inherits(NavSideBarListSectionWithDropDown, _React$PureComponent);

  function NavSideBarListSectionWithDropDown(props) {
    _classCallCheck(this, NavSideBarListSectionWithDropDown);

    var _this = _possibleConstructorReturn(this, (NavSideBarListSectionWithDropDown.__proto__ || Object.getPrototypeOf(NavSideBarListSectionWithDropDown)).call(this, props));

    _this.getCategoryListItem = _this.getCategoryListItem.bind(_this);
    _this.getNavSideBarListSection = _this.getNavSideBarListSection.bind(_this);

    _this.onClick = _this.onClick.bind(_this);
    _this.onStepInSection = _this.onStepInSection.bind(_this);
    _this.isOpen = _this.isOpen.bind(_this);

    _this.state = {
      openManually: false,
      open: _this.onStepInSection()
    };
    return _this;
  }

  _createClass(NavSideBarListSectionWithDropDown, [{
    key: 'onClick',
    value: function onClick() {
      this.setState({
        openManually: true,
        open: !this.isOpen()
      });
    }
  }, {
    key: 'onStepInSection',
    value: function onStepInSection() {
      return this.props.offsetIdx <= this.props.onStep && this.props.onStep < this.props.offsetIdx + this.props.sections.length;
    }
  }, {
    key: 'getCategoryListItem',
    value: function getCategoryListItem(section, screenIdx) {
      var sectionTitleCase = (0, _Utils.delimiterSeparatedToTitleCase)('_', section);
      var isOpen = this.isOpen();
      var className = (0, _classnames2.default)('nav-header-dropdown-list-item', {
        active: this.props.onStep === screenIdx,
        hidden: !isOpen
      });

      return _react2.default.createElement(_NavSideBarListItem2.default, {
        className: className,
        documentType: this.props.documentType,
        key: section,
        loadStaticBuilderSection: this.props.loadStaticBuilderSection,
        offsiteBuilder: this.props.offsiteBuilder,
        screenIdx: screenIdx,
        section: sectionTitleCase,
        title: (screenIdx + 1).toString()
      });
    }
  }, {
    key: 'getNavSideBarListSection',
    value: function getNavSideBarListSection() {
      var navSideBarListSection = [];
      var numOfSections = this.props.sections.length;
      for (var i = 0; i < numOfSections; i += 1) {
        var section = this.props.sections[i];
        var screenIdx = this.props.offsetIdx + i;
        var navSideBarListItem = this.getCategoryListItem(section, screenIdx);
        navSideBarListSection.push(navSideBarListItem);
      }

      return navSideBarListSection;
    }
  }, {
    key: 'isOpen',
    value: function isOpen() {
      var openAutomatically = !this.state.openManually && this.onStepInSection();

      return this.state.openManually && this.state.open || !this.state.openManually && openAutomatically;
    }
  }, {
    key: 'render',
    value: function render() {
      var navSideBarListSection = this.getNavSideBarListSection();
      var categoryTitleCase = (0, _Utils.delimiterSeparatedToTitleCase)('_', this.props.category).trim();
      var screenIdx = this.props.offsetIdx + this.props.sections.length;
      var lastSection = this.props.isLastSectionGetLink ? 'get_link' : 'request_signature';
      var requestSignatureNavSideBarListItem = this.getCategoryListItem(lastSection, screenIdx);

      var imageStyles = {
        width: DROPDOWN_ARROW_WIDTH,
        verticalAlign: 'middle',
        transform: 'rotate(0deg)'
      };

      if (this.isOpen()) {
        imageStyles.transform = 'rotate(90deg)';
      }

      return _react2.default.createElement(
        _react2.default.Fragment,
        {
          key: categoryTitleCase
        },
        _react2.default.createElement(
          _NavSideBarListSectionHeader2.default,
          {
            key: categoryTitleCase + '_heading',
            onClick: this.onClick
          },
          _react2.default.createElement('img', {
            className: 'nav-header-dropdown-button-img',
            alt: this.isOpen() ? 'Click to close' : 'Click to open',
            style: imageStyles,
            src: window.cdnUrl + '/images/arrows/arrow-large.png'
          }),
          _react2.default.createElement(
            'span',
            {
              className: 'nav-header-dropdown-button-text',
              style: spanButtonStyle
            },
            this.props.category
          )
        ),
        navSideBarListSection,
        this.props.showRequestSignature && requestSignatureNavSideBarListItem
      );
    }
  }]);

  return NavSideBarListSectionWithDropDown;
}(_react2.default.PureComponent);

exports.default = NavSideBarListSectionWithDropDown;


NavSideBarListSectionWithDropDown.defaultProps = {
  category: _propTypes2.default.string,
  isLastSectionGetLink: false,
  showRequestSignature: false,
  sections: [],
  offsiteBuilder: false
};

NavSideBarListSectionWithDropDown.propTypes = {
  category: _propTypes2.default.string,
  documentType: _propTypes2.default.string.isRequired,
  isLastSectionGetLink: _propTypes2.default.bool,
  loadStaticBuilderSection: _propTypes2.default.func.isRequired,
  offsetIdx: _propTypes2.default.number.isRequired,
  offsiteBuilder: _propTypes2.default.bool,
  onStep: _propTypes2.default.number.isRequired,
  sections: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showRequestSignature: _propTypes2.default.bool
};

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Utils = __webpack_require__(42);

var _Note = __webpack_require__(77);

var _Note2 = _interopRequireDefault(_Note);

var _AlertNote = __webpack_require__(249);

var _AlertNote2 = _interopRequireDefault(_AlertNote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoteWrapper = function NoteWrapper(props) {
  if ((0, _Utils.isGetLinkType)(window.CurrentDocumentInfo.type)) {
    return _react2.default.createElement(_AlertNote2.default, props);
  }
  return _react2.default.createElement(_Note2.default, props);
};

exports.default = NoteWrapper;

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StaticBuilderField = __webpack_require__(31);

var _StaticBuilderField2 = _interopRequireDefault(_StaticBuilderField);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectList = function SelectList(props) {
  return _react2.default.createElement(
    'select',
    {
      id: props.id,
      name: props.id,
      onChange: props.onChange,
      value: props.value
    },
    props.options.map(function (option) {
      return _react2.default.createElement(
        'option',
        { key: props.id + '_' + option.value, value: option.value },
        option.text
      );
    })
  );
};

SelectList.defaultProps = {
  value: ''
};

SelectList.propTypes = {
  id: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string,
    value: _propTypes2.default.string
  })).isRequired,
  value: _propTypes2.default.string
};

exports.default = (0, _StaticBuilderField2.default)(SelectList);

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticBuilderAddAnotherButton = function StaticBuilderAddAnotherButton(props) {
  return _react2.default.createElement(
    'div',
    { className: 'addAnotherButton' },
    _react2.default.createElement(
      'button',
      {
        type: 'button',
        className: 'btn btn-mini btn-primary',
        onClick: props.onAddAdditonalGroup
      },
      '+ Add Another'
    )
  );
};

StaticBuilderAddAnotherButton.propTypes = {
  onAddAdditonalGroup: _propTypes2.default.func.isRequired
};

exports.default = StaticBuilderAddAnotherButton;

/***/ }),

/***/ 259:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticBuilderBackButton = function StaticBuilderBackButton(props) {
  return _react2.default.createElement(
    'button',
    {
      type: 'button',
      onClick: props.onBack,
      'data-loading-text': 'Saving...',
      'data-finishing-text': 'Finishing...',
      className: 'backButton pull-left btn btn-large',
      id: 'staticBackButton'
    },
    'Back'
  );
};

StaticBuilderBackButton.propTypes = {
  onBack: _propTypes2.default.func.isRequired
};

exports.default = StaticBuilderBackButton;

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticBuilderDocumentPreview = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _StaticBuilderDocumentPreviewTitle = __webpack_require__(116);

var _StaticBuilderDocumentPreviewTitle2 = _interopRequireDefault(_StaticBuilderDocumentPreviewTitle);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaticBuilderDocumentPreview = exports.StaticBuilderDocumentPreview = function (_React$Component) {
  _inherits(StaticBuilderDocumentPreview, _React$Component);

  function StaticBuilderDocumentPreview() {
    _classCallCheck(this, StaticBuilderDocumentPreview);

    var _this = _possibleConstructorReturn(this, (StaticBuilderDocumentPreview.__proto__ || Object.getPrototypeOf(StaticBuilderDocumentPreview)).call(this));

    _this.hideStaticBuilderElements = _this.hideStaticBuilderElements.bind(_this);
    _this.replaceIframeUrl = _this.replaceIframeUrl.bind(_this);
    _this.docPreviewIframe = _react2.default.createRef();
    return _this;
  }

  _createClass(StaticBuilderDocumentPreview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.replaceIframeUrl(this.props.sourceURL + '&rand=' + this.props.version);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.version !== this.props.version) {
        this.replaceIframeUrl(this.props.sourceURL + '&rand=' + this.props.version);
      }
      // need this check so hideStaticBuilderElements doesn't get called on
      // original variation not on mobile
      if (prevProps.isBuilderHidden !== this.props.isBuilderHidden) {
        this.hideStaticBuilderElements();
      }
    }
  }, {
    key: 'hideStaticBuilderElements',
    value: function hideStaticBuilderElements() {
      if (!this.props.isBuilderHidden) {
        document.querySelector('#staticBuilderContent').style.display = 'block';
        document.querySelector('.builder-toolbar-inner-wrapper').style.display = 'block';
        document.querySelector('#builderNav').style.display = 'block';
      } else {
        document.querySelector('#staticBuilderContent').style.display = 'none';
        document.querySelector('.builder-toolbar-inner-wrapper').style.display = 'none';
        document.querySelector('#builderNav').style.display = 'none';
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'replaceIframeUrl',
    value: function replaceIframeUrl(url) {
      if (this.docPreviewIframe.contentWindow) {
        this.docPreviewIframe.contentWindow.location.replace(url);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var previewClass = (0, _classnames2.default)('document-preview-redesign-wrapper', {
        hide: this.props.isPreviewHidden
      });

      return _react2.default.createElement(
        'div',
        { className: previewClass },
        _react2.default.createElement(
          'div',
          { className: 'document-preview-header' },
          _react2.default.createElement(_StaticBuilderDocumentPreviewTitle2.default, null)
        ),
        _react2.default.createElement(
          'div',
          { id: 'documentPreviewBox', className: 'document-preview-box' },
          _react2.default.createElement('iframe', { className: 'document-preview', ref: function ref(c) {
              _this2.docPreviewIframe = c;
            } })
        )
      );
    }
  }]);

  return StaticBuilderDocumentPreview;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(_ref) {
  var StaticBuilderReducer = _ref.StaticBuilderReducer;
  return {
    isPreviewHidden: StaticBuilderReducer.isPreviewHidden,
    isBuilderHidden: StaticBuilderReducer.isBuilderHidden,
    version: StaticBuilderReducer.version
  };
};

var StaticBuilderDocumentPreviewWithRedux = ReactRedux.connect(mapStateToProps)(StaticBuilderDocumentPreview);

StaticBuilderDocumentPreview.defaultProps = {
  isPreviewHidden: false,
  version: Math.random()
};

StaticBuilderDocumentPreview.propTypes = {
  isBuilderHidden: _propTypes2.default.bool.isRequired,
  isPreviewHidden: _propTypes2.default.bool,
  sourceURL: _propTypes2.default.string.isRequired,
  version: _propTypes2.default.number
};

exports.default = (0, _WithInit2.default)(StaticBuilderDocumentPreviewWithRedux, true);

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Utils = __webpack_require__(18);

var _components = __webpack_require__(58);

var _CalendarField = __webpack_require__(110);

var _CalendarField2 = _interopRequireDefault(_CalendarField);

var _LineBreak = __webpack_require__(111);

var _LineBreak2 = _interopRequireDefault(_LineBreak);

var _MultiSelectCheckList = __webpack_require__(253);

var _MultiSelectCheckList2 = _interopRequireDefault(_MultiSelectCheckList);

var _NoteWrapper = __webpack_require__(256);

var _NoteWrapper2 = _interopRequireDefault(_NoteWrapper);

var _RadioButton = __webpack_require__(115);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _SelectList = __webpack_require__(257);

var _SelectList2 = _interopRequireDefault(_SelectList);

var _Subheading = __webpack_require__(119);

var _Subheading2 = _interopRequireDefault(_Subheading);

var _TextAreaField = __webpack_require__(269);

var _TextAreaField2 = _interopRequireDefault(_TextAreaField);

var _TextField = __webpack_require__(270);

var _TextField2 = _interopRequireDefault(_TextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIRST_FIELD_INDEX = 0;

var StaticBuilderFormField = function (_React$Component) {
  _inherits(StaticBuilderFormField, _React$Component);

  function StaticBuilderFormField(props) {
    _classCallCheck(this, StaticBuilderFormField);

    var _this = _possibleConstructorReturn(this, (StaticBuilderFormField.__proto__ || Object.getPrototypeOf(StaticBuilderFormField)).call(this, props));

    _this.getOptionsWithDefaults = _this.getOptionsWithDefaults.bind(_this);
    _this.addBlankChoiceToStateOptions = _this.addBlankChoiceToStateOptions.bind(_this);
    return _this;
  }

  _createClass(StaticBuilderFormField, [{
    key: 'getOptionsWithDefaults',
    value: function getOptionsWithDefaults(isChecked) {
      var field = this.props.field;

      var newOptions = field.options.slice();
      for (var i = 0; i < newOptions.length; i += 1) {
        if (isChecked(newOptions[i])) {
          newOptions[i].defaultChecked = true;
        }
      }
      return newOptions;
    }
  }, {
    key: 'addBlankChoiceToStateOptions',
    value: function addBlankChoiceToStateOptions() {
      // SmartyStreets will stupidly add a default choice to state dropdown if it doesn't have
      // one. This isn't needed so our code that enables SmartyStreets removes it, but since
      // SmartyStreets is not React aware it will break the current selection and force the dropdown
      // to select Alabama.  If we preemptively add our own blank choice this problem won't happen.

      // If the first three options are the first three states alphabetically we can be confident
      // that it is in fact a state list
      var _props$field = this.props.field,
          id = _props$field.id,
          options = _props$field.options;

      var firstOptions = options.map(function (option) {
        return option.text;
      }).slice(0, 3);
      var hasStateOptions = (0, _Utils.areArraysEqual)(firstOptions, ['Alabama', 'Alaska', 'Arizona']) || (0, _Utils.areArraysEqual)(firstOptions, ['AL', 'AK', 'AZ']);
      if (id.includes('state') && hasStateOptions) {
        return [{ text: '', value: '' }].concat(_toConsumableArray(options));
      }
      return options;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          field = _props.field,
          fieldNumber = _props.fieldNumber,
          setCurrentFieldValue = _props.setCurrentFieldValue;


      var commonProps = {
        id: field.id,
        label: field.label,
        info: field.info,
        isSelfServe: field.isSelfServe,
        setCurrentFieldValue: setCurrentFieldValue
      };
      var fieldComponent = null;
      switch (field.type) {
        case 'text_field':
          fieldComponent = _react2.default.createElement(_TextField2.default, _extends({}, commonProps, { initialValue: field.initialValue }));
          break;
        case 'hr':
          fieldComponent = _react2.default.createElement(_LineBreak2.default, commonProps);
          break;
        case 'note':
          fieldComponent = _react2.default.createElement(_NoteWrapper2.default, commonProps);
          break;
        case 'subheading':
          fieldComponent = _react2.default.createElement(_Subheading2.default, commonProps);
          break;
        case 'calendar':
          fieldComponent = _react2.default.createElement(_CalendarField2.default, _extends({}, commonProps, { initialValue: field.initialValue }));
          break;
        case 'calendar_month':
          fieldComponent = _react2.default.createElement(_CalendarField2.default, _extends({}, commonProps, {
            datepickerType: 'month',
            initialValue: field.initialValue
          }));
          break;
        case 'radio':
          fieldComponent = _react2.default.createElement(_RadioButton2.default, _extends({}, commonProps, {
            getOptionsWithDefaults: this.getOptionsWithDefaults,
            options: field.options,
            initialValue: field.initialValue
          }));
          break;
        case 'select':
          fieldComponent = _react2.default.createElement(_SelectList2.default, _extends({}, commonProps, {
            options: this.addBlankChoiceToStateOptions(),
            initialValue: field.initialValue
          }));
          break;
        case 'select_multiple':
          fieldComponent = _react2.default.createElement(_MultiSelectCheckList2.default, _extends({}, commonProps, {
            getOptionsWithDefaults: this.getOptionsWithDefaults,
            options: field.options,
            initialSelectedValues: field.initialValues
          }));
          break;
        case 'text_area':
        case 'textarea':
          fieldComponent = _react2.default.createElement(_TextAreaField2.default, _extends({}, commonProps, { initialValue: field.initialValue }));
          break;
        default:
          fieldComponent = null;
      }

      var isFirstField = fieldNumber === FIRST_FIELD_INDEX;
      if (isFirstField) {
        // Check for fieldNumber for the Self Serve demo case.
        // The automatically opened preview modal contains 2 fields by default
        // We only want to attach the answer question tooltip to the first field
        fieldComponent = _react2.default.createElement(
          _components.ElementWithAnswerQuestionTooltip,
          {
            targetElementType: field.type
          },
          fieldComponent
        );
      }

      return _react2.default.createElement(
        'div',
        { key: field.id, className: 'control-group', id: 'group_' + field.id },
        fieldComponent
      );
    }
  }]);

  return StaticBuilderFormField;
}(_react2.default.Component);

StaticBuilderFormField.defaultProps = {
  fieldNumber: 0,
  isSelfServe: false,
  setCurrentFieldValue: function setCurrentFieldValue() {}
};

StaticBuilderFormField.propTypes = {
  field: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      text: _propTypes2.default.string,
      value: _propTypes2.default.string
    }))
  }).isRequired,
  fieldNumber: _propTypes2.default.number,
  setCurrentFieldValue: _propTypes2.default.func
};

exports.default = StaticBuilderFormField;

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NavSideBarList = __webpack_require__(114);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaticBuilderNavSideBar = function (_React$PureComponent) {
  _inherits(StaticBuilderNavSideBar, _React$PureComponent);

  function StaticBuilderNavSideBar() {
    _classCallCheck(this, StaticBuilderNavSideBar);

    return _possibleConstructorReturn(this, (StaticBuilderNavSideBar.__proto__ || Object.getPrototypeOf(StaticBuilderNavSideBar)).apply(this, arguments));
  }

  _createClass(StaticBuilderNavSideBar, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { id: 'well1', className: 'well well-no-padding' },
        _react2.default.createElement(
          'ul',
          { id: 'WizardNav', className: 'nav nav-list ' + this.props.additionalClassNamesForNavList },
          _react2.default.createElement(_NavSideBarList.NavSideBarListWithSectionsWithRedux, _extends({}, this.props, {
            showRequestSignature: this.props.showRequestSignature
          }))
        )
      );
    }
  }]);

  return StaticBuilderNavSideBar;
}(_react2.default.PureComponent);

StaticBuilderNavSideBar.defaultProps = {
  showRequestSignature: false,
  additionalClassNamesForNavList: ''
};

StaticBuilderNavSideBar.propTypes = {
  additionalClassNamesForNavList: _propTypes2.default.string,
  showRequestSignature: _propTypes2.default.bool
};

exports.default = StaticBuilderNavSideBar;

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _StaticBuilderNavSideBar = __webpack_require__(262);

var _StaticBuilderNavSideBar2 = _interopRequireDefault(_StaticBuilderNavSideBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaticBuilderNavSideBarWrapper = function (_React$PureComponent) {
  _inherits(StaticBuilderNavSideBarWrapper, _React$PureComponent);

  function StaticBuilderNavSideBarWrapper() {
    _classCallCheck(this, StaticBuilderNavSideBarWrapper);

    return _possibleConstructorReturn(this, (StaticBuilderNavSideBarWrapper.__proto__ || Object.getPrototypeOf(StaticBuilderNavSideBarWrapper)).apply(this, arguments));
  }

  _createClass(StaticBuilderNavSideBarWrapper, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_StaticBuilderNavSideBar2.default, this.props);
    }
  }]);

  return StaticBuilderNavSideBarWrapper;
}(_react2.default.PureComponent);

exports.default = (0, _WithInit2.default)(StaticBuilderNavSideBarWrapper, true);

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _SignatureDeclineButton = __webpack_require__(320);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticBuilderSaveButton = function StaticBuilderSaveButton(props) {
  if (props.isHidden) {
    return null;
  }

  var signButtonClassNames = (0, _classnames2.default)('pull-right btn btn-large btn-success saveButton', {
    disabled: !props.isSignatureAdded
  });

  if (props.showSignButton) {
    return _react2.default.createElement(
      'div',
      { className: 'static-builder-sign-buttons' },
      props.isSelfServe && !props.isPreviewMode && _react2.default.createElement(_SignatureDeclineButton.SignatureDeclineButtonWithRedux, {
        confirmationTracking: 'Sign Decline',
        documentType: props.documentType,
        shareKey: props.shareKey,
        useWhiteText: false
      }),
      _react2.default.createElement(
        'button',
        {
          type: 'button',
          onClick: props.onSign,
          'data-loading-text': 'Saving...',
          'data-finishing-text': 'Finishing...',
          className: signButtonClassNames
        },
        'Sign'
      )
    );
  }
  return _react2.default.createElement(
    'button',
    {
      type: 'button',
      onClick: props.clickNextButton,
      'data-loading-text': 'Saving...',
      'data-finishing-text': 'Finishing...',
      className: 'pull-right btn btn-large btn-success saveButton',
      id: 'staticSaveButton'
    },
    props.buttonContent
  );
};

StaticBuilderSaveButton.defaultProps = {
  isPreviewMode: false,
  isSelfServe: false,
  shareKey: ''
};

StaticBuilderSaveButton.propTypes = {
  buttonContent: _propTypes2.default.string.isRequired,
  clickNextButton: _propTypes2.default.func.isRequired,
  documentType: _propTypes2.default.string.isRequired,
  isHidden: _propTypes2.default.bool.isRequired,
  isPreviewMode: _propTypes2.default.bool,
  isSelfServe: _propTypes2.default.bool,
  isSignatureAdded: _propTypes2.default.bool.isRequired,
  onSign: _propTypes2.default.func.isRequired,
  shareKey: _propTypes2.default.string,
  showSignButton: _propTypes2.default.bool.isRequired
};

exports.default = StaticBuilderSaveButton;

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AnimationConstants = __webpack_require__(322);

var _AnimationConstants2 = _interopRequireDefault(_AnimationConstants);

var _ProgressBar = __webpack_require__(99);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaticBuilderSaveProgressBar = function (_React$PureComponent) {
  _inherits(StaticBuilderSaveProgressBar, _React$PureComponent);

  function StaticBuilderSaveProgressBar() {
    _classCallCheck(this, StaticBuilderSaveProgressBar);

    return _possibleConstructorReturn(this, (StaticBuilderSaveProgressBar.__proto__ || Object.getPrototypeOf(StaticBuilderSaveProgressBar)).apply(this, arguments));
  }

  _createClass(StaticBuilderSaveProgressBar, [{
    key: 'render',
    value: function render() {
      if (!this.props.disabled && this.props.started && !this.props.finished) {
        return _react2.default.createElement(_ProgressBar2.default, {
          progressBarId: 'saveBarObj',
          progressBarClassName: 'progress progress-striped active',
          progressId: 'saveBar',
          progressClassName: 'bar',
          step: this.props.step,
          totalSteps: this.props.totalSteps
        });
      }

      return null;
    }
  }]);

  return StaticBuilderSaveProgressBar;
}(_react2.default.PureComponent);

StaticBuilderSaveProgressBar.defaultProps = {
  progressBarId: '',
  progressId: '',
  progressBarClassName: '',
  progressClassName: ''
};

StaticBuilderSaveProgressBar.propTypes = {
  disabled: _propTypes2.default.bool.isRequired,
  started: _propTypes2.default.bool.isRequired,
  finished: _propTypes2.default.bool.isRequired,
  step: _propTypes2.default.number.isRequired,
  totalSteps: _propTypes2.default.number.isRequired
};

var mapStateToProps = function mapStateToProps(_ref) {
  var AnimationReducer = _ref.AnimationReducer;
  return {
    disabled: AnimationReducer[_AnimationConstants2.default.STATIC_BUILDER_SAVE_ANIMATION].disabled,
    started: AnimationReducer[_AnimationConstants2.default.STATIC_BUILDER_SAVE_ANIMATION].started,
    finished: AnimationReducer[_AnimationConstants2.default.STATIC_BUILDER_SAVE_ANIMATION].finished,
    step: AnimationReducer[_AnimationConstants2.default.STATIC_BUILDER_SAVE_ANIMATION].step,
    totalSteps: AnimationReducer[_AnimationConstants2.default.STATIC_BUILDER_SAVE_ANIMATION].totalSteps
  };
};

exports.default = ReactRedux.connect(mapStateToProps)(StaticBuilderSaveProgressBar);

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CreatorButtons = __webpack_require__(136);

var _CreatorButtons2 = _interopRequireDefault(_CreatorButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticBuilderSignatureManagerCreatorButtons = function StaticBuilderSignatureManagerCreatorButtons(_ref) {
  var useSignature = _ref.useSignature,
      closeCreator = _ref.closeCreator;
  return _react2.default.createElement(_CreatorButtons2.default, {
    addBtnData: {
      id: 'add-sig-btn',
      className: 'btn btn-success btn-large save-use-btn success-btn add-sig-btn',
      click: useSignature,
      text: 'Sign'
    },
    cancelBtnData: {
      id: 'cancel-btn',
      className: 'btn btn-large save-use-btn cancel-btn',
      click: closeCreator,
      text: 'Cancel'
    }
  });
};

StaticBuilderSignatureManagerCreatorButtons.propTypes = {
  useSignature: _propTypes2.default.func.isRequired,
  closeCreator: _propTypes2.default.func.isRequired
};

exports.default = StaticBuilderSignatureManagerCreatorButtons;

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PreviewButton = __webpack_require__(138);

var _PreviewButton2 = _interopRequireDefault(_PreviewButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticBuilderSignatureManagerPreviewButton = function StaticBuilderSignatureManagerPreviewButton(props) {
  return _react2.default.createElement(_PreviewButton2.default, {
    id: 'signAnyDocBtn',
    className: 'btn btn-success btn-large save-use-btn success-btn',
    click: props.handleSignClick,
    text: 'Sign Any Document',
    isVisible: false
  });
};

StaticBuilderSignatureManagerPreviewButton.propTypes = {
  imageUrls: _propTypes2.default.shape({
    draw: _propTypes2.default.string,
    type: _propTypes2.default.string
  }).isRequired,
  handleSignClick: _propTypes2.default.func.isRequired
};

exports.default = StaticBuilderSignatureManagerPreviewButton;

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticBuilderSignatureManager = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _index = __webpack_require__(106);

var _index2 = _interopRequireDefault(_index);

var _EnhanceSignatures = __webpack_require__(137);

var _EnhanceSignatures2 = _interopRequireDefault(_EnhanceSignatures);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _PreviewButton = __webpack_require__(267);

var _PreviewButton2 = _interopRequireDefault(_PreviewButton);

var _CreatorButtons = __webpack_require__(266);

var _CreatorButtons2 = _interopRequireDefault(_CreatorButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaticBuilderSignatureManager = exports.StaticBuilderSignatureManager = function (_React$Component) {
  _inherits(StaticBuilderSignatureManager, _React$Component);

  _createClass(StaticBuilderSignatureManager, null, [{
    key: 'handleImageClick',
    value: function handleImageClick(src, type, e) {
      // Prevent default form submit for self-serve
      e.preventDefault();
    }
  }]);

  function StaticBuilderSignatureManager(props) {
    _classCallCheck(this, StaticBuilderSignatureManager);

    var _this = _possibleConstructorReturn(this, (StaticBuilderSignatureManager.__proto__ || Object.getPrototypeOf(StaticBuilderSignatureManager)).call(this, props));

    _this.isLoadFromSave = _this.isLoadFromSave.bind(_this);
    _this.loadSavedSignature = _this.loadSavedSignature.bind(_this);
    _this.loadSignedOutSignature = _this.loadSignedOutSignature.bind(_this);
    return _this;
  }

  _createClass(StaticBuilderSignatureManager, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var savedType = this.props.savedSignature.type;
      var savedUrl = this.props.savedSignature.url;
      var isSignatureManagerEmpty = !this.props.imageUrls.draw && !this.props.imageUrls.type;
      if (savedUrl !== this.props.imageUrls[savedType]) {
        this.loadSavedSignature();
      } else if (!savedUrl && isSignatureManagerEmpty) {
        this.loadSignedOutSignature();
      }

      if (this.props.signatureActions.isSaveButtonHidden) {
        this.props.signatureActions.closeCreatorAction();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var isSignaturePresent = this.props.imageUrls.draw || this.props.imageUrls.type;
      if (isSignaturePresent && !this.props.isSignatureAdded) {
        this.props.setIsSignatureAdded(true);
      } else if (!isSignaturePresent && this.props.isSignatureAdded) {
        this.props.setIsSignatureAdded(false);
      }
    }
  }, {
    key: 'loadSavedSignature',
    value: function loadSavedSignature() {
      var url = this.props.savedSignature.url;
      var type = this.props.savedSignature.type;
      if (this.props.imageUrls[type] !== url) {
        // save the props savedSignature into imageUrls redux state
        this.props.saveSingleSignature(url, type);
      }
    }
  }, {
    key: 'loadSignedOutSignature',
    value: function loadSignedOutSignature() {
      var lastUsedUrl = this.props.lastUsedImageUrl;
      if (!window.User.isLoggedIn && lastUsedUrl) {
        var lastUsedType = this.props.lastUsedImageType;
        if (this.props.imageUrls[lastUsedType] !== lastUsedUrl) {
          // save the lastUsed image into imageUrls redux state
          // so that it shows in SignatureManager
          this.props.saveSingleSignature(lastUsedUrl, lastUsedType);
        }
      }
    }
  }, {
    key: 'isLoadFromSave',
    value: function isLoadFromSave() {
      // if there is already a saved signature as a field value
      if (this.props.savedSignature.url) {
        return true;
      }

      // if there are two signatures we need to have only one load
      if (this.props.imageUrls.draw && this.props.imageUrls.type) {
        return true;
      }

      // if user is signed out and we have an image saved
      if (!window.User.isLoggedIn && this.props.lastUsedImageUrl) {
        return true;
      }

      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var isSignaturePresent = this.props.imageUrls.draw || this.props.imageUrls.type;
      var signatureManagerClassNames = (0, _classnames2.default)('signature-mananger-container', {
        'signature-present': isSignaturePresent
      });

      // boolean to determine when we override the imageUrls to something saved elsewhere
      var loadFromSave = this.isLoadFromSave();

      return _react2.default.createElement(
        'div',
        { key: this.props.key, className: 'control-group', id: 'group_' + this.props.key },
        _react2.default.createElement(
          'div',
          { className: signatureManagerClassNames },
          _react2.default.createElement(_index2.default, _extends({}, this.props, {
            afterSaveSignatureAction: this.props.onSign,
            buttonText: {
              type: 'Type with Keyboard',
              draw: 'Draw with Mouse'
            },
            clearBtnText: 'Clear',
            closeCreatorAction: this.props.signatureActions.closeCreatorAction,
            creatorButtons: _CreatorButtons2.default,
            drawCreatorLabel: 'Draw your signature',
            loadFromSave: loadFromSave,
            imageClick: StaticBuilderSignatureManager.handleImageClick,
            isSelfServe: this.props.isSelfServe,
            isSingleSignatureMode: true,
            openCreatorAction: this.props.signatureActions.openCreatorAction,
            preventFormSubmit: true,
            previewButtons: _PreviewButton2.default,
            previewButtonProps: { handleSignClick: StaticBuilderSignatureManager.handleImageClick },
            sigPadHeight: 115,
            sigPadWidth: 330,
            typeCreatorLabel: 'Type your full name',
            types: {
              type: true,
              draw: true
            }
          }))
        )
      );
    }
  }]);

  return StaticBuilderSignatureManager;
}(_react2.default.Component);

StaticBuilderSignatureManager.propTypes = {
  isSelfServe: _propTypes2.default.bool,
  key: _propTypes2.default.string.isRequired,
  signatureActions: _propTypes2.default.shape({
    openCreatorAction: _propTypes2.default.func,
    closeCreatorAction: _propTypes2.default.func,
    isSaveButtonHidden: _propTypes2.default.bool
  }).isRequired,
  imageUrls: _propTypes2.default.shape({
    draw: _propTypes2.default.string,
    type: _propTypes2.default.string
  }).isRequired,
  isSignatureAdded: _propTypes2.default.bool.isRequired,
  lastUsedImageType: _propTypes2.default.string,
  lastUsedImageUrl: _propTypes2.default.string,
  onSign: _propTypes2.default.func.isRequired,
  savedSignature: _propTypes2.default.shape({
    url: _propTypes2.default.string,
    type: _propTypes2.default.string
  }).isRequired,
  saveSingleSignature: _propTypes2.default.func.isRequired,
  setIsSignatureAdded: _propTypes2.default.func.isRequired
};

StaticBuilderSignatureManager.defaultProps = {
  isSelfServe: false,
  lastUsedImageType: '',
  lastUsedImageUrl: ''
};

var StaticBuilderSignatureManagerContainer = (0, _EnhanceSignatures2.default)(StaticBuilderSignatureManager);

exports.default = StaticBuilderSignatureManagerContainer;

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StaticBuilderField = __webpack_require__(31);

var _StaticBuilderField2 = _interopRequireDefault(_StaticBuilderField);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextAreaField = function TextAreaField(props) {
  return _react2.default.createElement('textarea', {
    className: 'input-xlarge',
    id: props.id.toLowerCase(),
    name: props.id,
    rows: 9,
    onChange: props.onChange,
    value: props.value
  });
};

TextAreaField.defaultProps = {
  value: ''
};

TextAreaField.propTypes = {
  id: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = (0, _StaticBuilderField2.default)(TextAreaField);

/***/ }),

/***/ 270:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StaticBuilderField = __webpack_require__(31);

var _StaticBuilderField2 = _interopRequireDefault(_StaticBuilderField);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(58);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextField = function (_React$Component) {
  _inherits(TextField, _React$Component);

  function TextField(props) {
    _classCallCheck(this, TextField);

    var _this = _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).call(this, props));

    _this.renderInput = _this.renderInput.bind(_this);
    return _this;
  }

  _createClass(TextField, [{
    key: 'renderInput',
    value: function renderInput(input) {
      // For the Self Serve Builder Recipient preview modal.
      // For the case where no popup is added, show a tooltip
      // attached to the sample text input by default
      // Needs to be on this level so that it wraps only the text box
      if (this.props.id === 'sample-text-box') {
        return _react2.default.createElement(_components.RecipientPreviewEmptyStateTextField, { targetElement: input });
      }

      return input;
    }
  }, {
    key: 'render',
    value: function render() {
      var input = _react2.default.createElement('input', {
        className: 'input-large',
        type: 'text',
        id: this.props.id.toLowerCase(),
        name: this.props.id,
        onChange: this.props.onChange,
        value: this.props.value
      });

      return this.renderInput(input);
    }
  }]);

  return TextField;
}(_react2.default.Component);

TextField.defaultProps = {
  value: ''
};

TextField.propTypes = {
  id: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired
};

exports.default = (0, _StaticBuilderField2.default)(TextField);

/***/ }),

/***/ 271:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withStaticBuilderSetup;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CustomPropTypes = __webpack_require__(19);

var _CustomPropTypes2 = _interopRequireDefault(_CustomPropTypes);

var _StaticBuilderFormattedFields = __webpack_require__(51);

var _StaticBuilderFormattedFields2 = _interopRequireDefault(_StaticBuilderFormattedFields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withStaticBuilderSetup(WrappedComponent) {
  var StaticBuilderSetup = function (_React$Component) {
    _inherits(StaticBuilderSetup, _React$Component);

    function StaticBuilderSetup(props) {
      _classCallCheck(this, StaticBuilderSetup);

      var _this = _possibleConstructorReturn(this, (StaticBuilderSetup.__proto__ || Object.getPrototypeOf(StaticBuilderSetup)).call(this, props));

      _this.getGroupedFields = _this.getGroupedFields.bind(_this);
      return _this;
    }

    _createClass(StaticBuilderSetup, [{
      key: 'getGroupedFields',
      value: function getGroupedFields() {
        var formattedFields = new _StaticBuilderFormattedFields2.default(this.props.sectionContent);

        this.props.fields.forEach(function (field, idx, array) {
          var updatedField = _extends({}, field, {
            options: field.options || []
          });

          var isEndOfMultiple = idx === array.length - 1;
          formattedFields.addField(updatedField, isEndOfMultiple);
        });
        return formattedFields;
      }
    }, {
      key: 'render',
      value: function render() {
        var formattedFields = this.getGroupedFields();

        return _react2.default.createElement(WrappedComponent, _extends({
          documentType: this.props.documentType,
          formattedFields: formattedFields
        }, this.props));
      }
    }]);

    return StaticBuilderSetup;
  }(_react2.default.Component);

  StaticBuilderSetup.defaultProps = {
    fields: []
  };

  StaticBuilderSetup.propTypes = {
    documentType: _propTypes2.default.string.isRequired,
    fields: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.string,
      label: _propTypes2.default.string,
      options: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.shape({
        text: _propTypes2.default.string,
        value: _propTypes2.default.string
      })), _propTypes2.default.string]),
      type: _propTypes2.default.string,
      info: _propTypes2.default.string
    })),
    sectionContent: _CustomPropTypes2.default.shapeWithStringValues.isRequired
  };

  return StaticBuilderSetup;
}

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StaticBuilderModalConstants = __webpack_require__(175);

var _StaticBuilderModalConstants2 = _interopRequireDefault(_StaticBuilderModalConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var closeStaticSecondActionModal = function closeStaticSecondActionModal() {
  return function (dispatch) {
    dispatch({
      type: _StaticBuilderModalConstants2.default.CLOSE_STATIC_SECOND_ACTION_MODAL
    });
  };
};

exports.default = closeStaticSecondActionModal;

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StaticBuilderModalConstants = __webpack_require__(175);

var _StaticBuilderModalConstants2 = _interopRequireDefault(_StaticBuilderModalConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var openStaticSecondActionModal = function openStaticSecondActionModal() {
  return function (dispatch) {
    dispatch({
      type: _StaticBuilderModalConstants2.default.OPEN_STATIC_SECOND_ACTION_MODAL
    });
  };
};

exports.default = openStaticSecondActionModal;

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StaticGetLinkSection = function StaticGetLinkSection(_ref) {
  var loadPreviousStaticBuilderSection = _ref.loadPreviousStaticBuilderSection,
      documentType = _ref.documentType;

  var onBackClick = (0, _react.useCallback)(function () {
    loadPreviousStaticBuilderSection();
  });

  var onSaveClick = (0, _react.useCallback)(function () {
    window._track('Save and Get Link', documentType + ' | Static-builder-member');
  });

  return _react2.default.createElement(
    'div',
    { id: 'screen', className: 'static-request-signature-content-section page' },
    _react2.default.createElement(
      'h2',
      null,
      'We\'ll create a reusable form with fillable fields from this waiver and take you to get a shareable link to your document'
    ),
    _react2.default.createElement(
      'div',
      { className: 'innerContent' },
      _react2.default.createElement(
        'div',
        { className: 'form-actions' },
        _react2.default.createElement(
          'button',
          {
            className: 'backButton pull-left btn btn-large',
            onClick: onBackClick
          },
          'Back'
        ),
        _react2.default.createElement(
          'button',
          {
            className: 'pull-right btn btn-large btn-success saveButton',
            onClick: onSaveClick
          },
          'Save & Get Link'
        )
      )
    )
  );
};

StaticGetLinkSection.defaultProps = {
  documentType: ''
};

StaticGetLinkSection.propTypes = {
  documentType: _propTypes2.default.string,
  loadPreviousStaticBuilderSection: _propTypes2.default.func.isRequired
};

exports.default = StaticGetLinkSection;

/***/ }),

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropDownSection = function DropDownSection(props) {
  var label = _react2.default.createElement(
    'label',
    { className: 'dropdown-section-label', htmlFor: 'requestSignatureOptions' },
    props.label
  );
  var options = props.options.map(function (option) {
    return _react2.default.createElement(
      'option',
      { key: option.label + option.value, value: option.value },
      option.label
    );
  });
  var postLabel = '';
  if (props.postLabel) {
    var postLabelClassNames = (0, _classnames2.default)('dropdown-section-post-label', {
      'dropdown-section-post-label-highlighted': props.highlightDropDownSection,
      'lighter-text': !props.highlightDropDownSection
    });
    var postLabelTextClassNames = (0, _classnames2.default)({ 'dropdown-section-text': props.highlightDropDownSection });
    postLabel = _react2.default.createElement(
      'label',
      { className: postLabelClassNames, htmlFor: 'requestSignatureOptions' },
      props.postLabel.split('\n').map(function (labelLine) {
        return _react2.default.createElement(
          'div',
          { className: postLabelTextClassNames },
          labelLine
        );
      })
    );
  }
  var dropDownSectionPostLabelWrapperClasses = (0, _classnames2.default)({ 'dropdown-section-post-label-wrapper-highlighted': props.highlightDropDownSection });

  return _react2.default.createElement(
    'div',
    { className: 'static-request-signature-content-section' },
    props.showDropDown && _react2.default.createElement(
      'div',
      null,
      label,
      _react2.default.createElement(
        'select',
        { id: 'requestSignatureOptions', onChange: props.onChange },
        options
      )
    ),
    _react2.default.createElement(
      'div',
      { className: dropDownSectionPostLabelWrapperClasses },
      postLabel
    )
  );
};

DropDownSection.propTypes = {
  highlightDropDownSection: _propTypes2.default.bool,
  label: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string,
    value: _propTypes2.default.string
  })).isRequired,
  postLabel: _propTypes2.default.string,
  showDropDown: _propTypes2.default.bool
};

DropDownSection.defaultProps = {
  highlightDropDownSection: false,
  onChange: function onChange() {
    return false;
  },
  postLabel: '',
  showDropDown: true
};

exports.default = DropDownSection;

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoSignatureToTemplateBuilderModalWithRedux = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(92);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = __webpack_require__(4);

var _SelfServeBuilderActions = __webpack_require__(41);

var _SelfServeBuilderConstants = __webpack_require__(73);

var _SelfServeBuilderConstants2 = _interopRequireDefault(_SelfServeBuilderConstants);

var _Icons = __webpack_require__(17);

var _DesignSystem = __webpack_require__(97);

var _main = __webpack_require__(85);

var _main2 = _interopRequireDefault(_main);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultModalStyle = {

  overlay: {
    background: 'transparent',
    zIndex: _main2.default.modalZIndex
  },
  content: {
    position: 'absolute',
    top: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: '0 2px 4px 0 rgba(0,0,0,0.5)',
    backgroundColor: 'white',
    height: 375,
    paddingTop: 0,
    width: 550,
    overflow: 'visible'
  }
};

var NoSignatureToTemplateBuilderModal = function (_React$PureComponent) {
  _inherits(NoSignatureToTemplateBuilderModal, _React$PureComponent);

  function NoSignatureToTemplateBuilderModal(props) {
    _classCallCheck(this, NoSignatureToTemplateBuilderModal);

    var _this = _possibleConstructorReturn(this, (NoSignatureToTemplateBuilderModal.__proto__ || Object.getPrototypeOf(NoSignatureToTemplateBuilderModal)).call(this, props));

    _this.declineDemo = _this.declineDemo.bind(_this);
    _this.tryDemo = _this.tryDemo.bind(_this);
    return _this;
  }

  _createClass(NoSignatureToTemplateBuilderModal, [{
    key: 'declineDemo',
    value: function declineDemo() {
      window._track('Maybe Later | No One Request Signature Modal', 'Static-Builder-Member');
      this.props.closeModal();
    }
  }, {
    key: 'tryDemo',
    value: function tryDemo() {
      window._track('Try Demo | No One Request Signature Modal', 'Static-Builder-Member');
      this.props.createSampleDocument(_SelfServeBuilderConstants2.default.SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_CONTRACT);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactModal2.default,
        {
          style: defaultModalStyle,
          ariaHideApp: false,
          isOpen: this.props.isOpen,
          onRequestClose: this.props.closeModal,
          shouldCloseOnOverlayClick: true
        },
        _react2.default.createElement(
          'div',
          { className: 'no-signature-template-builder-modal' },
          _react2.default.createElement(_Icons.CloseSmallIcon, {
            className: 'ds-icon-default cursor-pointer close-icon',
            onClick: this.props.closeModal
          }),
          _react2.default.createElement('img', {
            alt: 'convert to custom template',
            className: 'custom-template-icon',
            src: '/images/builder-static/make-template-2x.png'
          }),
          _react2.default.createElement(
            'div',
            { className: 'modal-header-wrapper' },
            _react2.default.createElement(
              _DesignSystem.Pill,
              {
                className: 'new-badge',
                type: 'alt'
              },
              'NEW'
            ),
            _react2.default.createElement(
              'h3',
              { className: 'modal-header' },
              'Turn your documents into this question-style format.'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'modal-text-wrapper' },
            _react2.default.createElement(
              'p',
              { className: 'modal-text' },
              'Your recipients can quickly and accurately fill out what you need.'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'modal-actions-wrapper' },
            _react2.default.createElement(
              'button',
              {
                className: 'ds-btn-secondary md',
                onClick: this.declineDemo
              },
              'Maybe Later'
            ),
            _react2.default.createElement(
              'button',
              {
                className: 'ds-btn-primary md',
                onClick: this.tryDemo
              },
              'Try a Demo'
            )
          )
        )
      );
    }
  }]);

  return NoSignatureToTemplateBuilderModal;
}(_react2.default.PureComponent);

NoSignatureToTemplateBuilderModal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  closeModal: _propTypes2.default.func.isRequired,
  createSampleDocument: _propTypes2.default.func.isRequired
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    createSampleDocument: _SelfServeBuilderActions.createSampleDocument
  }, dispatch);
};

var NoSignatureToTemplateBuilderModalWithRedux = exports.NoSignatureToTemplateBuilderModalWithRedux = ReactRedux.connect(null, mapDispatchToProps)(NoSignatureToTemplateBuilderModal);

exports.default = NoSignatureToTemplateBuilderModalWithRedux;

/***/ }),

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _messageHandler = __webpack_require__(71);

var _messageHandler2 = _interopRequireDefault(_messageHandler);

var _Validation = __webpack_require__(44);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _StaticBuilderActions = __webpack_require__(24);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SaveActionsEnum = {
  SAVE_AND_CONTINUE: 1,
  SAVE_AND_SHARE: 2,
  SAVE_AND_SIGN: 3,
  SAVE_SHARE_AND_SIGN: 4
};

var StaticCreateAccountForm = function (_React$Component) {
  _inherits(StaticCreateAccountForm, _React$Component);

  function StaticCreateAccountForm(props) {
    _classCallCheck(this, StaticCreateAccountForm);

    var _this = _possibleConstructorReturn(this, (StaticCreateAccountForm.__proto__ || Object.getPrototypeOf(StaticCreateAccountForm)).call(this, props));

    _this.state = {
      email: '',
      password: '',
      rePassword: '',
      newsletter: true,
      newsletterAlt: true,
      documentType: window.CurrentDocumentInfo.type,
      documentHash: window.SessionManager.hash,
      documentKey: window.SessionManager.id
    };

    _this.handleChange = _this.handleChange.bind(_this);
    _this.submitForm = _this.submitForm.bind(_this);
    _this.getRedirectUrl = _this.getRedirectUrl.bind(_this);

    if (_this.props.onBackClickOverride) {
      _this.onBackClick = _this.props.onBackClickOverride;
    } else {
      _this.onBackClick = _this.onBackClick.bind(_this);
    }
    return _this;
  }

  _createClass(StaticCreateAccountForm, [{
    key: 'onBackClick',
    value: function onBackClick(event) {
      event.preventDefault();
      this.props.loadPreviousStaticBuilderSection();
    }
  }, {
    key: 'getRedirectUrl',
    value: function getRedirectUrl() {
      var redirectUrl = '';
      if (this.props.currentAction === SaveActionsEnum.SAVE_AND_SHARE || this.props.currentAction === SaveActionsEnum.SAVE_SHARE_AND_SIGN) {
        redirectUrl = '/_api/convert-static-to-freewrite.php?action=request-signature&member=1&documentType=' + this.state.documentType + '&ses=' + this.state.documentHash + '&key=' + this.state.documentKey;
      } else if (this.props.currentAction === SaveActionsEnum.SAVE_AND_SIGN) {
        redirectUrl = '/_api/convert-static-to-freewrite.php?action=sign&member=1&documentType=' + this.state.documentType + '&ses=' + this.state.documentHash + '&key=' + this.state.documentKey;
      } else {
        redirectUrl = '/upgrade-pricing?ses=' + this.state.documentHash + '&key=' + this.state.documentKey + '&documentType=' + this.state.documentType;
      }
      return redirectUrl;
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      if (event.target.dataset.statekey === 'newsletter') {
        var _setState;

        this.setState((_setState = {}, _defineProperty(_setState, event.target.dataset.statekey, event.target.checked), _defineProperty(_setState, 'newsletterAlt', event.target.checked), _setState));
      } else {
        this.setState(_defineProperty({}, event.target.dataset.statekey, event.target.value));
      }
    }
  }, {
    key: 'submitForm',
    value: function submitForm(event) {
      event.preventDefault();

      var errorBoxHandler = this.props.setErrorBoxState;
      var data = {
        email: this.state.email,
        password: this.state.password,
        confirm_password: this.state.rePassword,
        primary_document_type: this.state.documentType,
        session_hash: this.state.documentHash,
        session_id: this.state.documentKey
      };
      var redirectUrl = this.getRedirectUrl();

      data['fs-newsletter'] = this.state.newsletter ? 'checked' : 'unchecked';
      data['fs-newsletter-alt'] = this.state.newsletterAlt ? 'checked' : 'unchecked';

      localStorage.removeItem('staticSection-' + window.SessionManager.id);
      localStorage.removeItem('staticViewedScreens-' + window.SessionManager.id);

      if (this.props.trackDropdownSelection) {
        switch (this.props.currentAction) {
          case SaveActionsEnum.SAVE_AND_SIGN:
            localStorage.setItem('staticRequestSignatureDropdownSelection', 'Me | Request Signature Section');
            break;
          case SaveActionsEnum.SAVE_AND_SHARE:
            localStorage.setItem('staticRequestSignatureDropdownSelection', 'Someone Else | Request Signature Section');
            break;
          case SaveActionsEnum.SAVE_SHARE_AND_SIGN:
            localStorage.setItem('staticRequestSignatureDropdownSelection', 'Me and Someone Else | Request Signature Section');
            break;
          case SaveActionsEnum.SAVE_AND_CONTINUE:
            localStorage.setItem('staticRequestSignatureDropdownSelection', 'No one | Request Signature Section');
            break;
          default:
            localStorage.setItem('staticRequestSignatureDropdownSelection', 'No one | Request Signature Section');
        }
      }

      var self = this;
      window.FormSwiftAPI.inlineRegister(data).then(function (result) {
        if (result) {
          window._track('Document Created', data.primary_document_type);
          window.localStorage.setItem('staticSection-' + window.SessionManager.id, JSON.stringify(window.ReactCompatibility.getStaticBuilderCurrentStep()));
          window.localStorage.setItem('accountCreatedFromStaticBuilder', true);

          if (self.props.trackingId) {
            window.localStorage.setItem('accountCreatedFromStaticBuilderTrackingId', self.props.trackingId);
          }

          if (self.props.postSubmitAction === 'nextBuilderStep') {
            window.localStorage.setItem('accountCreatedFromStaticBuilder', true);
            var screenNum = window.createAccountScreen;
            window.createAccountScreen = null;
            self.props.loadStaticBuilderSection(screenNum);
          } else {
            window.location = redirectUrl;
          }
        } else {
          var errorMessage = _messageHandler2.default.getErrorMessage(window.FormSwiftAPI.errorMessage, data.email);
          errorBoxHandler(true, errorMessage);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var checkboxStyles = {
        display: 'inline-block',
        paddingLeft: 10
      };

      var checkoutLabelStyles = {
        display: 'inline-block'
      };

      return _react2.default.createElement(
        _Validation.Form,
        {
          onSubmit: this.submitForm
        },
        _react2.default.createElement(
          'div',
          { className: 'control-group' },
          _react2.default.createElement(
            'label',
            { className: 'control-label', htmlFor: 'email' },
            'E-mail:'
          ),
          _react2.default.createElement(
            'div',
            { className: 'controls' },
            _react2.default.createElement(_Validation.Input, {
              type: 'text',
              'data-statekey': 'email',
              name: 'email',
              value: this.state.email,
              onChange: this.handleChange,
              validations: [_Validation.Rules.required, _Validation.Rules.email]
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'control-group' },
          _react2.default.createElement(
            'label',
            { className: 'control-label', htmlFor: 'password' },
            'Password:'
          ),
          _react2.default.createElement(
            'div',
            { className: 'controls' },
            _react2.default.createElement(_Validation.Input, {
              type: 'password',
              'data-statekey': 'password',
              name: 'password',
              value: this.state.password,
              onChange: this.handleChange,
              validations: [_Validation.Rules.required]
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'control-group' },
          _react2.default.createElement(
            'label',
            { className: 'control-label', htmlFor: 'confirm_password' },
            'Confirm Password:'
          ),
          _react2.default.createElement(
            'div',
            { className: 'controls' },
            _react2.default.createElement(_Validation.Input, {
              type: 'password',
              'data-statekey': 'rePassword',
              name: 'rePassword',
              value: this.state.rePassword,
              onChange: this.handleChange,
              validations: [_Validation.Rules.required, _Validation.Rules.passwordConfirm]
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'control-group' },
          _react2.default.createElement(
            'label',
            {
              className: 'control-label',
              style: checkoutLabelStyles,
              htmlFor: 'newsletter'
            },
            'Newsletter:'
          ),
          _react2.default.createElement(
            'div',
            { className: 'controls', style: checkboxStyles },
            _react2.default.createElement(
              'label',
              { className: 'checkbox', htmlFor: 'checkbox' },
              _react2.default.createElement('input', {
                name: 'fs-newsletter',
                type: 'checkbox',
                'data-statekey': 'newsletter',
                checked: this.state.newsletter,
                onChange: this.handleChange,
                id: 'newsletter'
              }),
              'Sign up for our free newsletter'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-actions' },
          _react2.default.createElement(
            'button',
            {
              className: 'pull-left btn btn-large',
              onClick: this.onBackClick,
              type: 'button'
            },
            this.props.backButtonCta
          ),
          _react2.default.createElement(
            'button',
            {
              className: 'pull-right btn btn-large btn-success saveButton',
              type: 'submit'
            },
            this.props.saveButtonCta
          )
        )
      );
    }
  }]);

  return StaticCreateAccountForm;
}(_react2.default.Component);

StaticCreateAccountForm.propTypes = {
  currentAction: _propTypes2.default.number,
  onBackClickOverride: _propTypes2.default.func,
  setErrorBoxState: _propTypes2.default.func,
  trackDropdownSelection: _propTypes2.default.bool,
  saveButtonCta: _propTypes2.default.string,
  backButtonCta: _propTypes2.default.string,
  postSubmitAction: _propTypes2.default.string,
  trackingId: _propTypes2.default.string,
  loadPreviousStaticBuilderSection: _propTypes2.default.func.isRequired
};

StaticCreateAccountForm.defaultProps = {
  currentAction: 0,
  setErrorBoxState: null,
  onBackClickOverride: null,
  trackDropdownSelection: true,
  saveButtonCta: 'Save & Create Account',
  backButtonCta: 'Back',
  postSubmitAction: 'redirect',
  trackingId: null
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadPreviousStaticBuilderSection: _StaticBuilderActions.loadPreviousStaticBuilderSection,
    loadStaticBuilderSection: _StaticBuilderActions.loadStaticBuilderSection
  }, dispatch);
};

var StaticCreateAccountFormWithRedux = ReactRedux.connect(null, mapDispatchToProps)(StaticCreateAccountForm);

exports.default = StaticCreateAccountFormWithRedux;

/***/ }),

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _W2HelpData = __webpack_require__(237);

var _W2HelpData2 = _interopRequireDefault(_W2HelpData);

var _Form1099MiscHelpData = __webpack_require__(235);

var _Form1099MiscHelpData2 = _interopRequireDefault(_Form1099MiscHelpData);

var _Form1099NecHelpData = __webpack_require__(236);

var _Form1099NecHelpData2 = _interopRequireDefault(_Form1099NecHelpData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpData = {
  w2: _W2HelpData2.default,
  form1099Misc: _Form1099MiscHelpData2.default,
  form1099Nec: _Form1099NecHelpData2.default
};

exports.default = HelpData;

/***/ }),

/***/ 280:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _HelpData = __webpack_require__(279);

var _HelpData2 = _interopRequireDefault(_HelpData);

var _List = __webpack_require__(281);

var _List2 = _interopRequireDefault(_List);

var _SearchInput = __webpack_require__(285);

var _SearchInput2 = _interopRequireDefault(_SearchInput);

var _Icons = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DOCUMENT_NAME_TO_DOCUMENT_TITLE = {
  w2: 'W-2',
  form1099Misc: '1099-MISC',
  form1099Nec: '1099-NEC'
};

var HelpSideBar = function (_React$Component) {
  _inherits(HelpSideBar, _React$Component);

  _createClass(HelpSideBar, null, [{
    key: 'filter',

    // Filter against key words as well as title
    value: function filter(item, event) {
      var inKeywords = item.keywords.filter(function (keyword) {
        return keyword.toLowerCase().search(event.target.value.toLowerCase()) !== -1;
      }).length > 0;
      var inTitle = item.title.toLowerCase().search(event.target.value.toLowerCase()) !== -1;
      return inKeywords || inTitle;
    }
  }, {
    key: 'calculateSidebarHeightOffset',
    value: function calculateSidebarHeightOffset() {
      var scrollOffset = window.scrollY;
      if (scrollOffset <= 60) {
        return 100.5 + (60 - scrollOffset);
      }
      return 100.5;
    }
  }]);

  function HelpSideBar(props) {
    _classCallCheck(this, HelpSideBar);

    var _this = _possibleConstructorReturn(this, (HelpSideBar.__proto__ || Object.getPrototypeOf(HelpSideBar)).call(this, props));

    _this.state = {
      initialItems: _HelpData2.default[props.documentName],
      items: _HelpData2.default[props.documentName],
      sidebarHeightOffset: 100.5
    };
    _this.filterList = _this.filterList.bind(_this);
    _this.hideSideBar = _this.hideSideBar.bind(_this);
    _this.toggleScroll = _this.toggleScroll.bind(_this);
    _this.setSidebarHeightOffset = _this.setSidebarHeightOffset.bind(_this);
    return _this;
  }

  _createClass(HelpSideBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.isNarrow) {
        window.addEventListener('scroll', this.setSidebarHeightOffset);
        this.setSidebarHeightOffset();
      }
    }
  }, {
    key: 'setSidebarHeightOffset',
    value: function setSidebarHeightOffset() {
      this.setState({
        sidebarHeightOffset: HelpSideBar.calculateSidebarHeightOffset()
      });
    }

    // Toggle scroll outside helpbar

  }, {
    key: 'toggleScroll',
    value: function toggleScroll() {
      if (this.props.showSideBar) {
        document.querySelector('#resumebuilder').style.overflow = 'hidden';
      } else {
        document.querySelector('#resumebuilder').style.overflow = 'auto';
      }
    }
  }, {
    key: 'filterList',
    value: function filterList(event) {
      var updatedList = this.state.initialItems;
      updatedList = updatedList.filter(function (item) {
        return HelpSideBar.filter(item, event);
      });
      this.setState({
        items: updatedList
      });
    }
  }, {
    key: 'hideSideBar',
    value: function hideSideBar() {
      this.props.toggleHelpSideBar();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          documentName = _props.documentName,
          isNarrow = _props.isNarrow,
          showSideBar = _props.showSideBar,
          updateBackgroundImage = _props.updateBackgroundImage;


      this.toggleScroll();
      var sidebarStateClass = (0, _classnames2.default)('help-side-bar', {
        'help-side-bar-show': showSideBar,
        'help-side-bar-hide': !showSideBar,
        'narrow-help-side-bar': isNarrow
      });

      var heightOffsetStyle = {
        height: 'calc(100% - ' + this.state.sidebarHeightOffset + 'px)'
      };
      var sidebarStyle = isNarrow && showSideBar ? heightOffsetStyle : {};
      return _react2.default.createElement(
        'div',
        {
          className: sidebarStateClass,
          style: sidebarStyle
        },
        _react2.default.createElement(_Icons.CloseIcon, {
          className: 'help-side-bar-close-icon',
          onClick: this.hideSideBar
        }),
        _react2.default.createElement(
          'div',
          { className: 'help-side-bar-input-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'help-document-title' },
            _react2.default.createElement(
              'h3',
              null,
              DOCUMENT_NAME_TO_DOCUMENT_TITLE[documentName],
              ' - Help'
            )
          ),
          _react2.default.createElement(
            _SearchInput2.default,
            {
              filterList: this.filterList,
              placeholder: isNarrow ? 'Search box number or keyword' : 'Search for a box number or keyword'
            },
            isNarrow && _react2.default.createElement(_Icons.SearchIcon, { className: 'help-side-bar-input-icon' })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'help-side-bar-list-wrapper' },
          _react2.default.createElement(_List2.default, {
            documentName: documentName,
            items: this.state.items,
            updateBackgroundImage: updateBackgroundImage
          })
        )
      );
    }
  }]);

  return HelpSideBar;
}(_react2.default.Component);

exports.default = HelpSideBar;


HelpSideBar.defaultProps = {
  isNarrow: false,
  showSideBar: false,
  toggleHelpSideBar: null,
  updateBackgroundImage: null
};

HelpSideBar.propTypes = {
  documentName: _propTypes2.default.string.isRequired,
  isNarrow: _propTypes2.default.bool,
  showSideBar: _propTypes2.default.bool,
  toggleHelpSideBar: _propTypes2.default.func,
  updateBackgroundImage: _propTypes2.default.func
};

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ListItemContent = __webpack_require__(282);

var _ListItemContent2 = _interopRequireDefault(_ListItemContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_React$Component) {
  _inherits(List, _React$Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _this.highlightBox = _this.highlightBox.bind(_this);
    _this.restoreForm = _this.restoreForm.bind(_this);

    _this.state = {
      highlightedBox: ''
    };
    return _this;
  }

  _createClass(List, [{
    key: 'highlightBox',
    value: function highlightBox(box) {
      if (this.props.shouldHighlight) {
        this.props.updateBackgroundImage(box);

        this.setState({
          highlightedBox: box
        });
      }
    }
  }, {
    key: 'restoreForm',
    value: function restoreForm() {
      if (this.props.shouldHighlight) {
        this.props.updateBackgroundImage('');

        this.setState({
          highlightedBox: ''
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          documentName = _props.documentName,
          items = _props.items,
          showThumbnail = _props.showThumbnail;

      return _react2.default.createElement(
        'ul',
        { className: 'help-side-bar-list' },
        items.map(function (item) {
          var thumbnailUrl = '/images/builder-static/' + documentName + '-highlighted-boxes/box-' + item.box + '.png';
          var thumbnail = documentName && showThumbnail ? thumbnailUrl : '';
          return _react2.default.createElement(
            'li',
            {
              key: 'item-' + item.title,
              onMouseEnter: function onMouseEnter() {
                return _this2.highlightBox(item.box);
              },
              onMouseLeave: _this2.restoreForm
            },
            _react2.default.createElement(_ListItemContent2.default, {
              box: item.box,
              details: item.details,
              isHighlighted: _this2.state.highlightedBox === item.box,
              thumbnail: thumbnail,
              title: item.title
            })
          );
        })
      );
    }
  }]);

  return List;
}(_react2.default.Component);

List.defaultProps = {
  documentName: '',
  items: [],
  shouldHighlight: false,
  showThumbnail: false,
  updateBackgroundImage: null
};

List.propTypes = {
  documentName: _propTypes2.default.string,
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    box: _propTypes2.default.string,
    details: _propTypes2.default.arrayOf(_propTypes2.default.string),
    keywords: _propTypes2.default.arrayOf(_propTypes2.default.string),
    title: _propTypes2.default.string
  })),
  shouldHighlight: _propTypes2.default.bool,
  showThumbnail: _propTypes2.default.bool,
  updateBackgroundImage: _propTypes2.default.func
};

exports.default = List;

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _ListItemContentTitle = __webpack_require__(284);

var _ListItemContentTitle2 = _interopRequireDefault(_ListItemContentTitle);

var _ListItemContentDetail = __webpack_require__(283);

var _ListItemContentDetail2 = _interopRequireDefault(_ListItemContentDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListItemContent = function ListItemContent(props) {
  var boxIdClass = (0, _classnames2.default)({
    highlight: props.isHighlighted
  });

  var box = props.box,
      details = props.details,
      thumbnail = props.thumbnail,
      title = props.title;


  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(_ListItemContentTitle2.default, {
      box: box,
      boxIdClass: boxIdClass,
      title: title
    }),
    _react2.default.createElement(
      'div',
      {
        className: 'help-side-bar-list-item help-side-bar-list-item-details',
        key: 'content-' + title
      },
      details.map(function (detail) {
        return _react2.default.createElement(_ListItemContentDetail2.default, { detail: detail });
      }),
      thumbnail && _react2.default.createElement('img', {
        alt: '',
        className: 'help-sidebar-thumbnail',
        src: thumbnail
      })
    )
  );
};

ListItemContent.defaultProps = {
  isHighlighted: false,
  thumbnail: ''
};

ListItemContent.propTypes = {
  box: _propTypes2.default.string.isRequired,
  details: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  isHighlighted: _propTypes2.default.bool,
  thumbnail: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired
};

exports.default = ListItemContent;

/***/ }),

/***/ 283:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListItemContentDetail = function ListItemContentDetail(props) {
  return _react2.default.createElement(
    'p',
    { key: 'detail-' + props.detail },
    props.detail
  );
};

ListItemContentDetail.propTypes = {
  detail: _propTypes2.default.string.isRequired
};

exports.default = ListItemContentDetail;

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ListItemContentTitle = function ListItemContentTitle(props) {
  var box = props.box,
      boxIdClass = props.boxIdClass,
      title = props.title;


  return _react2.default.createElement(
    'div',
    {
      className: 'help-side-bar-list-item help-side-bar-list-item-title',
      key: 'title-' + title
    },
    _react2.default.createElement(
      'span',
      { className: boxIdClass },
      box,
      '. '
    ),
    title
  );
};

ListItemContentTitle.defaultProps = {
  boxIdClass: ''
};

ListItemContentTitle.propTypes = {
  box: _propTypes2.default.string.isRequired,
  boxIdClass: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired
};

exports.default = ListItemContentTitle;

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchInput = function SearchInput(props) {
  var filterList = props.filterList,
      placeholder = props.placeholder;

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement('input', {
      type: 'text',
      placeholder: placeholder,
      onChange: filterList
    }),
    props.children
  );
};

SearchInput.defaultProps = {
  children: null
};

SearchInput.propTypes = {
  children: _propTypes2.default.node,
  filterList: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string.isRequired
};

exports.default = SearchInput;

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DownloadArrow = __webpack_require__(121);

var _DownloadArrow2 = _interopRequireDefault(_DownloadArrow);

var _DownloadOverlayConstants = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadArrows = function DownloadArrows(props) {
  var downloadArrows = [];
  for (var i = 0; i < props.numberOfDownloadArrows; i += 1) {
    var active = false;
    if (i === props.activeDownloadArrowIdx) {
      active = true;
    }
    downloadArrows.push(_react2.default.createElement(_DownloadArrow2.default, {
      key: i,
      active: active,
      downloadArrowDirection: props.downloadArrowDirection
    }));
  }

  return _react2.default.createElement(
    'div',
    { className: 'download-arrows' },
    downloadArrows
  );
};

DownloadArrows.propTypes = {
  activeDownloadArrowIdx: _propTypes2.default.number.isRequired,
  downloadArrowDirection: _propTypes2.default.oneOf([_DownloadOverlayConstants.DownloadArrowDirectionEnum.UP, _DownloadOverlayConstants.DownloadArrowDirectionEnum.RIGHT, _DownloadOverlayConstants.DownloadArrowDirectionEnum.DOWN, _DownloadOverlayConstants.DownloadArrowDirectionEnum.LEFT]).isRequired,
  numberOfDownloadArrows: _propTypes2.default.number.isRequired
};

exports.default = DownloadArrows;

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadOverlayCloseButton = function DownloadOverlayCloseButton(props) {
  var styles = {
    border: 'none',
    display: 'block',
    width: 50,
    height: 50
  };

  return _react2.default.createElement('button', { onClick: props.onClick, id: 'staticOverlayCloseButton', className: 'download-overlay-close-button', style: styles });
};

DownloadOverlayCloseButton.propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

exports.default = DownloadOverlayCloseButton;

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DownloadOverlayConstants = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DownloadOverlayText = function DownloadOverlayText(props) {
  var text = '';

  switch (props.browserType) {
    case _DownloadOverlayConstants.SupportedBrowserEnum.FIREFOX:
      text = 'Click the blue arrow for your downloaded document.';
      break;
    case _DownloadOverlayConstants.SupportedBrowserEnum.MSIE:
    default:
      // currently we don't show any download overlay text for remaining browsers
      break;
  }

  var styles = {
    color: '#fff',
    fontSize: 25,
    lineHeight: '25px',
    textAlign: 'center'
  };

  return _react2.default.createElement(
    'p',
    { className: 'download-overlay-text', style: styles },
    text
  );
};

DownloadOverlayText.propTypes = {
  browserType: _propTypes2.default.oneOf([_DownloadOverlayConstants.SupportedBrowserEnum.FIREFOX, _DownloadOverlayConstants.SupportedBrowserEnum.MSIE]).isRequired
};

exports.default = DownloadOverlayText;

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DownloadArrow = __webpack_require__(121);

Object.defineProperty(exports, 'DownloadArrow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DownloadArrow).default;
  }
});

var _DownloadArrows = __webpack_require__(286);

Object.defineProperty(exports, 'DownloadArrows', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DownloadArrows).default;
  }
});

var _DownloadOverlayCloseButton = __webpack_require__(287);

Object.defineProperty(exports, 'DownloadOverlayCloseButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DownloadOverlayCloseButton).default;
  }
});

var _DownloadOverlayText = __webpack_require__(288);

Object.defineProperty(exports, 'DownloadOverlayText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DownloadOverlayText).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = __webpack_require__(289);

var _DownloadOverlayConstants = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var bowser = __webpack_require__(122);

var DownloadOverlay = function (_React$Component) {
  _inherits(DownloadOverlay, _React$Component);

  _createClass(DownloadOverlay, null, [{
    key: 'getBrowserType',
    value: function getBrowserType() {
      if (bowser.firefox) {
        return _DownloadOverlayConstants.SupportedBrowserEnum.FIREFOX;
      }
      if (bowser.msie) {
        return _DownloadOverlayConstants.SupportedBrowserEnum.MSIE;
      }
      return null;
    }
  }, {
    key: 'isSupportedBrowser',
    value: function isSupportedBrowser(browserType) {
      return browserType === _DownloadOverlayConstants.SupportedBrowserEnum.FIREFOX || browserType === _DownloadOverlayConstants.SupportedBrowserEnum.MSIE;
    }
  }]);

  function DownloadOverlay(props) {
    _classCallCheck(this, DownloadOverlay);

    var _this = _possibleConstructorReturn(this, (DownloadOverlay.__proto__ || Object.getPrototypeOf(DownloadOverlay)).call(this, props));

    _this.onHide = _this.onHide.bind(_this);
    var downloadArrowDirection = void 0;

    var browserType = _this.props.browserType;
    if (!browserType) {
      browserType = DownloadOverlay.getBrowserType();
    }

    switch (browserType) {
      case _DownloadOverlayConstants.SupportedBrowserEnum.FIREFOX:
        downloadArrowDirection = _DownloadOverlayConstants.DownloadArrowDirectionEnum.UP;
        break;
      case _DownloadOverlayConstants.SupportedBrowserEnum.MSIE:
        downloadArrowDirection = _DownloadOverlayConstants.DownloadArrowDirectionEnum.DOWN;
        break;
      default:
        // currently we don't show any download overlay for remaining browsers
        break;
    }

    _this.state = {
      show: _this.props.show,
      activeDownloadArrowIdx: 0,
      numberOfDownloadArrows: _this.props.numberOfDownloadArrows,
      downloadArrowDirection: downloadArrowDirection,
      browserType: browserType
    };
    return _this;
  }

  _createClass(DownloadOverlay, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.interval = setInterval(function () {
        return _this2.tick();
      }, 1000);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.state.show = nextProps.show;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
  }, {
    key: 'onHide',
    value: function onHide() {
      return this.props.hideDownloadOverlay();
    }
  }, {
    key: 'tick',
    value: function tick() {
      var _this3 = this;

      this.setState(function () {
        var activeIdx = void 0;
        if (_this3.state.downloadArrowDirection === _DownloadOverlayConstants.DownloadArrowDirectionEnum.DOWN || _this3.state.downloadArrowDirection === _DownloadOverlayConstants.DownloadArrowDirectionEnum.RIGHT) {
          activeIdx = _this3.state.activeDownloadArrowIdx + 1;
        }
        if (_this3.state.downloadArrowDirection === _DownloadOverlayConstants.DownloadArrowDirectionEnum.UP || _this3.state.downloadArrowDirection === _DownloadOverlayConstants.DownloadArrowDirectionEnum.LEFT) {
          activeIdx = _this3.state.numberOfDownloadArrows + (_this3.state.activeDownloadArrowIdx - 1);
        }
        return {
          activeDownloadArrowIdx: Math.abs(activeIdx % _this3.state.numberOfDownloadArrows)
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var browserType = this.state.browserType;
      if (!this.state.show || !DownloadOverlay.isSupportedBrowser(browserType)) {
        return null;
      }
      var styles = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        zIndex: 9999,
        color: 'white',
        display: 'block'
      };

      var closeButtonStyle = {
        position: 'absolute'
      };
      var downloadArrowsStyle = {
        position: 'absolute'
      };

      var textStyle = {
        position: 'absolute',
        width: 200
      };

      switch (browserType) {
        case _DownloadOverlayConstants.SupportedBrowserEnum.FIREFOX:
          closeButtonStyle.top = 10;
          closeButtonStyle.right = 20;
          downloadArrowsStyle.top = 10;
          downloadArrowsStyle.right = 116;
          textStyle.top = 80;
          textStyle.right = 30;
          break;
        case _DownloadOverlayConstants.SupportedBrowserEnum.MSIE:
          closeButtonStyle.bottom = 170;
          closeButtonStyle.right = 150;
          downloadArrowsStyle.bottom = 70;
          downloadArrowsStyle.right = 400;
          textStyle.bottom = 140;
          textStyle.right = 200;
          textStyle.width = 400;
          break;
        default:
          // currently we don't show any download overlay for remaining browsers
          break;
      }

      var overlayButtonStyles = {
        width: '100%',
        height: '100%',
        backgroundColor: 'Transparent',
        border: 'none',
        cursor: 'default',
        outline: 'none'
      };

      return _react2.default.createElement(
        'div',
        { className: 'download-overlay', style: styles },
        _react2.default.createElement('button', { style: overlayButtonStyles, onClick: this.onHide }),
        _react2.default.createElement(
          'div',
          { style: closeButtonStyle },
          _react2.default.createElement(_components.DownloadOverlayCloseButton, {
            onClick: this.onHide
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'download-overlay-text-container', style: textStyle },
          _react2.default.createElement(_components.DownloadOverlayText, { browserType: browserType })
        ),
        _react2.default.createElement(
          'div',
          { style: downloadArrowsStyle },
          _react2.default.createElement(_components.DownloadArrows, {
            activeDownloadArrowIdx: this.state.activeDownloadArrowIdx,
            numberOfDownloadArrows: this.state.numberOfDownloadArrows,
            downloadArrowDirection: this.state.downloadArrowDirection
          })
        )
      );
    }
  }]);

  return DownloadOverlay;
}(_react2.default.Component);

DownloadOverlay.propTypes = {
  show: _propTypes2.default.bool,
  hideDownloadOverlay: _propTypes2.default.func.isRequired,
  numberOfDownloadArrows: _propTypes2.default.number,
  browserType: _propTypes2.default.oneOf([_DownloadOverlayConstants.SupportedBrowserEnum.FIREFOX, _DownloadOverlayConstants.SupportedBrowserEnum.MSIE, _DownloadOverlayConstants.SupportedBrowserEnum.MSEDGE])
};

DownloadOverlay.defaultProps = {
  show: false,
  numberOfDownloadArrows: 3,
  browserType: null
};

exports.default = DownloadOverlay;

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getUserLocale = exports.getUserLocales = void 0;

var _lodash = _interopRequireDefault(__webpack_require__(297));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var filterDuplicates = function filterDuplicates(arr) {
  return arr.filter(function (el, index, self) {
    return self.indexOf(el) === index;
  });
};

var fixLowercaseProperties = function fixLowercaseProperties(arr) {
  return arr.map(function (el) {
    if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) {
      return el;
    }

    var splitEl = el.split('-');
    return "".concat(splitEl[0], "-").concat(splitEl[1].toUpperCase());
  });
};

var getUserLocales = (0, _lodash.default)(function () {
  var languageList = [];

  if (typeof window !== 'undefined') {
    if (window.navigator.languages) {
      languageList.push.apply(languageList, _toConsumableArray(window.navigator.languages));
    }

    if (window.navigator.language) {
      languageList.push(window.navigator.language);
    }

    if (window.navigator.userLanguage) {
      languageList.push(window.navigator.userLanguage);
    }

    if (window.navigator.browserLanguage) {
      languageList.push(window.navigator.browserLanguage);
    }

    if (window.navigator.systemLanguage) {
      languageList.push(window.navigator.systemLanguage);
    }
  }

  languageList.push('en-US'); // Fallback

  return fixLowercaseProperties(filterDuplicates(languageList));
});
exports.getUserLocales = getUserLocales;
var getUserLocale = (0, _lodash.default)(function () {
  return getUserLocales()[0];
});
exports.getUserLocale = getUserLocale;
var _default = getUserLocale;
exports.default = _default;

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = once;


/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactLifecyclesCompat = __webpack_require__(337);

var _mergeClassNames = __webpack_require__(125);

var _mergeClassNames2 = _interopRequireDefault(_mergeClassNames);

var _Navigation = __webpack_require__(300);

var _Navigation2 = _interopRequireDefault(_Navigation);

var _CenturyView = __webpack_require__(127);

var _CenturyView2 = _interopRequireDefault(_CenturyView);

var _DecadeView = __webpack_require__(128);

var _DecadeView2 = _interopRequireDefault(_DecadeView);

var _YearView = __webpack_require__(130);

var _YearView2 = _interopRequireDefault(_YearView);

var _MonthView = __webpack_require__(129);

var _MonthView2 = _interopRequireDefault(_MonthView);

var _dates = __webpack_require__(15);

var _propTypes3 = __webpack_require__(9);

var _utils = __webpack_require__(131);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var allViews = ['century', 'decade', 'year', 'month'];
var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);

var datesAreDifferent = function datesAreDifferent(date1, date2) {
  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
};

/**
 * Returns views array with disallowed values cut off.
 */
var getLimitedViews = function getLimitedViews(minDetail, maxDetail) {
  return allViews.slice(allViews.indexOf(minDetail), allViews.indexOf(maxDetail) + 1);
};

var getView = function getView(view, minDetail, maxDetail) {
  if (view && getLimitedViews(minDetail, maxDetail).indexOf(view) !== -1) {
    return view;
  }

  return getLimitedViews(minDetail, maxDetail).pop();
};

/**
 * Determines whether a given view is allowed with currently applied settings.
 */
var isViewAllowed = function isViewAllowed(view, minDetail, maxDetail) {
  var views = getLimitedViews(minDetail, maxDetail);

  return views.indexOf(view) !== -1;
};

/**
 * Returns value type that can be returned with currently applied settings.
 */
var getValueType = function getValueType(maxDetail) {
  return allValueTypes[allViews.indexOf(maxDetail)];
};

var getValueFrom = function getValueFrom(value) {
  if (!value) {
    return null;
  }

  var rawValueFrom = value instanceof Array && value.length === 2 ? value[0] : value;

  if (!rawValueFrom) {
    return null;
  }

  var valueFromDate = new Date(rawValueFrom);

  if (isNaN(valueFromDate.getTime())) {
    throw new Error('Invalid date: ' + value);
  }

  return valueFromDate;
};

var getDetailValueFrom = function getDetailValueFrom(value, minDate, maxDate, maxDetail) {
  var valueFrom = getValueFrom(value);

  if (!valueFrom) {
    return null;
  }

  var detailValueFrom = (0, _dates.getBegin)(getValueType(maxDetail), valueFrom);

  return (0, _utils.between)(detailValueFrom, minDate, maxDate);
};

var getValueTo = function getValueTo(value) {
  if (!value) {
    return null;
  }

  var rawValueTo = value instanceof Array && value.length === 2 ? value[1] : value;

  if (!rawValueTo) {
    return null;
  }

  var valueToDate = new Date(rawValueTo);

  if (isNaN(valueToDate.getTime())) {
    throw new Error('Invalid date: ' + value);
  }

  return valueToDate;
};

var getDetailValueTo = function getDetailValueTo(value, minDate, maxDate, maxDetail) {
  var valueTo = getValueTo(value);

  if (!valueTo) {
    return null;
  }

  var detailValueTo = (0, _dates.getEnd)(getValueType(maxDetail), valueTo);

  return (0, _utils.between)(detailValueTo, minDate, maxDate);
};

var getDetailValueArray = function getDetailValueArray(value, minDate, maxDate, maxDetail) {
  if (value instanceof Array) {
    return value;
  }

  return [getDetailValueFrom(value, minDate, maxDate, maxDetail), getDetailValueTo(value, minDate, maxDate, maxDetail)];
};

var getActiveStartDate = function getActiveStartDate(props) {
  var activeStartDate = props.activeStartDate,
      maxDate = props.maxDate,
      maxDetail = props.maxDetail,
      minDate = props.minDate,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view;


  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = getDetailValueFrom(value, minDate, maxDate, maxDetail) || activeStartDate || new Date();
  return (0, _dates.getBegin)(rangeType, valueFrom);
};

var Calendar = function (_Component) {
  _inherits(Calendar, _Component);

  function Calendar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.setActiveStartDate = function (activeStartDate) {
      var onActiveDateChange = _this.props.onActiveDateChange;


      _this.setState({ activeStartDate: activeStartDate }, function () {
        var view = _this.state.view;


        (0, _utils.callIfDefined)(onActiveDateChange, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    }, _this.drillDown = function (activeStartDate) {
      if (!_this.drillDownAvailable) {
        return;
      }

      var _this$props = _this.props,
          maxDetail = _this$props.maxDetail,
          minDetail = _this$props.minDetail,
          onDrillDown = _this$props.onDrillDown;


      var views = getLimitedViews(minDetail, maxDetail);

      _this.setState(function (prevState) {
        var nextView = views[views.indexOf(prevState.view) + 1];
        return {
          activeStartDate: activeStartDate,
          view: nextView
        };
      }, function () {
        var view = _this.state.view;


        (0, _utils.callIfDefined)(onDrillDown, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    }, _this.drillUp = function () {
      if (!_this.drillUpAvailable) {
        return;
      }

      var _this$props2 = _this.props,
          maxDetail = _this$props2.maxDetail,
          minDetail = _this$props2.minDetail,
          onDrillUp = _this$props2.onDrillUp;


      var views = getLimitedViews(minDetail, maxDetail);

      _this.setState(function (prevState) {
        var nextView = views[views.indexOf(prevState.view) - 1];
        var activeStartDate = (0, _dates.getBegin)(nextView, prevState.activeStartDate);

        return {
          activeStartDate: activeStartDate,
          view: nextView
        };
      }, function () {
        var _this$state = _this.state,
            activeStartDate = _this$state.activeStartDate,
            view = _this$state.view;


        (0, _utils.callIfDefined)(onDrillUp, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    }, _this.onChange = function (value) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          selectRange = _this$props3.selectRange;


      var nextValue = void 0;
      var callback = void 0;
      if (selectRange) {
        var previousValue = _this.state.value;
        // Range selection turned on

        if (!previousValue || [].concat(previousValue).length !== 1 // 0 or 2 - either way we're starting a new array
        ) {
            // First value
            nextValue = (0, _dates.getBegin)(_this.valueType, value);
          } else {
          // Second value
          nextValue = (0, _dates.getValueRange)(_this.valueType, previousValue, value);
          callback = function callback() {
            return (0, _utils.callIfDefined)(onChange, nextValue);
          };
        }
      } else {
        // Range selection turned off
        nextValue = _this.getProcessedValue(value);
        callback = function callback() {
          return (0, _utils.callIfDefined)(onChange, nextValue);
        };
      }

      _this.setState({ value: nextValue }, callback);
    }, _this.onMouseOver = function (value) {
      _this.setState({ hover: value });
    }, _this.onMouseOut = function () {
      _this.setState({ hover: null });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Calendar, [{
    key: 'getProcessedValue',


    /**
     * Gets current value in a desired format.
     */
    value: function getProcessedValue(value) {
      var _props = this.props,
          minDate = _props.minDate,
          maxDate = _props.maxDate,
          maxDetail = _props.maxDetail,
          returnValue = _props.returnValue;


      switch (returnValue) {
        case 'start':
          return getDetailValueFrom(value, minDate, maxDate, maxDetail);
        case 'end':
          return getDetailValueTo(value, minDate, maxDate, maxDetail);
        case 'range':
          return getDetailValueArray(value, minDate, maxDate, maxDetail);
        default:
          throw new Error('Invalid returnValue.');
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _props2 = this.props,
          calendarType = _props2.calendarType,
          locale = _props2.locale,
          maxDate = _props2.maxDate,
          minDate = _props2.minDate,
          renderChildren = _props2.renderChildren,
          selectRange = _props2.selectRange,
          tileClassName = _props2.tileClassName,
          tileContent = _props2.tileContent,
          tileDisabled = _props2.tileDisabled;
      var _state = this.state,
          activeStartDate = _state.activeStartDate,
          hover = _state.hover,
          value = _state.value,
          view = _state.view;
      var onMouseOver = this.onMouseOver,
          valueType = this.valueType;


      var commonProps = {
        activeStartDate: activeStartDate,
        hover: hover,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        onMouseOver: selectRange ? onMouseOver : null,
        tileClassName: tileClassName,
        tileContent: tileContent || renderChildren, // For backwards compatibility
        tileDisabled: tileDisabled,
        value: value,
        valueType: valueType
      };

      var clickAction = this.drillDownAvailable ? this.drillDown : this.onChange;

      switch (view) {
        case 'century':
          {
            var onClickDecade = this.props.onClickDecade;


            return _react2.default.createElement(_CenturyView2.default, _extends({
              onClick: (0, _utils.mergeFunctions)(clickAction, onClickDecade)
            }, commonProps));
          }
        case 'decade':
          {
            var onClickYear = this.props.onClickYear;


            return _react2.default.createElement(_DecadeView2.default, _extends({
              onClick: (0, _utils.mergeFunctions)(clickAction, onClickYear)
            }, commonProps));
          }
        case 'year':
          {
            var _props3 = this.props,
                formatMonth = _props3.formatMonth,
                onClickMonth = _props3.onClickMonth;


            return _react2.default.createElement(_YearView2.default, _extends({
              formatMonth: formatMonth,
              onClick: (0, _utils.mergeFunctions)(clickAction, onClickMonth)
            }, commonProps));
          }
        case 'month':
          {
            var _props4 = this.props,
                formatShortWeekday = _props4.formatShortWeekday,
                onClickDay = _props4.onClickDay,
                onClickWeekNumber = _props4.onClickWeekNumber,
                showFixedNumberOfWeeks = _props4.showFixedNumberOfWeeks,
                showNeighboringMonth = _props4.showNeighboringMonth,
                showWeekNumbers = _props4.showWeekNumbers;


            return _react2.default.createElement(_MonthView2.default, _extends({
              calendarType: calendarType,
              formatShortWeekday: formatShortWeekday,
              onClick: (0, _utils.mergeFunctions)(clickAction, onClickDay),
              onClickWeekNumber: onClickWeekNumber,
              showFixedNumberOfWeeks: showFixedNumberOfWeeks,
              showNeighboringMonth: showNeighboringMonth,
              showWeekNumbers: showWeekNumbers
            }, commonProps));
          }
        default:
          throw new Error('Invalid view: ' + view + '.');
      }
    }
  }, {
    key: 'renderNavigation',
    value: function renderNavigation() {
      var showNavigation = this.props.showNavigation;


      if (!showNavigation) {
        return null;
      }

      var _props5 = this.props,
          formatMonthYear = _props5.formatMonthYear,
          locale = _props5.locale,
          maxDate = _props5.maxDate,
          maxDetail = _props5.maxDetail,
          minDate = _props5.minDate,
          minDetail = _props5.minDetail,
          next2Label = _props5.next2Label,
          nextLabel = _props5.nextLabel,
          navigationLabel = _props5.navigationLabel,
          prev2Label = _props5.prev2Label,
          prevLabel = _props5.prevLabel;
      var _state2 = this.state,
          activeRange = _state2.activeRange,
          activeStartDate = _state2.activeStartDate,
          view = _state2.view;


      return _react2.default.createElement(_Navigation2.default, {
        activeRange: activeRange,
        activeStartDate: activeStartDate,
        drillUp: this.drillUp,
        formatMonthYear: formatMonthYear,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        next2Label: next2Label,
        nextLabel: nextLabel,
        navigationLabel: navigationLabel,
        prev2Label: prev2Label,
        prevLabel: prevLabel,
        setActiveStartDate: this.setActiveStartDate,
        view: view,
        views: getLimitedViews(minDetail, maxDetail)
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          className = _props6.className,
          selectRange = _props6.selectRange;
      var value = this.state.value;
      var onMouseOut = this.onMouseOut;

      var valueArray = [].concat(value);

      return _react2.default.createElement(
        'div',
        {
          className: (0, _mergeClassNames2.default)('react-calendar', selectRange && valueArray.length === 1 && 'react-calendar--selectRange', className),
          onMouseOut: selectRange ? onMouseOut : null,
          onBlur: selectRange ? onMouseOut : null
        },
        this.renderNavigation(),
        this.renderContent()
      );
    }
  }, {
    key: 'drillDownAvailable',
    get: function get() {
      var _props7 = this.props,
          maxDetail = _props7.maxDetail,
          minDetail = _props7.minDetail;
      var view = this.state.view;


      var views = getLimitedViews(minDetail, maxDetail);

      return views.indexOf(view) < views.length - 1;
    }
  }, {
    key: 'drillUpAvailable',
    get: function get() {
      var _props8 = this.props,
          maxDetail = _props8.maxDetail,
          minDetail = _props8.minDetail;
      var view = this.state.view;


      var views = getLimitedViews(minDetail, maxDetail);

      return views.indexOf(view) > 0;
    }
  }, {
    key: 'valueType',
    get: function get() {
      var maxDetail = this.props.maxDetail;


      return getValueType(maxDetail);
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var minDate = nextProps.minDate,
          maxDate = nextProps.maxDate,
          minDetail = nextProps.minDetail,
          maxDetail = nextProps.maxDetail;


      var nextState = {};

      /**
       * If the next activeStartDate is different from the current one, update
       * activeStartDate (for display) and activeStartDateProps (for future comparisons)
       */
      var nextActiveStartDate = getActiveStartDate(nextProps);
      if (datesAreDifferent(nextActiveStartDate, prevState.activeStartDateProps)) {
        nextState.activeStartDate = nextActiveStartDate;
        nextState.activeStartDateProps = nextActiveStartDate;
      }

      /**
       * If the next view is different from the current one, and the previously set view is not
       * valid based on minDetail and maxDetail, get a new one.
       */
      var nextView = getView(nextProps.view, minDetail, maxDetail);
      if (nextView !== prevState.viewProps && !isViewAllowed(prevState.view, minDetail, maxDetail)) {
        nextState.view = nextView;
        nextState.viewProps = nextView;
      }

      /**
       * If the next value is different from the current one (with an exception of situation in
       * which values provided are limited by minDate and maxDate so that the dates are the same),
       * get a new one.
       */
      var values = [nextProps.value, prevState.valueProps];
      if (nextState.view // Allowed view changed
      || datesAreDifferent.apply(undefined, _toConsumableArray(values.map(function (value) {
        return getValueFrom(value, minDate, maxDate, maxDetail);
      }))) || datesAreDifferent.apply(undefined, _toConsumableArray(values.map(function (value) {
        return getValueTo(value, minDate, maxDate, maxDetail);
      })))) {
        nextState.value = nextProps.value;
        nextState.valueProps = nextProps.value;
      }

      if (!nextProps.selectRange && prevState.hover) {
        nextState.hover = null;
      }

      return nextState;
    }

    /**
     * Called when the user uses navigation buttons.
     */

  }]);

  return Calendar;
}(_react.Component);

exports.default = Calendar;


Calendar.defaultProps = {
  maxDetail: 'month',
  minDetail: 'century',
  returnValue: 'start',
  showNavigation: true,
  showNeighboringMonth: true,
  view: 'month'
};

Calendar.propTypes = {
  activeStartDate: _propTypes2.default.instanceOf(Date),
  calendarType: _propTypes3.isCalendarType,
  className: _propTypes3.isClassName,
  formatMonth: _propTypes2.default.func,
  formatMonthYear: _propTypes2.default.func,
  formatShortWeekday: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  maxDate: _propTypes3.isMaxDate,
  maxDetail: _propTypes2.default.oneOf(allViews),
  minDate: _propTypes3.isMinDate,
  minDetail: _propTypes2.default.oneOf(allViews),
  navigationLabel: _propTypes2.default.func,
  next2Label: _propTypes2.default.node,
  nextLabel: _propTypes2.default.node,
  onActiveDateChange: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onClickDay: _propTypes2.default.func,
  onClickDecade: _propTypes2.default.func,
  onClickMonth: _propTypes2.default.func,
  onClickWeekNumber: _propTypes2.default.func,
  onClickYear: _propTypes2.default.func,
  onDrillDown: _propTypes2.default.func,
  onDrillUp: _propTypes2.default.func,
  prev2Label: _propTypes2.default.node,
  prevLabel: _propTypes2.default.node,
  renderChildren: _propTypes2.default.func, // For backwards compatibility
  returnValue: _propTypes2.default.oneOf(['start', 'end', 'range']),
  selectRange: _propTypes2.default.bool,
  showFixedNumberOfWeeks: _propTypes2.default.bool,
  showNavigation: _propTypes2.default.bool,
  showNeighboringMonth: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,
  tileClassName: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes3.isClassName]),
  tileContent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  tileDisabled: _propTypes2.default.func,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes3.isValue]),
  view: _propTypes2.default.oneOf(allViews)
};

(0, _reactLifecyclesCompat.polyfill)(Calendar);

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dates = __webpack_require__(15);

var _dateFormatter = __webpack_require__(80);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navigation = function (_Component) {
  _inherits(Navigation, _Component);

  function Navigation() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Navigation);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navigation.__proto__ || Object.getPrototypeOf(Navigation)).call.apply(_ref, [this].concat(args))), _this), _this.onClickPrevious = function () {
      var _this$props = _this.props,
          date = _this$props.activeStartDate,
          view = _this$props.view,
          setActiveStartDate = _this$props.setActiveStartDate;

      setActiveStartDate((0, _dates.getBeginPrevious)(view, date));
    }, _this.onClickNext = function () {
      var _this$props2 = _this.props,
          date = _this$props2.activeStartDate,
          view = _this$props2.view,
          setActiveStartDate = _this$props2.setActiveStartDate;

      setActiveStartDate((0, _dates.getBeginNext)(view, date));
    }, _this.onClickPrevious2 = function () {
      var _this$props3 = _this.props,
          date = _this$props3.activeStartDate,
          view = _this$props3.view,
          setActiveStartDate = _this$props3.setActiveStartDate;

      setActiveStartDate((0, _dates.getBeginPrevious2)(view, date));
    }, _this.onClickNext2 = function () {
      var _this$props4 = _this.props,
          date = _this$props4.activeStartDate,
          view = _this$props4.view,
          setActiveStartDate = _this$props4.setActiveStartDate;

      setActiveStartDate((0, _dates.getBeginNext2)(view, date));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navigation, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _props = this.props,
          activeStartDate = _props.activeStartDate,
          locale = _props.locale,
          view = _props.view;


      return nextProps.activeStartDate !== activeStartDate || nextProps.locale !== locale || nextProps.view !== view;
    }
  }, {
    key: 'render',
    value: function render() {
      var label = this.label;
      var _props2 = this.props,
          date = _props2.activeStartDate,
          drillUp = _props2.drillUp,
          navigationLabel = _props2.navigationLabel,
          next2Label = _props2.next2Label,
          nextLabel = _props2.nextLabel,
          prev2Label = _props2.prev2Label,
          prevLabel = _props2.prevLabel,
          view = _props2.view;


      var className = 'react-calendar__navigation';

      return _react2.default.createElement(
        'div',
        {
          className: className,
          style: { display: 'flex' }
        },
        prev2Label !== null && view !== 'century' && _react2.default.createElement(
          'button',
          {
            className: className + '__arrow ' + className + '__prev2-button',
            disabled: this.prev2ButtonDisabled,
            onClick: this.onClickPrevious2,
            type: 'button'
          },
          prev2Label
        ),
        _react2.default.createElement(
          'button',
          {
            className: className + '__arrow ' + className + '__prev-button',
            disabled: this.prevButtonDisabled,
            onClick: this.onClickPrevious,
            type: 'button'
          },
          prevLabel
        ),
        _react2.default.createElement(
          'button',
          {
            className: 'react-calendar__navigation__label',
            onClick: drillUp,
            disabled: !this.drillUpAvailable,
            style: { flexGrow: 1 },
            type: 'button'
          },
          navigationLabel ? navigationLabel({ date: date, view: view, label: label }) : label
        ),
        _react2.default.createElement(
          'button',
          {
            className: className + '__arrow ' + className + '__next-button',
            disabled: this.nextButtonDisabled,
            onClick: this.onClickNext,
            type: 'button'
          },
          nextLabel
        ),
        next2Label !== null && view !== 'century' && _react2.default.createElement(
          'button',
          {
            className: className + '__arrow ' + className + '__next2-button',
            disabled: this.next2ButtonDisabled,
            onClick: this.onClickNext2,
            type: 'button'
          },
          next2Label
        )
      );
    }
  }, {
    key: 'drillUpAvailable',
    get: function get() {
      var _props3 = this.props,
          view = _props3.view,
          views = _props3.views;

      return views.indexOf(view) > 0;
    }
  }, {
    key: 'prevButtonDisabled',
    get: function get() {
      var _props4 = this.props,
          date = _props4.activeStartDate,
          minDate = _props4.minDate,
          view = _props4.view;

      var previousActiveStartDate = (0, _dates.getBeginPrevious)(view, date);
      if (previousActiveStartDate.getFullYear() < 1000) {
        return true;
      }
      var previousActiveEndDate = (0, _dates.getEndPrevious)(view, date);
      return minDate && minDate >= previousActiveEndDate;
    }
  }, {
    key: 'prev2ButtonDisabled',
    get: function get() {
      var _props5 = this.props,
          date = _props5.activeStartDate,
          minDate = _props5.minDate,
          view = _props5.view;

      var previousActiveStartDate = (0, _dates.getBeginPrevious2)(view, date);
      if (previousActiveStartDate.getFullYear() < 1000) {
        return true;
      }
      var previousActiveEndDate = (0, _dates.getEndPrevious2)(view, date);
      return minDate && minDate >= previousActiveEndDate;
    }
  }, {
    key: 'nextButtonDisabled',
    get: function get() {
      var _props6 = this.props,
          date = _props6.activeStartDate,
          maxDate = _props6.maxDate,
          view = _props6.view;

      var nextActiveStartDate = (0, _dates.getBeginNext)(view, date);
      return maxDate && maxDate <= nextActiveStartDate;
    }
  }, {
    key: 'next2ButtonDisabled',
    get: function get() {
      var _props7 = this.props,
          date = _props7.activeStartDate,
          maxDate = _props7.maxDate,
          view = _props7.view;

      var nextActiveStartDate = (0, _dates.getBeginNext2)(view, date);
      return maxDate && maxDate <= nextActiveStartDate;
    }
  }, {
    key: 'label',
    get: function get() {
      var _props8 = this.props,
          date = _props8.activeStartDate,
          formatMonthYear = _props8.formatMonthYear,
          locale = _props8.locale,
          view = _props8.view;


      switch (view) {
        case 'century':
          return (0, _dates.getCenturyLabel)(date);
        case 'decade':
          return (0, _dates.getDecadeLabel)(date);
        case 'year':
          return (0, _dates.getYear)(date);
        case 'month':
          return formatMonthYear(date, locale);
        default:
          throw new Error('Invalid view: ' + view + '.');
      }
    }
  }]);

  return Navigation;
}(_react.Component);

exports.default = Navigation;


Navigation.defaultProps = {
  formatMonthYear: _dateFormatter.formatMonthYear,
  next2Label: '»',
  nextLabel: '›',
  prev2Label: '«',
  prevLabel: '‹'
};

Navigation.propTypes = {
  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
  drillUp: _propTypes2.default.func.isRequired,
  formatMonthYear: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  maxDate: _propTypes2.default.instanceOf(Date),
  minDate: _propTypes2.default.instanceOf(Date),
  next2Label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  nextLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  navigationLabel: _propTypes2.default.func,
  prev2Label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  prevLabel: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  setActiveStartDate: _propTypes2.default.func.isRequired,
  view: _propTypes3.isView.isRequired,
  views: _propTypes3.isViews.isRequired
};

/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tile = __webpack_require__(60);

var _Tile2 = _interopRequireDefault(_Tile);

var _dates = __webpack_require__(15);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var className = 'react-calendar__century-view__decades__decade';

var Decade = function Decade(_ref) {
  var classes = _ref.classes,
      point = _ref.point,
      otherProps = _objectWithoutProperties(_ref, ['classes', 'point']);

  return _react2.default.createElement(
    _Tile2.default,
    _extends({}, otherProps, {
      classes: [].concat(_toConsumableArray(classes), [className]),
      dateTime: point + 'T00:00:00.000',
      maxDateTransform: _dates.getEndOfDecade,
      minDateTransform: _dates.getBeginOfDecade,
      view: 'century'
    }),
    (0, _dates.getDecadeLabel)(point)
  );
};

Decade.propTypes = _extends({
  point: _propTypes2.default.number.isRequired
}, _propTypes3.tileProps);

exports.default = Decade;

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TileGroup = __webpack_require__(61);

var _TileGroup2 = _interopRequireDefault(_TileGroup);

var _Decade = __webpack_require__(301);

var _Decade2 = _interopRequireDefault(_Decade);

var _dates = __webpack_require__(15);

var _propTypes = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Decades = function (_PureComponent) {
  _inherits(Decades, _PureComponent);

  function Decades() {
    _classCallCheck(this, Decades);

    return _possibleConstructorReturn(this, (Decades.__proto__ || Object.getPrototypeOf(Decades)).apply(this, arguments));
  }

  _createClass(Decades, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_TileGroup2.default, _extends({}, this.props, {
        className: 'react-calendar__century-view__decades',
        dateTransform: _dates.getBeginOfDecade,
        dateType: 'decade',
        end: this.end,
        start: this.start,
        step: 10,
        tile: _Decade2.default
      }));
    }
  }, {
    key: 'start',
    get: function get() {
      var activeStartDate = this.props.activeStartDate;

      return (0, _dates.getBeginOfCenturyYear)(activeStartDate);
    }
  }, {
    key: 'end',
    get: function get() {
      return this.start + 99;
    }
  }]);

  return Decades;
}(_react.PureComponent);

exports.default = Decades;


Decades.propTypes = _extends({}, _propTypes.tileGroupProps);

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tile = __webpack_require__(60);

var _Tile2 = _interopRequireDefault(_Tile);

var _dates = __webpack_require__(15);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var className = 'react-calendar__decade-view__years__year';

var Year = function Year(_ref) {
  var classes = _ref.classes,
      point = _ref.point,
      otherProps = _objectWithoutProperties(_ref, ['classes', 'point']);

  return _react2.default.createElement(
    _Tile2.default,
    _extends({}, otherProps, {
      classes: [].concat(_toConsumableArray(classes), [className]),
      dateTime: point + 'T00:00:00.000',
      maxDateTransform: _dates.getEndOfYear,
      minDateTransform: _dates.getBeginOfYear,
      view: 'decade'
    }),
    point
  );
};

Year.propTypes = _extends({
  point: _propTypes2.default.number.isRequired
}, _propTypes3.tileProps);

exports.default = Year;

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TileGroup = __webpack_require__(61);

var _TileGroup2 = _interopRequireDefault(_TileGroup);

var _Year = __webpack_require__(303);

var _Year2 = _interopRequireDefault(_Year);

var _dates = __webpack_require__(15);

var _propTypes = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Years = function (_PureComponent) {
  _inherits(Years, _PureComponent);

  function Years() {
    _classCallCheck(this, Years);

    return _possibleConstructorReturn(this, (Years.__proto__ || Object.getPrototypeOf(Years)).apply(this, arguments));
  }

  _createClass(Years, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_TileGroup2.default, _extends({}, this.props, {
        className: 'react-calendar__decade-view__years',
        dateTransform: function dateTransform(year) {
          return new Date(year, 0, 1);
        },
        dateType: 'year',
        end: this.end,
        start: this.start,
        tile: _Year2.default
      }));
    }
  }, {
    key: 'start',
    get: function get() {
      var activeStartDate = this.props.activeStartDate;

      return (0, _dates.getBeginOfDecadeYear)(activeStartDate);
    }
  }, {
    key: 'end',
    get: function get() {
      return this.start + 9;
    }
  }]);

  return Years;
}(_react.PureComponent);

exports.default = Years;


Years.propTypes = _extends({}, _propTypes.tileGroupProps);

/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tile = __webpack_require__(60);

var _Tile2 = _interopRequireDefault(_Tile);

var _dates = __webpack_require__(15);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var className = 'react-calendar__month-view__days__day';

var Day = function Day(_ref) {
  var calendarType = _ref.calendarType,
      classes = _ref.classes,
      currentMonthIndex = _ref.currentMonthIndex,
      date = _ref.date,
      otherProps = _objectWithoutProperties(_ref, ['calendarType', 'classes', 'currentMonthIndex', 'date']);

  return _react2.default.createElement(
    _Tile2.default,
    _extends({}, otherProps, {
      classes: [].concat(_toConsumableArray(classes), [className, (0, _dates.isWeekend)(date, calendarType) ? className + '--weekend' : null, date.getMonth() !== currentMonthIndex ? className + '--neighboringMonth' : null]),
      date: date,
      dateTime: (0, _dates.getISOLocalDate)(date) + 'T00:00:00.000',
      maxDateTransform: _dates.getEndOfDay,
      minDateTransform: _dates.getBeginOfDay,
      view: 'month'
    }),
    (0, _dates.getDay)(date)
  );
};

Day.propTypes = _extends({
  currentMonthIndex: _propTypes2.default.number.isRequired
}, _propTypes3.tileProps);

exports.default = Day;

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TileGroup = __webpack_require__(61);

var _TileGroup2 = _interopRequireDefault(_TileGroup);

var _Day = __webpack_require__(305);

var _Day2 = _interopRequireDefault(_Day);

var _dates = __webpack_require__(15);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Days = function (_PureComponent) {
  _inherits(Days, _PureComponent);

  function Days() {
    _classCallCheck(this, Days);

    return _possibleConstructorReturn(this, (Days.__proto__ || Object.getPrototypeOf(Days)).apply(this, arguments));
  }

  _createClass(Days, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var monthIndex = this.monthIndex;

      var _props = this.props,
          showNeighboringMonth = _props.showNeighboringMonth,
          otherProps = _objectWithoutProperties(_props, ['showNeighboringMonth']);

      return _react2.default.createElement(_TileGroup2.default, _extends({}, otherProps, {
        className: 'react-calendar__month-view__days',
        count: 7,
        dateTransform: function dateTransform(day) {
          return new Date(_this2.year, monthIndex, day);
        },
        dateType: 'day',
        end: this.end,
        offset: this.offset,
        start: this.start,
        tile: _Day2.default
        // Tile props
        , currentMonthIndex: monthIndex
      }));
    }
  }, {
    key: 'offset',
    get: function get() {
      var _props2 = this.props,
          showFixedNumberOfWeeks = _props2.showFixedNumberOfWeeks,
          showNeighboringMonth = _props2.showNeighboringMonth;


      if (showFixedNumberOfWeeks || showNeighboringMonth) {
        return 0;
      }

      var _props3 = this.props,
          activeStartDate = _props3.activeStartDate,
          calendarType = _props3.calendarType;


      return (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
    }

    /**
     * Defines on which day of the month the grid shall start. If we simply show current
     * month, we obviously start on day one, but if showNeighboringMonth is set to
     * true, we need to find the beginning of the week the first day of the month is in.
     */

  }, {
    key: 'start',
    get: function get() {
      var _props4 = this.props,
          showFixedNumberOfWeeks = _props4.showFixedNumberOfWeeks,
          showNeighboringMonth = _props4.showNeighboringMonth;


      if (showFixedNumberOfWeeks || showNeighboringMonth) {
        var _props5 = this.props,
            activeStartDate = _props5.activeStartDate,
            calendarType = _props5.calendarType;

        return -(0, _dates.getDayOfWeek)(activeStartDate, calendarType) + 1;
      }

      return 1;
    }

    /**
     * Defines on which day of the month the grid shall end. If we simply show current
     * month, we need to stop on the last day of the month, but if showNeighboringMonth
     * is set to true, we need to find the end of the week the last day of the month is in.
     */

  }, {
    key: 'end',
    get: function get() {
      var _props6 = this.props,
          activeStartDate = _props6.activeStartDate,
          showFixedNumberOfWeeks = _props6.showFixedNumberOfWeeks,
          showNeighboringMonth = _props6.showNeighboringMonth;

      var daysInMonth = (0, _dates.getDaysInMonth)(activeStartDate);

      if (showFixedNumberOfWeeks) {
        // Always show 6 weeks
        return this.start + 6 * 7 - 1;
      }

      if (showNeighboringMonth) {
        var year = this.year,
            monthIndex = this.monthIndex;
        var calendarType = this.props.calendarType;

        var activeEndDate = new Date(year, monthIndex, daysInMonth);
        return daysInMonth + (7 - (0, _dates.getDayOfWeek)(activeEndDate, calendarType) - 1);
      }

      return daysInMonth;
    }
  }, {
    key: 'year',
    get: function get() {
      var activeStartDate = this.props.activeStartDate;

      return (0, _dates.getYear)(activeStartDate);
    }
  }, {
    key: 'monthIndex',
    get: function get() {
      var activeStartDate = this.props.activeStartDate;

      return (0, _dates.getMonthIndex)(activeStartDate);
    }
  }]);

  return Days;
}(_react.PureComponent);

exports.default = Days;


Days.propTypes = _extends({
  calendarType: _propTypes3.isCalendarType.isRequired,
  showFixedNumberOfWeeks: _propTypes2.default.bool,
  showNeighboringMonth: _propTypes2.default.bool
}, _propTypes3.tileGroupProps);

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WeekNumber = function WeekNumber(_ref) {
  var date = _ref.date,
      onClickWeekNumber = _ref.onClickWeekNumber,
      weekNumber = _ref.weekNumber;
  return onClickWeekNumber ? _react2.default.createElement(
    'button',
    {
      className: 'react-calendar__tile',
      onClick: function onClick() {
        return onClickWeekNumber(weekNumber, date);
      },
      style: { flexGrow: 1 },
      type: 'button'
    },
    _react2.default.createElement(
      'span',
      null,
      weekNumber
    )
  ) : _react2.default.createElement(
    'div',
    {
      className: 'react-calendar__tile',
      style: { flexGrow: 1 }
    },
    _react2.default.createElement(
      'span',
      null,
      weekNumber
    )
  );
};

WeekNumber.propTypes = {
  date: _propTypes2.default.instanceOf(Date).isRequired,
  onClickWeekNumber: _propTypes2.default.func,
  weekNumber: _propTypes2.default.number.isRequired
};

exports.default = WeekNumber;

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WeekNumber = __webpack_require__(307);

var _WeekNumber2 = _interopRequireDefault(_WeekNumber);

var _Flex = __webpack_require__(79);

var _Flex2 = _interopRequireDefault(_Flex);

var _dates = __webpack_require__(15);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WeekNumbers = function (_PureComponent) {
  _inherits(WeekNumbers, _PureComponent);

  function WeekNumbers() {
    _classCallCheck(this, WeekNumbers);

    return _possibleConstructorReturn(this, (WeekNumbers.__proto__ || Object.getPrototypeOf(WeekNumbers)).apply(this, arguments));
  }

  _createClass(WeekNumbers, [{
    key: 'render',
    value: function render() {
      var dates = this.dates,
          numberOfWeeks = this.numberOfWeeks,
          weekNumbers = this.weekNumbers;
      var onClickWeekNumber = this.props.onClickWeekNumber;


      return _react2.default.createElement(
        _Flex2.default,
        {
          className: 'react-calendar__month-view__weekNumbers',
          count: numberOfWeeks,
          direction: 'column',
          style: { flexBasis: 'calc(100% * (1 / 8)', flexShrink: 0 }
        },
        weekNumbers.map(function (weekNumber, weekIndex) {
          return _react2.default.createElement(_WeekNumber2.default, {
            date: dates[weekIndex],
            key: weekNumber,
            onClickWeekNumber: onClickWeekNumber,
            weekNumber: weekNumber
          });
        })
      );
    }
  }, {
    key: 'startWeekday',
    get: function get() {
      var _props = this.props,
          activeStartDate = _props.activeStartDate,
          calendarType = _props.calendarType;

      return (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
    }
  }, {
    key: 'numberOfDays',
    get: function get() {
      var activeStartDate = this.props.activeStartDate;

      return (0, _dates.getDaysInMonth)(activeStartDate);
    }
  }, {
    key: 'numberOfWeeks',
    get: function get() {
      var showFixedNumberOfWeeks = this.props.showFixedNumberOfWeeks;


      if (showFixedNumberOfWeeks) {
        return 6;
      }

      var days = this.numberOfDays - (7 - this.startWeekday);
      return 1 + Math.ceil(days / 7);
    }
  }, {
    key: 'year',
    get: function get() {
      var activeStartDate = this.props.activeStartDate;

      return (0, _dates.getYear)(activeStartDate);
    }
  }, {
    key: 'monthIndex',
    get: function get() {
      var activeStartDate = this.props.activeStartDate;

      return (0, _dates.getMonthIndex)(activeStartDate);
    }
  }, {
    key: 'day',
    get: function get() {
      var activeStartDate = this.props.activeStartDate;

      return (0, _dates.getDay)(activeStartDate);
    }
  }, {
    key: 'dates',
    get: function get() {
      var year = this.year,
          monthIndex = this.monthIndex,
          numberOfWeeks = this.numberOfWeeks,
          day = this.day;
      var calendarType = this.props.calendarType;


      var dates = [];
      for (var index = 0; index < numberOfWeeks; index += 1) {
        dates.push((0, _dates.getBeginOfWeek)(new Date(year, monthIndex, day + index * 7), calendarType));
      }
      return dates;
    }
  }, {
    key: 'weekNumbers',
    get: function get() {
      var dates = this.dates;
      var calendarType = this.props.calendarType;

      return dates.map(function (date) {
        return (0, _dates.getWeekNumber)(date, calendarType);
      });
    }
  }]);

  return WeekNumbers;
}(_react.PureComponent);

exports.default = WeekNumbers;


WeekNumbers.propTypes = {
  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
  calendarType: _propTypes3.isCalendarType.isRequired,
  onClickWeekNumber: _propTypes2.default.func,
  showFixedNumberOfWeeks: _propTypes2.default.bool
};

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Flex = __webpack_require__(79);

var _Flex2 = _interopRequireDefault(_Flex);

var _dates = __webpack_require__(15);

var _dateFormatter = __webpack_require__(80);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekdays = function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _props = this.props,
          calendarType = _props.calendarType,
          locale = _props.locale;


      return nextProps.calendarType !== calendarType || nextProps.locale !== locale;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          calendarType = _props2.calendarType,
          formatShortWeekday = _props2.formatShortWeekday,
          locale = _props2.locale;
      var beginOfMonth = this.beginOfMonth,
          year = this.year,
          monthIndex = this.monthIndex;


      var weekdays = [];

      for (var weekday = 1; weekday <= 7; weekday += 1) {
        var weekdayDate = new Date(year, monthIndex, weekday - (0, _dates.getDayOfWeek)(beginOfMonth, calendarType));

        weekdays.push(_react2.default.createElement(
          'div',
          {
            className: 'react-calendar__month-view__weekdays__weekday',
            key: weekday,
            style: { flexGrow: 1 }
          },
          formatShortWeekday(weekdayDate, locale).replace('.', '')
        ));
      }

      return _react2.default.createElement(
        _Flex2.default,
        {
          className: 'react-calendar__month-view__weekdays',
          count: 7
        },
        weekdays
      );
    }
  }, {
    key: 'beginOfMonth',
    get: function get() {
      var month = this.props.month;


      return (0, _dates.getBeginOfMonth)(month);
    }
  }, {
    key: 'year',
    get: function get() {
      var beginOfMonth = this.beginOfMonth;


      return (0, _dates.getYear)(beginOfMonth);
    }
  }, {
    key: 'monthIndex',
    get: function get() {
      var beginOfMonth = this.beginOfMonth;


      return (0, _dates.getMonthIndex)(beginOfMonth);
    }
  }]);

  return Weekdays;
}(_react.Component);

exports.default = Weekdays;


Weekdays.defaultProps = {
  formatShortWeekday: _dateFormatter.formatShortWeekday
};

Weekdays.propTypes = {
  calendarType: _propTypes3.isCalendarType.isRequired,
  formatShortWeekday: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  month: _propTypes2.default.oneOfType([_propTypes2.default.string, // Only strings that are parseable to integer
  _propTypes2.default.number, _propTypes2.default.instanceOf(Date)]).isRequired
};

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = withStaticBuilder;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(13);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dompurify = __webpack_require__(53);

var _dompurify2 = _interopRequireDefault(_dompurify);

var _reactTooltip = __webpack_require__(132);

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _CustomPropTypes = __webpack_require__(19);

var _CustomPropTypes2 = _interopRequireDefault(_CustomPropTypes);

var _Utils = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withStaticBuilder(WrappedComponent) {
  var StaticBuilderField = function (_React$Component) {
    _inherits(StaticBuilderField, _React$Component);

    _createClass(StaticBuilderField, null, [{
      key: 'delimiterSeparatedToTitleCase',
      value: function delimiterSeparatedToTitleCase(delimter, string) {
        return string.split(delimter).map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ');
      }
    }, {
      key: 'init',
      value: function init(id, props) {
        _reactDom2.default.render(_react2.default.createElement(StaticBuilderField, props), document.getElementById(id));
      }
    }, {
      key: 'onPopoverClick',
      value: function onPopoverClick(e) {
        var isMobileOptimization = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        e.preventDefault();

        if (isMobileOptimization) {
          var button = e.currentTarget;

          // This is a hack to reopen the tooltip when the user
          // clicks away from a focused text input on mobile
          setTimeout(function () {
            _reactTooltip2.default.show(button);
          }, 250);
        }
      }
    }, {
      key: 'onFocus',
      value: function onFocus(e) {
        var formInputs = [].concat(_toConsumableArray(document.querySelectorAll('.controls')));
        // If the current focused field is not the first field, we want to scroll to it
        if (e.currentTarget !== formInputs[0] && !formInputs[0].contains(e.currentTarget)) {
          window.scrollTo(0, window.scrollY + e.currentTarget.getBoundingClientRect().top - 46);
        }
      }
    }]);

    function StaticBuilderField(props) {
      _classCallCheck(this, StaticBuilderField);

      var _this = _possibleConstructorReturn(this, (StaticBuilderField.__proto__ || Object.getPrototypeOf(StaticBuilderField)).call(this, props));

      _this.state = {
        // react treats props as string literals, however since we encode them on save
        // we need to decode them on load
        value: (0, _Utils.htmlDecode)(_this.props.initialValue),
        selectedValues: Object.keys(_this.props.initialSelectedValues).reduce(function (runningDecodedSelectedValues, key) {
          var decodedSelectedValues = runningDecodedSelectedValues;
          decodedSelectedValues[(0, _Utils.htmlDecode)(key)] = _this.props.initialSelectedValues[key];
          return decodedSelectedValues;
        }, {})
      };

      _this.onChange = _this.onChange.bind(_this);
      _this.getLabel = _this.getLabel.bind(_this);
      return _this;
    }

    _createClass(StaticBuilderField, [{
      key: 'onChange',
      value: function onChange(e) {
        if (e.target.type === 'checkbox') {
          var updatedSelectedValues = this.state.selectedValues;
          updatedSelectedValues[e.target.value] = e.target.checked;
          this.setState({
            selectedValues: updatedSelectedValues
          });
        } else {
          var value = e.target.value;

          this.props.setCurrentFieldValue(value);
          this.setState({
            value: value
          });
        }
      }
    }, {
      key: 'getLabel',
      value: function getLabel() {
        var label = this.props.label;
        // if the label is empty, let's use the id in title case
        // the first character of a label should always be capatalized
        // the last character of a label should be a colon

        // if we only have id = pets_allowed -> Pets Allowed:
        // if we have label = pets allowed -> Pets allowed:
        if (!label) {
          label = StaticBuilderField.delimiterSeparatedToTitleCase('_', this.props.id);
        }
        label = label.charAt(0).toUpperCase() + label.slice(1);

        if (label.endsWith(':')) {
          return label;
        }

        return label + ':';
      }
    }, {
      key: 'render',
      value: function render() {
        var label = this.getLabel();

        var infoNode = null;
        if (this.props.info) {
          infoNode = _react2.default.createElement(
            'button',
            {
              className: 'field-info',
              'data-tip': true,
              'data-for': this.props.id + '-fieldInfoTooltip',
              'data-class': 'field-info-tooltip',
              'data-delay-hide': '50',
              onClick: function onClick(e) {
                StaticBuilderField.onPopoverClick(e, false);
              }
            },
            _react2.default.createElement('i', { className: 'icon icon-info-sign' }),
            _react2.default.createElement(
              _reactTooltip2.default,
              {
                id: this.props.id + '-fieldInfoTooltip',
                className: 'field-info-tooltip',
                place: 'bottom',
                type: 'light',
                effect: 'solid',
                border: true
              },
              _react2.default.createElement(
                'div',
                { className: 'popover-inner' },
                _react2.default.createElement('div', { className: 'popover-title' }),
                _react2.default.createElement('div', {
                  className: 'popover-content',
                  dangerouslySetInnerHTML: { __html: '' + _dompurify2.default.sanitize(this.props.info) }
                })
              )
            )
          );
        }

        return _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement('label', {
            className: 'control-label',
            htmlFor: '' + this.props.id,
            dangerouslySetInnerHTML: { __html: '' + _dompurify2.default.sanitize(label) }
          }),
          _react2.default.createElement(
            'div',
            {
              className: 'controls'
            },
            _react2.default.createElement(
              'div',
              {
                className: 'wrapped-static-field',
                onFocus: undefined
              },
              _react2.default.createElement(WrappedComponent, _extends({
                onChange: this.onChange,
                value: this.state.value,
                selectedValues: this.state.selectedValues
              }, this.props))
            ),
            infoNode
          )
        );
      }
    }]);

    return StaticBuilderField;
  }(_react2.default.Component);

  StaticBuilderField.defaultProps = {
    label: '',
    initialValue: '',
    initialSelectedValues: {},
    info: '',
    setCurrentFieldValue: function setCurrentFieldValue() {}
  };

  StaticBuilderField.propTypes = {
    id: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string,
    initialValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
    initialSelectedValues: _CustomPropTypes2.default.shapeWithBooleanValues.isRequired,
    info: _propTypes2.default.string,
    setCurrentFieldValue: _propTypes2.default.func
  };

  return StaticBuilderField;
}

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Tile = __webpack_require__(60);

var _Tile2 = _interopRequireDefault(_Tile);

var _dates = __webpack_require__(15);

var _dateFormatter = __webpack_require__(80);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var className = 'react-calendar__year-view__months__month';

var Month = function Month(_ref) {
  var classes = _ref.classes,
      date = _ref.date,
      formatMonth = _ref.formatMonth,
      locale = _ref.locale,
      otherProps = _objectWithoutProperties(_ref, ['classes', 'date', 'formatMonth', 'locale']);

  return _react2.default.createElement(
    _Tile2.default,
    _extends({}, otherProps, {
      classes: [].concat(_toConsumableArray(classes), [className]),
      date: date,
      dateTime: (0, _dates.getISOLocalMonth)(date) + 'T00:00:00.000',
      maxDateTransform: _dates.getEndOfMonth,
      minDateTransform: _dates.getBeginOfMonth,
      view: 'year'
    }),
    formatMonth(date, locale)
  );
};

Month.defaultProps = {
  formatMonth: _dateFormatter.formatMonth
};

Month.propTypes = _extends({}, _propTypes3.tileProps, {
  formatMonth: _propTypes2.default.func,
  locale: _propTypes2.default.string
});

exports.default = Month;

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TileGroup = __webpack_require__(61);

var _TileGroup2 = _interopRequireDefault(_TileGroup);

var _Month = __webpack_require__(310);

var _Month2 = _interopRequireDefault(_Month);

var _dates = __webpack_require__(15);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Months = function (_PureComponent) {
  _inherits(Months, _PureComponent);

  function Months() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Months);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Months.__proto__ || Object.getPrototypeOf(Months)).call.apply(_ref, [this].concat(args))), _this), _this.start = 0, _this.end = 11, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Months, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_TileGroup2.default, _extends({}, this.props, {
        className: 'react-calendar__year-view__months',
        dateTransform: function dateTransform(monthIndex) {
          return new Date(_this2.year, monthIndex, 1);
        },
        dateType: 'month',
        end: this.end,
        start: this.start,
        tile: _Month2.default
      }));
    }
  }, {
    key: 'year',
    get: function get() {
      var activeStartDate = this.props.activeStartDate;

      return (0, _dates.getYear)(activeStartDate);
    }
  }]);

  return Months;
}(_react.PureComponent);

exports.default = Months;


Months.propTypes = _extends({}, _propTypes3.tileGroupProps, {
  locale: _propTypes2.default.string
});

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MonthView = exports.YearView = exports.DecadeView = exports.CenturyView = exports.Calendar = undefined;

var _Calendar = __webpack_require__(299);

var _Calendar2 = _interopRequireDefault(_Calendar);

var _CenturyView = __webpack_require__(127);

var _CenturyView2 = _interopRequireDefault(_CenturyView);

var _DecadeView = __webpack_require__(128);

var _DecadeView2 = _interopRequireDefault(_DecadeView);

var _YearView = __webpack_require__(130);

var _YearView2 = _interopRequireDefault(_YearView);

var _MonthView = __webpack_require__(129);

var _MonthView2 = _interopRequireDefault(_MonthView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Calendar2.default;
exports.Calendar = _Calendar2.default;
exports.CenturyView = _CenturyView2.default;
exports.DecadeView = _DecadeView2.default;
exports.YearView = _YearView2.default;
exports.MonthView = _MonthView2.default;

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(0),__webpack_require__(1),__webpack_require__(37),__webpack_require__(416)):"function"===typeof define&&define.amd?define(["react","prop-types","uuid/v4","lodash.omit"],t):"object"===typeof exports?exports.main=t(require("react"),require("prop-types"),require("uuid/v4"),require("lodash.omit")):e.main=t(e.React,e.PropTypes,e.uuid,e["_.omit"])}(this,function(e,t,r,n){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var r={};return t.m=e,t.c=r,t.d=function(e,r,n){t.o(e,r)||Object.defineProperty(e,r,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var r=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(r,"a",r),r},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=10)}([function(t,r){t.exports=e},function(e,r){e.exports=t},function(e,t,r){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function i(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){var t,r;return r=t=function(t){function r(){return n(this,r),o(this,(r.__proto__||Object.getPrototypeOf(r)).apply(this,arguments))}return i(r,t),f(r,[{key:"render",value:function(){var t=this.context._getProps(this.id);return t?u.a.createElement(e,Object.assign({},t,{onChange:this.handleChange,onBlur:this.handleBlur})):null}}]),r}(c.a),t.displayName="Control("+e.name+")",r}t.a=a;var s=r(0),u=r.n(s),c=r(3),f=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}()},function(e,t,r){"use strict";function n(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function a(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}var s=r(0),u=(r.n(s),r(1)),c=r.n(u),f=r(4),l=r.n(f),p=r(5),b=r.n(p),d=r(6),y=r.n(d),h=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),v=function(e){function t(){var e,r,n,a;o(this,t);for(var s=arguments.length,u=Array(s),c=0;c<s;c++)u[c]=arguments[c];return r=n=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),n.id=y()(),n.handleChange=function(e){e.persist(),n.context._handleChange(e,n.id),n.props.onChange&&n.props.onChange(e)},n.handleBlur=function(e){e.persist(),n.context._handleBlur(e,n.id),n.props.onBlur&&n.props.onBlur(e)},a=r,i(n,a)}return a(t,e),h(t,[{key:"componentDidMount",value:function(){this.context._register(this,this.id)}},{key:"componentWillUnmount",value:function(){this.context._unregister(this,this.id)}},{key:"componentWillReceiveProps",value:function(e){var t=e.validations,r=n(e,["validations"]),o=this.props,i=o.validations,a=n(o,["validations"]);b()(a,r)&&l()(i,t)||this.context._setProps(r,this.id)}},{key:"shouldComponentUpdate",value:function(e,t,r){return r!==this.context}},{key:"render",value:function(){return null}}]),t}(s.Component);v.contextTypes={_register:c.a.func.isRequired,_unregister:c.a.func.isRequired,_setProps:c.a.func.isRequired,_handleChange:c.a.func.isRequired,_handleBlur:c.a.func.isRequired,_getProps:c.a.func.isRequired},v.propTypes={validations:c.a.arrayOf(c.a.func),onChange:c.a.func,onBlur:c.a.func},v.defaultProps={validations:[]},t.a=v},function(e,t){e.exports=function(e,t){if(e===t)return!0;var r=e.length;if(t.length!==r)return!1;for(var n=0;n<r;n++)if(e[n]!==t[n])return!1;return!0}},function(e,t){e.exports=function(e,t){if(e===t)return!0;var r=Object.keys(e),n=Object.keys(t),o=r.length;if(n.length!==o)return!1;for(var i=0;i<o;i++){var a=r[i];if(e[a]!==t[a])return!1}return!0}},function(e,t){e.exports=r},function(e,t,r){"use strict";function n(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function o(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function i(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)}function a(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function u(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function c(e){var t,r,c;return r=t=function(t){function r(e,t){a(this,r);var n=s(this,(r.__proto__||Object.getPrototypeOf(r)).call(this,e,t));return c.call(n),n.state={byName:{},byId:{}},n}return u(r,t),h(r,[{key:"getChildContext",value:function(){var e=this;return{_register:this._register,_unregister:this._unregister,_setProps:this._setProps,_handleChange:this._handleChange,_handleBlur:this._handleBlur,_getProps:this._getProps,_errors:Object.keys(this.state.byId).filter(function(t){return e.state.byId[t].error})}}},{key:"render",value:function(){return l.a.createElement(e,Object.assign({},this.props,{validate:this.validate,validateAll:this.validateAll,getValues:this.getValues,showError:this.showError,hideError:this.hideError}))}}]),r}(f.PureComponent),t.displayName="Form("+e.name+")",t.propTypes={},t.childContextTypes={_register:b.a.func.isRequired,_unregister:b.a.func.isRequired,_setProps:b.a.func.isRequired,_handleChange:b.a.func.isRequired,_handleBlur:b.a.func.isRequired,_getProps:b.a.func.isRequired,_errors:b.a.array},c=function(){var e=this;this._register=function(t,r){e.setState(function(e){return{byName:Object.assign({},e.byName,o({},t.props.name,[].concat(i(e.byName[t.props.name]||[]),[r]))),byId:Object.assign({},e.byId,o({},r,Object.assign({},t.props,{isCheckable:v(t),value:t.props.value||""},v(t)?{checked:!!t.props.checked}:{})))}},e._setErrors)},this._unregister=function(t,r){var n=[].concat(i(e.state.byName[t.props.name]));n.splice(n.indexOf(r),1);var a=n.length?Object.assign({},e.state.byName,o({},t.props.name,n)):y()(e.state.byName,t.props.name);e.setState({byName:a,byId:y()(e.state.byId,r)})},this._getProps=function(t){if(e.state.byId[t]){var r=e.state.byId[t];r.validations,r.isCheckable;return n(r,["validations","isCheckable"])}},this._setProps=function(t,r){e.setState(function(e){return{byId:Object.assign({},e.byId,o({},r,Object.assign({},e.byId[r],t)))}},e._setErrors)},this._handleChange=function(t,r){var n=e.state.byId[r].isCheckable;e.setState({byId:Object.assign({},e.state.byId,n?Object.assign({},e.state.byName[e.state.byId[r].name].reduce(function(t,r){return t[r]=Object.assign({},e.state.byId[r],{checked:!1}),t},{})):{},o({},r,Object.assign({},e.state.byId[r],{isChanged:!0,value:t.target.value},n&&{checked:t.target.checked})))},e._setErrors)},this._handleBlur=function(t,r){e.setState({byId:Object.assign({},e.state.byId,o({},r,Object.assign({},e.state.byId[r],{isUsed:!0,value:t.target.value})))},e._setErrors)},this._setErrors=function(){e.setState(function(e){return{byId:Object.keys(e.byId).reduce(function(t,r){var n=e.byId[r].validations,o=e.byId[r],i=Object.keys(e.byName).reduce(function(t,r){return t[r]=e.byName[r].map(function(t){return e.byId[t]}),t},{}),a=o.value;t[r]=Object.assign({},e.byId[r]);var s=!0,u=!1,c=void 0;try{for(var f,l=n[Symbol.iterator]();!(s=(f=l.next()).done);s=!0){var p=f.value,b=p(a,o,i);if(b){t[r].error=b;break}delete t[r].error}}catch(e){u=!0,c=e}finally{try{!s&&l.return&&l.return()}finally{if(u)throw c}}return t},{})}})},this.getValues=function(){return Object.keys(e.state.byName).reduce(function(t,r){return e.state.byName[r].length>1?t[r]=e.state.byName[r].map(function(t){return e.state.byId[t].value}):t[r]=e.state.byId[e.state.byName[r][0]].value,t},{})},this.validate=function(t){e.setState(function(e){return{byId:Object.assign({},e.byId,e.byName[t].reduce(function(t,r){return t[r]=Object.assign({},e.byId[r],{isChanged:!0,isUsed:!0}),t},{}))}},e._setErrors)},this.validateAll=function(){e.setState(function(e){return{byId:Object.assign({},e.byId,Object.keys(e.byName).reduce(function(t,r){return e.byName[r].reduce(function(r,n){return t[n]=Object.assign({},e.byId[n],{isChanged:!0,isUsed:!0}),r},{}),t},{}))}},e._setErrors)},this.showError=function(t,r){t&&setTimeout(function(){e.setState({byId:Object.assign({},e.state.byId,o({},t.id,Object.assign({},e.state.byId[t.id],{isChanged:!0,isUsed:!0,error:r})))})},0)},this.hideError=function(t){e.setState(function(e){return{byId:Object.assign({},e.byId,o({},t.id,Object.assign({},y()(e.byId[t.id],"error"),{isChanged:!1,isUsed:!1})))}})}},r}t.a=c;var f=r(0),l=r.n(f),p=r(1),b=r.n(p),d=r(8),y=r.n(d),h=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),v=function(e){return"radio"===e.props.type||"checkbox"===e.props.type}},function(e,t){e.exports=n},function(e,t,r){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==typeof t&&"function"!==typeof t?e:t}function i(e,t){if("function"!==typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t)}function a(e){var t,r;return r=t=function(t){function r(){return n(this,r),o(this,(r.__proto__||Object.getPrototypeOf(r)).apply(this,arguments))}return i(r,t),l(r,[{key:"shouldComponentUpdate",value:function(e,t,r){return r._errors!==this.context._errors}},{key:"render",value:function(){var t=!!Object.keys(this.context._errors).length;return u.a.createElement(e,Object.assign({},this.props,{hasErrors:t}))}}]),r}(s.Component),t.contextTypes={_errors:f.a.arrayOf(f.a.oneOfType([f.a.object,f.a.string]))},t.displayName="Button("+e.name+")",r}t.a=a;var s=r(0),u=r.n(s),c=r(1),f=r.n(c),l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}()},function(e,t,r){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=r(7);r.d(t,"form",function(){return n.a});var o=r(2);r.d(t,"control",function(){return o.a});var i=r(9);r.d(t,"button",function(){return i.a})}])});
//# sourceMappingURL=main.js.map

/***/ }),

/***/ 316:
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExportProgressBarWithRedux = exports.ExportProgressBar = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _Animation = __webpack_require__(323);

var _ProgressBar = __webpack_require__(99);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _ProgressBarStep = __webpack_require__(348);

var _ProgressBarStep2 = _interopRequireDefault(_ProgressBarStep);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExportProgressBar = exports.ExportProgressBar = function (_React$Component) {
  _inherits(ExportProgressBar, _React$Component);

  function ExportProgressBar(props) {
    _classCallCheck(this, ExportProgressBar);

    var _this = _possibleConstructorReturn(this, (ExportProgressBar.__proto__ || Object.getPrototypeOf(ExportProgressBar)).call(this, props));

    var defaultCallback = function defaultCallback() {
      window.location.assign(props.href);
    };

    _this.state = {
      progressBarStepAnimationTime: 3500,
      callbackToUse: props.callback || defaultCallback
    };
    return _this;
  }

  _createClass(ExportProgressBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var userId = window.COOKIE.get('userid');
      if (userId) {
        this.state.callbackToUse();
        return;
      }

      this.props.startProgressBarAnimation(4, this.state.progressBarStepAnimationTime);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var callbackToUse = this.state.callbackToUse;
      if (this.props.progressBarAnimation.finished) {
        setTimeout(function () {
          callbackToUse();
        }, 100);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var animationStarted = this.props.progressBarAnimation.started;
      return _react2.default.createElement(
        'div',
        { className: 'export-progress-bar' },
        _react2.default.createElement(
          'div',
          { className: 'export-progress-bar-content' },
          _react2.default.createElement(
            'div',
            { className: 'progress-header' },
            'Preparing Document...'
          ),
          _react2.default.createElement(_ProgressBar2.default, {
            progressBarClassName: 'progress-bar',
            progressClassName: 'progress-bar-progress',
            step: this.props.progressBarAnimation.step,
            totalSteps: this.props.progressBarAnimation.totalSteps
          }),
          _react2.default.createElement(
            'ul',
            { className: 'spinner-wrapper' },
            _react2.default.createElement(_ProgressBarStep2.default, {
              started: animationStarted && this.props.progressBarAnimation.step >= 0,
              completed: this.props.progressBarAnimation.step > 0,
              animationTime: this.state.progressBarStepAnimationTime,
              text: 'Proofreading clauses'
            }),
            _react2.default.createElement(_ProgressBarStep2.default, {
              started: animationStarted && this.props.progressBarAnimation.step >= 1,
              completed: this.props.progressBarAnimation.step > 1,
              animationTime: this.state.progressBarStepAnimationTime,
              text: 'Enabling electronic signatures'
            }),
            _react2.default.createElement(_ProgressBarStep2.default, {
              started: animationStarted && this.props.progressBarAnimation.step >= 2,
              completed: this.props.progressBarAnimation.step > 2,
              animationTime: this.state.progressBarStepAnimationTime,
              text: 'Preparing document in word and PDF formats'
            }),
            _react2.default.createElement(_ProgressBarStep2.default, {
              started: animationStarted && this.props.progressBarAnimation.step >= 3,
              completed: this.props.progressBarAnimation.finished,
              animationTime: this.state.progressBarStepAnimationTime,
              text: 'Eliminating spelling and grammar errors'
            })
          )
        )
      );
    }
  }]);

  return ExportProgressBar;
}(_react2.default.Component);

ExportProgressBar.propTypes = {
  callback: _propTypes2.default.func,
  href: _propTypes2.default.string.isRequired,
  progressBarAnimation: _propTypes2.default.shape({
    started: _propTypes2.default.bool,
    finished: _propTypes2.default.bool,
    step: _propTypes2.default.number,
    totalSteps: _propTypes2.default.number
  }).isRequired,
  startProgressBarAnimation: _propTypes2.default.func.isRequired
};

ExportProgressBar.defaultProps = {
  callback: null
};

var mapStateToProps = function mapStateToProps(_ref) {
  var AnimationReducer = _ref.AnimationReducer;
  return {
    progressBarAnimation: AnimationReducer[_Animation.AnimationConstants.PROGRESS_BAR_ANIMATION]
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)(_extends({}, _Animation.AnimationActions), dispatch);
};

var ExportProgressBarWithRedux = exports.ExportProgressBarWithRedux = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(ExportProgressBar);

exports.default = (0, _WithInit2.default)(ExportProgressBarWithRedux, true);

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ModalConstants = __webpack_require__(20);

var _ModalConstants2 = _interopRequireDefault(_ModalConstants);

var _ConnectModal = __webpack_require__(34);

var _ConnectModal2 = _interopRequireDefault(_ConnectModal);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _SignatureReminderBodyContent = __webpack_require__(357);

var _SignatureReminderBodyContent2 = _interopRequireDefault(_SignatureReminderBodyContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FreeWriteSignatureReminderModalContainer = (0, _ConnectModal2.default)(_BaseModal2.default, 'signatureReminderModal', {
  modalType: _ModalConstants2.default.FREE_WRITE_SIGNATURE_REMINDER,
  bodyContent: _react2.default.createElement(_SignatureReminderBodyContent2.default, {
    modalType: _ModalConstants2.default.FREE_WRITE_SIGNATURE_REMINDER
  }),
  footerButtons: false,
  trackFreeWrite: true,
  ariaLabel: 'Signature Reminder Modal',
  includeHeaderCloseButton: false,
  preventClickingOutside: true
});

exports.default = FreeWriteSignatureReminderModalContainer;

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(13);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _ModalActions = __webpack_require__(82);

var ModalActions = _interopRequireWildcard(_ModalActions);

var _store = __webpack_require__(25);

var _store2 = _interopRequireDefault(_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var connectModal = function connectModal(WrappedComponent, elmId) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var mapStateToProps = function mapStateToProps(state) {
    return {
      activeModal: state.ModalHandler.activeModal,
      finalStep: state.ModalHandler.finalStep,
      additionalData: state.ModalHandler.additionalData
    };
  };

  var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)(_extends({}, ModalActions), dispatch);
  };

  var ConnectedWrappedComponent = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);

  var ModalContainer = function (_React$Component) {
    _inherits(ModalContainer, _React$Component);

    function ModalContainer() {
      _classCallCheck(this, ModalContainer);

      return _possibleConstructorReturn(this, (ModalContainer.__proto__ || Object.getPrototypeOf(ModalContainer)).apply(this, arguments));
    }

    _createClass(ModalContainer, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            ConnectedWrappedComponent,
            this.props,
            this.props.children && this.props.children
          )
        );
      }
    }], [{
      key: 'init',
      value: function init(additionalData) {
        var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var elementId = id || elmId;
        var properties = Object.assign({}, props, additionalData);

        _reactDom2.default.render(_react2.default.createElement(
          ReactRedux.Provider,
          { store: _store2.default },
          _react2.default.createElement(ModalContainer, properties)
        ), document.getElementById(elementId));
      }
    }]);

    return ModalContainer;
  }(_react2.default.Component);

  ModalContainer.defaultProps = {
    children: null
  };

  ModalContainer.propTypes = {
    children: _propTypes2.default.node
  };

  return ModalContainer;
};

if (window.FormSwift && window.FormSwift.React) {
  var newActions = Object.assign({}, window.FormSwift.React.actions, ModalActions);
  window.FormSwift.React.actions = newActions;
} else {
  window.FormSwift = {
    React: {
      store: _store2.default,
      actions: ModalActions
    }
  };
}

exports.default = connectModal;

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _validator = __webpack_require__(202);

var _validator2 = _interopRequireDefault(_validator);

var _Validation = __webpack_require__(44);

var _HiddenFormFields = __webpack_require__(350);

var _HiddenFormFields2 = _interopRequireDefault(_HiddenFormFields);

var _NewAccountTermsOfService = __webpack_require__(215);

var _NewAccountTermsOfService2 = _interopRequireDefault(_NewAccountTermsOfService);

var _BaseFormRow = __webpack_require__(76);

var _BaseFormRow2 = _interopRequireDefault(_BaseFormRow);

var _formswiftApi = __webpack_require__(209);

var _formswiftApi2 = _interopRequireDefault(_formswiftApi);

var _EmailFormField = __webpack_require__(359);

var _EmailFormField2 = _interopRequireDefault(_EmailFormField);

var _PasswordFormField = __webpack_require__(360);

var _PasswordFormField2 = _interopRequireDefault(_PasswordFormField);

var _ConfirmPasswordFormField = __webpack_require__(358);

var _ConfirmPasswordFormField2 = _interopRequireDefault(_ConfirmPasswordFormField);

var _RegisterFormConstants = __webpack_require__(216);

var _RegisterFormConstants2 = _interopRequireDefault(_RegisterFormConstants);

var _getEmailConsent2 = __webpack_require__(345);

var _getEmailConsent3 = _interopRequireDefault(_getEmailConsent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RegisterForm = function (_React$Component) {
  _inherits(RegisterForm, _React$Component);

  function RegisterForm(props) {
    _classCallCheck(this, RegisterForm);

    var _this = _possibleConstructorReturn(this, (RegisterForm.__proto__ || Object.getPrototypeOf(RegisterForm)).call(this, props));

    var countryIsoAlpha2 = window.CurrentUser ? window.CurrentUser.countryIsoAlpha2 : '';

    var _getEmailConsent = (0, _getEmailConsent3.default)(countryIsoAlpha2),
        defaultMarketingConsent = _getEmailConsent.defaultConsent,
        isEmailMarketingConsentOptionShown = _getEmailConsent.isShown;

    _this.state = {
      'valid-email': false,
      'validations-email': [_validator2.default.isEmail],
      confirmPassword: '',
      defaultMarketingConsent: defaultMarketingConsent,
      hasSubmittedRegisterRequest: false,
      isConsentToEmailMarketingGiven: defaultMarketingConsent,
      isEmailMarketingConsentOptionShown: isEmailMarketingConsentOptionShown
    };

    _this.validateField = _this.validateField.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onPasswordChange = _this.onPasswordChange.bind(_this);
    _this.onMarketingConsentChange = _this.onMarketingConsentChange.bind(_this);
    _this.getHiddenFormFields = _this.getHiddenFormFields.bind(_this);
    _this.getEmailFormField = _this.getEmailFormField.bind(_this);
    _this.getPasswordFormField = _this.getPasswordFormField.bind(_this);
    _this.getConfirmPasswordFormField = _this.getConfirmPasswordFormField.bind(_this);
    _this.getPromoCodeFormField = _this.getPromoCodeFormField.bind(_this);
    _this.getEmailConsentCheckbox = _this.getEmailConsentCheckbox.bind(_this);
    _this.isFormValid = _this.isFormValid.bind(_this);
    return _this;
  }

  _createClass(RegisterForm, [{
    key: 'onChange',
    value: function onChange(event) {
      var validations = this.state['validations-' + event.target.dataset.statekey];
      var numOfValidations = validations.length;
      var valid = true;
      for (var i = 0; i < numOfValidations; i += 1) {
        valid = valid && validations[i](event.target.value);
      }

      this.setState(_defineProperty({}, 'valid-' + event.target.dataset.statekey, valid));
    }
  }, {
    key: 'onPasswordChange',
    value: function onPasswordChange(e) {
      if (!this.props.hideConfirmPassword) {
        return;
      }
      this.setState({
        confirmPassword: e.currentTarget.value
      });
    }
  }, {
    key: 'onMarketingConsentChange',
    value: function onMarketingConsentChange() {
      this.setState({ isConsentToEmailMarketingGiven: this.state.defaultMarketingConsent === undefined && this.state.isConsentToEmailMarketingGiven === undefined ? false : !this.state.isConsentToEmailMarketingGiven
      });
    }
  }, {
    key: 'getEmailFormField',
    value: function getEmailFormField() {
      return _react2.default.createElement(_EmailFormField2.default, {
        emailPlaceholder: this.props.emailPlaceholder,
        onChange: this.onChange
      });
    }
  }, {
    key: 'getHiddenFormFields',
    value: function getHiddenFormFields() {
      var hiddenFields = [{ name: 'funnelCategory', value: this.props.funnelCategory }, { name: 'funnelPage', value: this.props.funnelPage }, { name: 'primary_document_type', value: this.props.documentType }, { name: 'session_id', value: this.props.sessionKey }, { name: 'session_hash', value: this.props.sessionHash }, { name: 'redirect_url', value: this.props.redirectToPage }, { name: 'originalPage', value: this.props.originalPage }, { name: 'fs-newsletter', value: this.props.newsletter }, { name: 'fs-newsletter-alt', value: this.props.newsletter }];

      if (this.props.hideConfirmPassword) {
        hiddenFields.push({ name: 'confirm_password', value: this.state.confirmPassword, id: 'confirm_password' });
      }

      return _react2.default.createElement(_HiddenFormFields2.default, {
        className: 'hidden-form-fields',
        fieldAttributesArr: hiddenFields
      });
    }
  }, {
    key: 'getPasswordFormField',
    value: function getPasswordFormField() {
      var enablePassword = this.isFieldEnabled('password');
      return _react2.default.createElement(_PasswordFormField2.default, {
        enabled: enablePassword,
        passwordPlaceholder: this.props.passwordPlaceholder,
        onPasswordChange: this.onPasswordChange
      });
    }
  }, {
    key: 'getConfirmPasswordFormField',
    value: function getConfirmPasswordFormField() {
      if (this.props.hideConfirmPassword) {
        return null;
      }
      var enablePassword = this.isFieldEnabled('password');
      return _react2.default.createElement(_ConfirmPasswordFormField2.default, {
        enabled: enablePassword,
        passwordPlaceholder: this.props.passwordPlaceholder
      });
    }
  }, {
    key: 'getPromoCodeFormField',
    value: function getPromoCodeFormField() {
      var promoCodeRow = null;
      if (this.props.promoCode) {
        var enablePromoCode = this.isFieldEnabled('promoCode');
        var promoCodeFormClasses = (0, _classnames2.default)('control-group', {
          disabled: !enablePromoCode || this.props.isPromoCodeHidden,
          hidden: this.props.isPromoCodeHidden
        });
        var promoCodeValidationProps = {
          type: 'text',
          name: 'promo-code',
          id: 'promoCode',
          className: 'input-xlarge',
          value: this.props.promoCode,
          disabled: !enablePromoCode,
          validations: []
        };
        promoCodeRow = _react2.default.createElement(_BaseFormRow2.default, {
          formClasses: promoCodeFormClasses,
          inputClasses: 'controls',
          htmlFor: 'promoCode',
          label: 'Promo Code:',
          stateKey: 'promoCode',
          validationProps: promoCodeValidationProps
        });
      }
      return promoCodeRow;
    }
  }, {
    key: 'getEmailConsentCheckbox',
    value: function getEmailConsentCheckbox() {
      var marketingConsentCopy = 'I would ' + (this.state.defaultMarketingConsent === undefined ? 'not' : '') + ' like to receive email marketing updates from FormSwift.';

      if (this.state.isEmailMarketingConsentOptionShown) {
        return _react2.default.createElement(
          'div',
          { className: 'email-marketing-consent-checkbox-wrapper' },
          _react2.default.createElement('input', {
            id: 'email-marketing-consent',
            name: 'email-marketing-consent',
            onChange: this.onMarketingConsentChange,
            type: 'checkbox'
          }),
          _react2.default.createElement(
            'label',
            {
              htmlFor: 'email-marketing-consent'
            },
            marketingConsentCopy
          )
        );
      }
      return null;
    }
  }, {
    key: 'isFormValid',
    value: function isFormValid() {
      var _this2 = this;

      return Object.keys(this.form.state.byId).reduce(function (validFields, id) {
        return validFields && !_this2.form.state.byId[id].error;
      }, true);
    }
  }, {
    key: 'handleSubmit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var validForm, payload, handleResult;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                this.form.validateAll();
                validForm = this.isFormValid();

                if (!validForm) {
                  _context.next = 11;
                  break;
                }

                this.setState({ hasSubmittedRegisterRequest: true });
                window._track('Make Account', 'Click');
                // Submit the form

                if (!this.props.shareRegister) {
                  _context.next = 10;
                  break;
                }

                payload = _extends({}, _formswiftApi2.default.buildPayload(e.target), {
                  share_key: this.props.shareKey,
                  finish: true,
                  email_marketing_consent: this.state.isConsentToEmailMarketingGiven
                });

                handleResult = function handleResult() {
                  window.location.assign('/my-documents');
                };

                return _context.abrupt('return', window.FormSwiftAPI.handleShareRegister(e.target, payload['promo-code'], true, handleResult, payload));

              case 10:
                return _context.abrupt('return', window.FormSwiftAPI.handleInlineRegister(e.target, e));

              case 11:
                return _context.abrupt('return', false);

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSubmit(_x) {
        return _ref.apply(this, arguments);
      }

      return handleSubmit;
    }()
  }, {
    key: 'isFieldEnabled',
    value: function isFieldEnabled(field) {
      var enableField = true;
      var fieldsRequiredBefore = [];
      switch (field) {
        case 'password':
          fieldsRequiredBefore = this.props['fields-before-password'];
          break;
        case 'promoCode':
          fieldsRequiredBefore = this.props['fields-before-promoCode'];
          break;
        default:
          break;
      }

      for (var i = 0; i < fieldsRequiredBefore.length; i += 1) {
        var validFieldRequiredBefore = this.state['valid-' + fieldsRequiredBefore[i]];
        enableField = enableField && validFieldRequiredBefore;
      }
      return enableField;
    }
  }, {
    key: 'validateField',
    value: function validateField(fieldName) {
      this.form.validate(fieldName);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var emailRow = this.getEmailFormField();
      var passwordRow = this.getPasswordFormField();
      var confirmPassword = this.getConfirmPasswordFormField();
      var promoCodeRow = this.getPromoCodeFormField();
      var hiddenFormFields = this.getHiddenFormFields();
      var emailConsentCheckbox = this.getEmailConsentCheckbox();

      return _react2.default.createElement(
        _Validation.Form,
        {
          id: 'chargifyForm',
          method: 'post',
          target: '_parent',
          onSubmit: this.handleSubmit,
          ref: function ref(c) {
            _this3.form = c;
          },
          className: 'new-account-form inlineAccountCreation'
        },
        _react2.default.createElement(
          'h1',
          { className: 'new-account-page-header' },
          this.props.heading
        ),
        _react2.default.createElement(
          'fieldset',
          null,
          emailRow,
          passwordRow,
          confirmPassword,
          promoCodeRow,
          this.props.displayTOS === _RegisterFormConstants2.default.TOP && _react2.default.createElement(
            'div',
            { className: 'register-with-tos' },
            _react2.default.createElement(_NewAccountTermsOfService2.default, null)
          ),
          emailConsentCheckbox,
          _react2.default.createElement(
            'div',
            { className: 'form-actions submit-button-wrapper' },
            hiddenFormFields,
            _react2.default.createElement(
              'button',
              {
                id: 'submitRegister',
                type: 'submit',
                disabled: this.state.hasSubmittedRegisterRequest,
                className: 'btn btn-primary btn-large btn-success submit-button',
                'data-loading-text': 'Creating Account...'
              },
              'Create Account'
            )
          )
        ),
        this.props.displayTOS === _RegisterFormConstants2.default.BOTTOM && _react2.default.createElement(
          'div',
          { className: 'terms-of-service' },
          _react2.default.createElement(
            'p',
            { className: 'terms-of-service-text' },
            'Your e-mail will not be shared with anyone. We will not send you junk mail or newsletters.'
          ),
          _react2.default.createElement(_NewAccountTermsOfService2.default, null)
        )
      );
    }
  }]);

  return RegisterForm;
}(_react2.default.Component);

RegisterForm.defaultProps = {
  heading: 'Create An Account To Save Your Document',
  promoCode: '',
  emailPlaceholder: '',
  passwordPlaceholder: '',
  'fields-before-password': [],
  'fields-before-promoCode': [],
  funnelCategory: '',
  funnelPage: '',
  documentType: '',
  isPromoCodeHidden: '',
  sessionKey: '',
  sessionHash: '',
  redirectToPage: '',
  originalPage: '',
  newsletter: '',
  hideConfirmPassword: true,
  shareKey: '',
  shareRegister: false,
  displayTOS: _RegisterFormConstants2.default.BOTTOM
};

RegisterForm.propTypes = {
  heading: _propTypes2.default.string,
  promoCode: _propTypes2.default.string,
  emailPlaceholder: _propTypes2.default.string,
  passwordPlaceholder: _propTypes2.default.string,
  'fields-before-password': _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['email'])),
  'fields-before-promoCode': _propTypes2.default.arrayOf(_propTypes2.default.oneOf(['email', 'password'])),
  funnelCategory: _propTypes2.default.string,
  funnelPage: _propTypes2.default.string,
  documentType: _propTypes2.default.string,
  isPromoCodeHidden: _propTypes2.default.bool,
  sessionKey: _propTypes2.default.string,
  sessionHash: _propTypes2.default.string,
  redirectToPage: _propTypes2.default.string,
  originalPage: _propTypes2.default.string,
  newsletter: _propTypes2.default.string,
  hideConfirmPassword: _propTypes2.default.bool,
  shareKey: _propTypes2.default.string,
  shareRegister: _propTypes2.default.bool,
  displayTOS: _propTypes2.default.oneOf([_RegisterFormConstants2.default.TOP, _RegisterFormConstants2.default.BOTTOM, _RegisterFormConstants2.default.NONE])
};

exports.default = RegisterForm;

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isoConsent = {
  AT: { defaultConsent: undefined, isShown: true },
  BE: { defaultConsent: undefined, isShown: true },
  BG: { defaultConsent: undefined, isShown: true },
  HR: { defaultConsent: undefined, isShown: true },
  CY: { defaultConsent: undefined, isShown: true },
  CZ: { defaultConsent: undefined, isShown: true },
  DK: { defaultConsent: undefined, isShown: true },
  EE: { defaultConsent: undefined, isShown: true },
  FI: { defaultConsent: undefined, isShown: true },
  FR: { defaultConsent: undefined, isShown: true },
  DE: { defaultConsent: undefined, isShown: true },
  GR: { defaultConsent: undefined, isShown: true },
  HU: { defaultConsent: undefined, isShown: true },
  IE: { defaultConsent: undefined, isShown: true },
  IS: { defaultConsent: undefined, isShown: true },
  IT: { defaultConsent: undefined, isShown: true },
  LV: { defaultConsent: undefined, isShown: true },
  LI: { defaultConsent: undefined, isShown: true },
  LT: { defaultConsent: undefined, isShown: true },
  LU: { defaultConsent: undefined, isShown: true },
  MT: { defaultConsent: undefined, isShown: true },
  NL: { defaultConsent: undefined, isShown: true },
  NO: { defaultConsent: undefined, isShown: true },
  PL: { defaultConsent: undefined, isShown: true },
  PT: { defaultConsent: undefined, isShown: true },
  RO: { defaultConsent: undefined, isShown: true },
  SK: { defaultConsent: undefined, isShown: true },
  SI: { defaultConsent: undefined, isShown: true },
  ES: { defaultConsent: undefined, isShown: true },
  SE: { defaultConsent: undefined, isShown: true },
  MX: { defaultConsent: undefined, isShown: true },
  GB: { defaultConsent: undefined, isShown: true },
  PE: { defaultConsent: false, isShown: true },
  CO: { defaultConsent: false, isShown: true },
  TR: { defaultConsent: false, isShown: true },
  TW: { defaultConsent: false, isShown: true },
  VN: { defaultConsent: false, isShown: true },
  AE: { defaultConsent: false, isShown: true },
  JP: { defaultConsent: false, isShown: true },
  KR: { defaultConsent: false, isShown: true },
  IL: { defaultConsent: false, isShown: true }
};

var getEmailConsent = function getEmailConsent(iso) {
  return iso in isoConsent ? isoConsent[iso] : { defaultConsent: undefined, isShownForCountry: false };
};

exports.default = getEmailConsent;

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBody = function ModalBody(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'ds-modal-body' },
    children
  );
};

ModalBody.defaultProps = {
  children: null
};

ModalBody.propTypes = {
  children: _propTypes2.default.node
};

exports.default = ModalBody;

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Typography = __webpack_require__(48);

var _ModalIcon = __webpack_require__(602);

var _ModalIcon2 = _interopRequireDefault(_ModalIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIcons = function getIcons(modalIcon, iconClassName, orientation) {
  return {
    TopIcon: function TopIcon() {
      var topModalIcon = _extends({}, modalIcon, {
        className: (0, _classnames2.default)('ds-modal-icon-top', iconClassName)
      });
      return modalIcon && orientation === 'top' ? _react2.default.createElement(_ModalIcon2.default, topModalIcon) : null;
    },
    BottomIcon: function BottomIcon() {
      var bottomModalIcon = _extends({}, modalIcon, {
        className: (0, _classnames2.default)('ds-modal-icon-bottom', iconClassName)
      });
      return modalIcon && orientation === 'bottom' ? _react2.default.createElement(_ModalIcon2.default, bottomModalIcon) : null;
    }
  };
};

var ModalHeader = function ModalHeader(props) {
  var headerCopy = props.headerCopy,
      iconOrientation = props.iconOrientation,
      modalIcon = props.modalIcon;

  var _getIcons = getIcons(modalIcon, modalIcon.className, iconOrientation),
      TopIcon = _getIcons.TopIcon,
      BottomIcon = _getIcons.BottomIcon;

  var Header = (0, _react.useCallback)(function () {
    return headerCopy ? _react2.default.createElement(
      _Typography.HeadingF,
      { className: 'ds-modal-header' },
      headerCopy
    ) : null;
  }, [headerCopy]);

  return _react2.default.createElement(
    'div',
    { className: 'ds-modal-header-container' },
    _react2.default.createElement(TopIcon, null),
    _react2.default.createElement(Header, null),
    _react2.default.createElement(BottomIcon, null)
  );
};

ModalHeader.defaultProps = {
  headerCopy: '',
  iconOrientation: 'top',
  modalIcon: {}
};

ModalHeader.propTypes = {
  headerCopy: _propTypes2.default.string,
  iconOrientation: _propTypes2.default.string,
  modalIcon: _propTypes2.default.shape({
    alt: _propTypes2.default.string,
    className: _propTypes2.default.string,
    src: _propTypes2.default.string
  })
};

exports.default = ModalHeader;

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _ProgressSpinner = __webpack_require__(349);

var _ProgressSpinner2 = _interopRequireDefault(_ProgressSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBarStep = function ProgressBarStep(props) {
  var spinnerItemClassName = (0, _classnames2.default)('spinner-item', {
    completed: props.completed
  });
  return _react2.default.createElement(
    'li',
    { className: spinnerItemClassName },
    props.completed && _react2.default.createElement(
      'div',
      {
        className: 'loading-complete-wrapper'
      },
      _react2.default.createElement('img', {
        alt: 'Done',
        className: 'progress-complete',
        src: '//cdn.smartresumewizard.com/images/icons/check-mark-2x.png'
      })
    ),
    !props.completed && _react2.default.createElement(_ProgressSpinner2.default, {
      started: props.started,
      animationTime: props.animationTime
    }),
    _react2.default.createElement(
      'div',
      { className: 'progess-bar-step-text' },
      props.text
    )
  );
};

ProgressBarStep.propTypes = {
  animationTime: _propTypes2.default.number.isRequired,
  started: _propTypes2.default.bool,
  completed: _propTypes2.default.bool,
  text: _propTypes2.default.string
};

ProgressBarStep.defaultProps = {
  completed: false,
  started: false,
  text: ''
};

exports.default = ProgressBarStep;

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Migrated from progress-circle.js, which was based off of // spinner code from https://codepen.io/phantomesse/pen/uzeyC?q=loading+circle&limit=all&type=type-pen
var PROGRESS_SPOKE_COUNT = 8.0;
var SPOKE_WIDTH = 4;
var PROGRESS_SPOKE_DURATION = 500;
var PROGRESS_SPOKE_X_OFFSET = 0.75;
var PROGRESS_SPOKE_Y_OFFSET = 1.5;
var PROGRESS_SPOKE_CONTAINER_WIDTH = 25;

var ProgressSpinner = function ProgressSpinner(props) {
  if (!props.started) {
    return _react2.default.createElement('div', { className: 'loading-spinner' });
  }

  var delay = (props.animationTime - PROGRESS_SPOKE_DURATION) / PROGRESS_SPOKE_COUNT / 1000.0;
  var progressSpinner = [];

  for (var i = 0; i < PROGRESS_SPOKE_COUNT; i += 1) {
    var degreeTot = (PROGRESS_SPOKE_COUNT * 3 / 4 + i) * 360;
    var degree = degreeTot / PROGRESS_SPOKE_COUNT;
    var degreeRadians = degree * (Math.PI / 180);
    var radius = (PROGRESS_SPOKE_CONTAINER_WIDTH - SPOKE_WIDTH * 3) / 2;
    var x = Math.cos(degreeRadians) * radius + radius + SPOKE_WIDTH * PROGRESS_SPOKE_X_OFFSET;
    var y = Math.sin(degreeRadians) * radius + radius + SPOKE_WIDTH * PROGRESS_SPOKE_Y_OFFSET;

    var style = {
      width: SPOKE_WIDTH * 1.5 + 'px',
      height: SPOKE_WIDTH / 2 + 'px',
      top: y + 'px',
      left: x + 'px',
      transform: 'rotate(' + degree + 'deg)',
      animationDuration: PROGRESS_SPOKE_DURATION / 1000.0 + 's',
      animationDelay: delay * i + 's'
    };

    var spoke = _react2.default.createElement('div', {
      key: i,
      className: 'spoke',
      style: style
    });

    progressSpinner.push(spoke);
  }
  return _react2.default.createElement(
    'div',
    { className: 'loading-spinner' },
    progressSpinner
  );
};

ProgressSpinner.propTypes = {
  animationTime: _propTypes2.default.number.isRequired,
  started: _propTypes2.default.bool
};

ProgressSpinner.defaultProps = {
  completed: false,
  started: false
};

exports.default = ProgressSpinner;

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _StaticBuilder = __webpack_require__(167);

var _IowaBENInput = __webpack_require__(614);

var _IowaBENInput2 = _interopRequireDefault(_IowaBENInput);

var _HelpSideBarButton = __webpack_require__(177);

var _HelpSideBarButton2 = _interopRequireDefault(_HelpSideBarButton);

var _downloadOverlayManager = __webpack_require__(102);

var _downloadOverlayManager2 = _interopRequireDefault(_downloadOverlayManager);

var _ConnectedHelpSideBar = __webpack_require__(176);

var _ConnectedHelpSideBar2 = _interopRequireDefault(_ConnectedHelpSideBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.NavSideBarList = _StaticBuilder.NavSideBarList;
window.HelpSideBarButton = _HelpSideBarButton2.default;
window.ConnectedHelpSideBar = _ConnectedHelpSideBar2.default;
var OfferManager = __webpack_require__(72);
window.ProgressBar = __webpack_require__(599);

var VisualStatic = function () {
  _createClass(VisualStatic, null, [{
    key: 'redirectTo',
    value: function redirectTo(uri) {
      window.location.href = uri;
    }
  }, {
    key: 'setupUnpaidExport',
    value: function setupUnpaidExport() {
      var buttonSelectors = '.export-button-preview, #efileDocument';

      if (!window.SessionManager.showReactivationOffer) {
        // NON-PAYING users take them to the new account page
        $(buttonSelectors).each(function setUnpaidClickEvents() {
          $(this).attr('href', '#');
          $(this).attr('target', '');

          $(this).click(function () {
            var successAction = function unpaidExportSuccessAction() {
              // This is the default new account page url pulled from the preview modal.
              VisualStatic.redirectTo($('.proceed-to-export-upgrade').attr('href'));
            };
            window.SessionManager.save(successAction);
          });
        });
      } else {
        var om = new OfferManager();
        om.applyReactivationOffer(buttonSelectors);
      }
    }
  }, {
    key: 'addEFileButton',
    value: function addEFileButton() {
      // Add tax filing button
      var taxFilingURL = '/taxFiling.php' + window.location.search;
      $('#exportButtons .btn-group').prepend('<a id="efileDocument" href="' + taxFilingURL + '" class="btn" style="margin-left: 10px" href="#" target="_blank"><i class="icon icon-folder-open"></i> eFile Document</a>');

      if (window.SessionManager.showReactivationOffer) {
        var om = new OfferManager();
        om.applyReactivationOffer('#efileDocument');
      }
    }
  }, {
    key: 'setTabOrder',
    value: function setTabOrder(orderOfFormFields) {
      for (var i = 0; i < orderOfFormFields.length; i += 1) {
        $('[name=\'' + orderOfFormFields[i] + '\']').attr('tabindex', i + 1);
      }
    }
  }, {
    key: 'setPlaceholders',
    value: function setPlaceholders(removeLabelsFromFields) {
      removeLabelsFromFields.forEach(function (field) {
        $('[name=\'' + field + '\']').attr('placeholder', '- Click To Add -');
      });
    }
  }, {
    key: 'initExportPDF',
    value: function initExportPDF() {
      // EXPORT PDF
      // Export to PDF logic for paying and non paying users
      if (window.SessionManager.isPaidUser) {
        // For PAYING users save and export the PDF
        $('.export-button-preview').click(function () {
          $('#instructionPane h1').text('Saving Document...');
          $('#instructionPane').modal('show');

          // Save the current form state, and download the PDF
          var successAction = function paidExportSuccessAction() {
            var offerManager = new window.OfferManager();
            offerManager.requestExport(function () {
              if (typeof window.FreemiumBox !== 'undefined') {
                window.FreemiumBox.deductCredit();
              }

              $('#saveBarObj').hide();
              setTimeout(function () {
                $('#instructionPane h1').text('Compiling Your PDF Document...');
              }, 1000);
              setTimeout(function () {
                $('#instructionPane').modal('hide');
              }, 5500);
              document.location = '/_api/fillAndExportPDFFromSession.php' + document.location.search;
              _downloadOverlayManager2.default.show();
            }, '/new-account-for-doc?' + window.location.search.substr(1), true);
          };
          window.SessionManager.save(successAction);
        });
      } else {
        VisualStatic.setupUnpaidExport(window.SessionManager.showReactivationOffer);
      }
    }
  }]);

  function VisualStatic() {
    var showEFileButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _classCallCheck(this, VisualStatic);

    this.showEFileButton = showEFileButton;
    this.orderOfFormFields = [];
  }

  _createClass(VisualStatic, [{
    key: 'initOnReactComponentsMounted',
    value: function initOnReactComponentsMounted() {
      var _this = this;

      var checkForMountedComponentsIntervalId = setInterval(function () {
        var allComponentsMounted = _this.orderOfFormFields.reduce(function (mounted, fieldId) {
          return mounted && document.querySelector('[name="' + fieldId + '"]') !== null;
        }, true);

        if (allComponentsMounted) {
          clearInterval(checkForMountedComponentsIntervalId);
          _this.initBuilderOnReactComponentsMounted();
        }
      }, 100);
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();
    }
  }, {
    key: 'initBuilder',
    value: function initBuilder() {
      // Enter key is disabled from triggering a PDF export
      window.disableEnterKey = true;

      // Add the Progress Bar
      window.ProgressBar.init();
      $('body').on('change', window.ProgressBar.inputTypeText, window.ProgressBar.handleEvent);

      // Start auto-saving in the background
      window.SessionManager.autoSave.start();

      // ------------------- UI Modification

      // Force non-responsive display
      $('.row-fluid').addClass('row').removeClass('row-fluid');
      $('.builder .builder-content').css({ float: 'left' });

      // Hide all labels and replace them with placeholders
      $('form :input').each(function (index, elem) {
        var eId = $(elem).attr('id');
        var elemLabel = $(elem).parents('form').find('label[for=' + eId + ']');
        var label = elemLabel.length === 1 ? elemLabel : null;

        if (eId && elemLabel) {
          $(elem).attr('placeholder', $(label).html());
          $(label).addClass('hide-label');
        }
      });

      // Remove the extra info from our loading modal
      $('#instructionPane .modal-body').html("<p>We're filling in your content, formatting, validating &amp; preparing your document</p>");
      $('#instructionPane .modal-footer').html(''); // There are a few Paragraphs here, hide all of them but keep the first.

      if (this.showEFileButton) {
        VisualStatic.addEFileButton();
      }

      // Remove the current preview functionality that comes with static docs
      $('.export-button-preview').attr('onclick', '');
      $('.export-button-preview').attr('href', '#');
      $('#exportToggle').hide();

      // For Paid users make the button text as Download PDF.
      if (window.SessionManager.isPaidUser) {
        $('.export-button-preview').html('<i class="icon icon-white icon-download-alt"></i> Download & Print PDF');
      }
    }
  }], [{
    key: 'setUpIowaBENInput',
    value: function setUpIowaBENInput() {
      var payeeState = document.getElementById('payee1_state');
      window.ReactCompatibility.selectEfileState(payeeState.value);
      _IowaBENInput2.default.init({ value: document.getElementById('payee1_ia_ben').value });

      // Create event handler for filing state in order to show/hide IA_BEN field
      ['change', 'input'].forEach(function (event) {
        payeeState.addEventListener(event, function () {
          window.ReactCompatibility.selectEfileState(payeeState.value);
        });
      });
    }
  }, {
    key: 'disableW2SelectDefaultOption',
    value: function disableW2SelectDefaultOption() {
      var employmentType = document.getElementById('payee1_employment_type').firstChild;
      var kindOfEmployer = document.getElementById('payer_kind_of_employer').firstChild;
      employmentType.value = '';
      employmentType.disabled = true;
      kindOfEmployer.value = '';
      kindOfEmployer.disabled = true;
    }
  }]);

  return VisualStatic;
}();

module.exports = VisualStatic;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HiddenFormFields = function (_React$Component) {
  _inherits(HiddenFormFields, _React$Component);

  function HiddenFormFields(props) {
    _classCallCheck(this, HiddenFormFields);

    var _this = _possibleConstructorReturn(this, (HiddenFormFields.__proto__ || Object.getPrototypeOf(HiddenFormFields)).call(this, props));

    _this.generateAllInputs = _this.generateAllInputs.bind(_this);
    return _this;
  }

  _createClass(HiddenFormFields, [{
    key: 'generateAllInputs',
    value: function generateAllInputs() {
      return this.props.fieldAttributesArr.map(function (attr) {
        var val = attr.value;
        if (val == null) {
          val = '';
        }
        return _react2.default.createElement('input', {
          type: 'hidden',
          name: attr.name,
          value: val,
          key: attr.name,
          id: attr.id
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var inputs = this.generateAllInputs();

      return _react2.default.createElement(
        'div',
        null,
        inputs
      );
    }
  }]);

  return HiddenFormFields;
}(_react2.default.Component);

HiddenFormFields.propTypes = {
  fieldAttributesArr: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string,
    value: _propTypes2.default.any,
    id: _propTypes2.default.string
  })).isRequired
};

exports.default = HiddenFormFields;

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExportProgressBarModal = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ExportProgressBar = __webpack_require__(318);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Export progress modal does not close, but `BaseModal` requires a `closeModal`
// method prop and calls it, which is why we have an empty method passed in
var ExportProgressBarModal = exports.ExportProgressBarModal = function ExportProgressBarModal(props) {
  return _react2.default.createElement(_BaseModal2.default, {
    modalType: 'export-progress-bar-modal',
    activeModal: 'export-progress-bar-modal',
    ariaHideApp: false,
    modalClass: 'progress-modal',
    closeModal: function closeModal() {},
    modalBodyClass: 'modal-content',
    bodyContent: _react2.default.createElement(_ExportProgressBar.ExportProgressBarWithRedux, { href: props.href, callback: props.callback })
  });
};

ExportProgressBarModal.propTypes = {
  href: _propTypes2.default.string.isRequired,
  callback: _propTypes2.default.func
};

ExportProgressBarModal.defaultProps = {
  callback: null
};

exports.default = (0, _WithInit2.default)(ExportProgressBarModal, true);

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WithInit = __webpack_require__(6);

var _WithInit2 = _interopRequireDefault(_WithInit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactivationOfferModal = function ReactivationOfferModal(_ref) {
  var reactivationPage = _ref.reactivationPage;

  var trackAndRedirect = function trackAndRedirect() {
    window._track('Get Started | Reactivation Modal', reactivationPage);
    window.location.assign('/my-account?skip_start_reactivation=1');
  };

  return _react2.default.createElement(
    _react2.default.Fragment,
    null,
    _react2.default.createElement(
      'div',
      { className: 'modal-header' },
      _react2.default.createElement(
        'button',
        { className: 'close', 'data-dismiss': 'modal' },
        'X'
      ),
      _react2.default.createElement(
        'h3',
        null,
        'This feature requires a paid subscription.'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal-body' },
      _react2.default.createElement(
        'p',
        { className: 'reactivate-yours' },
        'Reactivate yours now for $37 per month.'
      ),
      _react2.default.createElement(
        'p',
        { className: 'reactivation-seconds' },
        'It only takes a few seconds.'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal-footer' },
      _react2.default.createElement(
        'div',
        { className: 'buttons center' },
        _react2.default.createElement(
          'a',
          { className: 'btn btn-success btn-large', onClick: trackAndRedirect },
          'Get Started'
        )
      )
    )
  );
};

ReactivationOfferModal.propTypes = {
  reactivationPage: _propTypes2.default.string.isRequired
};

exports.default = (0, _WithInit2.default)(ReactivationOfferModal);

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(13);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _store = __webpack_require__(25);

var _store2 = _interopRequireDefault(_store);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _ConnectModal = __webpack_require__(34);

var _ConnectModal2 = _interopRequireDefault(_ConnectModal);

var _ModalConstants = __webpack_require__(20);

var _ModalConstants2 = _interopRequireDefault(_ModalConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpdateSubscriptionProgressModalWithRedux = (0, _ConnectModal2.default)(_BaseModal2.default);

var UpdateSubscriptionProgressModal = function (_React$Component) {
  _inherits(UpdateSubscriptionProgressModal, _React$Component);

  function UpdateSubscriptionProgressModal() {
    _classCallCheck(this, UpdateSubscriptionProgressModal);

    return _possibleConstructorReturn(this, (UpdateSubscriptionProgressModal.__proto__ || Object.getPrototypeOf(UpdateSubscriptionProgressModal)).apply(this, arguments));
  }

  _createClass(UpdateSubscriptionProgressModal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(UpdateSubscriptionProgressModalWithRedux, {
        modalType: _ModalConstants2.default.UPDATE_SUBSCRIPTION_PROGRESS_READY,
        headerText: 'Updating Subscription...',
        bodyContent: _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'p',
            null,
            'Please wait, this could take up to 15 seconds.'
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Do not refresh'
            ),
            ' your browser'
          )
        ),
        footerContent: _react2.default.createElement('img', { alt: 'Loading', src: '//cdn.smartresumewizard.com/images/icons/loading_circle.gif' }),
        ariaLabel: 'Updating Subscription'
      });
    }
  }], [{
    key: 'init',
    value: function init(id, props) {
      _reactDom2.default.render(_react2.default.createElement(
        ReactRedux.Provider,
        { store: _store2.default },
        _react2.default.createElement(UpdateSubscriptionProgressModal, props)
      ), document.getElementById(id));
    }
  }]);

  return UpdateSubscriptionProgressModal;
}(_react2.default.Component);

exports.default = UpdateSubscriptionProgressModal;

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = __webpack_require__(219);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalInput = function (_React$Component) {
  _inherits(ModalInput, _React$Component);

  function ModalInput(props) {
    _classCallCheck(this, ModalInput);

    var _this = _possibleConstructorReturn(this, (ModalInput.__proto__ || Object.getPrototypeOf(ModalInput)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.state = {
      value: _this.props.value
    };
    return _this;
  }

  _createClass(ModalInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      this.setState({
        value: event.target.value
      });

      if (this.props.onChange) {
        this.props.onChange(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var autoComplete = 'off';
      if (this.props.autoComplete) {
        autoComplete = 'on';
      }

      var className = 'modal-input-container control-group';
      if (this.props.type === 'hidden') {
        className += ' hidden';
      }

      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'label',
          { className: 'control-label', htmlFor: this.props.htmlFor },
          this.props.label
        ),
        _react2.default.createElement(
          'div',
          { className: 'controls' },
          _react2.default.createElement(_Input2.default, {
            type: this.props.type,
            autoComplete: autoComplete,
            className: 'modal-input input-xlarge',
            id: this.props.id,
            name: this.props.name,
            value: this.state.value,
            onChange: this.handleChange,
            validations: this.props.validations
          })
        )
      );
    }
  }]);

  return ModalInput;
}(_react2.default.Component);

ModalInput.defaultProps = {
  autoComplete: true,
  value: '',
  onChange: null,
  validations: [function () {}]
};

ModalInput.propTypes = {
  id: _propTypes2.default.string.isRequired,
  htmlFor: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string,
  autoComplete: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  validations: _propTypes2.default.arrayOf(_propTypes2.default.func)
};

exports.default = ModalInput;

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ModalConstants = __webpack_require__(20);

var _ModalConstants2 = _interopRequireDefault(_ModalConstants);

var _ConnectModal = __webpack_require__(34);

var _ConnectModal2 = _interopRequireDefault(_ConnectModal);

var _BaseModal = __webpack_require__(28);

var _BaseModal2 = _interopRequireDefault(_BaseModal);

var _SignatureCancelSurveyBodyContent = __webpack_require__(356);

var _SignatureCancelSurveyBodyContent2 = _interopRequireDefault(_SignatureCancelSurveyBodyContent);

var _reactDom = __webpack_require__(13);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _store = __webpack_require__(25);

var _store2 = _interopRequireDefault(_store);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FreeWriteSignatureCancelSurveyModalWithRedux = (0, _ConnectModal2.default)(_BaseModal2.default);

var FreeWriteSignatureCancelSurveyModalContainer = function (_React$Component) {
  _inherits(FreeWriteSignatureCancelSurveyModalContainer, _React$Component);

  function FreeWriteSignatureCancelSurveyModalContainer() {
    _classCallCheck(this, FreeWriteSignatureCancelSurveyModalContainer);

    return _possibleConstructorReturn(this, (FreeWriteSignatureCancelSurveyModalContainer.__proto__ || Object.getPrototypeOf(FreeWriteSignatureCancelSurveyModalContainer)).apply(this, arguments));
  }

  _createClass(FreeWriteSignatureCancelSurveyModalContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(FreeWriteSignatureCancelSurveyModalWithRedux, {
        modalType: _ModalConstants2.default.FREE_WRITE_CANCEL_SIGNATURE_SURVEY,
        includeHeaderCloseButton: true,
        bodyContent: _react2.default.createElement(_SignatureCancelSurveyBodyContent2.default, {
          modalType: _ModalConstants2.default.FREE_WRITE_CANCEL_SIGNATURE_SURVEY
        }),
        footerButtons: false,
        trackFreeWrite: true,
        ariaLabel: 'Cancel Signature Survey Request Modal'
      });
    }
  }], [{
    key: 'init',
    value: function init(id) {
      _reactDom2.default.render(_react2.default.createElement(
        ReactRedux.Provider,
        { store: _store2.default },
        _react2.default.createElement(FreeWriteSignatureCancelSurveyModalContainer, null)
      ), document.getElementById(id));
    }
  }]);

  return FreeWriteSignatureCancelSurveyModalContainer;
}(_react2.default.Component);

exports.default = FreeWriteSignatureCancelSurveyModalContainer;

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignatureCancelSurveyModalBodyContent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(83);

var _Button2 = _interopRequireDefault(_Button);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalActions = __webpack_require__(82);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    closeModal: _ModalActions.closeModal
  }, dispatch);
};

var SignatureCancelSurveyModalBodyContent = exports.SignatureCancelSurveyModalBodyContent = function (_React$Component) {
  _inherits(SignatureCancelSurveyModalBodyContent, _React$Component);

  function SignatureCancelSurveyModalBodyContent() {
    _classCallCheck(this, SignatureCancelSurveyModalBodyContent);

    var _this = _possibleConstructorReturn(this, (SignatureCancelSurveyModalBodyContent.__proto__ || Object.getPrototypeOf(SignatureCancelSurveyModalBodyContent)).call(this));

    _this.state = {
      response: null,
      cancelReason: '',
      selection: null
    };
    _this.onChange = _this.changeSelection.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.onChangeText = _this.changeText.bind(_this);
    return _this;
  }

  _createClass(SignatureCancelSurveyModalBodyContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window._track('Viewed Cancel Request Survey', 'My Documents');
    }
  }, {
    key: 'changeSelection',
    value: function changeSelection(e) {
      var cancelReason = e.target.value === 'Other' ? ' ' + this.state.cancelReason : '';
      this.setState({
        response: '' + e.target.value + cancelReason + ' | Cancel Request Survey',
        selection: e.target.value
      });
    }
  }, {
    key: 'changeText',
    value: function changeText(e) {
      this.setState({
        cancelReason: '' + e.target.value
      });

      if (this.state.selection === 'Other') {
        this.setState({
          response: this.state.selection + ' ' + e.target.value + ' | Cancel Request Survey'
        });
      }
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      if (this.state.response) {
        this.props.closeModal(this.props.modalType);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cancel-sig-survey' },
        _react2.default.createElement(
          'h4',
          null,
          'Request Canceled. Do you mind sharing why you canceled your request?'
        ),
        _react2.default.createElement(
          'form',
          { id: 'cancelForm' },
          _react2.default.createElement('input', {
            type: 'radio',
            name: 'cancelReason',
            value: 'Don\'t understand feature',
            id: 'understand',
            onChange: this.onChange
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: 'understand' },
            'I don\u2019t understand what this feature is.'
          ),
          _react2.default.createElement('input', {
            type: 'radio',
            name: 'cancelReason',
            value: 'Still need to edit',
            id: 'edit',
            onChange: this.onChange
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: 'edit' },
            'I still need to edit my document.'
          ),
          _react2.default.createElement('input', {
            type: 'radio',
            name: 'cancelReason',
            value: 'Only one signing',
            id: 'oneSigning',
            onChange: this.onChange
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: 'oneSigner' },
            'I am the only one signing this document and therefore do not need to send it to someone else.'
          ),
          _react2.default.createElement('input', {
            type: 'radio',
            name: 'cancelReason',
            value: 'Don\'t need signature',
            id: 'noSignature',
            onChange: this.onChange
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: 'noSignature' },
            'I don\u2019t need a signature on this document.'
          ),
          _react2.default.createElement('input', {
            type: 'radio',
            name: 'cancelReason',
            value: 'Other',
            id: 'other',
            onChange: this.onChange
          }),
          _react2.default.createElement(
            'label',
            { htmlFor: 'other' },
            'Other ',
            _react2.default.createElement(
              'i',
              null,
              '(please explain)'
            ),
            ' '
          ),
          _react2.default.createElement('textarea', { name: 'cancelReason', id: 'otherReason', onChange: this.onChangeText })
        ),
        _react2.default.createElement(
          'div',
          { className: 'buttons' },
          _react2.default.createElement(_Button2.default, {
            buttonOnClick: this.closeModal,
            buttonText: 'Submit Answer',
            trackCategory: this.state.response,
            trackAction: 'My Documents',
            form: 'cancelForm',
            type: 'submit'
          })
        )
      );
    }
  }]);

  return SignatureCancelSurveyModalBodyContent;
}(_react2.default.Component);

SignatureCancelSurveyModalBodyContent.defaultProps = {
  modalType: ''
};

SignatureCancelSurveyModalBodyContent.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  modalType: _propTypes2.default.string
};

var ConnectedSignatureCancelSurveyModalBody = ReactRedux.connect(null, mapDispatchToProps)(SignatureCancelSurveyModalBodyContent);
exports.default = ConnectedSignatureCancelSurveyModalBody;

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignatureReminderModalBodyContent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Button = __webpack_require__(83);

var _Button2 = _interopRequireDefault(_Button);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalActions = __webpack_require__(82);

var _SignatureManagerActions = __webpack_require__(140);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _redux = __webpack_require__(4);

var _EditorOverlayActions = __webpack_require__(325);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    closeModal: _ModalActions.closeModal,
    updateSignatureActiveButton: _SignatureManagerActions.updateSignatureActiveButton,
    expandFreeWriteAddSignatureSection: _SignatureManagerActions.expandFreeWriteAddSignatureSection,
    requestFreeWriteExport: _EditorOverlayActions.requestFreeWriteExport
  }, dispatch);
};

var SignatureReminderModalBodyContent = exports.SignatureReminderModalBodyContent = function (_React$Component) {
  _inherits(SignatureReminderModalBodyContent, _React$Component);

  function SignatureReminderModalBodyContent() {
    _classCallCheck(this, SignatureReminderModalBodyContent);

    var _this = _possibleConstructorReturn(this, (SignatureReminderModalBodyContent.__proto__ || Object.getPrototypeOf(SignatureReminderModalBodyContent)).call(this));

    _this.state = {
      response: null,
      cancelReason: '',
      selection: null
    };
    _this.expandSignatureSection = _this.expandSignatureSection.bind(_this);
    _this.continueWithoutSigning = _this.continueWithoutSigning.bind(_this);
    return _this;
  }

  _createClass(SignatureReminderModalBodyContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.localStorage.setItem('signatureAdded', 1);
      window._track('Viewed Signature Reminder', 'My Documents');
    }
  }, {
    key: 'continueWithoutSigning',
    value: function continueWithoutSigning() {
      this.props.closeModal(this.props.modalType);
      this.props.requestFreeWriteExport();
      window._track('Continue Without Signing | Viewed Signature Reminder', 'My Documents');
    }
  }, {
    key: 'expandSignatureSection',
    value: function expandSignatureSection() {
      this.props.closeModal(this.props.modalType);
      this.props.expandFreeWriteAddSignatureSection('type');
      window._track('Sign Now | Viewed Signature Reminder', 'My Documents');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'signature-reminder' },
        _react2.default.createElement('button', { className: 'modal-close-btn', onClick: this.continueWithoutSigning }),
        _react2.default.createElement('img', { className: 'signature-reminder-image', src: window.cdnUrl + '/images/signature-reminder/signature-reminder-2x.png', alt: 'Signature' }),
        _react2.default.createElement(
          'h4',
          null,
          'Do you need to sign this document?'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Type, draw or add a signature to make your document official.'
        ),
        _react2.default.createElement(
          'div',
          { className: 'buttons' },
          _react2.default.createElement(_Button2.default, {
            buttonOnClick: this.expandSignatureSection,
            buttonText: 'Sign Now',
            trackCategory: this.state.response,
            trackAction: 'My Documents',
            type: 'submit'
          }),
          _react2.default.createElement(
            'button',
            {
              className: 'continue-without-signing-btn',
              onClick: this.continueWithoutSigning
            },
            'Continue without signing'
          )
        )
      );
    }
  }]);

  return SignatureReminderModalBodyContent;
}(_react2.default.Component);

SignatureReminderModalBodyContent.defaultProps = {
  modalType: ''
};

SignatureReminderModalBodyContent.propTypes = {
  closeModal: _propTypes2.default.func.isRequired,
  modalType: _propTypes2.default.string,
  expandFreeWriteAddSignatureSection: _propTypes2.default.func.isRequired,
  requestFreeWriteExport: _propTypes2.default.func.isRequired
};

var ConnectedSignatureReminderModalBody = ReactRedux.connect(null, mapDispatchToProps)(SignatureReminderModalBodyContent);
exports.default = ConnectedSignatureReminderModalBody;

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Validation = __webpack_require__(44);

var _BaseFormRow = __webpack_require__(76);

var _BaseFormRow2 = _interopRequireDefault(_BaseFormRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmPasswordFormField = function (_React$Component) {
  _inherits(ConfirmPasswordFormField, _React$Component);

  function ConfirmPasswordFormField(props) {
    _classCallCheck(this, ConfirmPasswordFormField);

    var _this = _possibleConstructorReturn(this, (ConfirmPasswordFormField.__proto__ || Object.getPrototypeOf(ConfirmPasswordFormField)).call(this, props));

    _this.getConfirmPasswordFormField = _this.getConfirmPasswordFormField.bind(_this);
    return _this;
  }

  _createClass(ConfirmPasswordFormField, [{
    key: 'getConfirmPasswordFormField',
    value: function getConfirmPasswordFormField() {
      var enableConfirmPassword = this.props.enabled;
      var confirmPasswordFormClasses = (0, _classnames2.default)('confirm-password-form-field', 'control-group', {
        disabled: !enableConfirmPassword
      });
      var passwordValidationProps = {
        type: 'password',
        name: 'confirm_password',
        id: 'confirm_password',
        className: 'required input-xlarge',
        disabled: !enableConfirmPassword,
        placeholder: this.props.confirmPasswordPlaceholder,
        autoComplete: 'off',
        validations: this.props.validations
      };
      return _react2.default.createElement(_BaseFormRow2.default, {
        formClasses: confirmPasswordFormClasses,
        inputClasses: 'controls',
        htmlFor: 'confirm_password',
        label: 'Confirm Password:',
        stateKey: 'confirm_password',
        value: '',
        validationProps: passwordValidationProps,
        onChange: this.props.onPasswordChange
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var passwordFormField = this.getConfirmPasswordFormField();
      return passwordFormField;
    }
  }]);

  return ConfirmPasswordFormField;
}(_react2.default.Component);

exports.default = ConfirmPasswordFormField;


ConfirmPasswordFormField.defaultProps = {
  enabled: true,
  onPasswordChange: function onPasswordChange() {},
  confirmPasswordPlaceholder: '',
  validations: [_Validation.Rules.required, _Validation.Rules.passwordConfirm]
};

ConfirmPasswordFormField.propTypes = {
  enabled: _propTypes2.default.bool,
  onPasswordChange: _propTypes2.default.func,
  confirmPasswordPlaceholder: _propTypes2.default.string,
  validations: _propTypes2.default.arrayOf(_propTypes2.default.func)
};

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Validation = __webpack_require__(44);

var _BaseFormRow = __webpack_require__(76);

var _BaseFormRow2 = _interopRequireDefault(_BaseFormRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EmailFormField = function (_React$Component) {
  _inherits(EmailFormField, _React$Component);

  function EmailFormField(props) {
    _classCallCheck(this, EmailFormField);

    var _this = _possibleConstructorReturn(this, (EmailFormField.__proto__ || Object.getPrototypeOf(EmailFormField)).call(this, props));

    _this.getEmailFormField = _this.getEmailFormField.bind(_this);
    return _this;
  }

  _createClass(EmailFormField, [{
    key: 'getEmailFormField',
    value: function getEmailFormField() {
      var className = 'required email-class email input-xlarge';
      var emailValidationProps = {
        type: 'text',
        name: 'email',
        id: 'email',
        className: className,
        placeholder: this.props.emailPlaceholder,
        validations: this.props.validations,
        autoComplete: 'email'
      };
      return _react2.default.createElement(_BaseFormRow2.default, {
        formClasses: 'control-group email-form-field',
        inputClasses: 'controls',
        htmlFor: 'email',
        label: 'E-mail:',
        stateKey: 'email',
        validationProps: emailValidationProps,
        onChange: this.props.onChange
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var emailFormField = this.getEmailFormField();
      return emailFormField;
    }
  }]);

  return EmailFormField;
}(_react2.default.Component);

exports.default = EmailFormField;


EmailFormField.defaultProps = {
  onChange: function onChange() {},
  emailPlaceholder: '',
  validations: [_Validation.Rules.required, _Validation.Rules.email]
};

EmailFormField.propTypes = {
  onChange: _propTypes2.default.func,
  emailPlaceholder: _propTypes2.default.string,
  validations: _propTypes2.default.arrayOf(_propTypes2.default.func)
};

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Validation = __webpack_require__(44);

var _BaseFormRow = __webpack_require__(76);

var _BaseFormRow2 = _interopRequireDefault(_BaseFormRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PasswordFormField = function (_React$Component) {
  _inherits(PasswordFormField, _React$Component);

  function PasswordFormField(props) {
    _classCallCheck(this, PasswordFormField);

    var _this = _possibleConstructorReturn(this, (PasswordFormField.__proto__ || Object.getPrototypeOf(PasswordFormField)).call(this, props));

    _this.getPasswordFormField = _this.getPasswordFormField.bind(_this);
    return _this;
  }

  _createClass(PasswordFormField, [{
    key: 'getPasswordFormField',
    value: function getPasswordFormField() {
      var enablePassword = this.props.enabled;
      var passwordFormClasses = (0, _classnames2.default)('password-form-field', 'control-group', {
        disabled: !enablePassword
      });
      var passwordValidationProps = {
        type: 'password',
        name: 'password',
        id: 'password',
        className: 'required input-xlarge',
        disabled: !enablePassword,
        placeholder: this.props.passwordPlaceholder,
        autoComplete: 'off',
        validations: this.props.validations
      };
      return _react2.default.createElement(_BaseFormRow2.default, {
        formClasses: passwordFormClasses,
        inputClasses: 'controls',
        htmlFor: 'password',
        label: 'Password:',
        stateKey: 'password',
        value: '',
        validationProps: passwordValidationProps,
        onChange: this.props.onPasswordChange
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var passwordFormField = this.getPasswordFormField();
      return passwordFormField;
    }
  }]);

  return PasswordFormField;
}(_react2.default.Component);

exports.default = PasswordFormField;


PasswordFormField.defaultProps = {
  enabled: true,
  onPasswordChange: function onPasswordChange() {},
  passwordPlaceholder: '',
  validations: [_Validation.Rules.required]
};

PasswordFormField.propTypes = {
  enabled: _propTypes2.default.bool,
  onPasswordChange: _propTypes2.default.func,
  passwordPlaceholder: _propTypes2.default.string,
  validations: _propTypes2.default.arrayOf(_propTypes2.default.func)
};

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Buttons = __webpack_require__(12);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _ModalTertiaryButton = __webpack_require__(604);

var _ModalTertiaryButton2 = _interopRequireDefault(_ModalTertiaryButton);

var _ModalSecondaryButton = __webpack_require__(603);

var _ModalSecondaryButton2 = _interopRequireDefault(_ModalSecondaryButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalActions = function ModalActions(props) {
  var isCtaSectionVisible = props.isCtaSectionVisible,
      primaryCta = props.primaryCta,
      secondaryCta = props.secondaryCta,
      tertiaryBtn = props.tertiaryBtn;


  if (!isCtaSectionVisible) {
    return null;
  }

  var btnCopy = primaryCta.btnCopy,
      className = primaryCta.className,
      onClick = primaryCta.onClick;


  var primaryClasses = (0, _classnames2.default)('ds-modal-primary-btn', className);

  return _react2.default.createElement(
    'div',
    { className: 'ds-modal-btn-container' },
    _react2.default.createElement(
      'div',
      { className: 'ds-modal-cta-row' },
      _react2.default.createElement(_ModalSecondaryButton2.default, secondaryCta),
      _react2.default.createElement(
        'div',
        { className: 'ds-modal-primary-btn-container' },
        _react2.default.createElement(
          _Buttons.PrimaryButton,
          {
            className: primaryClasses,
            onClick: onClick
          },
          btnCopy
        )
      )
    ),
    _react2.default.createElement(_ModalTertiaryButton2.default, tertiaryBtn)
  );
};

ModalActions.defaultProps = {
  isCtaSectionVisible: true,
  secondaryCta: {},
  tertiaryBtn: {}
};

ModalActions.propTypes = {
  isCtaSectionVisible: _propTypes2.default.bool,
  primaryCta: _propTypes2.default.shape({
    btnCopy: _propTypes2.default.string,
    className: _propTypes2.default.string,
    onClick: _propTypes2.default.func
  }).isRequired,
  secondaryCta: _propTypes2.default.shape({
    btnCopy: _propTypes2.default.string,
    className: _propTypes2.default.string,
    onClick: _propTypes2.default.func
  }),
  tertiaryBtn: _propTypes2.default.shape({
    btnCopy: _propTypes2.default.string,
    className: _propTypes2.default.string,
    leadingCopy: _propTypes2.default.string,
    onClick: _propTypes2.default.func,
    variation: _propTypes2.default.oneOf(['', 'alternative'])
  })
};

exports.default = ModalActions;

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _funUtil = __webpack_require__(81);

var _ModalConstants = __webpack_require__(20);

var _ModalConstants2 = _interopRequireDefault(_ModalConstants);

var _FreeWriteBuilderModalConstants = __webpack_require__(101);

var _FreeWriteBuilderModalConstants2 = _interopRequireDefault(_FreeWriteBuilderModalConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactCompatibility = {
  documentSettingsInitialized: function documentSettingsInitialized(documentSettings) {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.documentSettingsInitialized(documentSettings));
  },
  getDocumentContentToSave: function getDocumentContentToSave() {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.getDocumentContentToSave());
  },
  getDocumentShareContentToSave: function getDocumentShareContentToSave() {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.getDocumentShareContentToSave());
  },
  getDefaultDragAndDropDisabled: function getDefaultDragAndDropDisabled() {
    var state = window.FormSwift.React.store.getState();
    return state.UploadHandler.defaultDropTrackingDisabled;
  },
  disableDefaultDragAndDropTracking: function disableDefaultDragAndDropTracking() {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.disableDefaultDragAndDropTracking());
  },
  enableDefaultDragAndDropTracking: function enableDefaultDragAndDropTracking() {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.enableDefaultDragAndDropTracking());
  },
  getState: function getState() {
    return window.FormSwift.React.store.getState();
  },
  getZIndexPopup: function getZIndexPopup() {
    var state = window.FormSwift.React.store.getState();
    return state.popupHandler.zIndex;
  },
  setZIndexPopup: function setZIndexPopup(zIndex) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.setZIndexPopup(zIndex));
  },
  clearActivePopup: function clearActivePopup() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.clearActivePopup());
  },
  createCheckboxPopup: function createCheckboxPopup() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 28;
    var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 28;
    var pageIdx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window.getPageIndex();
    var checked = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var disabled = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.createCheckboxPopup(x, y, width, height, pageIdx, checked, disabled));
  },
  createTextPopup: function createTextPopup(_ref) {
    var _ref$x = _ref.x,
        x = _ref$x === undefined ? 0 : _ref$x,
        _ref$y = _ref.y,
        y = _ref$y === undefined ? 0 : _ref$y,
        _ref$width = _ref.width,
        width = _ref$width === undefined ? 12 : _ref$width,
        _ref$height = _ref.height,
        height = _ref$height === undefined ? 28 : _ref$height,
        _ref$pageIdx = _ref.pageIdx,
        pageIdx = _ref$pageIdx === undefined ? window.getPageIndex() : _ref$pageIdx,
        _ref$text = _ref.text,
        text = _ref$text === undefined ? '' : _ref$text,
        _ref$bold = _ref.bold,
        bold = _ref$bold === undefined ? false : _ref$bold,
        _ref$italic = _ref.italic,
        italic = _ref$italic === undefined ? false : _ref$italic,
        _ref$fontFamily = _ref.fontFamily,
        fontFamily = _ref$fontFamily === undefined ? 'Arial' : _ref$fontFamily,
        _ref$fontSize = _ref.fontSize,
        fontSize = _ref$fontSize === undefined ? 17 : _ref$fontSize,
        _ref$color = _ref.color,
        color = _ref$color === undefined ? '#000000' : _ref$color,
        _ref$draggable = _ref.draggable,
        draggable = _ref$draggable === undefined ? true : _ref$draggable,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === undefined ? false : _ref$disabled,
        _ref$backgroundColor = _ref.backgroundColor,
        backgroundColor = _ref$backgroundColor === undefined ? null : _ref$backgroundColor;

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.createTextPopup({
      x: x,
      y: y,
      width: width,
      height: height,
      pageIdx: pageIdx,
      text: text,
      bold: bold,
      italic: italic,
      fontFamily: fontFamily,
      fontSize: fontSize,
      color: color,
      draggable: draggable,
      disabled: disabled,
      backgroundColor: backgroundColor
    }));
  },
  setRulerActive: function setRulerActive(active) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.setRulerActive(active));
  },
  initEditorMode: function initEditorMode(mode) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.setEditorMode(mode, false));
  },
  setEditorMode: function setEditorMode(mode) {
    var persist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.setEditorMode(mode, persist));
  },
  updateEditorMode: function updateEditorMode(mode) {
    var persist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.updateEditorMode(mode, persist));
  },
  enableSign: function enableSign() {
    var persist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.enableSign(persist));
  },
  enableEdit: function enableEdit() {
    var persist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.enableEdit(persist));
  },
  enableView: function enableView() {
    var persist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.enableView(persist));
  },
  enableRequestSignature: function enableRequestSignature() {
    var persist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.enableRequestSignature(persist));
  },
  enableRequestSignatureWait: function enableRequestSignatureWait() {
    var persist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.enableRequestSignatureWait(persist));
  },
  enableRequestSignatureFill: function enableRequestSignatureFill() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.enableRequestSignatureFill());
  },
  enableSenderSigning: function enableSenderSigning() {
    var persist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.enableSenderSigning(persist));
  },
  unwrapRequestSignaturePopups: function unwrapRequestSignaturePopups() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.unwrapRequestSignaturePopups());
  },
  showSignatureDeclineToolbar: function showSignatureDeclineToolbar() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.showSignatureDeclineToolbar());
  },
  createRequestSignaturePopup: function createRequestSignaturePopup(requestType, x, y, width, height, pageIdx, draggable, disabled, resizable, requestSettings, contentSettings) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.createRequestSignaturePopup(requestType, x, y, width, height, pageIdx, draggable, disabled, resizable, requestSettings, contentSettings));
  },
  createImagePopup: function createImagePopup(src, imgIdx, pageIdx, width, x, y) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.createImgPopup(src, imgIdx, pageIdx, width, x, y));
  },
  createLogoPopup: function createLogoPopup(src, imgIdx, width, x, y) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.createLogoPopup(src, imgIdx, width, x, y));
  },
  createResizablePopup: function createResizablePopup(src, type, imgIdx, pageIdx, width, height, x, y) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.createResizablePopup(src, type, imgIdx, pageIdx, width, height, x, y));
  },
  createSignaturePopup: function createSignaturePopup(src, imgIdx, pageIdx, width, x, y) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.createSigPopup(src, imgIdx, pageIdx, width, x, y));
  },
  deletePopup: function deletePopup(id) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.deletePopup(id));
  },
  deleteSharePopups: function deleteSharePopups() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.deleteSharePopups());
  },
  movePopup: function movePopup(popupID, x, y) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.movePopup(popupID, x, y));
  },
  updatePopup: function updatePopup(popupID, updatedAttributes) {
    if (!popupID) return;
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.changePopup(popupID, updatedAttributes));
  },
  updateRequestSignaturePopupContentSettings: function updateRequestSignaturePopupContentSettings(popupID, updatedAttributes) {
    var reactState = ReactCompatibility.getState();
    var popupData = reactState.popupHandler.popups[popupID];
    var mergedAttributes = _extends({}, popupData.contentSettings, updatedAttributes);

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.changePopup(popupID, {
      contentSettings: mergedAttributes
    }));
  },
  showDownloadOverlay: function showDownloadOverlay() {
    window.FormSwift.React.store.dispatch(window.window.FormSwift.React.actions.showDownloadOverlay());
  },
  openStaticSecondActionModal: function openStaticSecondActionModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openStaticSecondActionModal());
  },
  openSignatureManager: function openSignatureManager() {
    var fromPopupID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.loadPopupIdToSignatureManager(fromPopupID));
  },
  closeSignatureManager: function closeSignatureManager() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.hideFreeWriteSignatureSection());
  },
  savePopupAsSignature: function savePopupAsSignature(popupID, textVal) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.savePopupAsSignature(popupID, textVal));
  },
  selectDocumentSession: function selectDocumentSession(sessionId, documentType, documentName, key) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.selectDocumentSession(sessionId, documentType, documentName, key));
  },
  deselectDocumentSession: function deselectDocumentSession(sessionId) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.deselectDocumentSession(sessionId));
  },
  editDocumentName: function editDocumentName(sessionListIndex, documentName) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.editDocumentName(sessionListIndex, documentName));
  },
  toggleHelpSideBar: function toggleHelpSideBar() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.toggleHelpSideBar());
  },
  openFreeWriteLoadingDocumentModal: function openFreeWriteLoadingDocumentModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openModal(_ModalConstants2.default.FREE_WRITE_LOADING_DOCUMENT));
  },
  closeFreeWriteLoadingDocumentModal: function closeFreeWriteLoadingDocumentModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.closeModal(_ModalConstants2.default.FREE_WRITE_LOADING_DOCUMENT));
  },
  finishFreeWriteLoadingDocumentModal: function finishFreeWriteLoadingDocumentModal() {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.finishModal(_ModalConstants2.default.FREE_WRITE_LOADING_DOCUMENT));

    if (callback) {
      callback();
    }
  },
  openFreeWriteDocumentReadyOnboardingModal: function openFreeWriteDocumentReadyOnboardingModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openFreeWriteOnboardingModal(_FreeWriteBuilderModalConstants2.default.DOCUMENT_READY_FREEWRITE_MODAL));
  },
  closeFreeWriteDocumentReadyModal: function closeFreeWriteDocumentReadyModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.closeModal(_ModalConstants2.default.FREE_WRITE_DOCUMENT_READY));
  },
  openFreeWriteExportDocumentModal: function openFreeWriteExportDocumentModal(format) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openFreeWriteExportDocumentModal(format));
  },
  closeFreeWriteExportDocumentModal: function closeFreeWriteExportDocumentModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.closeModal(_ModalConstants2.default.FREE_WRITE_EXPORT_DOCUMENT));
  },
  openFreeWriteDocumentShareModal: function openFreeWriteDocumentShareModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openModal(_ModalConstants2.default.FREE_WRITE_DOCUMENT_SHARE));
  },
  expandFreeWriteDocumentSignatureSection: function expandFreeWriteDocumentSignatureSection() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.expandFreeWriteSignatureSection());
  },
  openFreeWriteEraserOnboardingModal: function openFreeWriteEraserOnboardingModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openFreeWriteOnboardingModal(_FreeWriteBuilderModalConstants2.default.ERASER_FREEWRITE_MODAL));
  },
  openFreeWriteHighlighterOnboardingModal: function openFreeWriteHighlighterOnboardingModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openFreeWriteOnboardingModal(_FreeWriteBuilderModalConstants2.default.HIGHLIGHTER_FREEWRITE_MODAL));
  },
  openFreeWriteRedactOnboardingModal: function openFreeWriteRedactOnboardingModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openFreeWriteOnboardingModal(_FreeWriteBuilderModalConstants2.default.REDACT_FREEWRITE_MODAL));
  },
  openFreeWriteSignatureCancelModal: function openFreeWriteSignatureCancelModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openModal(_ModalConstants2.default.FREE_WRITE_CANCEL_SIGNATURE));
  },
  openFreeWriteSignatureCancelSurveyModal: function openFreeWriteSignatureCancelSurveyModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openModal(_ModalConstants2.default.FREE_WRITE_CANCEL_SIGNATURE_SURVEY));
  },
  openFreeWriteRequireSignatureModal: function openFreeWriteRequireSignatureModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openModal(_ModalConstants2.default.FREE_WRITE_REQUIRE_SIGNATURE));
  },
  openFreeWriteSignatureReminderModal: function openFreeWriteSignatureReminderModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openModal(_ModalConstants2.default.FREE_WRITE_SIGNATURE_REMINDER));
  },
  selectEfileState: function selectEfileState(val) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.selectState(val));
  },
  openFreeWriteUploadLoadingModal: function openFreeWriteUploadLoadingModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openModal(_ModalConstants2.default.FREE_WRITE_UPLOAD_LOADING));
  },
  closeFreeWriteUploadLoadingModal: function closeFreeWriteUploadLoadingModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.closeModal(_ModalConstants2.default.FREE_WRITE_UPLOAD_LOADING));
  },
  openFreeWriteUploadReadyModal: function openFreeWriteUploadReadyModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openModal(_ModalConstants2.default.FREE_WRITE_UPLOAD_READY));
  },
  openStaticFinishLaterModal: function openStaticFinishLaterModal() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.openModal(_ModalConstants2.default.STATIC_FINISH_LATER));
  },
  setFreeWriteUploadReadyRedirectURL: function setFreeWriteUploadReadyRedirectURL(redirectURL, documentType, sessionHash, sessionKey) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.setUploadRedirectURL(redirectURL, documentType, sessionHash, sessionKey));
  },
  setStaticBuilderNavStep: function setStaticBuilderNavStep(step) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.setStaticBuilderNavStep(step));
  },
  saveFreeWriteContent: function saveFreeWriteContent() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.saveFreeWriteContent());
  },
  startFreeWriteAutoSave: function startFreeWriteAutoSave() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.startFreeWriteAutoSave());
  },
  stopFreeWriteAutoSave: function stopFreeWriteAutoSave() {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.stopAutoSave());
  },
  editPDFPagesSetPagesFromFile: function editPDFPagesSetPagesFromFile(file) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.setPagesFromFile(file));
  },
  getStaticBuilderCurrentStep: function getStaticBuilderCurrentStep() {
    var state = window.FormSwift.React.store.getState();
    return state.StaticBuilderReducer.step;
  },
  setStaticBuilderStepHistory: function setStaticBuilderStepHistory(stepHistory) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.setStaticBuilderStepHistory(stepHistory));
  },
  getStaticBuilderSectionKeys: function getStaticBuilderSectionKeys() {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.getStaticBuilderSectionKeys());
  },
  setStaticBuilderSectionKeys: function setStaticBuilderSectionKeys(keys) {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.setStaticBuilderSectionKeys(keys));
  },
  setStaticBuilderSaveProgressBarAnimationStep: function setStaticBuilderSaveProgressBarAnimationStep(step) {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.setStaticBuilderSaveProgressBarAnimationStep(step));
  },
  startStaticBuilderSaveProgressBarAnimation: function startStaticBuilderSaveProgressBarAnimation() {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.startStaticBuilderSaveProgressBarAnimation());
  },
  finishStaticBuilderSaveProgressBarAnimation: function finishStaticBuilderSaveProgressBarAnimation() {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.finishStaticBuilderSaveProgressBarAnimation());
  },
  disableStaticBuilderSaveProgressBarAnimation: function disableStaticBuilderSaveProgressBarAnimation() {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.disableStaticBuilderSaveProgressBarAnimation());
  },
  loadDocumentContent: function loadDocumentContent(documentContent) {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.loadDocumentContent(documentContent));
  },
  saveStaticBuilderSectionContent: function saveStaticBuilderSectionContent(sectionContent, sectionStep, sectionTitle, sessionId, sessionHash, nextStepEnabled, successAction) {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.saveStaticBuilderSectionContent(sectionContent, sectionStep, sectionTitle, sessionId, sessionHash, nextStepEnabled, successAction));
  },
  addStaticBuilderOnSectionLoadAction: function addStaticBuilderOnSectionLoadAction(onSectionLoadAction) {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.addStaticBuilderOnSectionLoadAction(onSectionLoadAction));
  },
  loadNextStaticBuilderSection: function loadNextStaticBuilderSection(skipSection) {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.loadNextStaticBuilderSection(skipSection));
  },
  loadStaticBuilderSection: function loadStaticBuilderSection(sectionStep) {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.loadStaticBuilderSection(sectionStep));
  },
  enableRecipientSignature: function enableRecipientSignature() {
    return window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.enableRecipientSignature());
  },
  setPopupAttachedToMouse: function setPopupAttachedToMouse(isAttached) {
    window.FormSwift.React.store.dispatch(window.FormSwift.React.actions.setPopupAttachedToMouse(isAttached));
  },
  mainContainerHeightAdjusted: function mainContainerHeightAdjusted(newHeight) {
    var mainContainerHeightAdjusted = (0, _funUtil.getIn)(window, 'FormSwift', 'React', 'actions', 'mainContainerHeightAdjusted');
    if (mainContainerHeightAdjusted) {
      window.FormSwift.React.store.dispatch(mainContainerHeightAdjusted(newHeight));
    }
  }
};
module.exports = ReactCompatibility;

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getLinkSectionTypes = ['waiver-v3', 'release-of-liability-v3'];

var isGetLinkType = exports.isGetLinkType = function isGetLinkType(documentType) {
  return getLinkSectionTypes.indexOf(documentType) !== -1;
};

var isLastSectionGetLink = exports.isLastSectionGetLink = function isLastSectionGetLink(documentType, fieldValue) {
  var isGeneralForm = fieldValue === 'general_form';
  return isGeneralForm && isGetLinkType(documentType);
};

var stepsToTime = exports.stepsToTime = function stepsToTime(numberOfSteps) {
  var TIME_TO_COMPLETE_SECTION_MULTIPLIER = 1 / 3;
  var time = numberOfSteps * TIME_TO_COMPLETE_SECTION_MULTIPLIER;
  var minutes = Math.floor(time);
  var seconds = time * 60 % 60;
  seconds = seconds.toFixed(0);
  var timeString = '';

  if (minutes <= 0 && seconds > 0) {
    return seconds + ' sec';
  }

  if (minutes > 0) {
    timeString = minutes + ' min';
  }
  if (minutes > 1) {
    timeString = timeString + 's';
  }
  if (seconds > 0) {
    timeString = timeString + ' ' + seconds + ' sec';
  }
  return timeString;
};

/***/ }),

/***/ 444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalInput = __webpack_require__(354);

var _ModalInput2 = _interopRequireDefault(_ModalInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalSyncedInput = function (_React$Component) {
  _inherits(ModalSyncedInput, _React$Component);

  function ModalSyncedInput(props) {
    _classCallCheck(this, ModalSyncedInput);

    var _this = _possibleConstructorReturn(this, (ModalSyncedInput.__proto__ || Object.getPrototypeOf(ModalSyncedInput)).call(this, props));

    _this.handleChange = _this.handleChange.bind(_this);
    _this.state = {
      syncedValue: _this.props.value
    };
    return _this;
  }

  _createClass(ModalSyncedInput, [{
    key: 'handleChange',
    value: function handleChange(event) {
      this.setState({
        syncedValue: event.target.value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var visibleFieldProps = {
        id: this.props.id,
        autoComplete: this.props.autoComplete,
        htmlFor: this.props.htmlFor,
        label: this.props.label,
        name: this.props.name,
        type: this.props.type,
        value: this.state.syncedValue,
        onChange: this.handleChange
      };
      var visibleField = _react2.default.createElement(_ModalInput2.default, visibleFieldProps);

      var hiddenFieldProps = {
        id: this.props.hiddenId,
        htmlFor: this.props.hiddenHtmlFor,
        label: this.props.hiddenLabel,
        name: this.props.hiddenName,
        type: 'hidden',
        value: this.state.syncedValue
      };
      var hiddenField = _react2.default.createElement(_ModalInput2.default, hiddenFieldProps);

      return _react2.default.createElement(
        'div',
        { className: 'modal-synced-input-container' },
        visibleField,
        hiddenField
      );
    }
  }]);

  return ModalSyncedInput;
}(_react2.default.Component);

ModalSyncedInput.defaultProps = {
  autoComplete: true,
  value: ''
};

ModalSyncedInput.propTypes = {
  id: _propTypes2.default.string.isRequired,
  htmlFor: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string,
  autoComplete: _propTypes2.default.bool,
  hiddenId: _propTypes2.default.string.isRequired,
  hiddenHtmlFor: _propTypes2.default.string.isRequired,
  hiddenLabel: _propTypes2.default.string.isRequired,
  hiddenName: _propTypes2.default.string.isRequired
};

exports.default = ModalSyncedInput;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber', 'payee1_2ndtinnotice', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_direct_sales', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_section409a_deferrals', 'payee1_section409a_income', 'payee1_statetax_with1', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state_income1', 'payee1_statetax_with2', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income2'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      var eFileButton = document.getElementById('efileDocument');
      // Hide the eFiling option for the 2014 tax returns
      if (!window.SessionManager.isPaidUser && eFileButton) {
        eFileButton.style.display = 'none';
      }

      // --------------------  Attach button events
      VisualStatic.initExportPDF();

      // EFILE
      // Save the document, then then navigate to tax filing page
      // It's a redirect so we're never actually hiding the
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_company_name1', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var regexValidations = {
            payer_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state1_name: stateRegex,
            payee1_state2_name: stateRegex,
            payee1_accountnumber: { regex: new RegExp('^.{1,20}$'), message: '20 or less characters' },
            payee1_rents: currencyRegex,
            payee1_royalties: currencyRegex,
            payee1_other_income: currencyRegex,
            payee1_fedtaxwith: currencyRegex,
            payee1_fishingboat_proceeds: currencyRegex,
            payee1_medical_healthcare_payments: currencyRegex,
            payee1_non_employee_comp: currencyRegex,
            payee1_sub_payments_div_intr: currencyRegex,
            payee1_crop_ins: currencyRegex,
            payee1_excess_golden_parachut: currencyRegex,
            payee1_statetax_with1: currencyRegex,
            payee1_statetax_with2: currencyRegex,
            payee1_state_income1: currencyRegex,
            payee1_state_income2: currencyRegex,
            payee1_section409a_deferrals: currencyRegex,
            payee1_section409a_income: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber', 'payee1_2ndtinnotice', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_direct_sales', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_section409a_deferrals', 'payee1_section409a_income', 'payee1_statetax_with1', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state_income1', 'payee1_statetax_with2', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income2'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();
      VisualStatic.setUpIowaBENInput();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      var eFileButton = document.getElementById('efileDocument');
      // Hide the eFiling option for the 2014 tax returns
      if (!window.SessionManager.isPaidUser && eFileButton) {
        eFileButton.style.display = 'none';
      }

      // --------------------  Attach button events
      VisualStatic.initExportPDF();

      // EFILE
      // Save the document, then then navigate to tax filing page
      // It's a redirect so we're never actually hiding the
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_company_name1', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var regexValidations = {
            payer_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state1_name: stateRegex,
            payee1_state2_name: stateRegex,
            payee1_accountnumber: { regex: new RegExp('^.{1,20}$'), message: '20 or less characters' },
            payee1_rents: currencyRegex,
            payee1_royalties: currencyRegex,
            payee1_other_income: currencyRegex,
            payee1_fedtaxwith: currencyRegex,
            payee1_fishingboat_proceeds: currencyRegex,
            payee1_medical_healthcare_payments: currencyRegex,
            payee1_non_employee_comp: currencyRegex,
            payee1_sub_payments_div_intr: currencyRegex,
            payee1_crop_ins: currencyRegex,
            payee1_excess_golden_parachut: currencyRegex,
            payee1_statetax_with1: currencyRegex,
            payee1_statetax_with2: currencyRegex,
            payee1_state_income1: currencyRegex,
            payee1_state_income2: currencyRegex,
            payee1_section409a_deferrals: currencyRegex,
            payee1_section409a_income: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber', 'payee1_2ndtinnotice', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_direct_sales', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_section409a_deferrals', 'payee1_section409a_income', 'payee1_statetax_with1', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state_income1', 'payee1_statetax_with2', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income2'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_non_employee_comp', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();
      VisualStatic.setUpIowaBENInput();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      var eFileButton = document.getElementById('efileDocument');
      // Hide the eFiling option for the 2014 tax returns
      if (!window.SessionManager.isPaidUser && eFileButton) {
        eFileButton.style.display = 'none';
      }

      // --------------------  Attach button events
      VisualStatic.initExportPDF();

      // EFILE
      // Save the document, then then navigate to tax filing page
      // It's a redirect so we're never actually hiding the
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_company_name1', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var regexValidations = {
            payer_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state1_name: stateRegex,
            payee1_state2_name: stateRegex,
            payee1_accountnumber: { regex: new RegExp('^.{1,20}$'), message: '20 or less characters' },
            payee1_rents: currencyRegex,
            payee1_royalties: currencyRegex,
            payee1_other_income: currencyRegex,
            payee1_fedtaxwith: currencyRegex,
            payee1_fishingboat_proceeds: currencyRegex,
            payee1_medical_healthcare_payments: currencyRegex,
            payee1_non_employee_comp: currencyRegex,
            payee1_sub_payments_div_intr: currencyRegex,
            payee1_crop_ins: currencyRegex,
            payee1_excess_golden_parachut: currencyRegex,
            payee1_statetax_with1: currencyRegex,
            payee1_statetax_with2: currencyRegex,
            payee1_state_income1: currencyRegex,
            payee1_state_income2: currencyRegex,
            payee1_section409a_deferrals: currencyRegex,
            payee1_section409a_income: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payer_country', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber', 'payee1_fatca_filing', 'payee1_2ndtinnotice', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_direct_sales', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_gross_paid_attorney', 'payee1_section409a_deferrals', 'payee1_excess_golden_parachut', 'payee1_section409a_income', 'payee1_statetax_with1', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state_income1', 'payee1_statetax_with2', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income2'];

      this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();
      VisualStatic.setUpIowaBENInput();

      // Set the correct order of fields
      VisualStatic.setTabOrder(this.orderOfFormFields);

      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      var eFileButton = document.getElementById('efileDocument');
      // Hide the eFiling option for unpaid users
      if (!window.SessionManager.isPaidUser && eFileButton) {
        eFileButton.style.display = 'none';
      }

      // Attach button events
      VisualStatic.initExportPDF();

      // [E-file] Context on the E-file flow at this stage:
      // When the e-filing button is clicked, we validate that required fields are added and
      // that certain fields have passed regex validation. Once all specified fields pass validation,
      // we should save the document session and redirect to the taxFiling page.
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_company_name1', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var regexValidations = {
            payer_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state1_name: stateRegex,
            payee1_state2_name: stateRegex,
            payee1_accountnumber: { regex: new RegExp('^.{1,20}$'), message: '20 or less characters' },
            payee1_rents: currencyRegex,
            payee1_royalties: currencyRegex,
            payee1_other_income: currencyRegex,
            payee1_fedtaxwith: currencyRegex,
            payee1_fishingboat_proceeds: currencyRegex,
            payee1_medical_healthcare_payments: currencyRegex,
            payee1_sub_payments_div_intr: currencyRegex,
            payee1_crop_ins: currencyRegex,
            payee1_excess_golden_parachut: currencyRegex,
            payee1_statetax_with1: currencyRegex,
            payee1_statetax_with2: currencyRegex,
            payee1_state_income1: currencyRegex,
            payee1_state_income2: currencyRegex,
            payee1_section409a_deferrals: currencyRegex,
            payee1_section409a_income: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Enter key is disabled from triggering a PDF export
var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payee1_tin', 'payee1_tin', 'payer_tin', 'payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_w2_control_number', 'payee1_first_name', 'payee1_middle_initial', 'payee1_last_name', 'payee1_name_suffix', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_phone', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_wages', 'payee1_soc_sec_withh', 'payee1_med_wages_and_tips', 'payee1_medicare_withh', 'payee1_soc_sec_tips', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_non_qual457', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_state_name_one', 'payee1_state_id_one', 'payee1_state_wages_tips_etc_one', 'payee1_state_tax_withh_one', 'payee1_local_wages_tips_etc_one', 'payee1_local_tax_withh_one', 'payee1_local_name_one', 'payee1_state_name_two', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_two', 'payee1_local_name_two', 'payee1_local_name_two', 'payee1_local_name_two'];

      this.removeLabelsFromFields = ['payee1_tin', 'payer_tin', 'payee1_w2_control_number', 'payee1_state_name_one', 'payee1_state_name_two', 'payee1_state_id_one', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_one', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_one', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_one', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_one', 'payee1_local_tax_withh_two', 'payee1_local_name_one', 'payee1_local_name_two', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_non_qual457', 'payee1_soc_sec_tips', 'payee1_med_wages_and_tips', 'payee1_soc_sec_wages', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_withh', 'payee1_medicare_withh', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();
      VisualStatic.setUpIowaBENInput();

      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      // Hide the eFiling option for the 2014 tax returns
      if (!window.SessionManager.isPaidUser) {
        var eFileElm = document.getElementById('efileDocument');
        if (eFileElm) {
          eFileElm.style.display = 'none';
        }

        document.getElementById('group_efiling_subheading').style.display = 'none';
        document.getElementById('group_payee1_employment_type').style.visibility = 'hidden';
        document.getElementById('group_payer_kind_of_employer').style.visibility = 'hidden';
        document.getElementById('group_payee1_non_qual_non457').style.visibility = 'hidden';

        // group_efiling_subheading is not displayed, which affects positioning of country fields
        document.getElementById('group_payee1_country').style.top = '-3042px';
        document.getElementById('group_payer_country').style.top = '-3355px';
      }

      // Disables default dropdown option for W2 additional fields:
      // payee1_employment_type and payer_kind_of_employer
      VisualStatic.disableW2SelectDefaultOption();

      // --------------------  Attach button events
      VisualStatic.initExportPDF();

      // EFILE
      // Save the document, then then navigate to tax filing page
      // It's a redirect so we're never actually hiding the
      var eFileButton = document.getElementById('efileDocument');
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_first_name', 'payee1_last_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_employment_type', 'payer_kind_of_employer'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var regexValidations = {
            payer_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_code_a: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payee1_code_b: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payee1_code_c: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state_name_one: stateRegex,
            payee1_state_name_two: stateRegex,
            payee1_local_name_one: { regex: new RegExp('^.{1,11}$'), message: '11 or less characters' },
            payee1_local_name_two: { regex: new RegExp('^.{1,11}$'), message: '11 or less characters' },
            payee1_allocated_tips: currencyRegex,
            payee1_dependent_care_benefits: currencyRegex,
            payee1_fit_withh: currencyRegex,
            payee1_local_tax_withh_one: currencyRegex,
            payee1_local_tax_withh_two: currencyRegex,
            payee1_local_wages_tips_etc_one: currencyRegex,
            payee1_local_wages_tips_etc_two: currencyRegex,
            payee1_medicare_withh: currencyRegex,
            payee1_med_wages_and_tips: currencyRegex,
            payee1_non_qual457: currencyRegex,
            payee1_non_qual_non457: currencyRegex,
            payee1_soc_sec_tips: currencyRegex,
            payee1_soc_sec_wages: currencyRegex,
            payee1_soc_sec_withh: currencyRegex,
            payee1_state_tax_withh_one: currencyRegex,
            payee1_state_tax_withh_two: currencyRegex,
            payee1_state_wages_tips_etc_one: currencyRegex,
            payee1_state_wages_tips_etc_two: currencyRegex,
            payee1_wages_tips_other_comp: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Enter key is disabled from triggering a PDF export
var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payee1_tin', 'payee1_tin', 'payer_tin', 'payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_w2_control_number', 'payee1_first_name', 'payee1_middle_initial', 'payee1_last_name', 'payee1_name_suffix', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_phone', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_wages', 'payee1_soc_sec_withh', 'payee1_med_wages_and_tips', 'payee1_medicare_withh', 'payee1_soc_sec_tips', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_non_qual457', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_state_name_one', 'payee1_state_id_one', 'payee1_state_wages_tips_etc_one', 'payee1_state_tax_withh_one', 'payee1_local_wages_tips_etc_one', 'payee1_local_tax_withh_one', 'payee1_local_name_one', 'payee1_state_name_two', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_two', 'payee1_local_name_two', 'payee1_local_name_two', 'payee1_local_name_two'];

      this.removeLabelsFromFields = ['payee1_tin', 'payer_tin', 'payee1_w2_control_number', 'payee1_state_name_one', 'payee1_state_name_two', 'payee1_state_id_one', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_one', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_one', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_one', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_one', 'payee1_local_tax_withh_two', 'payee1_local_name_one', 'payee1_local_name_two', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_non_qual457', 'payee1_soc_sec_tips', 'payee1_med_wages_and_tips', 'payee1_soc_sec_wages', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_withh', 'payee1_medicare_withh', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();
      VisualStatic.setUpIowaBENInput();

      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      // Hide the eFiling option for the 2014 tax returns
      if (!window.SessionManager.isPaidUser) {
        var eFileElm = document.getElementById('efileDocument');
        if (eFileElm) {
          eFileElm.style.display = 'none';
        }

        document.getElementById('group_efiling_subheading').style.display = 'none';
        document.getElementById('group_payee1_employment_type').style.visibility = 'hidden';
        document.getElementById('group_payer_kind_of_employer').style.visibility = 'hidden';
        document.getElementById('group_payee1_non_qual_non457').style.visibility = 'hidden';

        // group_efiling_subheading is not displayed, which affects positioning of country fields
        document.getElementById('group_payee1_country').style.top = '-3042px';
        document.getElementById('group_payer_country').style.top = '-3355px';
      }

      // Disables default dropdown option for W2 additional fields:
      // payee1_employment_type and payer_kind_of_employer
      VisualStatic.disableW2SelectDefaultOption();

      // --------------------  Attach button events
      VisualStatic.initExportPDF();

      // EFILE
      // Save the document, then then navigate to tax filing page
      // It's a redirect so we're never actually hiding the
      var eFileButton = document.getElementById('efileDocument');
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_first_name', 'payee1_last_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_employment_type', 'payer_kind_of_employer'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var regexValidations = {
            payer_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_code_a: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payee1_code_b: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payee1_code_c: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state_name_one: stateRegex,
            payee1_state_name_two: stateRegex,
            payee1_local_name_one: { regex: new RegExp('^.{1,11}$'), message: '11 or less characters' },
            payee1_local_name_two: { regex: new RegExp('^.{1,11}$'), message: '11 or less characters' },
            payee1_allocated_tips: currencyRegex,
            payee1_dependent_care_benefits: currencyRegex,
            payee1_fit_withh: currencyRegex,
            payee1_local_tax_withh_one: currencyRegex,
            payee1_local_tax_withh_two: currencyRegex,
            payee1_local_wages_tips_etc_one: currencyRegex,
            payee1_local_wages_tips_etc_two: currencyRegex,
            payee1_medicare_withh: currencyRegex,
            payee1_med_wages_and_tips: currencyRegex,
            payee1_non_qual457: currencyRegex,
            payee1_non_qual_non457: currencyRegex,
            payee1_soc_sec_tips: currencyRegex,
            payee1_soc_sec_wages: currencyRegex,
            payee1_soc_sec_withh: currencyRegex,
            payee1_state_tax_withh_one: currencyRegex,
            payee1_state_tax_withh_two: currencyRegex,
            payee1_state_wages_tips_etc_one: currencyRegex,
            payee1_state_wages_tips_etc_two: currencyRegex,
            payee1_wages_tips_other_comp: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Enter key is disabled from triggering a PDF export
var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payee1_tin', 'payee1_tin', 'payer_tin', 'payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_w2_control_number', 'payee1_first_name', 'payee1_middle_initial', 'payee1_last_name', 'payee1_name_suffix', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_phone', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_wages', 'payee1_soc_sec_withh', 'payee1_med_wages_and_tips', 'payee1_medicare_withh', 'payee1_soc_sec_tips', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_non_qual457', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_state_name_one', 'payee1_state_id_one', 'payee1_state_wages_tips_etc_one', 'payee1_state_tax_withh_one', 'payee1_local_wages_tips_etc_one', 'payee1_local_tax_withh_one', 'payee1_local_name_one', 'payee1_state_name_two', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_two', 'payee1_local_name_two', 'payee1_local_name_two', 'payee1_local_name_two'];

      this.removeLabelsFromFields = ['payee1_tin', 'payer_tin', 'payee1_w2_control_number', 'payee1_state_name_one', 'payee1_state_name_two', 'payee1_state_id_one', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_one', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_one', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_one', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_one', 'payee1_local_tax_withh_two', 'payee1_local_name_one', 'payee1_local_name_two', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_non_qual457', 'payee1_soc_sec_tips', 'payee1_med_wages_and_tips', 'payee1_soc_sec_wages', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_withh', 'payee1_medicare_withh', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();
      VisualStatic.setUpIowaBENInput();

      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      // Hide the eFiling option for the 2014 tax returns
      if (!window.SessionManager.isPaidUser) {
        var eFileElm = document.getElementById('efileDocument');
        if (eFileElm) {
          eFileElm.style.display = 'none';
        }

        document.getElementById('group_efiling_subheading').style.display = 'none';
        document.getElementById('group_payee1_employment_type').style.visibility = 'hidden';
        document.getElementById('group_payer_kind_of_employer').style.visibility = 'hidden';
        document.getElementById('group_payee1_non_qual_non457').style.visibility = 'hidden';

        // group_efiling_subheading is not displayed, which affects positioning of country fields
        document.getElementById('group_payee1_country').style.top = '-3042px';
        document.getElementById('group_payer_country').style.top = '-3355px';
      }

      // Disables default dropdown option for W2 additional fields:
      // payee1_employment_type and payer_kind_of_employer
      VisualStatic.disableW2SelectDefaultOption();

      // --------------------  Attach button events
      VisualStatic.initExportPDF();

      // EFILE
      // Save the document, then then navigate to tax filing page
      // It's a redirect so we're never actually hiding the
      var eFileButton = document.getElementById('efileDocument');
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_first_name', 'payee1_last_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_employment_type', 'payer_kind_of_employer'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var regexValidations = {
            payer_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_code_a: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payee1_code_b: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payee1_code_c: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state_name_one: stateRegex,
            payee1_state_name_two: stateRegex,
            payee1_local_name_one: { regex: new RegExp('^.{1,11}$'), message: '11 or less characters' },
            payee1_local_name_two: { regex: new RegExp('^.{1,11}$'), message: '11 or less characters' },
            payee1_allocated_tips: currencyRegex,
            payee1_dependent_care_benefits: currencyRegex,
            payee1_fit_withh: currencyRegex,
            payee1_local_tax_withh_one: currencyRegex,
            payee1_local_tax_withh_two: currencyRegex,
            payee1_local_wages_tips_etc_one: currencyRegex,
            payee1_local_wages_tips_etc_two: currencyRegex,
            payee1_medicare_withh: currencyRegex,
            payee1_med_wages_and_tips: currencyRegex,
            payee1_non_qual457: currencyRegex,
            payee1_non_qual_non457: currencyRegex,
            payee1_soc_sec_tips: currencyRegex,
            payee1_soc_sec_wages: currencyRegex,
            payee1_soc_sec_withh: currencyRegex,
            payee1_state_tax_withh_one: currencyRegex,
            payee1_state_tax_withh_two: currencyRegex,
            payee1_state_wages_tips_etc_one: currencyRegex,
            payee1_state_wages_tips_etc_two: currencyRegex,
            payee1_wages_tips_other_comp: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Enter key is disabled from triggering a PDF export
var VisualStatic = __webpack_require__(35);
var FormFields = __webpack_require__(57);

var Form = function (_VisualStatic) {
  _inherits(Form, _VisualStatic);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'init',
    value: function init() {
      this.orderOfFormFields = ['payee1_tin', 'payee1_tin', 'payer_tin', 'payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payer_country', 'payee1_w2_control_number', 'payee1_first_name', 'payee1_middle_initial', 'payee1_last_name', 'payee1_name_suffix', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_phone', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_wages', 'payee1_soc_sec_withh', 'payee1_med_wages_and_tips', 'payee1_medicare_withh', 'payee1_soc_sec_tips', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_non_qual457', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d', 'payee1_statutory_ind', 'payee1_retirement_plan_ind', 'payee1_third_party_sick_pay_ind', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_state_name_one', 'payee1_state_id_one', 'payee1_state_wages_tips_etc_one', 'payee1_state_tax_withh_one', 'payee1_local_wages_tips_etc_one', 'payee1_local_tax_withh_one', 'payee1_local_name_one', 'payee1_state_name_two', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_two', 'payee1_local_name_two', 'payee1_local_name_two', 'payee1_local_name_two'];

      this.removeLabelsFromFields = ['payee1_tin', 'payer_tin', 'payee1_w2_control_number', 'payee1_state_name_one', 'payee1_state_name_two', 'payee1_state_id_one', 'payee1_state_id_two', 'payee1_state_wages_tips_etc_one', 'payee1_state_wages_tips_etc_two', 'payee1_state_tax_withh_one', 'payee1_state_tax_withh_two', 'payee1_local_wages_tips_etc_one', 'payee1_local_wages_tips_etc_two', 'payee1_local_tax_withh_one', 'payee1_local_tax_withh_two', 'payee1_local_name_one', 'payee1_local_name_two', 'payee1_box14_text_one', 'payee1_box14_text_two', 'payee1_box14_text_three', 'payee1_non_qual457', 'payee1_soc_sec_tips', 'payee1_med_wages_and_tips', 'payee1_soc_sec_wages', 'payee1_wages_tips_other_comp', 'payee1_fit_withh', 'payee1_soc_sec_withh', 'payee1_medicare_withh', 'payee1_allocated_tips', 'payee1_dependent_care_benefits', 'payee1_code_a', 'payee1_amt_a', 'payee1_code_b', 'payee1_amt_b', 'payee1_code_c', 'payee1_amt_c', 'payee1_code_d', 'payee1_amt_d'];

      this.initOnReactComponentsMounted();
    }
  }, {
    key: 'initBuilderOnReactComponentsMounted',
    value: function initBuilderOnReactComponentsMounted() {
      this.initBuilder();
      VisualStatic.setUpIowaBENInput();

      VisualStatic.setTabOrder(this.orderOfFormFields);

      // Remove labels (they are basically duplicates)
      VisualStatic.setPlaceholders(this.removeLabelsFromFields);

      // Hide the eFiling option for upaid users
      if (!window.SessionManager.isPaidUser) {
        var eFileElm = document.getElementById('efileDocument');
        if (eFileElm) {
          eFileElm.style.display = 'none';
        }

        document.getElementById('group_efiling_subheading').style.display = 'none';
        document.getElementById('group_payee1_employment_type').style.visibility = 'hidden';
        document.getElementById('group_payer_kind_of_employer').style.visibility = 'hidden';
        document.getElementById('group_payee1_non_qual_non457').style.visibility = 'hidden';

        // group_efiling_subheading is not displayed, which affects positioning of country fields
        document.getElementById('group_payee1_country').style.top = '-3042px';
        document.getElementById('group_payer_country').style.top = '-3355px';
      }

      // Disables default dropdown option for W2 additional fields:
      // payee1_employment_type and payer_kind_of_employer
      VisualStatic.disableW2SelectDefaultOption();

      // Attach button events
      VisualStatic.initExportPDF();

      // [E-file] Context on the E-file flow at this stage:
      // When the e-filing button is clicked, we validate that required fields are added and
      // that certain fields have passed regex validation. Once all specified fields pass validation,
      // we should save the document session and redirect to the taxFiling page.
      var eFileButton = document.getElementById('efileDocument');
      if (eFileButton) {
        eFileButton.addEventListener('click', function (e) {
          var requiredFields = ['payer_tin', 'payer_address1', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_country', 'payer_phone', 'payee1_tin', 'payee1_first_name', 'payee1_last_name', 'payee1_address1', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_employment_type', 'payer_kind_of_employer'];

          var hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
          if (!hasRequiredFields) {
            e.preventDefault();
            return false;
          }

          var currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
          var stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
          var regexValidations = {
            payer_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_tin: { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' },
            payee1_code_a: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payee1_code_b: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payee1_code_c: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payee1_code_d: { regex: new RegExp('^[a-zA-Z]{1,2}$'), message: '2 or less letters only' },
            payee1_amt_a: currencyRegex,
            payee1_amt_b: currencyRegex,
            payee1_amt_c: currencyRegex,
            payee1_amt_d: currencyRegex,
            payer_state: stateRegex,
            payee1_state: stateRegex,
            payee1_state_name_one: stateRegex,
            payee1_state_name_two: stateRegex,
            payee1_local_name_one: { regex: new RegExp('^.{1,11}$'), message: '11 or less characters' },
            payee1_local_name_two: { regex: new RegExp('^.{1,11}$'), message: '11 or less characters' },
            payee1_allocated_tips: currencyRegex,
            payee1_dependent_care_benefits: currencyRegex,
            payee1_fit_withh: currencyRegex,
            payee1_local_tax_withh_one: currencyRegex,
            payee1_local_tax_withh_two: currencyRegex,
            payee1_local_wages_tips_etc_one: currencyRegex,
            payee1_local_wages_tips_etc_two: currencyRegex,
            payee1_medicare_withh: currencyRegex,
            payee1_med_wages_and_tips: currencyRegex,
            payee1_non_qual457: currencyRegex,
            payee1_non_qual_non457: currencyRegex,
            payee1_soc_sec_tips: currencyRegex,
            payee1_soc_sec_wages: currencyRegex,
            payee1_soc_sec_withh: currencyRegex,
            payee1_state_tax_withh_one: currencyRegex,
            payee1_state_tax_withh_two: currencyRegex,
            payee1_state_wages_tips_etc_one: currencyRegex,
            payee1_state_wages_tips_etc_two: currencyRegex,
            payee1_wages_tips_other_comp: currencyRegex
          };
          var validFields = FormFields.validateFields(regexValidations);
          if (!validFields) {
            e.preventDefault();
            return false;
          }

          // Validations passed, save and submit
          return window.SessionManager.save(function () {
            return true;
          });
        });
      }
    }
  }]);

  return Form;
}(VisualStatic);

module.exports = Form;

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(13);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Validation = __webpack_require__(44);

var _ModalForm = __webpack_require__(617);

var _ModalForm2 = _interopRequireDefault(_ModalForm);

var _ModalInput = __webpack_require__(354);

var _ModalInput2 = _interopRequireDefault(_ModalInput);

var _ModalSyncedInput = __webpack_require__(444);

var _ModalSyncedInput2 = _interopRequireDefault(_ModalSyncedInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateAccountModal = function (_React$Component) {
  _inherits(CreateAccountModal, _React$Component);

  _createClass(CreateAccountModal, null, [{
    key: 'init',
    value: function init(props) {
      var elementId = props.id || 'createAccountModal';

      _reactDom2.default.render(_react2.default.createElement(CreateAccountModal, props), document.getElementById(elementId));
    }
  }, {
    key: 'handleDownloadClick',
    value: function handleDownloadClick() {
      window._track('Download Document', 'New Account Modal - Shared');
    }
  }, {
    key: 'getEmailProps',
    value: function getEmailProps() {
      var emailProps = {
        id: 'email',
        htmlFor: 'email',
        label: 'E-mail:',
        name: 'email',
        type: 'text',
        validations: [_Validation.Rules.required, _Validation.Rules.email]
      };
      return emailProps;
    }
  }, {
    key: 'getSyncedPasswordProps',
    value: function getSyncedPasswordProps() {
      var syncedPasswordProps = {
        id: 'password',
        htmlFor: 'password',
        label: 'Password:',
        name: 'password',
        type: 'password',
        autocomplete: false,
        hiddenId: 'confirmPassword',
        hiddenHtmlFor: 'confirmPassword',
        hiddenLabel: 'Confirm Password:',
        hiddenName: 'confirm_password'
      };
      return syncedPasswordProps;
    }
  }, {
    key: 'getPasswordProps',
    value: function getPasswordProps() {
      var passwordProps = {
        id: 'password',
        htmlFor: 'password',
        label: 'Password:',
        name: 'password',
        type: 'password',
        autocomplete: false,
        validations: [_Validation.Rules.required]
      };
      return passwordProps;
    }
  }, {
    key: 'getConfirmPasswordProps',
    value: function getConfirmPasswordProps() {
      var confirmPasswordProps = {
        id: 'confirmPassword',
        htmlFor: 'confirmPassword',
        label: 'Confirm Password:',
        name: 'confirm_password',
        type: 'password',
        autocomplete: false,
        validations: [_Validation.Rules.required, _Validation.Rules.passwordConfirm]
      };
      return confirmPasswordProps;
    }
  }]);

  function CreateAccountModal(props) {
    _classCallCheck(this, CreateAccountModal);

    var _this = _possibleConstructorReturn(this, (CreateAccountModal.__proto__ || Object.getPrototypeOf(CreateAccountModal)).call(this, props));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.getShareKeyProps = _this.getShareKeyProps.bind(_this);
    return _this;
  }

  _createClass(CreateAccountModal, [{
    key: 'getShareKeyProps',
    value: function getShareKeyProps() {
      var shareKeyProps = {
        id: 'shareKey',
        htmlFor: 'shareKey',
        label: 'shareKey:',
        name: 'share_key',
        type: 'hidden',
        value: this.props.shareKey
      };
      return shareKeyProps;
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      this.props.onSubmit(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var emailProps = CreateAccountModal.getEmailProps();
      var emailInputField = _react2.default.createElement(_ModalInput2.default, _extends({ key: emailProps.id }, emailProps));

      var inputs = [emailInputField];
      if (this.props.hideConfirmPassword) {
        var syncedPasswordProps = CreateAccountModal.getSyncedPasswordProps();
        var syncedPasswordField = _react2.default.createElement(_ModalSyncedInput2.default, _extends({
          key: syncedPasswordProps.id + '-' + syncedPasswordProps.hiddenId
        }, syncedPasswordProps));
        inputs.push(syncedPasswordField);
      } else {
        var passwordProps = CreateAccountModal.getPasswordProps();
        var passwordInputField = _react2.default.createElement(_ModalInput2.default, _extends({ key: passwordProps.id }, passwordProps));

        var confirmPasswordProps = CreateAccountModal.getConfirmPasswordProps();
        var confirmPasswordInputField = _react2.default.createElement(_ModalInput2.default, _extends({
          key: confirmPasswordProps.id
        }, confirmPasswordProps));

        inputs.push(passwordInputField);
        inputs.push(confirmPasswordInputField);
      }

      if (this.props.shareKey) {
        var shareKeyProps = this.getShareKeyProps();
        var shareKeyField = _react2.default.createElement(_ModalInput2.default, _extends({ key: shareKeyProps.id }, shareKeyProps));

        inputs.push(shareKeyField);
      }

      var modalErrorStyle = {
        fontSize: '16px'
      };

      return _react2.default.createElement(
        'div',
        { id: 'createAccountModal', className: 'pane hide modal fade' },
        _react2.default.createElement(
          'div',
          { className: 'modal-header' },
          _react2.default.createElement(
            'span',
            null,
            this.props.heading
          ),
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement('button', {
              id: 'download_button-modal',
              onClick: CreateAccountModal.handleDownloadClick,
              className: 'btn', title: 'Download Document'
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'modal-body' },
          _react2.default.createElement(
            'h3',
            { className: 'centered' },
            this.props.bodyHeading
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('div', {
            id: 'createAccountModalError',
            className: 'alert alert-danger hide',
            style: modalErrorStyle
          }),
          _react2.default.createElement(_ModalForm2.default, {
            inputs: inputs,
            onSubmit: this.handleSubmit,
            submitLabel: 'Create Account'
          })
        )
      );
    }
  }]);

  return CreateAccountModal;
}(_react2.default.Component);

CreateAccountModal.defaultProps = {
  shareKey: '',
  hideConfirmPassword: true
};

CreateAccountModal.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  shareKey: _propTypes2.default.string,
  heading: _propTypes2.default.string.isRequired,
  bodyHeading: _propTypes2.default.string.isRequired,
  hideConfirmPassword: _propTypes2.default.bool
};

exports.default = CreateAccountModal;

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Utils = __webpack_require__(18);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StaticBuilderFormattedFields = function () {
  function StaticBuilderFormattedFields(sectionContent) {
    _classCallCheck(this, StaticBuilderFormattedFields);

    // Each of formattedFields should look something like:
    // {
    //   field: {},
    //   fields: [ field1, ...],
    //   isMultiple: boolean,
    //   isEndOfMultiple: boolean,
    // }
    this.formattedFields = [];
    this.sectionContent = sectionContent;
    this.currentFieldNumber = null;
  }

  _createClass(StaticBuilderFormattedFields, [{
    key: 'getAllFormattedFields',
    value: function getAllFormattedFields() {
      return this.formattedFields;
    }
  }, {
    key: 'setupFieldInitialValue',
    value: function setupFieldInitialValue(field) {
      var updatedField = _extends({}, field);

      if (field.type === 'select_multiple') {
        var initialValuesArray = [];

        // if the field has content, then our api (php) correctly returns json
        try {
          initialValuesArray = JSON.parse(this.sectionContent[field.id] || null) || [];
        } catch (error) {
          // otherwise it returns the string `--` which we can't parse.
          // So, when we can't parse the json we use the field value itself, `--`.
          initialValuesArray = [this.sectionContent[field.id]];
        }
        updatedField.initialValues = (0, _Utils.arrayToObjWithValues)(initialValuesArray, true);
      } else {
        updatedField.initialValue = this.sectionContent[field.id];
      }

      return updatedField;
    }

    // Since our product maps use numbers in the id of a field to determine
    // whether fields should be grouped (and order is important), we need to
    // iterate through them first to properly create the groups.

  }, {
    key: 'addField',
    value: function addField(field) {
      var isEndOfMultiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var updatedField = this.setupFieldInitialValue(field);

      // We first check if an id ends in a number, if so, we create a group
      // and all immediete consecutive fields with ids that end with the same
      // number will be in the same group (if a field later in the array has
      // an id with the same number, but is not consecutive, it will be in a new separate group)
      var idDelimSeparated = updatedField.id.split('_');
      var lastFieldIdChar = idDelimSeparated[idDelimSeparated.length - 1];

      // Finally, we only include the option to 'add more fields' to a group if
      // the field that immediately follows the group does not end in a number
      // or if we are on the last field in the array
      if ((0, _Utils.isNumeric)(lastFieldIdChar)) {
        this.addFieldMultiple(updatedField, lastFieldIdChar, isEndOfMultiple);
      } else {
        // reset currentFieldNumber since any fields afterwards that end in the same number
        // should not be grouped
        this.currentFieldNumber = null;
        if (this.formattedFields.length) {
          this.formattedFields[this.formattedFields.length - 1].isEndOfMultiple = true;
        }

        this.formattedFields.push({
          field: updatedField,
          isMultiple: false,
          isEndOfMultiple: true
        });
      }
    }
  }, {
    key: 'addFieldMultiple',
    value: function addFieldMultiple(updatedField, lastFieldIdChar, isEndOfMultiple) {
      if (this.currentFieldNumber === lastFieldIdChar) {
        this.formattedFields[this.formattedFields.length - 1].fields.push(updatedField);
        this.formattedFields[this.formattedFields.length - 1].isEndOfMultiple = isEndOfMultiple;
      } else {
        this.currentFieldNumber = lastFieldIdChar;
        this.formattedFields.push({
          fields: [updatedField],
          isMultiple: true,
          isEndOfMultiple: isEndOfMultiple
        });
      }
    }
  }]);

  return StaticBuilderFormattedFields;
}();

exports.default = StaticBuilderFormattedFields;

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(733);

var FormFields = function () {
  function FormFields() {
    _classCallCheck(this, FormFields);
  }

  _createClass(FormFields, null, [{
    key: 'confirmEmail',
    value: function confirmEmail(emailStr) {
      return document.getElementById('email').value === emailStr;
    }
  }, {
    key: 'duplicateField',
    value: function duplicateField(firstId, copyId) {
      var _this = this;

      $('#' + firstId).keyup(function () {
        var curVal = $(_this).val(); // grab what's in the field
        // do stuff with curVal so that it's what you want
        $('#' + copyId).val(curVal);
      });
    }
  }, {
    key: 'fieldsHaveContent',
    value: function fieldsHaveContent(fieldSetArray) {
      for (var i = 0; i < fieldSetArray.length; i += 1) {
        if ($('[name=\'' + fieldSetArray[i] + '\']').val().length < 1) {
          FormFields.errorAlert('Please fill in ' + $('label[for=' + fieldSetArray[i] + ']').text());
          $('[name=\'' + fieldSetArray[i] + '\']').focus();
          return false;
        }
      }
      return true;
    }
  }, {
    key: 'errorAlert',
    value: function errorAlert(msg) {
      var errorModal = $('div.alert-danger');
      if (errorModal.length === 0) {
        // Create the modal
        $('#srb_content_wrapper').prepend('<div class="alert alert-danger alert-visual-static efile"><strong>Error!</strong> ' + msg + '</div>');
      } else {
        // Alter existing modal
        errorModal.fadeOut(500);
        errorModal.html('<strong>Error!</strong> ' + msg);
        errorModal.fadeIn(500);
      }
      return false;
    }
  }, {
    key: 'checkRequiredFields',
    value: function checkRequiredFields(fields) {
      var missingRequirements = fields.filter(function (field) {
        var value = document.getElementById(field).value;
        return value === null || value === undefined || value === '';
      });
      var isMissingRequirements = missingRequirements.length > 0;

      if (isMissingRequirements) {
        var fieldName = document.querySelector('#group_' + missingRequirements[0] + ' label').innerHTML.replace(':', '');
        FormFields.errorAlert('Missing required field: ' + fieldName);
        document.getElementById(missingRequirements[0]).focus();
      }
      return !isMissingRequirements;
    }
  }, {
    key: 'validateFields',
    value: function validateFields(regexValidations) {
      var regexFields = Object.keys(regexValidations);
      var invalidFields = regexFields.filter(function (field) {
        var regex = regexValidations[field].regex;
        var value = document.getElementById(field).value;
        return value !== null && value !== undefined && value !== '' && regex.test(value) === false;
      });
      var isInvalid = invalidFields.length > 0;

      if (isInvalid) {
        var fieldName = document.querySelector('#group_' + invalidFields[0] + ' label').innerHTML.replace(':', '');
        var message = regexValidations[invalidFields[0]].message;
        FormFields.errorAlert('Incorrect format for ' + fieldName + ': ' + message);
        document.getElementById(invalidFields[0]).focus();
      }

      return !isInvalid;
    }
  }]);

  return FormFields;
}();

module.exports = FormFields;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AnswerQuestionTooltipContent = __webpack_require__(108);

Object.defineProperty(exports, 'AnswerQuestionTooltipContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AnswerQuestionTooltipContent).default;
  }
});

var _DisableOverlay = __webpack_require__(243);

Object.defineProperty(exports, 'DisableOverlay', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DisableOverlay).default;
  }
});

var _ElementWithAnswerFilledTooltip = __webpack_require__(244);

Object.defineProperty(exports, 'ElementWithAnswerFilledTooltip', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ElementWithAnswerFilledTooltip).default;
  }
});

var _ElementWithAnswerQuestionTooltip = __webpack_require__(245);

Object.defineProperty(exports, 'ElementWithAnswerQuestionTooltip', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ElementWithAnswerQuestionTooltip).default;
  }
});

var _OrganizeSectionsButton = __webpack_require__(246);

Object.defineProperty(exports, 'OrganizeSectionsButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OrganizeSectionsButton).default;
  }
});

var _RecipientPreviewEmptyStateTextField = __webpack_require__(247);

Object.defineProperty(exports, 'RecipientPreviewEmptyStateTextField', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RecipientPreviewEmptyStateTextField).default;
  }
});

var _RecipientPreviewEmptyStateTooltip = __webpack_require__(109);

Object.defineProperty(exports, 'RecipientPreviewEmptyStateTooltip', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RecipientPreviewEmptyStateTooltip).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DownloadArrowDirectionEnum = exports.DownloadArrowDirectionEnum = {
  UP: 1,
  RIGHT: 2,
  DOWN: 3,
  LEFT: 4
};

var SupportedBrowserEnum = exports.SupportedBrowserEnum = {
  CHROME: 1,
  FIREFOX: 2,
  MSIE: 3,
  MSEDGE: 4
};

/***/ }),

/***/ 599:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var ProgressBar = {
  contentWrapper: null,
  inputTypeText: null,
  containerContent: null,
  progressLineSelector: '.progress_line .inner',
  progressValueSelector: '.status_completing .value',
  progressTimeLeftSelector: '.time_to_finish',
  progressTimeExplanationSelector: '.time_explanation',

  timeEstimate: '<div class="time_estimate sticky-time-estimate">' + '<p class="time_line"><span class="time_to_finish"></span><span class="time_explanation"></p>' + '<div class="progress_bar">' + '<div class="progress_line">' + '<div class="inner"></div> ' + '</div>' + '<p class="status_completing">' + '<span class="value">0</span>' + ' % Complete' + '</p>' + '<div class="arrow_0"></div>' + '<div class="arrow_1"></div>' + '<div class="arrow_2"></div>' + '<div class="arrow_3"></div>' + '</div>' + '</div>'
};

ProgressBar.init = function () {
  $('body').addClass('h-prog');

  ProgressBar.contentWrapper = $('#srb_content_wrapper');
  ProgressBar.inputTypeText = ProgressBar.contentWrapper.find('input[type="text"]');
  ProgressBar.containerContent = $('.builder-toolbar .container');

  ProgressBar.containerContent.append(ProgressBar.timeEstimate);

  ProgressBar.handleEvent();
  ProgressBar.handleCompletionTime();
  ProgressBar.handleStickiness();
};

ProgressBar.setValues = function (counter, elemVal, cssElem) {
  if (counter === 0) {
    elemVal.text('20');
    cssElem.css({
      width: '22%'
    });
  } else if (counter > 0 && counter <= 4) {
    elemVal.text('40');
    cssElem.css({
      width: '42%'
    });
  } else if (counter >= 5 && counter <= 9) {
    elemVal.text('60');
    cssElem.css({
      width: '62%'
    });
  } else if (counter >= 10 && counter <= 14) {
    elemVal.text('80');
    cssElem.css({
      width: '82%'
    });
  } else if (counter >= 15) {
    elemVal.text('100');
    cssElem.css({
      width: '100%'
    });
  }
};

ProgressBar.handleEvent = function () {
  var counter = 0;
  var value = $(ProgressBar.progressValueSelector);
  var progressLine = $(ProgressBar.progressLineSelector);

  ProgressBar.inputTypeText.each(function () {
    if ($(this).val().length) {
      counter += 1;
    }
  });

  ProgressBar.setValues(counter, value, progressLine);
};

ProgressBar.handleCompletionTime = function () {
  var changeLimelineText = function changeLimelineText(filledInputCount) {
    $(ProgressBar.progressTimeExplanationSelector).text('Until Completion');

    if (filledInputCount === 0) {
      $(ProgressBar.progressTimeLeftSelector).text('2 min ');
      $(ProgressBar.progressValueSelector).text('20');
    } else if (filledInputCount > 0 && filledInputCount < 5) {
      $(ProgressBar.progressTimeLeftSelector).text('1 Min 30 Sec ');
    } else if (filledInputCount >= 5 && filledInputCount < 10) {
      $(ProgressBar.progressTimeLeftSelector).text('1 Min ');
    } else if (filledInputCount >= 10 && filledInputCount < 15) {
      $(ProgressBar.progressTimeLeftSelector).text('30 Sec ');
    } else {
      $(ProgressBar.progressTimeLeftSelector).text('You’re Done! ');
      $(ProgressBar.progressTimeExplanationSelector).text(' ');
    }
  };

  var countFilledInputs = function countFilledInputs() {
    var currentNumber = 0;

    $.each($('input[type="text"]'), function () {
      if ($(this).val().length) currentNumber += 1;
    });

    return currentNumber;
  };

  var updateCompletionTime = function updateCompletionTime() {
    var numberFilledInputs = countFilledInputs();
    changeLimelineText(numberFilledInputs);
  };

  updateCompletionTime();

  $('body').on('change', 'input[type="text"]', updateCompletionTime);
};

ProgressBar.handleStickiness = function () {
  var timeEstimateToolbarTop = $('.sticky-time-estimate-toolbar').offset().top;

  $(window).scroll(function () {
    if ($(window).scrollTop() >= timeEstimateToolbarTop) {
      $('.sticky-time-estimate-toolbar').addClass('fixed');
    } else {
      $('.sticky-time-estimate-toolbar').removeClass('fixed');
    }
  });
};

module.exports = ProgressBar;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mergeClassNames = __webpack_require__(125);

var _mergeClassNames2 = _interopRequireDefault(_mergeClassNames);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Tile = function Tile(_ref) {
  var activeStartDate = _ref.activeStartDate,
      children = _ref.children,
      classes = _ref.classes,
      date = _ref.date,
      dateTime = _ref.dateTime,
      maxDate = _ref.maxDate,
      maxDateTransform = _ref.maxDateTransform,
      minDate = _ref.minDate,
      minDateTransform = _ref.minDateTransform,
      onClick = _ref.onClick,
      onMouseOver = _ref.onMouseOver,
      style = _ref.style,
      tileClassName = _ref.tileClassName,
      tileContent = _ref.tileContent,
      tileDisabled = _ref.tileDisabled,
      view = _ref.view;
  return _react2.default.createElement(
    'button',
    {
      className: (0, _mergeClassNames2.default)(classes, tileClassName instanceof Function ? tileClassName({ date: date, view: view }) : tileClassName),
      disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({ activeStartDate: activeStartDate, date: date, view: view }),
      onClick: onClick && function () {
        return onClick(date);
      },
      onMouseOver: onMouseOver && function () {
        return onMouseOver(date);
      },
      onFocus: onMouseOver && function () {
        return onMouseOver(date);
      },
      style: style,
      type: 'button'
    },
    _react2.default.createElement(
      'time',
      { dateTime: dateTime },
      children
    ),
    typeof tileContent === 'function' ? tileContent({ date: date, view: view }) : tileContent
  );
};

Tile.propTypes = _extends({}, _propTypes3.tileProps, {
  children: _propTypes2.default.node.isRequired,
  dateTime: _propTypes2.default.string.isRequired,
  maxDateTransform: _propTypes2.default.func.isRequired,
  minDateTransform: _propTypes2.default.func.isRequired
});

exports.default = Tile;

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalIcon = function ModalIcon(_ref) {
  var alt = _ref.alt,
      className = _ref.className,
      src = _ref.src;

  if (!src) {
    return null;
  }

  var iconClasses = (0, _classnames2.default)('ds-modal-icon', className);

  return _react2.default.createElement(
    'div',
    { className: 'ds-modal-icon-container' },
    _react2.default.createElement('img', {
      alt: alt,
      className: iconClasses,
      src: src
    })
  );
};

ModalIcon.defaultProps = {
  alt: '',
  className: '',
  src: ''
};

ModalIcon.propTypes = {
  alt: _propTypes2.default.string,
  className: _propTypes2.default.string,
  src: _propTypes2.default.string
};

exports.default = ModalIcon;

/***/ }),

/***/ 603:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Buttons = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalSecondaryButton = function ModalSecondaryButton(props) {
  var btnCopy = props.btnCopy,
      className = props.className,
      onClick = props.onClick;


  if (!btnCopy) {
    return null;
  }

  var secondaryClasses = (0, _classnames2.default)('ds-modal-secondary-btn', className);

  return _react2.default.createElement(
    'div',
    { className: 'ds-modal-secondary-btn-container' },
    _react2.default.createElement(
      _Buttons.SecondaryButton,
      {
        className: secondaryClasses,
        onClick: onClick
      },
      btnCopy
    )
  );
};

ModalSecondaryButton.defaultProps = {
  btnCopy: '',
  className: '',
  onClick: function onClick() {}
};

ModalSecondaryButton.propTypes = {
  btnCopy: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

exports.default = ModalSecondaryButton;

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Buttons = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalTertiaryButton = function ModalTertiaryButton(props) {
  var btnCopy = props.btnCopy,
      className = props.className,
      onClick = props.onClick,
      leadingCopy = props.leadingCopy,
      variation = props.variation;


  if (!btnCopy) {
    return null;
  }

  var tertiaryClasses = (0, _classnames2.default)('ds-modal-tertiary-btn', className);

  var LeadingCopy = (0, _react.useCallback)(function () {
    return leadingCopy ? _react2.default.createElement(
      'span',
      { className: 'ds-modal-leading-tertiary-btn-copy' },
      leadingCopy
    ) : null;
  }, [leadingCopy]);

  return _react2.default.createElement(
    'div',
    { className: 'ds-modal-btn-row' },
    _react2.default.createElement(LeadingCopy, null),
    _react2.default.createElement(
      'div',
      { className: 'ds-modal-tertiary-btn-container' },
      _react2.default.createElement(
        _Buttons.TertiaryButton,
        {
          className: tertiaryClasses,
          onClick: onClick,
          variation: variation
        },
        btnCopy
      )
    )
  );
};

ModalTertiaryButton.defaultProps = {
  btnCopy: '',
  className: '',
  leadingCopy: '',
  onClick: function onClick() {},
  variation: ''
};

ModalTertiaryButton.propTypes = {
  className: _propTypes2.default.string,
  btnCopy: _propTypes2.default.string,
  leadingCopy: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  variation: _propTypes2.default.oneOf(['', 'alternative'])
};

exports.default = ModalTertiaryButton;

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Flex = __webpack_require__(79);

var _Flex2 = _interopRequireDefault(_Flex);

var _utils = __webpack_require__(131);

var _propTypes3 = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TileGroup = function TileGroup(_ref) {
  var className = _ref.className,
      count = _ref.count,
      dateTransform = _ref.dateTransform,
      dateType = _ref.dateType,
      end = _ref.end,
      hover = _ref.hover,
      offset = _ref.offset,
      start = _ref.start,
      step = _ref.step,
      Tile = _ref.tile,
      value = _ref.value,
      valueType = _ref.valueType,
      tileProps = _objectWithoutProperties(_ref, ['className', 'count', 'dateTransform', 'dateType', 'end', 'hover', 'offset', 'start', 'step', 'tile', 'value', 'valueType']);

  var tiles = [];
  for (var point = start; point <= end; point += step) {
    var date = dateTransform(point);

    tiles.push(_react2.default.createElement(Tile, _extends({
      classes: (0, _utils.getTileClasses)({
        value: value, valueType: valueType, date: date, dateType: dateType, hover: hover
      }),
      date: date,
      point: point,
      key: date.getTime()
    }, tileProps)));
  }

  return _react2.default.createElement(
    _Flex2.default,
    {
      className: className,
      count: count,
      offset: offset,
      wrap: true
    },
    tiles
  );
};

TileGroup.propTypes = _extends({}, _propTypes3.tileGroupProps, {
  activeStartDate: _propTypes2.default.instanceOf(Date),
  count: _propTypes2.default.number,
  dateTransform: _propTypes2.default.func.isRequired,
  offset: _propTypes2.default.number,
  tile: _propTypes2.default.func.isRequired,
  step: _propTypes2.default.number
});

TileGroup.defaultProps = {
  count: 3,
  step: 1
};

exports.default = TileGroup;

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var selectState = function selectState(val) {
  return function (dispatch) {
    dispatch({
      type: 'SELECT_EFILE_STATE',
      selectedState: val
    });
  };
};

exports.default = selectState;

/***/ }),

/***/ 614:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IowaBENInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(13);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(3);

var ReactRedux = _interopRequireWildcard(_reactRedux);

var _IowaBENInputActions = __webpack_require__(613);

var _IowaBENInputActions2 = _interopRequireDefault(_IowaBENInputActions);

var _store = __webpack_require__(25);

var _store2 = _interopRequireDefault(_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IowaBENInput = exports.IowaBENInput = function (_React$PureComponent) {
  _inherits(IowaBENInput, _React$PureComponent);

  function IowaBENInput(props) {
    _classCallCheck(this, IowaBENInput);

    var _this = _possibleConstructorReturn(this, (IowaBENInput.__proto__ || Object.getPrototypeOf(IowaBENInput)).call(this, props));

    _this.isVisible = _this.isVisible.bind(_this);
    return _this;
  }

  _createClass(IowaBENInput, [{
    key: 'isVisible',
    value: function isVisible() {
      return this.props.filingState !== null && this.props.filingState.toLowerCase() === 'ia';
    }
  }, {
    key: 'render',
    value: function render() {
      return !this.isVisible() ? null : _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'label',
          { className: 'control-label hide-label', htmlFor: 'payee1_ia_ben' },
          'Iowa Business eFile Number (BEN)'
        ),
        _react2.default.createElement(
          'div',
          { className: 'controls' },
          _react2.default.createElement('input', {
            type: 'text',
            className: 'input-large',
            defaultValue: this.props.value,
            id: 'payee1_ia_ben',
            name: 'payee1_ia_ben',
            placeholder: 'Iowa Business eFile Number (BEN)'
          })
        )
      );
    }
  }]);

  return IowaBENInput;
}(_react2.default.PureComponent);

IowaBENInput.propTypes = {
  filingState: _propTypes2.default.string,
  value: _propTypes2.default.string
};

IowaBENInput.defaultProps = {
  filingState: null,
  value: ''
};

var mapStateToProps = function mapStateToProps(_ref) {
  var IowaBENInputHandler = _ref.IowaBENInputHandler;
  return {
    filingState: IowaBENInputHandler.filingState
  };
};
var ConnectedIowaBENInput = ReactRedux.connect(mapStateToProps)(IowaBENInput);

ConnectedIowaBENInput.init = function (props, id) {
  var elementId = id || 'group_payee1_ia_ben';
  _reactDom2.default.render(_react2.default.createElement(
    ReactRedux.Provider,
    { store: _store2.default },
    _react2.default.createElement(ConnectedIowaBENInput, props)
  ), document.getElementById(elementId));
};

if (window.FormSwift && window.FormSwift.React) {
  var newActions = Object.assign({}, window.FormSwift.React.actions, { selectState: _IowaBENInputActions2.default });
  window.FormSwift.React.actions = newActions;
} else {
  window.FormSwift = {
    React: {
      store: _store2.default,
      actions: { selectState: _IowaBENInputActions2.default }
    }
  };
}

exports.default = ConnectedIowaBENInput;

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Validation = __webpack_require__(44);

var _ModalInput = __webpack_require__(354);

var _ModalInput2 = _interopRequireDefault(_ModalInput);

var _ModalSyncedInput = __webpack_require__(444);

var _ModalSyncedInput2 = _interopRequireDefault(_ModalSyncedInput);

var _NewAccountTermsOfService = __webpack_require__(215);

var _NewAccountTermsOfService2 = _interopRequireDefault(_NewAccountTermsOfService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalForm = function (_React$Component) {
  _inherits(ModalForm, _React$Component);

  function ModalForm(props) {
    _classCallCheck(this, ModalForm);

    var _this = _possibleConstructorReturn(this, (ModalForm.__proto__ || Object.getPrototypeOf(ModalForm)).call(this, props));

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  _createClass(ModalForm, [{
    key: 'handleSubmit',
    value: function handleSubmit(event) {
      this.form.validateAll();
      this.props.onSubmit(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _Validation.Form,
        {
          className: 'form-horizontal',
          onSubmit: this.handleSubmit,
          method: 'POST',
          ref: function ref(c) {
            _this2.form = c;
          }
        },
        this.props.inputs.map(function (inputField) {
          return inputField;
        }),
        _react2.default.createElement(
          'div',
          { className: 'control-group' },
          _react2.default.createElement(
            'div',
            { className: 'register-with-tos send-for-signature-with-tos' },
            _react2.default.createElement(_NewAccountTermsOfService2.default, null)
          ),
          _react2.default.createElement(
            'button',
            {
              type: 'submit',
              className: 'btn btn-success btn-large submit-btn'
            },
            this.props.submitLabel
          )
        )
      );
    }
  }]);

  return ModalForm;
}(_react2.default.Component);

ModalForm.propTypes = {
  inputs: _propTypes2.default.arrayOf(function (propValue, key, componentName, location, propFullName) {
    if (propValue[key].type !== _ModalInput2.default && propValue[key].type !== _ModalSyncedInput2.default) {
      return new Error('Invalid prop \'' + propFullName + '\' supplied to \'' + componentName + '\'. Validation failed.');
    }
    return undefined;
  }).isRequired,

  onSubmit: _propTypes2.default.func.isRequired,
  submitLabel: _propTypes2.default.string.isRequired
};

exports.default = ModalForm;

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var OfferManager = function OfferManager() {
    var that = this;

    that.showReactivationModal = function () {
        // hide all other modals first, other-wise they might appear on top of the offer

        $(".modal").each(function () {
            $(this).modal("hide");
        });

        $("#reactivation-offer-modal").modal("show");
    };

    that.requestExport = function (afterSuccessFunc, upgradeUrl, checkOnly, search) {
        var paramStr = search || window.location.search.substr(1);
        if (checkOnly) {
            paramStr += "&check_only=1";
        }

        if (window.exportURL && window.exportURL.includes('force_download=1')) {
            paramStr += "&force_download=1";
        }
        if (paramStr.indexOf('?') === 0) {
            paramStr = paramStr.substring(1);
        }
        $.post("/_api/requestExport.php", paramStr, function (resp) {
            if (resp.allow_export) {
                afterSuccessFunc();
            } else {
                if (resp.next_action == 'show_reactivation_modal') {
                    that.showReactivationModal();
                } else {
                    window.location = upgradeUrl;
                }
            }
        });
    };

    that.applyReactivationOffer = function (showOfferOn) {
        $(showOfferOn).each(this.addReactivationOfferClickEvent);
    };

    that.addReactivationOfferClickEvent = function () {

        // We don't want any other onclick events firing, remove them then add our own.
        $(this).prop('onclick', null);
        $(this).attr("href", "#");

        $(this).click(function (e) {
            that.showReactivationModal();
            e.preventDefault();
            return false;
        });
    };
};

module.exports = OfferManager;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery Validation Plugin v1.18.0
 *
 * https://jqueryvalidation.org/
 *
 * Copyright (c) 2018 Jörn Zaefferer
 * Released under the MIT license
 */
(function( factory ) {
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module === "object" && module.exports) {
		module.exports = factory( require( "jquery" ) );
	} else {
		factory( jQuery );
	}
}(function( $ ) {

$.extend( $.fn, {

	// https://jqueryvalidation.org/validate/
	validate: function( options ) {

		// If nothing is selected, return nothing; can't chain anyway
		if ( !this.length ) {
			if ( options && options.debug && window.console ) {
				console.warn( "Nothing selected, can't validate, returning nothing." );
			}
			return;
		}

		// Check if a validator for this form was already created
		var validator = $.data( this[ 0 ], "validator" );
		if ( validator ) {
			return validator;
		}

		// Add novalidate tag if HTML5.
		this.attr( "novalidate", "novalidate" );

		validator = new $.validator( options, this[ 0 ] );
		$.data( this[ 0 ], "validator", validator );

		if ( validator.settings.onsubmit ) {

			this.on( "click.validate", ":submit", function( event ) {

				// Track the used submit button to properly handle scripted
				// submits later.
				validator.submitButton = event.currentTarget;

				// Allow suppressing validation by adding a cancel class to the submit button
				if ( $( this ).hasClass( "cancel" ) ) {
					validator.cancelSubmit = true;
				}

				// Allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
				if ( $( this ).attr( "formnovalidate" ) !== undefined ) {
					validator.cancelSubmit = true;
				}
			} );

			// Validate the form on submit
			this.on( "submit.validate", function( event ) {
				if ( validator.settings.debug ) {

					// Prevent form submit to be able to see console output
					event.preventDefault();
				}

				function handle() {
					var hidden, result;

					// Insert a hidden input as a replacement for the missing submit button
					// The hidden input is inserted in two cases:
					//   - A user defined a `submitHandler`
					//   - There was a pending request due to `remote` method and `stopRequest()`
					//     was called to submit the form in case it's valid
					if ( validator.submitButton && ( validator.settings.submitHandler || validator.formSubmitted ) ) {
						hidden = $( "<input type='hidden'/>" )
							.attr( "name", validator.submitButton.name )
							.val( $( validator.submitButton ).val() )
							.appendTo( validator.currentForm );
					}

					if ( validator.settings.submitHandler && !validator.settings.debug ) {
						result = validator.settings.submitHandler.call( validator, validator.currentForm, event );
						if ( hidden ) {

							// And clean up afterwards; thanks to no-block-scope, hidden can be referenced
							hidden.remove();
						}
						if ( result !== undefined ) {
							return result;
						}
						return false;
					}
					return true;
				}

				// Prevent submit for invalid forms or custom submit handlers
				if ( validator.cancelSubmit ) {
					validator.cancelSubmit = false;
					return handle();
				}
				if ( validator.form() ) {
					if ( validator.pendingRequest ) {
						validator.formSubmitted = true;
						return false;
					}
					return handle();
				} else {
					validator.focusInvalid();
					return false;
				}
			} );
		}

		return validator;
	},

	// https://jqueryvalidation.org/valid/
	valid: function() {
		var valid, validator, errorList;

		if ( $( this[ 0 ] ).is( "form" ) ) {
			valid = this.validate().form();
		} else {
			errorList = [];
			valid = true;
			validator = $( this[ 0 ].form ).validate();
			this.each( function() {
				valid = validator.element( this ) && valid;
				if ( !valid ) {
					errorList = errorList.concat( validator.errorList );
				}
			} );
			validator.errorList = errorList;
		}
		return valid;
	},

	// https://jqueryvalidation.org/rules/
	rules: function( command, argument ) {
		var element = this[ 0 ],
			settings, staticRules, existingRules, data, param, filtered;

		// If nothing is selected, return empty object; can't chain anyway
		if ( element == null ) {
			return;
		}

		if ( !element.form && element.isContentEditable ) {
			element.form = this.closest( "form" )[ 0 ];
			element.name = this.attr( "name" );
		}

		if ( element.form == null ) {
			return;
		}

		if ( command ) {
			settings = $.data( element.form, "validator" ).settings;
			staticRules = settings.rules;
			existingRules = $.validator.staticRules( element );
			switch ( command ) {
			case "add":
				$.extend( existingRules, $.validator.normalizeRule( argument ) );

				// Remove messages from rules, but allow them to be set separately
				delete existingRules.messages;
				staticRules[ element.name ] = existingRules;
				if ( argument.messages ) {
					settings.messages[ element.name ] = $.extend( settings.messages[ element.name ], argument.messages );
				}
				break;
			case "remove":
				if ( !argument ) {
					delete staticRules[ element.name ];
					return existingRules;
				}
				filtered = {};
				$.each( argument.split( /\s/ ), function( index, method ) {
					filtered[ method ] = existingRules[ method ];
					delete existingRules[ method ];
				} );
				return filtered;
			}
		}

		data = $.validator.normalizeRules(
		$.extend(
			{},
			$.validator.classRules( element ),
			$.validator.attributeRules( element ),
			$.validator.dataRules( element ),
			$.validator.staticRules( element )
		), element );

		// Make sure required is at front
		if ( data.required ) {
			param = data.required;
			delete data.required;
			data = $.extend( { required: param }, data );
		}

		// Make sure remote is at back
		if ( data.remote ) {
			param = data.remote;
			delete data.remote;
			data = $.extend( data, { remote: param } );
		}

		return data;
	}
} );

// Custom selectors
$.extend( $.expr.pseudos || $.expr[ ":" ], {		// '|| $.expr[ ":" ]' here enables backwards compatibility to jQuery 1.7. Can be removed when dropping jQ 1.7.x support

	// https://jqueryvalidation.org/blank-selector/
	blank: function( a ) {
		return !$.trim( "" + $( a ).val() );
	},

	// https://jqueryvalidation.org/filled-selector/
	filled: function( a ) {
		var val = $( a ).val();
		return val !== null && !!$.trim( "" + val );
	},

	// https://jqueryvalidation.org/unchecked-selector/
	unchecked: function( a ) {
		return !$( a ).prop( "checked" );
	}
} );

// Constructor for validator
$.validator = function( options, form ) {
	this.settings = $.extend( true, {}, $.validator.defaults, options );
	this.currentForm = form;
	this.init();
};

// https://jqueryvalidation.org/jQuery.validator.format/
$.validator.format = function( source, params ) {
	if ( arguments.length === 1 ) {
		return function() {
			var args = $.makeArray( arguments );
			args.unshift( source );
			return $.validator.format.apply( this, args );
		};
	}
	if ( params === undefined ) {
		return source;
	}
	if ( arguments.length > 2 && params.constructor !== Array  ) {
		params = $.makeArray( arguments ).slice( 1 );
	}
	if ( params.constructor !== Array ) {
		params = [ params ];
	}
	$.each( params, function( i, n ) {
		source = source.replace( new RegExp( "\\{" + i + "\\}", "g" ), function() {
			return n;
		} );
	} );
	return source;
};

$.extend( $.validator, {

	defaults: {
		messages: {},
		groups: {},
		rules: {},
		errorClass: "error",
		pendingClass: "pending",
		validClass: "valid",
		errorElement: "label",
		focusCleanup: false,
		focusInvalid: true,
		errorContainer: $( [] ),
		errorLabelContainer: $( [] ),
		onsubmit: true,
		ignore: ":hidden",
		ignoreTitle: false,
		onfocusin: function( element ) {
			this.lastActive = element;

			// Hide error label and remove error class on focus if enabled
			if ( this.settings.focusCleanup ) {
				if ( this.settings.unhighlight ) {
					this.settings.unhighlight.call( this, element, this.settings.errorClass, this.settings.validClass );
				}
				this.hideThese( this.errorsFor( element ) );
			}
		},
		onfocusout: function( element ) {
			if ( !this.checkable( element ) && ( element.name in this.submitted || !this.optional( element ) ) ) {
				this.element( element );
			}
		},
		onkeyup: function( element, event ) {

			// Avoid revalidate the field when pressing one of the following keys
			// Shift       => 16
			// Ctrl        => 17
			// Alt         => 18
			// Caps lock   => 20
			// End         => 35
			// Home        => 36
			// Left arrow  => 37
			// Up arrow    => 38
			// Right arrow => 39
			// Down arrow  => 40
			// Insert      => 45
			// Num lock    => 144
			// AltGr key   => 225
			var excludedKeys = [
				16, 17, 18, 20, 35, 36, 37,
				38, 39, 40, 45, 144, 225
			];

			if ( event.which === 9 && this.elementValue( element ) === "" || $.inArray( event.keyCode, excludedKeys ) !== -1 ) {
				return;
			} else if ( element.name in this.submitted || element.name in this.invalid ) {
				this.element( element );
			}
		},
		onclick: function( element ) {

			// Click on selects, radiobuttons and checkboxes
			if ( element.name in this.submitted ) {
				this.element( element );

			// Or option elements, check parent select in that case
			} else if ( element.parentNode.name in this.submitted ) {
				this.element( element.parentNode );
			}
		},
		highlight: function( element, errorClass, validClass ) {
			if ( element.type === "radio" ) {
				this.findByName( element.name ).addClass( errorClass ).removeClass( validClass );
			} else {
				$( element ).addClass( errorClass ).removeClass( validClass );
			}
		},
		unhighlight: function( element, errorClass, validClass ) {
			if ( element.type === "radio" ) {
				this.findByName( element.name ).removeClass( errorClass ).addClass( validClass );
			} else {
				$( element ).removeClass( errorClass ).addClass( validClass );
			}
		}
	},

	// https://jqueryvalidation.org/jQuery.validator.setDefaults/
	setDefaults: function( settings ) {
		$.extend( $.validator.defaults, settings );
	},

	messages: {
		required: "This field is required.",
		remote: "Please fix this field.",
		email: "Please enter a valid email address.",
		url: "Please enter a valid URL.",
		date: "Please enter a valid date.",
		dateISO: "Please enter a valid date (ISO).",
		number: "Please enter a valid number.",
		digits: "Please enter only digits.",
		equalTo: "Please enter the same value again.",
		maxlength: $.validator.format( "Please enter no more than {0} characters." ),
		minlength: $.validator.format( "Please enter at least {0} characters." ),
		rangelength: $.validator.format( "Please enter a value between {0} and {1} characters long." ),
		range: $.validator.format( "Please enter a value between {0} and {1}." ),
		max: $.validator.format( "Please enter a value less than or equal to {0}." ),
		min: $.validator.format( "Please enter a value greater than or equal to {0}." ),
		step: $.validator.format( "Please enter a multiple of {0}." )
	},

	autoCreateRanges: false,

	prototype: {

		init: function() {
			this.labelContainer = $( this.settings.errorLabelContainer );
			this.errorContext = this.labelContainer.length && this.labelContainer || $( this.currentForm );
			this.containers = $( this.settings.errorContainer ).add( this.settings.errorLabelContainer );
			this.submitted = {};
			this.valueCache = {};
			this.pendingRequest = 0;
			this.pending = {};
			this.invalid = {};
			this.reset();

			var currentForm = this.currentForm,
				groups = ( this.groups = {} ),
				rules;
			$.each( this.settings.groups, function( key, value ) {
				if ( typeof value === "string" ) {
					value = value.split( /\s/ );
				}
				$.each( value, function( index, name ) {
					groups[ name ] = key;
				} );
			} );
			rules = this.settings.rules;
			$.each( rules, function( key, value ) {
				rules[ key ] = $.validator.normalizeRule( value );
			} );

			function delegate( event ) {

				// Set form expando on contenteditable
				if ( !this.form && this.isContentEditable ) {
					this.form = $( this ).closest( "form" )[ 0 ];
					this.name = $( this ).attr( "name" );
				}

				// Ignore the element if it belongs to another form. This will happen mainly
				// when setting the `form` attribute of an input to the id of another form.
				if ( currentForm !== this.form ) {
					return;
				}

				var validator = $.data( this.form, "validator" ),
					eventType = "on" + event.type.replace( /^validate/, "" ),
					settings = validator.settings;
				if ( settings[ eventType ] && !$( this ).is( settings.ignore ) ) {
					settings[ eventType ].call( validator, this, event );
				}
			}

			$( this.currentForm )
				.on( "focusin.validate focusout.validate keyup.validate",
					":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'], " +
					"[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], " +
					"[type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'], " +
					"[type='radio'], [type='checkbox'], [contenteditable], [type='button']", delegate )

				// Support: Chrome, oldIE
				// "select" is provided as event.target when clicking a option
				.on( "click.validate", "select, option, [type='radio'], [type='checkbox']", delegate );

			if ( this.settings.invalidHandler ) {
				$( this.currentForm ).on( "invalid-form.validate", this.settings.invalidHandler );
			}
		},

		// https://jqueryvalidation.org/Validator.form/
		form: function() {
			this.checkForm();
			$.extend( this.submitted, this.errorMap );
			this.invalid = $.extend( {}, this.errorMap );
			if ( !this.valid() ) {
				$( this.currentForm ).triggerHandler( "invalid-form", [ this ] );
			}
			this.showErrors();
			return this.valid();
		},

		checkForm: function() {
			this.prepareForm();
			for ( var i = 0, elements = ( this.currentElements = this.elements() ); elements[ i ]; i++ ) {
				this.check( elements[ i ] );
			}
			return this.valid();
		},

		// https://jqueryvalidation.org/Validator.element/
		element: function( element ) {
			var cleanElement = this.clean( element ),
				checkElement = this.validationTargetFor( cleanElement ),
				v = this,
				result = true,
				rs, group;

			if ( checkElement === undefined ) {
				delete this.invalid[ cleanElement.name ];
			} else {
				this.prepareElement( checkElement );
				this.currentElements = $( checkElement );

				// If this element is grouped, then validate all group elements already
				// containing a value
				group = this.groups[ checkElement.name ];
				if ( group ) {
					$.each( this.groups, function( name, testgroup ) {
						if ( testgroup === group && name !== checkElement.name ) {
							cleanElement = v.validationTargetFor( v.clean( v.findByName( name ) ) );
							if ( cleanElement && cleanElement.name in v.invalid ) {
								v.currentElements.push( cleanElement );
								result = v.check( cleanElement ) && result;
							}
						}
					} );
				}

				rs = this.check( checkElement ) !== false;
				result = result && rs;
				if ( rs ) {
					this.invalid[ checkElement.name ] = false;
				} else {
					this.invalid[ checkElement.name ] = true;
				}

				if ( !this.numberOfInvalids() ) {

					// Hide error containers on last error
					this.toHide = this.toHide.add( this.containers );
				}
				this.showErrors();

				// Add aria-invalid status for screen readers
				$( element ).attr( "aria-invalid", !rs );
			}

			return result;
		},

		// https://jqueryvalidation.org/Validator.showErrors/
		showErrors: function( errors ) {
			if ( errors ) {
				var validator = this;

				// Add items to error list and map
				$.extend( this.errorMap, errors );
				this.errorList = $.map( this.errorMap, function( message, name ) {
					return {
						message: message,
						element: validator.findByName( name )[ 0 ]
					};
				} );

				// Remove items from success list
				this.successList = $.grep( this.successList, function( element ) {
					return !( element.name in errors );
				} );
			}
			if ( this.settings.showErrors ) {
				this.settings.showErrors.call( this, this.errorMap, this.errorList );
			} else {
				this.defaultShowErrors();
			}
		},

		// https://jqueryvalidation.org/Validator.resetForm/
		resetForm: function() {
			if ( $.fn.resetForm ) {
				$( this.currentForm ).resetForm();
			}
			this.invalid = {};
			this.submitted = {};
			this.prepareForm();
			this.hideErrors();
			var elements = this.elements()
				.removeData( "previousValue" )
				.removeAttr( "aria-invalid" );

			this.resetElements( elements );
		},

		resetElements: function( elements ) {
			var i;

			if ( this.settings.unhighlight ) {
				for ( i = 0; elements[ i ]; i++ ) {
					this.settings.unhighlight.call( this, elements[ i ],
						this.settings.errorClass, "" );
					this.findByName( elements[ i ].name ).removeClass( this.settings.validClass );
				}
			} else {
				elements
					.removeClass( this.settings.errorClass )
					.removeClass( this.settings.validClass );
			}
		},

		numberOfInvalids: function() {
			return this.objectLength( this.invalid );
		},

		objectLength: function( obj ) {
			/* jshint unused: false */
			var count = 0,
				i;
			for ( i in obj ) {

				// This check allows counting elements with empty error
				// message as invalid elements
				if ( obj[ i ] !== undefined && obj[ i ] !== null && obj[ i ] !== false ) {
					count++;
				}
			}
			return count;
		},

		hideErrors: function() {
			this.hideThese( this.toHide );
		},

		hideThese: function( errors ) {
			errors.not( this.containers ).text( "" );
			this.addWrapper( errors ).hide();
		},

		valid: function() {
			return this.size() === 0;
		},

		size: function() {
			return this.errorList.length;
		},

		focusInvalid: function() {
			if ( this.settings.focusInvalid ) {
				try {
					$( this.findLastActive() || this.errorList.length && this.errorList[ 0 ].element || [] )
					.filter( ":visible" )
					.focus()

					// Manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
					.trigger( "focusin" );
				} catch ( e ) {

					// Ignore IE throwing errors when focusing hidden elements
				}
			}
		},

		findLastActive: function() {
			var lastActive = this.lastActive;
			return lastActive && $.grep( this.errorList, function( n ) {
				return n.element.name === lastActive.name;
			} ).length === 1 && lastActive;
		},

		elements: function() {
			var validator = this,
				rulesCache = {};

			// Select all valid inputs inside the form (no submit or reset buttons)
			return $( this.currentForm )
			.find( "input, select, textarea, [contenteditable]" )
			.not( ":submit, :reset, :image, :disabled" )
			.not( this.settings.ignore )
			.filter( function() {
				var name = this.name || $( this ).attr( "name" ); // For contenteditable
				if ( !name && validator.settings.debug && window.console ) {
					console.error( "%o has no name assigned", this );
				}

				// Set form expando on contenteditable
				if ( this.isContentEditable ) {
					this.form = $( this ).closest( "form" )[ 0 ];
					this.name = name;
				}

				// Ignore elements that belong to other/nested forms
				if ( this.form !== validator.currentForm ) {
					return false;
				}

				// Select only the first element for each name, and only those with rules specified
				if ( name in rulesCache || !validator.objectLength( $( this ).rules() ) ) {
					return false;
				}

				rulesCache[ name ] = true;
				return true;
			} );
		},

		clean: function( selector ) {
			return $( selector )[ 0 ];
		},

		errors: function() {
			var errorClass = this.settings.errorClass.split( " " ).join( "." );
			return $( this.settings.errorElement + "." + errorClass, this.errorContext );
		},

		resetInternals: function() {
			this.successList = [];
			this.errorList = [];
			this.errorMap = {};
			this.toShow = $( [] );
			this.toHide = $( [] );
		},

		reset: function() {
			this.resetInternals();
			this.currentElements = $( [] );
		},

		prepareForm: function() {
			this.reset();
			this.toHide = this.errors().add( this.containers );
		},

		prepareElement: function( element ) {
			this.reset();
			this.toHide = this.errorsFor( element );
		},

		elementValue: function( element ) {
			var $element = $( element ),
				type = element.type,
				val, idx;

			if ( type === "radio" || type === "checkbox" ) {
				return this.findByName( element.name ).filter( ":checked" ).val();
			} else if ( type === "number" && typeof element.validity !== "undefined" ) {
				return element.validity.badInput ? "NaN" : $element.val();
			}

			if ( element.isContentEditable ) {
				val = $element.text();
			} else {
				val = $element.val();
			}

			if ( type === "file" ) {

				// Modern browser (chrome & safari)
				if ( val.substr( 0, 12 ) === "C:\\fakepath\\" ) {
					return val.substr( 12 );
				}

				// Legacy browsers
				// Unix-based path
				idx = val.lastIndexOf( "/" );
				if ( idx >= 0 ) {
					return val.substr( idx + 1 );
				}

				// Windows-based path
				idx = val.lastIndexOf( "\\" );
				if ( idx >= 0 ) {
					return val.substr( idx + 1 );
				}

				// Just the file name
				return val;
			}

			if ( typeof val === "string" ) {
				return val.replace( /\r/g, "" );
			}
			return val;
		},

		check: function( element ) {
			element = this.validationTargetFor( this.clean( element ) );

			var rules = $( element ).rules(),
				rulesCount = $.map( rules, function( n, i ) {
					return i;
				} ).length,
				dependencyMismatch = false,
				val = this.elementValue( element ),
				result, method, rule, normalizer;

			// Prioritize the local normalizer defined for this element over the global one
			// if the former exists, otherwise user the global one in case it exists.
			if ( typeof rules.normalizer === "function" ) {
				normalizer = rules.normalizer;
			} else if (	typeof this.settings.normalizer === "function" ) {
				normalizer = this.settings.normalizer;
			}

			// If normalizer is defined, then call it to retreive the changed value instead
			// of using the real one.
			// Note that `this` in the normalizer is `element`.
			if ( normalizer ) {
				val = normalizer.call( element, val );

				// Delete the normalizer from rules to avoid treating it as a pre-defined method.
				delete rules.normalizer;
			}

			for ( method in rules ) {
				rule = { method: method, parameters: rules[ method ] };
				try {
					result = $.validator.methods[ method ].call( this, val, element, rule.parameters );

					// If a method indicates that the field is optional and therefore valid,
					// don't mark it as valid when there are no other rules
					if ( result === "dependency-mismatch" && rulesCount === 1 ) {
						dependencyMismatch = true;
						continue;
					}
					dependencyMismatch = false;

					if ( result === "pending" ) {
						this.toHide = this.toHide.not( this.errorsFor( element ) );
						return;
					}

					if ( !result ) {
						this.formatAndAdd( element, rule );
						return false;
					}
				} catch ( e ) {
					if ( this.settings.debug && window.console ) {
						console.log( "Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e );
					}
					if ( e instanceof TypeError ) {
						e.message += ".  Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.";
					}

					throw e;
				}
			}
			if ( dependencyMismatch ) {
				return;
			}
			if ( this.objectLength( rules ) ) {
				this.successList.push( element );
			}
			return true;
		},

		// Return the custom message for the given element and validation method
		// specified in the element's HTML5 data attribute
		// return the generic message if present and no method specific message is present
		customDataMessage: function( element, method ) {
			return $( element ).data( "msg" + method.charAt( 0 ).toUpperCase() +
				method.substring( 1 ).toLowerCase() ) || $( element ).data( "msg" );
		},

		// Return the custom message for the given element name and validation method
		customMessage: function( name, method ) {
			var m = this.settings.messages[ name ];
			return m && ( m.constructor === String ? m : m[ method ] );
		},

		// Return the first defined argument, allowing empty strings
		findDefined: function() {
			for ( var i = 0; i < arguments.length; i++ ) {
				if ( arguments[ i ] !== undefined ) {
					return arguments[ i ];
				}
			}
			return undefined;
		},

		// The second parameter 'rule' used to be a string, and extended to an object literal
		// of the following form:
		// rule = {
		//     method: "method name",
		//     parameters: "the given method parameters"
		// }
		//
		// The old behavior still supported, kept to maintain backward compatibility with
		// old code, and will be removed in the next major release.
		defaultMessage: function( element, rule ) {
			if ( typeof rule === "string" ) {
				rule = { method: rule };
			}

			var message = this.findDefined(
					this.customMessage( element.name, rule.method ),
					this.customDataMessage( element, rule.method ),

					// 'title' is never undefined, so handle empty string as undefined
					!this.settings.ignoreTitle && element.title || undefined,
					$.validator.messages[ rule.method ],
					"<strong>Warning: No message defined for " + element.name + "</strong>"
				),
				theregex = /\$?\{(\d+)\}/g;
			if ( typeof message === "function" ) {
				message = message.call( this, rule.parameters, element );
			} else if ( theregex.test( message ) ) {
				message = $.validator.format( message.replace( theregex, "{$1}" ), rule.parameters );
			}

			return message;
		},

		formatAndAdd: function( element, rule ) {
			var message = this.defaultMessage( element, rule );

			this.errorList.push( {
				message: message,
				element: element,
				method: rule.method
			} );

			this.errorMap[ element.name ] = message;
			this.submitted[ element.name ] = message;
		},

		addWrapper: function( toToggle ) {
			if ( this.settings.wrapper ) {
				toToggle = toToggle.add( toToggle.parent( this.settings.wrapper ) );
			}
			return toToggle;
		},

		defaultShowErrors: function() {
			var i, elements, error;
			for ( i = 0; this.errorList[ i ]; i++ ) {
				error = this.errorList[ i ];
				if ( this.settings.highlight ) {
					this.settings.highlight.call( this, error.element, this.settings.errorClass, this.settings.validClass );
				}
				this.showLabel( error.element, error.message );
			}
			if ( this.errorList.length ) {
				this.toShow = this.toShow.add( this.containers );
			}
			if ( this.settings.success ) {
				for ( i = 0; this.successList[ i ]; i++ ) {
					this.showLabel( this.successList[ i ] );
				}
			}
			if ( this.settings.unhighlight ) {
				for ( i = 0, elements = this.validElements(); elements[ i ]; i++ ) {
					this.settings.unhighlight.call( this, elements[ i ], this.settings.errorClass, this.settings.validClass );
				}
			}
			this.toHide = this.toHide.not( this.toShow );
			this.hideErrors();
			this.addWrapper( this.toShow ).show();
		},

		validElements: function() {
			return this.currentElements.not( this.invalidElements() );
		},

		invalidElements: function() {
			return $( this.errorList ).map( function() {
				return this.element;
			} );
		},

		showLabel: function( element, message ) {
			var place, group, errorID, v,
				error = this.errorsFor( element ),
				elementID = this.idOrName( element ),
				describedBy = $( element ).attr( "aria-describedby" );

			if ( error.length ) {

				// Refresh error/success class
				error.removeClass( this.settings.validClass ).addClass( this.settings.errorClass );

				// Replace message on existing label
				error.html( message );
			} else {

				// Create error element
				error = $( "<" + this.settings.errorElement + ">" )
					.attr( "id", elementID + "-error" )
					.addClass( this.settings.errorClass )
					.html( message || "" );

				// Maintain reference to the element to be placed into the DOM
				place = error;
				if ( this.settings.wrapper ) {

					// Make sure the element is visible, even in IE
					// actually showing the wrapped element is handled elsewhere
					place = error.hide().show().wrap( "<" + this.settings.wrapper + "/>" ).parent();
				}
				if ( this.labelContainer.length ) {
					this.labelContainer.append( place );
				} else if ( this.settings.errorPlacement ) {
					this.settings.errorPlacement.call( this, place, $( element ) );
				} else {
					place.insertAfter( element );
				}

				// Link error back to the element
				if ( error.is( "label" ) ) {

					// If the error is a label, then associate using 'for'
					error.attr( "for", elementID );

					// If the element is not a child of an associated label, then it's necessary
					// to explicitly apply aria-describedby
				} else if ( error.parents( "label[for='" + this.escapeCssMeta( elementID ) + "']" ).length === 0 ) {
					errorID = error.attr( "id" );

					// Respect existing non-error aria-describedby
					if ( !describedBy ) {
						describedBy = errorID;
					} else if ( !describedBy.match( new RegExp( "\\b" + this.escapeCssMeta( errorID ) + "\\b" ) ) ) {

						// Add to end of list if not already present
						describedBy += " " + errorID;
					}
					$( element ).attr( "aria-describedby", describedBy );

					// If this element is grouped, then assign to all elements in the same group
					group = this.groups[ element.name ];
					if ( group ) {
						v = this;
						$.each( v.groups, function( name, testgroup ) {
							if ( testgroup === group ) {
								$( "[name='" + v.escapeCssMeta( name ) + "']", v.currentForm )
									.attr( "aria-describedby", error.attr( "id" ) );
							}
						} );
					}
				}
			}
			if ( !message && this.settings.success ) {
				error.text( "" );
				if ( typeof this.settings.success === "string" ) {
					error.addClass( this.settings.success );
				} else {
					this.settings.success( error, element );
				}
			}
			this.toShow = this.toShow.add( error );
		},

		errorsFor: function( element ) {
			var name = this.escapeCssMeta( this.idOrName( element ) ),
				describer = $( element ).attr( "aria-describedby" ),
				selector = "label[for='" + name + "'], label[for='" + name + "'] *";

			// 'aria-describedby' should directly reference the error element
			if ( describer ) {
				selector = selector + ", #" + this.escapeCssMeta( describer )
					.replace( /\s+/g, ", #" );
			}

			return this
				.errors()
				.filter( selector );
		},

		// See https://api.jquery.com/category/selectors/, for CSS
		// meta-characters that should be escaped in order to be used with JQuery
		// as a literal part of a name/id or any selector.
		escapeCssMeta: function( string ) {
			return string.replace( /([\\!"#$%&'()*+,./:;<=>?@\[\]^`{|}~])/g, "\\$1" );
		},

		idOrName: function( element ) {
			return this.groups[ element.name ] || ( this.checkable( element ) ? element.name : element.id || element.name );
		},

		validationTargetFor: function( element ) {

			// If radio/checkbox, validate first element in group instead
			if ( this.checkable( element ) ) {
				element = this.findByName( element.name );
			}

			// Always apply ignore filter
			return $( element ).not( this.settings.ignore )[ 0 ];
		},

		checkable: function( element ) {
			return ( /radio|checkbox/i ).test( element.type );
		},

		findByName: function( name ) {
			return $( this.currentForm ).find( "[name='" + this.escapeCssMeta( name ) + "']" );
		},

		getLength: function( value, element ) {
			switch ( element.nodeName.toLowerCase() ) {
			case "select":
				return $( "option:selected", element ).length;
			case "input":
				if ( this.checkable( element ) ) {
					return this.findByName( element.name ).filter( ":checked" ).length;
				}
			}
			return value.length;
		},

		depend: function( param, element ) {
			return this.dependTypes[ typeof param ] ? this.dependTypes[ typeof param ]( param, element ) : true;
		},

		dependTypes: {
			"boolean": function( param ) {
				return param;
			},
			"string": function( param, element ) {
				return !!$( param, element.form ).length;
			},
			"function": function( param, element ) {
				return param( element );
			}
		},

		optional: function( element ) {
			var val = this.elementValue( element );
			return !$.validator.methods.required.call( this, val, element ) && "dependency-mismatch";
		},

		startRequest: function( element ) {
			if ( !this.pending[ element.name ] ) {
				this.pendingRequest++;
				$( element ).addClass( this.settings.pendingClass );
				this.pending[ element.name ] = true;
			}
		},

		stopRequest: function( element, valid ) {
			this.pendingRequest--;

			// Sometimes synchronization fails, make sure pendingRequest is never < 0
			if ( this.pendingRequest < 0 ) {
				this.pendingRequest = 0;
			}
			delete this.pending[ element.name ];
			$( element ).removeClass( this.settings.pendingClass );
			if ( valid && this.pendingRequest === 0 && this.formSubmitted && this.form() ) {
				$( this.currentForm ).submit();

				// Remove the hidden input that was used as a replacement for the
				// missing submit button. The hidden input is added by `handle()`
				// to ensure that the value of the used submit button is passed on
				// for scripted submits triggered by this method
				if ( this.submitButton ) {
					$( "input:hidden[name='" + this.submitButton.name + "']", this.currentForm ).remove();
				}

				this.formSubmitted = false;
			} else if ( !valid && this.pendingRequest === 0 && this.formSubmitted ) {
				$( this.currentForm ).triggerHandler( "invalid-form", [ this ] );
				this.formSubmitted = false;
			}
		},

		previousValue: function( element, method ) {
			method = typeof method === "string" && method || "remote";

			return $.data( element, "previousValue" ) || $.data( element, "previousValue", {
				old: null,
				valid: true,
				message: this.defaultMessage( element, { method: method } )
			} );
		},

		// Cleans up all forms and elements, removes validator-specific events
		destroy: function() {
			this.resetForm();

			$( this.currentForm )
				.off( ".validate" )
				.removeData( "validator" )
				.find( ".validate-equalTo-blur" )
					.off( ".validate-equalTo" )
					.removeClass( "validate-equalTo-blur" )
				.find( ".validate-lessThan-blur" )
					.off( ".validate-lessThan" )
					.removeClass( "validate-lessThan-blur" )
				.find( ".validate-lessThanEqual-blur" )
					.off( ".validate-lessThanEqual" )
					.removeClass( "validate-lessThanEqual-blur" )
				.find( ".validate-greaterThanEqual-blur" )
					.off( ".validate-greaterThanEqual" )
					.removeClass( "validate-greaterThanEqual-blur" )
				.find( ".validate-greaterThan-blur" )
					.off( ".validate-greaterThan" )
					.removeClass( "validate-greaterThan-blur" );
		}

	},

	classRuleSettings: {
		required: { required: true },
		email: { email: true },
		url: { url: true },
		date: { date: true },
		dateISO: { dateISO: true },
		number: { number: true },
		digits: { digits: true },
		creditcard: { creditcard: true }
	},

	addClassRules: function( className, rules ) {
		if ( className.constructor === String ) {
			this.classRuleSettings[ className ] = rules;
		} else {
			$.extend( this.classRuleSettings, className );
		}
	},

	classRules: function( element ) {
		var rules = {},
			classes = $( element ).attr( "class" );

		if ( classes ) {
			$.each( classes.split( " " ), function() {
				if ( this in $.validator.classRuleSettings ) {
					$.extend( rules, $.validator.classRuleSettings[ this ] );
				}
			} );
		}
		return rules;
	},

	normalizeAttributeRule: function( rules, type, method, value ) {

		// Convert the value to a number for number inputs, and for text for backwards compability
		// allows type="date" and others to be compared as strings
		if ( /min|max|step/.test( method ) && ( type === null || /number|range|text/.test( type ) ) ) {
			value = Number( value );

			// Support Opera Mini, which returns NaN for undefined minlength
			if ( isNaN( value ) ) {
				value = undefined;
			}
		}

		if ( value || value === 0 ) {
			rules[ method ] = value;
		} else if ( type === method && type !== "range" ) {

			// Exception: the jquery validate 'range' method
			// does not test for the html5 'range' type
			rules[ method ] = true;
		}
	},

	attributeRules: function( element ) {
		var rules = {},
			$element = $( element ),
			type = element.getAttribute( "type" ),
			method, value;

		for ( method in $.validator.methods ) {

			// Support for <input required> in both html5 and older browsers
			if ( method === "required" ) {
				value = element.getAttribute( method );

				// Some browsers return an empty string for the required attribute
				// and non-HTML5 browsers might have required="" markup
				if ( value === "" ) {
					value = true;
				}

				// Force non-HTML5 browsers to return bool
				value = !!value;
			} else {
				value = $element.attr( method );
			}

			this.normalizeAttributeRule( rules, type, method, value );
		}

		// 'maxlength' may be returned as -1, 2147483647 ( IE ) and 524288 ( safari ) for text inputs
		if ( rules.maxlength && /-1|2147483647|524288/.test( rules.maxlength ) ) {
			delete rules.maxlength;
		}

		return rules;
	},

	dataRules: function( element ) {
		var rules = {},
			$element = $( element ),
			type = element.getAttribute( "type" ),
			method, value;

		for ( method in $.validator.methods ) {
			value = $element.data( "rule" + method.charAt( 0 ).toUpperCase() + method.substring( 1 ).toLowerCase() );

			// Cast empty attributes like `data-rule-required` to `true`
			if ( value === "" ) {
				value = true;
			}

			this.normalizeAttributeRule( rules, type, method, value );
		}
		return rules;
	},

	staticRules: function( element ) {
		var rules = {},
			validator = $.data( element.form, "validator" );

		if ( validator.settings.rules ) {
			rules = $.validator.normalizeRule( validator.settings.rules[ element.name ] ) || {};
		}
		return rules;
	},

	normalizeRules: function( rules, element ) {

		// Handle dependency check
		$.each( rules, function( prop, val ) {

			// Ignore rule when param is explicitly false, eg. required:false
			if ( val === false ) {
				delete rules[ prop ];
				return;
			}
			if ( val.param || val.depends ) {
				var keepRule = true;
				switch ( typeof val.depends ) {
				case "string":
					keepRule = !!$( val.depends, element.form ).length;
					break;
				case "function":
					keepRule = val.depends.call( element, element );
					break;
				}
				if ( keepRule ) {
					rules[ prop ] = val.param !== undefined ? val.param : true;
				} else {
					$.data( element.form, "validator" ).resetElements( $( element ) );
					delete rules[ prop ];
				}
			}
		} );

		// Evaluate parameters
		$.each( rules, function( rule, parameter ) {
			rules[ rule ] = $.isFunction( parameter ) && rule !== "normalizer" ? parameter( element ) : parameter;
		} );

		// Clean number parameters
		$.each( [ "minlength", "maxlength" ], function() {
			if ( rules[ this ] ) {
				rules[ this ] = Number( rules[ this ] );
			}
		} );
		$.each( [ "rangelength", "range" ], function() {
			var parts;
			if ( rules[ this ] ) {
				if ( $.isArray( rules[ this ] ) ) {
					rules[ this ] = [ Number( rules[ this ][ 0 ] ), Number( rules[ this ][ 1 ] ) ];
				} else if ( typeof rules[ this ] === "string" ) {
					parts = rules[ this ].replace( /[\[\]]/g, "" ).split( /[\s,]+/ );
					rules[ this ] = [ Number( parts[ 0 ] ), Number( parts[ 1 ] ) ];
				}
			}
		} );

		if ( $.validator.autoCreateRanges ) {

			// Auto-create ranges
			if ( rules.min != null && rules.max != null ) {
				rules.range = [ rules.min, rules.max ];
				delete rules.min;
				delete rules.max;
			}
			if ( rules.minlength != null && rules.maxlength != null ) {
				rules.rangelength = [ rules.minlength, rules.maxlength ];
				delete rules.minlength;
				delete rules.maxlength;
			}
		}

		return rules;
	},

	// Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
	normalizeRule: function( data ) {
		if ( typeof data === "string" ) {
			var transformed = {};
			$.each( data.split( /\s/ ), function() {
				transformed[ this ] = true;
			} );
			data = transformed;
		}
		return data;
	},

	// https://jqueryvalidation.org/jQuery.validator.addMethod/
	addMethod: function( name, method, message ) {
		$.validator.methods[ name ] = method;
		$.validator.messages[ name ] = message !== undefined ? message : $.validator.messages[ name ];
		if ( method.length < 3 ) {
			$.validator.addClassRules( name, $.validator.normalizeRule( name ) );
		}
	},

	// https://jqueryvalidation.org/jQuery.validator.methods/
	methods: {

		// https://jqueryvalidation.org/required-method/
		required: function( value, element, param ) {

			// Check if dependency is met
			if ( !this.depend( param, element ) ) {
				return "dependency-mismatch";
			}
			if ( element.nodeName.toLowerCase() === "select" ) {

				// Could be an array for select-multiple or a string, both are fine this way
				var val = $( element ).val();
				return val && val.length > 0;
			}
			if ( this.checkable( element ) ) {
				return this.getLength( value, element ) > 0;
			}
			return value !== undefined && value !== null && value.length > 0;
		},

		// https://jqueryvalidation.org/email-method/
		email: function( value, element ) {

			// From https://html.spec.whatwg.org/multipage/forms.html#valid-e-mail-address
			// Retrieved 2014-01-14
			// If you have a problem with this implementation, report a bug against the above spec
			// Or use custom methods to implement your own email validation
			return this.optional( element ) || /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test( value );
		},

		// https://jqueryvalidation.org/url-method/
		url: function( value, element ) {

			// Copyright (c) 2010-2013 Diego Perini, MIT licensed
			// https://gist.github.com/dperini/729294
			// see also https://mathiasbynens.be/demo/url-regex
			// modified to allow protocol-relative URLs
			return this.optional( element ) || /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})).?)(?::\d{2,5})?(?:[/?#]\S*)?$/i.test( value );
		},

		// https://jqueryvalidation.org/date-method/
		date: ( function() {
			var called = false;

			return function( value, element ) {
				if ( !called ) {
					called = true;
					if ( this.settings.debug && window.console ) {
						console.warn(
							"The `date` method is deprecated and will be removed in version '2.0.0'.\n" +
							"Please don't use it, since it relies on the Date constructor, which\n" +
							"behaves very differently across browsers and locales. Use `dateISO`\n" +
							"instead or one of the locale specific methods in `localizations/`\n" +
							"and `additional-methods.js`."
						);
					}
				}

				return this.optional( element ) || !/Invalid|NaN/.test( new Date( value ).toString() );
			};
		}() ),

		// https://jqueryvalidation.org/dateISO-method/
		dateISO: function( value, element ) {
			return this.optional( element ) || /^\d{4}[\/\-](0?[1-9]|1[012])[\/\-](0?[1-9]|[12][0-9]|3[01])$/.test( value );
		},

		// https://jqueryvalidation.org/number-method/
		number: function( value, element ) {
			return this.optional( element ) || /^(?:-?\d+|-?\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test( value );
		},

		// https://jqueryvalidation.org/digits-method/
		digits: function( value, element ) {
			return this.optional( element ) || /^\d+$/.test( value );
		},

		// https://jqueryvalidation.org/minlength-method/
		minlength: function( value, element, param ) {
			var length = $.isArray( value ) ? value.length : this.getLength( value, element );
			return this.optional( element ) || length >= param;
		},

		// https://jqueryvalidation.org/maxlength-method/
		maxlength: function( value, element, param ) {
			var length = $.isArray( value ) ? value.length : this.getLength( value, element );
			return this.optional( element ) || length <= param;
		},

		// https://jqueryvalidation.org/rangelength-method/
		rangelength: function( value, element, param ) {
			var length = $.isArray( value ) ? value.length : this.getLength( value, element );
			return this.optional( element ) || ( length >= param[ 0 ] && length <= param[ 1 ] );
		},

		// https://jqueryvalidation.org/min-method/
		min: function( value, element, param ) {
			return this.optional( element ) || value >= param;
		},

		// https://jqueryvalidation.org/max-method/
		max: function( value, element, param ) {
			return this.optional( element ) || value <= param;
		},

		// https://jqueryvalidation.org/range-method/
		range: function( value, element, param ) {
			return this.optional( element ) || ( value >= param[ 0 ] && value <= param[ 1 ] );
		},

		// https://jqueryvalidation.org/step-method/
		step: function( value, element, param ) {
			var type = $( element ).attr( "type" ),
				errorMessage = "Step attribute on input type " + type + " is not supported.",
				supportedTypes = [ "text", "number", "range" ],
				re = new RegExp( "\\b" + type + "\\b" ),
				notSupported = type && !re.test( supportedTypes.join() ),
				decimalPlaces = function( num ) {
					var match = ( "" + num ).match( /(?:\.(\d+))?$/ );
					if ( !match ) {
						return 0;
					}

					// Number of digits right of decimal point.
					return match[ 1 ] ? match[ 1 ].length : 0;
				},
				toInt = function( num ) {
					return Math.round( num * Math.pow( 10, decimals ) );
				},
				valid = true,
				decimals;

			// Works only for text, number and range input types
			// TODO find a way to support input types date, datetime, datetime-local, month, time and week
			if ( notSupported ) {
				throw new Error( errorMessage );
			}

			decimals = decimalPlaces( param );

			// Value can't have too many decimals
			if ( decimalPlaces( value ) > decimals || toInt( value ) % toInt( param ) !== 0 ) {
				valid = false;
			}

			return this.optional( element ) || valid;
		},

		// https://jqueryvalidation.org/equalTo-method/
		equalTo: function( value, element, param ) {

			// Bind to the blur event of the target in order to revalidate whenever the target field is updated
			var target = $( param );
			if ( this.settings.onfocusout && target.not( ".validate-equalTo-blur" ).length ) {
				target.addClass( "validate-equalTo-blur" ).on( "blur.validate-equalTo", function() {
					$( element ).valid();
				} );
			}
			return value === target.val();
		},

		// https://jqueryvalidation.org/remote-method/
		remote: function( value, element, param, method ) {
			if ( this.optional( element ) ) {
				return "dependency-mismatch";
			}

			method = typeof method === "string" && method || "remote";

			var previous = this.previousValue( element, method ),
				validator, data, optionDataString;

			if ( !this.settings.messages[ element.name ] ) {
				this.settings.messages[ element.name ] = {};
			}
			previous.originalMessage = previous.originalMessage || this.settings.messages[ element.name ][ method ];
			this.settings.messages[ element.name ][ method ] = previous.message;

			param = typeof param === "string" && { url: param } || param;
			optionDataString = $.param( $.extend( { data: value }, param.data ) );
			if ( previous.old === optionDataString ) {
				return previous.valid;
			}

			previous.old = optionDataString;
			validator = this;
			this.startRequest( element );
			data = {};
			data[ element.name ] = value;
			$.ajax( $.extend( true, {
				mode: "abort",
				port: "validate" + element.name,
				dataType: "json",
				data: data,
				context: validator.currentForm,
				success: function( response ) {
					var valid = response === true || response === "true",
						errors, message, submitted;

					validator.settings.messages[ element.name ][ method ] = previous.originalMessage;
					if ( valid ) {
						submitted = validator.formSubmitted;
						validator.resetInternals();
						validator.toHide = validator.errorsFor( element );
						validator.formSubmitted = submitted;
						validator.successList.push( element );
						validator.invalid[ element.name ] = false;
						validator.showErrors();
					} else {
						errors = {};
						message = response || validator.defaultMessage( element, { method: method, parameters: value } );
						errors[ element.name ] = previous.message = message;
						validator.invalid[ element.name ] = true;
						validator.showErrors( errors );
					}
					previous.valid = valid;
					validator.stopRequest( element, valid );
				}
			}, param ) );
			return "pending";
		}
	}

} );

// Ajax mode: abort
// usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
// if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()

var pendingRequests = {},
	ajax;

// Use a prefilter if available (1.5+)
if ( $.ajaxPrefilter ) {
	$.ajaxPrefilter( function( settings, _, xhr ) {
		var port = settings.port;
		if ( settings.mode === "abort" ) {
			if ( pendingRequests[ port ] ) {
				pendingRequests[ port ].abort();
			}
			pendingRequests[ port ] = xhr;
		}
	} );
} else {

	// Proxy ajax
	ajax = $.ajax;
	$.ajax = function( settings ) {
		var mode = ( "mode" in settings ? settings : $.ajaxSettings ).mode,
			port = ( "port" in settings ? settings : $.ajaxSettings ).port;
		if ( mode === "abort" ) {
			if ( pendingRequests[ port ] ) {
				pendingRequests[ port ].abort();
			}
			pendingRequests[ port ] = ajax.apply( this, arguments );
			return pendingRequests[ port ];
		}
		return ajax.apply( this, arguments );
	};
}
return $;
}));

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Input = __webpack_require__(219);

var _Input2 = _interopRequireDefault(_Input);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseFormRow = function (_React$Component) {
  _inherits(BaseFormRow, _React$Component);

  function BaseFormRow(props) {
    _classCallCheck(this, BaseFormRow);

    var _this = _possibleConstructorReturn(this, (BaseFormRow.__proto__ || Object.getPrototypeOf(BaseFormRow)).call(this, props));

    _this.state = {
      isFocused: false,
      showError: false
    };

    _this.onFocus = _this.onFocus.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onShowError = _this.onShowError.bind(_this);
    _this.onHideError = _this.onHideError.bind(_this);
    return _this;
  }

  _createClass(BaseFormRow, [{
    key: 'onFocus',
    value: function onFocus(e) {
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
      this.setState({
        isFocused: true
      });
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
      this.setState({
        isFocused: false
      });
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      if (this.props.onChange) {
        this.props.onChange(e);
      }
    }
  }, {
    key: 'onShowError',
    value: function onShowError() {
      this.setState({
        showError: true
      });
    }
  }, {
    key: 'onHideError',
    value: function onHideError() {
      this.setState({
        showError: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var validationProps = this.props.validationProps;
      if (this.props.stateKey) {
        validationProps['data-statekey'] = this.props.stateKey;
      }

      var labelClassName = 'control-label ' + this.props.labelClasses;
      var inputWrapperClassName = 'input ' + this.props.inputClasses;
      var formRowClassName = (0, _classnames2.default)('form-row ' + this.props.formClasses, {
        focus: this.state.isFocused,
        'is-invalid-input': this.state.showError
      });

      return _react2.default.createElement(
        'div',
        { className: formRowClassName },
        _react2.default.createElement(
          'label',
          {
            htmlFor: this.props.htmlFor,
            className: labelClassName
          },
          this.props.label
        ),
        _react2.default.createElement(
          'div',
          { className: inputWrapperClassName },
          _react2.default.createElement(_Input2.default, _extends({}, validationProps, {
            handleOnChange: this.onChange,
            handleOnBlur: this.onBlur,
            handleOnFocus: this.onFocus,
            onHideError: this.onHideError,
            onShowError: this.onShowError
          })),
          this.props.children
        )
      );
    }
  }]);

  return BaseFormRow;
}(_react2.default.Component);

BaseFormRow.defaultProps = {
  formClasses: '',
  stateKey: '',
  inputClasses: '',
  children: null,
  labelClasses: '',
  handleInputChange: function handleInputChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onChange: function onChange() {}
};

BaseFormRow.propTypes = {
  formClasses: _propTypes2.default.string,
  htmlFor: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string.isRequired,
  labelClasses: _propTypes2.default.string,
  inputClasses: _propTypes2.default.string,
  stateKey: _propTypes2.default.string,
  validationProps: _propTypes2.default.shape({
    type: _propTypes2.default.string,
    id: _propTypes2.default.string,
    maxLength: _propTypes2.default.string,
    name: _propTypes2.default.string,
    autoComplete: _propTypes2.default.string,
    className: _propTypes2.default.string,
    value: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    validations: _propTypes2.default.arrayOf(_propTypes2.default.func),
    onChange: _propTypes2.default.func
  }).isRequired,
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  children: _propTypes2.default.node
};

exports.default = BaseFormRow;

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dompurify = __webpack_require__(53);

var _dompurify2 = _interopRequireDefault(_dompurify);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Note = function Note(props) {
  var labelClass = (0, _classnames2.default)('controls', {
    alert: props.includeDefaultNoteStyle
  });
  return _react2.default.createElement('div', {
    className: labelClass,
    dangerouslySetInnerHTML: { __html: '' + _dompurify2.default.sanitize(props.label) }
  });
};

Note.defaultProps = {
  includeDefaultNoteStyle: true
};

Note.propTypes = {
  includeDefaultNoteStyle: _propTypes2.default.bool,
  label: _propTypes2.default.string.isRequired
};

exports.default = Note;

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var toPercent = function toPercent(num) {
  return num + '%';
};

var Flex = function Flex(_ref) {
  var children = _ref.children,
      className = _ref.className,
      direction = _ref.direction,
      count = _ref.count,
      offset = _ref.offset,
      style = _ref.style,
      wrap = _ref.wrap,
      otherProps = _objectWithoutProperties(_ref, ['children', 'className', 'direction', 'count', 'offset', 'style', 'wrap']);

  return _react2.default.createElement(
    'div',
    _extends({
      className: className,
      style: _extends({
        display: 'flex',
        flexDirection: direction,
        flexWrap: wrap ? 'wrap' : 'no-wrap'
      }, style)
    }, otherProps),
    _react2.default.Children.map(children, function (child, index) {
      return _react2.default.cloneElement(child, _extends({}, child.props, {
        style: {
          flexBasis: toPercent(100 / count),
          maxWidth: toPercent(100 / count),
          overflow: 'hidden',
          marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
        }
      }));
    })
  );
};

Flex.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  count: _propTypes2.default.number.isRequired,
  direction: _propTypes2.default.string,
  offset: _propTypes2.default.number,
  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
  wrap: _propTypes2.default.bool
};

exports.default = Flex;

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatShortWeekday = exports.formatMonth = exports.formatMonthYear = exports.formatDate = undefined;

var _getUserLocale = __webpack_require__(296);

var _getUserLocale2 = _interopRequireDefault(_getUserLocale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatterCache = {};

/**
 * Gets Intl-based date formatter from formatter cache. If it doesn't exist in cache
 * just yet, it will be created on the fly.
 */
var getFormatter = function getFormatter(options, locale) {
  if (!locale) {
    // Default parameter is not enough as it does not protect us from null values
    // eslint-disable-next-line no-param-reassign
    locale = (0, _getUserLocale2.default)();
  }

  var stringifiedOptions = JSON.stringify(options);

  if (!formatterCache[locale]) {
    formatterCache[locale] = {};
  }

  if (!formatterCache[locale][stringifiedOptions]) {
    formatterCache[locale][stringifiedOptions] = new Intl.DateTimeFormat(locale, options).format;
  }

  return formatterCache[locale][stringifiedOptions];
};

/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 */
var toSafeHour = function toSafeHour(date) {
  var safeDate = new Date(date);
  return new Date(safeDate.setHours(12));
};

var formatDate = exports.formatDate = function formatDate(date, locale) {
  return getFormatter({ day: 'numeric', month: 'numeric', year: 'numeric' }, locale)(toSafeHour(date));
};

var formatMonthYear = exports.formatMonthYear = function formatMonthYear(date, locale) {
  return getFormatter({ month: 'long', year: 'numeric' }, locale)(toSafeHour(date));
};

var formatMonth = exports.formatMonth = function formatMonth(date, locale) {
  return getFormatter({ month: 'long' }, locale)(toSafeHour(date));
};

var formatShortWeekday = exports.formatShortWeekday = function formatShortWeekday(date, locale) {
  return getFormatter({ weekday: 'short' }, locale)(toSafeHour(date));
};

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
  var onClickHandler = function onClickHandler() {
    if (props.trackCategory && props.trackAction) {
      window._track(props.trackCategory, props.trackAction);
    }
    props.buttonOnClick();
  };

  return _react2.default.createElement(
    'button',
    {
      id: props.id,
      className: props.buttonClass,
      onClick: onClickHandler
    },
    props.buttonText
  );
};

Button.propTypes = {
  buttonOnClick: _propTypes2.default.func,
  buttonText: _propTypes2.default.string,
  buttonClass: _propTypes2.default.string,
  id: _propTypes2.default.string,
  trackCategory: _propTypes2.default.string,
  trackAction: _propTypes2.default.string
};

Button.defaultProps = {
  buttonOnClick: function buttonOnClick() {
    return true;
  },
  buttonClass: 'btn btn-large btn-success',
  buttonText: 'Success',
  id: '',
  trackCategory: null,
  trackAction: null
};

exports.default = Button;

/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendSessionLinkEmail = exports.closeEmailModal = exports.openEmailModal = undefined;

var _FormSwiftAPIClient = __webpack_require__(63);

var _FormSwiftAPIClient2 = _interopRequireDefault(_FormSwiftAPIClient);

var _SessionEmailConstants = __webpack_require__(889);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var uuidV4 = __webpack_require__(37);

var formSwiftAPIClient = new _FormSwiftAPIClient2.default(window.API_URL);

var openEmailModal = exports.openEmailModal = function openEmailModal() {
  return function (dispatch) {
    dispatch({
      type: _SessionEmailConstants.StaticSessionEmailEnum.STATIC_BUILDER_EMAIL_MODAL_OPEN
    });
  };
};

var closeEmailModal = exports.closeEmailModal = function closeEmailModal() {
  return function (dispatch) {
    dispatch({
      type: _SessionEmailConstants.StaticSessionEmailEnum.STATIC_BUILDER_EMAIL_MODAL_CLOSE
    });
  };
};

var sendSessionLinkEmail = exports.sendSessionLinkEmail = function sendSessionLinkEmail(sessionId, sessionHash, documentType, emailTo, successCallback) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var payload;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                type: _SessionEmailConstants.StaticSessionEmailEnum.STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_REQUEST
              });

              _context.prev = 1;
              payload = {
                document_type: documentType,
                email_to: emailTo,
                session_hash: sessionHash,
                version: uuidV4()
              };
              _context.next = 5;
              return formSwiftAPIClient.request('POST', '/email/send-session-link/' + sessionId, payload);

            case 5:

              dispatch({
                type: _SessionEmailConstants.StaticSessionEmailEnum.STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_SUCCESS
              });

              successCallback();
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](1);

              dispatch({
                type: _SessionEmailConstants.StaticSessionEmailEnum.STATIC_BUILDER_SEND_SESSION_LINK_EMAIL_FAILURE,
                error: _context.t0.message
              });

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[1, 9]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tileProps = exports.tileGroupProps = exports.isView = exports.isClassName = exports.isViews = exports.isValue = exports.isMaxDate = exports.isMinDate = exports.isCalendarType = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var calendarTypes = ['ISO 8601', 'US', 'Arabic', 'Hebrew'];
var allViews = ['century', 'decade', 'year', 'month'];

var isCalendarType = exports.isCalendarType = _propTypes2.default.oneOf(calendarTypes);

var isMinDate = exports.isMinDate = function isMinDate(props, propName, componentName) {
  var minDate = props[propName];


  if (minDate) {
    if (!(minDate instanceof Date)) {
      return new Error('Invalid prop `' + propName + '` of type `' + (typeof minDate === 'undefined' ? 'undefined' : _typeof(minDate)) + '` supplied to `' + componentName + '`, expected instance of `Date`.');
    }

    var maxDate = props.maxDate;


    if (maxDate && minDate > maxDate) {
      return new Error('Invalid prop `' + propName + '` of type `' + (typeof minDate === 'undefined' ? 'undefined' : _typeof(minDate)) + '` supplied to `' + componentName + '`, minDate cannot be larger than maxDate.');
    }
  }

  // Everything is fine
  return null;
};

var isMaxDate = exports.isMaxDate = function isMaxDate(props, propName, componentName) {
  var maxDate = props[propName];


  if (maxDate) {
    if (!(maxDate instanceof Date)) {
      return new Error('Invalid prop `' + propName + '` of type `' + (typeof maxDate === 'undefined' ? 'undefined' : _typeof(maxDate)) + '` supplied to `' + componentName + '`, expected instance of `Date`.');
    }

    var minDate = props.minDate;


    if (minDate && maxDate < minDate) {
      return new Error('Invalid prop `' + propName + '` of type `' + (typeof maxDate === 'undefined' ? 'undefined' : _typeof(maxDate)) + '` supplied to `' + componentName + '`, maxDate cannot be smaller than minDate.');
    }
  }

  // Everything is fine
  return null;
};

var isValue = exports.isValue = _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(Date))]);

var isViews = exports.isViews = _propTypes2.default.arrayOf(_propTypes2.default.oneOf(allViews));

var isClassName = exports.isClassName = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]);

var isView = exports.isView = function isView(props, propName, componentName) {
  var view = props[propName];
  var views = props.views;


  var allowedViews = views || allViews;

  if (allowedViews.indexOf(view) === -1) {
    return new Error('Invalid prop `' + propName + '` of value `' + view + '` supplied to `' + componentName + '`, expected one of [' + ['a', 'b', 'c', 'd', 'e'].map(function (a) {
      return '"' + a + '"';
    }).join(', ') + '].');
  }

  // Everything is fine
  return null;
};

isView.isRequired = function (props, propName, componentName) {
  var view = props[propName];


  if (!view) {
    return new Error('The prop `' + propName + '` is marked as required in `' + componentName + '`, but its value is `' + view + '`.');
  }

  return isView(props, propName, componentName);
};

var tileGroupProps = exports.tileGroupProps = {
  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
  hover: _propTypes2.default.instanceOf(Date),
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: _propTypes2.default.func,
  onMouseOver: _propTypes2.default.func,
  tileClassName: _propTypes2.default.oneOfType([_propTypes2.default.func, isClassName]),
  tileContent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  value: isValue,
  valueType: _propTypes2.default.string
};

var tileProps = exports.tileProps = {
  activeStartDate: _propTypes2.default.instanceOf(Date).isRequired,
  classes: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  date: _propTypes2.default.instanceOf(Date).isRequired,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: _propTypes2.default.func,
  onMouseOver: _propTypes2.default.func,
  style: _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
  tileClassName: _propTypes2.default.oneOfType([_propTypes2.default.func, isClassName]),
  tileContent: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  tileDisabled: _propTypes2.default.func
};

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = function ProgressBar(props) {
  return _react2.default.createElement(
    'div',
    {
      id: props.progressBarId,
      className: props.progressBarClassName,
      style: props.style
    },
    _react2.default.createElement('div', {
      id: props.progressId,
      className: props.progressClassName,
      style: {
        width: props.step * 100 / props.totalSteps + '%'
      }
    })
  );
};

ProgressBar.defaultProps = {
  progressBarId: '',
  progressId: '',
  progressBarClassName: '',
  progressClassName: '',
  style: {}
};

ProgressBar.propTypes = {
  step: _propTypes2.default.number.isRequired,
  totalSteps: _propTypes2.default.number.isRequired,
  style: _propTypes2.default.shape({
    display: _propTypes2.default.string
  }),
  progressBarId: _propTypes2.default.string,
  progressId: _propTypes2.default.string,
  progressBarClassName: _propTypes2.default.string,
  progressClassName: _propTypes2.default.string
};

exports.default = ProgressBar;

/***/ })

},[1311]);


// WEBPACK FOOTER //
// builder.js